import { PrismicHyperlink, PrismicImageType } from '@emico/prismic'
export type UnknownJSON = unknown | null
export type { PrismicHyperlink, PrismicImageType }

export type Maybe<T> = T | null
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K]
}
export type MakeOptional<T, K extends keyof T> = Omit<T, K> &
  { [SubKey in K]?: Maybe<T[SubKey]> }
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> &
  { [SubKey in K]: Maybe<T[SubKey]> }
/** All built-in and custom scalars, mapped to their actual values */
export interface Scalars {
  ID: string
  String: string
  Boolean: boolean
  Int: number
  Float: number
  TODO: any
  /** DateTime */
  DateTime: any
  /**
   * The `Long` scalar type represents non-fractional signed whole numeric values.
   * Long can represent values between -(2^63) and 2^63 - 1.
   */
  Long: any
  /** Raw JSON value */
  Json: UnknownJSON
  /** Date */
  Date: any
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: UnknownJSON
}

export interface AddAdvCommentInput {
  /** Email Address. */
  email?: Maybe<Scalars['String']>
  /** Review. */
  message: Scalars['String']
  /** Nickname. */
  nickname?: Maybe<Scalars['String']>
  /** Review ID. */
  review_id: Scalars['Int']
}

export interface AddAdvCommentOutput {
  __typename?: 'AddAdvCommentOutput'
  /** Commented Review. */
  review: Maybe<Review>
  /** Status. */
  success: Maybe<Scalars['Boolean']>
}

export interface AddAdvReviewInput {
  /** Review. */
  detail: Scalars['String']
  /** GDPR. */
  gdpr?: Maybe<Scalars['Boolean']>
  /** Email Address. */
  guest_email?: Maybe<Scalars['String']>
  /** Recommendation. */
  is_recommended?: Maybe<Scalars['Boolean']>
  /** List of advantages */
  like_about?: Maybe<Array<Maybe<LikeInput>>>
  /** Nickname. */
  nickname: Scalars['String']
  /** List of disadvantages */
  not_like_about?: Maybe<Array<Maybe<LikeInput>>>
  /** Product ID. */
  product_id: Scalars['Int']
  /** Ratings */
  ratings?: Maybe<Array<Maybe<RatingInput>>>
  /** Summary. */
  title: Scalars['String']
  /** Path to tmp images location to save review images. */
  tmp_images_path?: Maybe<Array<Maybe<Scalars['String']>>>
}

export interface AddAdvReviewOutput {
  __typename?: 'AddAdvReviewOutput'
  /** Status. */
  success: Maybe<Scalars['Boolean']>
}

export interface AddAdvVoteInput {
  /** Review ID. */
  review_id: Scalars['Int']
  /** Nickname. */
  type: Scalars['String']
}

export interface AddAdvVoteOutput {
  __typename?: 'AddAdvVoteOutput'
  /** Commented Review. */
  review: Maybe<Review>
  /** Status. */
  success: Maybe<Scalars['Boolean']>
}

export interface AddBundleProductsToCartInput {
  cart_id: Scalars['String']
  cart_items: Array<Maybe<BundleProductCartItemInput>>
}

export interface AddBundleProductsToCartOutput {
  __typename?: 'AddBundleProductsToCartOutput'
  cart: Cart
}

export interface AddConfigurableProductsToCartInput {
  cart_id: Scalars['String']
  cart_items: Array<Maybe<ConfigurableProductCartItemInput>>
}

export interface AddConfigurableProductsToCartOutput {
  __typename?: 'AddConfigurableProductsToCartOutput'
  cart: Cart
}

export interface AdditionalDataField {
  field: Scalars['String']
  value: Scalars['String']
}

export interface AddSimpleProductsToCartInput {
  cart_id: Scalars['String']
  cart_items: Array<Maybe<SimpleProductCartItemInput>>
}

export interface AddSimpleProductsToCartOutput {
  __typename?: 'AddSimpleProductsToCartOutput'
  cart: Cart
}

export interface AddVirtualProductsToCartInput {
  cart_id: Scalars['String']
  cart_items: Array<Maybe<VirtualProductCartItemInput>>
}

export interface AddVirtualProductsToCartOutput {
  __typename?: 'AddVirtualProductsToCartOutput'
  cart: Cart
}

/** A bucket that contains information for each filterable option (such as price, category ID, and custom attributes). */
export interface Aggregation {
  __typename?: 'Aggregation'
  /** Attribute code of the aggregation group. */
  attributeCode: Scalars['String']
  /** The number of options in the aggregation group. */
  count: Maybe<Scalars['Int']>
  /** The aggregation display name. */
  label: Maybe<Scalars['String']>
  /** Array of options for the aggregation. */
  options: Maybe<Array<Maybe<AggregationOption>>>
}

export interface AggregationOption extends AggregationOptionInterface {
  __typename?: 'AggregationOption'
  /** The number of items that match the aggregation option. */
  count: Maybe<Scalars['Int']>
  /** Aggregation option display label. */
  label: Maybe<Scalars['String']>
  /** The internal ID that represents the value of the option. */
  value: Scalars['String']
}

export interface AggregationOptionInterface {
  /** The number of items that match the aggregation option. */
  count: Maybe<Scalars['Int']>
  /** Aggregation option display label. */
  label: Maybe<Scalars['String']>
  /** The internal ID that represents the value of the option. */
  value: Scalars['String']
}

export interface AmReviewSetting {
  __typename?: 'AmReviewSetting'
  /** Available filter. */
  availableFilters: Maybe<Array<Maybe<ReviewFilter>>>
  /** Available orders. */
  availableOrders: Maybe<Array<Maybe<ReviewOrder>>>
  /** Сonsent Text. */
  getGdprText: Maybe<Scalars['String']>
  /** Review Image Width. */
  getReviewImageWidth: Maybe<Scalars['String']>
  /** Allow answer. */
  isAllowAnswer: Maybe<Scalars['Boolean']>
  /** Allow coupons. */
  isAllowCoupons: Maybe<Scalars['Boolean']>
  /** Allow guest. */
  isAllowGuest: Maybe<Scalars['Boolean']>
  /** Allow helpful. */
  isAllowHelpful: Maybe<Scalars['Boolean']>
  /** Allow images. */
  isAllowImages: Maybe<Scalars['Boolean']>
  /** Review Reminder. */
  isAllowReminder: Maybe<Scalars['Boolean']>
  /** Comments Enabled. */
  isCommentsEnabled: Maybe<Scalars['Boolean']>
  /** Sorting enabled. */
  isFilteringEnabled: Maybe<Scalars['Boolean']>
  /** GDPR Consent. */
  isGdprEnabled: Maybe<Scalars['Boolean']>
  /** Guest Can Comment. */
  isGuestCanComment: Maybe<Scalars['Boolean']>
  /** Is Guest Email Showed. */
  isGuestEmailShow: Maybe<Scalars['Boolean']>
  /** Is Images Required. */
  isImagesRequired: Maybe<Scalars['Boolean']>
  /** Pros and Cons. */
  isProsConsEnabled: Maybe<Scalars['Boolean']>
  /** Recomended field enable. */
  isRecommendFieldEnabled: Maybe<Scalars['Boolean']>
  /** Reminder Enabled. */
  isReminderEnabled: Maybe<Scalars['Boolean']>
  /** Sorting enabled. */
  isSortingEnabled: Maybe<Scalars['Boolean']>
  /** Toolbar displayed. */
  isToolbarDisplayed: Maybe<Scalars['Boolean']>
  /** Reviews Per Page. */
  perPage: Maybe<Scalars['Int']>
  /** List of predefined advantages */
  preLikeAbout: Maybe<Array<Maybe<Like>>>
  /** List of predefined disadvantages */
  preNotLikeAbout: Maybe<Array<Maybe<Like>>>
  /** Available Ratings. */
  ratings: Maybe<Array<Maybe<Rating>>>
  /** Images to Show. */
  slidesToShow: Maybe<Scalars['Int']>
}

export interface AmReviewWidget {
  __typename?: 'AmReviewWidget'
  /** Reviews from Current Category Only. */
  currentCategory: Maybe<Scalars['Boolean']>
  /** Reviews of Products which belong to the Same Categories Only. */
  currentProductCategory: Maybe<Scalars['Boolean']>
  /** Enable Slider. */
  enableSlider: Maybe<Scalars['Boolean']>
  items: Maybe<Array<Maybe<AmReviewWidgetItem>>>
  /** Reviews Type. */
  reviewType: Maybe<Scalars['Int']>
  /** Number of Reviews to Show. */
  reviewsCount: Maybe<Scalars['Int']>
  title: Maybe<Scalars['String']>
}

export interface AmReviewWidgetItem {
  __typename?: 'AmReviewWidgetItem'
  /** Date. */
  date: Maybe<Scalars['String']>
  image: Maybe<ProductImage>
  /** Product Name. */
  name: Maybe<Scalars['String']>
  /** Product URL. */
  productUrl: Maybe<Scalars['String']>
  /** Rating votes. */
  ratingVotes: Maybe<Array<Maybe<RatingVote>>>
  /** Recommended Html. */
  recommendedHtml: Maybe<Scalars['String']>
  /** Review By. */
  reviewBy: Maybe<Scalars['String']>
  /** Review Message. */
  reviewMessage: Maybe<Scalars['String']>
}

export interface AppliedCoupon {
  __typename?: 'AppliedCoupon'
  code: Scalars['String']
}

export interface ApplyCouponToCartInput {
  cart_id: Scalars['String']
  coupon_code: Scalars['String']
}

export interface ApplyCouponToCartOutput {
  __typename?: 'ApplyCouponToCartOutput'
  cart: Cart
}

/** AreaInput defines the parameters which will be used for filter by specified location. */
export interface AreaInput {
  /** The radius for the search in KM. */
  radius: Scalars['Int']
  /** The country code where search must be performed. Required parameter together with region, city or postcode. */
  search_term: Scalars['String']
}

/** Attribute contains the attribute_type of the specified attribute_code and entity_type */
export interface Attribute {
  __typename?: 'Attribute'
  /** The unique identifier for an attribute code. This value should be in lowercase letters without spaces. */
  attributeCode: Maybe<Scalars['String']>
  /** Attribute options list. */
  attributeOptions: Maybe<Array<Maybe<AttributeOption>>>
  /** The data type of the attribute */
  attributeType: Maybe<Scalars['String']>
  /** The type of entity that defines the attribute */
  entityType: Maybe<Scalars['String']>
  /** The frontend input type of the attribute */
  inputType: Maybe<Scalars['String']>
}

/** AttributeInput specifies the attribute_code and entity_type to search */
export interface AttributeInput {
  /** The unique identifier for an attribute code. This value should be in lowercase letters without spaces. */
  attribute_code?: Maybe<Scalars['String']>
  /** The type of entity that defines the attribute */
  entity_type?: Maybe<Scalars['String']>
}

/** Attribute option. */
export interface AttributeOption {
  __typename?: 'AttributeOption'
  /** Attribute option label. */
  label: Maybe<Scalars['String']>
  /** Attribute option value. */
  value: Maybe<Scalars['String']>
}

export interface AvailablePaymentMethod {
  __typename?: 'AvailablePaymentMethod'
  /** The payment method code */
  code: Scalars['String']
  /** The payment method title. */
  title: Scalars['String']
}

export interface AvailableShippingMethod {
  __typename?: 'AvailableShippingMethod'
  amount: Money
  available: Scalars['Boolean']
  /** @deprecated The field should not be used on the storefront */
  baseAmount: Maybe<Money>
  carrierCode: Scalars['String']
  carrierTitle: Scalars['String']
  errorMessage: Maybe<Scalars['String']>
  /** Could be null if method is not available */
  methodCode: Maybe<Scalars['String']>
  /** Could be null if method is not available */
  methodTitle: Maybe<Scalars['String']>
  priceExclTax: Money
  priceInclTax: Money
}

export interface BillingAddressInput {
  address?: Maybe<CartAddressInput>
  customer_address_id?: Maybe<Scalars['Int']>
  /** Set billing address same as shipping */
  same_as_shipping?: Maybe<Scalars['Boolean']>
  /** Deprecated: use `same_as_shipping` field instead */
  use_for_shipping?: Maybe<Scalars['Boolean']>
}

export interface BillingCartAddress extends CartAddressInterface {
  __typename?: 'BillingCartAddress'
  city: Scalars['String']
  company: Maybe<Scalars['String']>
  country: CartAddressCountry
  /** @deprecated The field is used only in shipping address */
  customerNotes: Maybe<Scalars['String']>
  firstname: Scalars['String']
  lastname: Scalars['String']
  postcode: Maybe<Scalars['String']>
  region: Maybe<CartAddressRegion>
  street: Array<Maybe<Scalars['String']>>
  telephone: Scalars['String']
  vatNumber: Maybe<Scalars['String']>
}

/** Breadcrumb item. */
export interface Breadcrumb {
  __typename?: 'Breadcrumb'
  /** Category ID. */
  categoryId: Maybe<Scalars['Int']>
  /** Category level. */
  categoryLevel: Maybe<Scalars['Int']>
  /** Category name. */
  categoryName: Maybe<Scalars['String']>
  /** Category URL key. */
  categoryUrlKey: Maybe<Scalars['String']>
  /** Category URL path. */
  categoryUrlPath: Maybe<Scalars['String']>
}

export interface BundleCartItem extends CartItemInterface {
  __typename?: 'BundleCartItem'
  bundleOptions: Array<Maybe<SelectedBundleOption>>
  customizableOptions: Array<Maybe<SelectedCustomizableOption>>
  id: Scalars['String']
  prices: Maybe<CartItemPrices>
  product: ProductInterface
  quantity: Scalars['Float']
}

/** BundleItem defines an individual item in a bundle product. */
export interface BundleItem {
  __typename?: 'BundleItem'
  /** An ID assigned to each type of item in a bundle product. */
  optionId: Maybe<Scalars['Int']>
  /** An array of additional options for this bundle item. */
  options: Maybe<Array<Maybe<BundleItemOption>>>
  /** he relative position of this item compared to the other bundle items. */
  position: Maybe<Scalars['Int']>
  /** Indicates whether the item must be included in the bundle. */
  required: Maybe<Scalars['Boolean']>
  /** The SKU of the bundle product. */
  sku: Maybe<Scalars['String']>
  /** The display name of the item. */
  title: Maybe<Scalars['String']>
  /** The input type that the customer uses to select the item. Examples include radio button and checkbox. */
  type: Maybe<Scalars['String']>
}

/** BundleItemOption defines characteristics and options for a specific bundle item. */
export interface BundleItemOption {
  __typename?: 'BundleItemOption'
  /** Indicates whether the customer can change the number of items for this option. */
  canChangeQuantity: Maybe<Scalars['Boolean']>
  /** The ID assigned to the bundled item option. */
  id: Maybe<Scalars['Int']>
  /** Indicates whether this option is the default option. */
  isDefault: Maybe<Scalars['Boolean']>
  /** The text that identifies the bundled item option. */
  label: Maybe<Scalars['String']>
  /** When a bundle item contains multiple options, the relative position of this option compared to the other options. */
  position: Maybe<Scalars['Int']>
  /** The price of the selected option. */
  price: Maybe<Scalars['Float']>
  /** One of FIXED, PERCENT, or DYNAMIC. */
  priceType: Maybe<PriceTypeEnum>
  /** Contains details about this product option. */
  product: Maybe<ProductInterface>
  /**
   * Indicates the quantity of this specific bundle item.
   * @deprecated The `qty` is deprecated. Use `quantity` instead.
   */
  qty: Maybe<Scalars['Float']>
  /** Indicates the quantity of this specific bundle item. */
  quantity: Maybe<Scalars['Float']>
}

export interface BundleOptionInput {
  id: Scalars['Int']
  quantity: Scalars['Float']
  value: Array<Maybe<Scalars['String']>>
}

/** BundleProduct defines basic features of a bundle product and contains multiple BundleItems. */
export interface BundleProduct
  extends ProductInterface,
    PhysicalProductInterface,
    CustomizableProductInterface {
  __typename?: 'BundleProduct'
  activity: Maybe<Scalars['String']>
  allowcoupon: Maybe<Scalars['Int']>
  allowingenico: Maybe<Scalars['Int']>
  allowpostnllabel: Maybe<Scalars['Int']>
  allowreview: Maybe<Scalars['Int']>
  alternatiefmemo: Maybe<Scalars['String']>
  /** The attribute set assigned to the product. */
  attributeSetId: Maybe<Scalars['Int']>
  /**
   * Relative canonical URL. This value is returned only if the system setting 'Use
   * Canonical Link Meta Tag For Products' is enabled
   */
  canonicalUrl: Maybe<Scalars['String']>
  /** The categories assigned to a product. */
  categories: Maybe<Array<Maybe<CategoryInterface>>>
  categoryGear: Maybe<Scalars['String']>
  climate: Maybe<Scalars['String']>
  collar: Maybe<Scalars['String']>
  color: Maybe<Scalars['Int']>
  cons: Maybe<Scalars['String']>
  /** The product's country of origin. */
  countryOfManufacture: Maybe<Scalars['String']>
  /** Timestamp indicating when the product was created. */
  createdAt: Maybe<Scalars['String']>
  /** Crosssell Products */
  crosssellProducts: Maybe<Array<Maybe<ProductInterface>>>
  /** Detailed information about the product. The value can include simple HTML tags. */
  description: Maybe<ComplexTextValue>
  doorverkooppremie: Maybe<Scalars['String']>
  /** Indicates whether the bundle product has a dynamic price. */
  dynamicPrice: Maybe<Scalars['Boolean']>
  /** Indicates whether the bundle product has a dynamic SK. */
  dynamicSku: Maybe<Scalars['Boolean']>
  /** Indicates whether the bundle product has a dynamically calculated weight. */
  dynamicWeight: Maybe<Scalars['Boolean']>
  ean: Maybe<Scalars['String']>
  ecoCollection: Maybe<Scalars['Int']>
  enabled: Maybe<Scalars['Int']>
  erinRecommends: Maybe<Scalars['Int']>
  factuurinformatie: Maybe<Scalars['String']>
  featuresBags: Maybe<Scalars['String']>
  fixedprice: Maybe<Scalars['Int']>
  fixeduntil: Maybe<Scalars['String']>
  gebruikbundelproductenprijs: Maybe<Scalars['Int']>
  gender: Maybe<Scalars['String']>
  /** Indicates whether a gift message is available. */
  giftMessageAvailable: Maybe<Scalars['String']>
  google: Maybe<Scalars['Int']>
  /** The ID number assigned to the product. */
  id: Scalars['Int']
  /** The relative path to the main image on the product page. */
  image: Maybe<ProductImage>
  inkoopprijs: Maybe<Scalars['String']>
  isBuitenkansje: Maybe<Scalars['Int']>
  isInStock: Maybe<Scalars['Int']>
  /** An array containing information about individual bundle items. */
  items: Maybe<Array<Maybe<BundleItem>>>
  keepproductbuttons: Maybe<Scalars['Int']>
  kenmerken: Maybe<Scalars['String']>
  kieskeurig: Maybe<Scalars['Int']>
  kieskeurigbe: Maybe<Scalars['Int']>
  kieskeurigtekstad: Maybe<Scalars['String']>
  korteomschrijving: Maybe<Scalars['String']>
  korteomschrijving2: Maybe<Scalars['String']>
  langeomschrijving: Maybe<Scalars['String']>
  /** A number representing the product's manufacturer. */
  manufacturer: Maybe<Scalars['Int']>
  material: Maybe<Scalars['String']>
  maxprijsomnia: Maybe<Scalars['String']>
  /** An array of Media Gallery objects. */
  mediaGallery: Maybe<Array<Maybe<MediaGalleryInterface>>>
  /**
   * An array of MediaGalleryEntry objects.
   * @deprecated Use product's `media_gallery` instead
   */
  mediaGalleryEntries: Maybe<Array<Maybe<MediaGalleryEntry>>>
  merk: Maybe<Scalars['Int']>
  /** A brief overview of the product for search results listings, maximum 255 characters. */
  metaDescription: Maybe<Scalars['String']>
  /** A comma-separated list of keywords that are visible only to search engines. */
  metaKeyword: Maybe<Scalars['String']>
  /** A string that is displayed in the title bar and tab of the browser and in search results lists. */
  metaTitle: Maybe<Scalars['String']>
  modeltype: Maybe<Scalars['String']>
  /** The product name. Customers use this name to identify the product. */
  name: Scalars['String']
  new: Maybe<Scalars['Int']>
  /** The beginning date for new product listings, and determines if the product is featured as a new product. */
  newFromDate: Maybe<Scalars['String']>
  /** The end date for new product listings. */
  newToDate: Maybe<Scalars['String']>
  omnia: Maybe<Scalars['Int']>
  /** Product stock only x left count */
  onlyXLeftInStock: Maybe<Scalars['Float']>
  opmerking1: Maybe<Scalars['String']>
  opmerking2: Maybe<Scalars['String']>
  /** An array of options for a customizable product. */
  options: Maybe<Array<Maybe<CustomizableOptionInterface>>>
  /** If the product has multiple options, determines where they appear on the product page. */
  optionsContainer: Maybe<Scalars['String']>
  pattern: Maybe<Scalars['String']>
  percentagekortingopprijsvanbundelproducten: Maybe<Scalars['String']>
  performanceFabric: Maybe<Scalars['Int']>
  pimcoreId: Maybe<Scalars['Int']>
  populariteit: Maybe<Scalars['String']>
  /**
   * A ProductPrices object, indicating the price of an item.
   * @deprecated Use price_range for product price information.
   */
  price: Maybe<ProductPrices>
  /** A PriceRange object, indicating the range of prices for the product */
  priceRange: PriceRange
  /** An array of TierPrice objects. */
  priceTiers: Maybe<Array<Maybe<TierPrice>>>
  /** One of PRICE_RANGE or AS_LOW_AS. */
  priceView: Maybe<PriceViewEnum>
  prijs: Maybe<Scalars['String']>
  /** An array of ProductLinks objects. */
  productLinks: Maybe<Array<Maybe<ProductLinksInterface>>>
  productnaam: Maybe<Scalars['String']>
  productnaam1: Maybe<Scalars['String']>
  productspideren: Maybe<Scalars['Int']>
  promotekst: Maybe<Scalars['String']>
  pros: Maybe<Scalars['String']>
  /** Related Products */
  relatedProducts: Maybe<Array<Maybe<ProductInterface>>>
  s2m: Maybe<Scalars['Int']>
  sale: Maybe<Scalars['Int']>
  serie: Maybe<Scalars['String']>
  /** Indicates whether to ship bundle items together or individually. */
  shipBundleItems: Maybe<ShipBundleItemsEnum>
  /** A short description of the product. Its use depends on the theme. */
  shortDescription: Maybe<ComplexTextValue>
  size: Maybe<Scalars['Int']>
  /** A number or code assigned to a product to identify the product, options, price, and manufacturer. */
  sku: Scalars['String']
  sleeve: Maybe<Scalars['String']>
  /** The relative path to the small image, which is used on catalog pages. */
  smallImage: Maybe<ProductImage>
  /** The beginning date that a product has a special price. */
  specialFromDate: Maybe<Scalars['String']>
  /** The discounted price of the product. */
  specialPrice: Maybe<Scalars['Float']>
  /** The end date that a product has a special price. */
  specialToDate: Maybe<Scalars['String']>
  specialprice: Maybe<Scalars['String']>
  specificationsBluetoothspeakerAansluitingen: Maybe<Scalars['String']>
  specificationsBluetoothspeakerAantalspeakers: Maybe<Scalars['String']>
  specificationsBluetoothspeakerAantalusb: Maybe<Scalars['String']>
  specificationsBluetoothspeakerAantalusbc: Maybe<Scalars['String']>
  specificationsBluetoothspeakerAfmetingen: Maybe<Scalars['String']>
  specificationsBluetoothspeakerAfmetingensubwoofer: Maybe<Scalars['String']>
  specificationsBluetoothspeakerFabriekscode: Maybe<Scalars['String']>
  specificationsBluetoothspeakerGewicht: Maybe<Scalars['String']>
  specificationsBluetoothspeakerGewichtsubwoofer: Maybe<Scalars['String']>
  specificationsBluetoothspeakerIntroductiejaar: Maybe<Scalars['String']>
  specificationsBluetoothspeakerKanalen: Maybe<Scalars['String']>
  specificationsBluetoothspeakerKleur: Maybe<Scalars['Int']>
  specificationsBluetoothspeakerSpeeltaf: Maybe<Scalars['String']>
  specificationsBluetoothspeakerStandaardmeegeleverd: Maybe<Scalars['String']>
  specificationsBluetoothspeakerStreaming: Maybe<Scalars['String']>
  specificationsBluetoothspeakerStroomvoorziening: Maybe<Scalars['String']>
  specificationsBluetoothspeakerTypeaudio: Maybe<Scalars['Int']>
  specificationsBluetoothspeakerTypespeaker: Maybe<Scalars['String']>
  specificationsBluetoothspeakerVermogen: Maybe<Scalars['String']>
  specificationsBlurayspelerAfmetingen: Maybe<Scalars['String']>
  specificationsBlurayspelerAfspelenvan: Maybe<Scalars['String']>
  specificationsBlurayspelerAnalogeaudio: Maybe<Scalars['String']>
  specificationsBlurayspelerAudioenvideo: Maybe<Scalars['String']>
  specificationsBlurayspelerBdlive: Maybe<Scalars['Int']>
  specificationsBlurayspelerBluetooth: Maybe<Scalars['Int']>
  specificationsBlurayspelerCoaxiaal: Maybe<Scalars['String']>
  specificationsBlurayspelerDecoders: Maybe<Scalars['String']>
  specificationsBlurayspelerDigitaalcoaxaal: Maybe<Scalars['String']>
  specificationsBlurayspelerDigitaaloptisch: Maybe<Scalars['String']>
  specificationsBlurayspelerDigitaleoptisch: Maybe<Scalars['Int']>
  specificationsBlurayspelerDlna: Maybe<Scalars['Int']>
  specificationsBlurayspelerDriedondersteuning: Maybe<Scalars['Int']>
  specificationsBlurayspelerEthernet: Maybe<Scalars['String']>
  specificationsBlurayspelerFormats: Maybe<Scalars['String']>
  specificationsBlurayspelerFuncties: Maybe<Scalars['String']>
  specificationsBlurayspelerGecerthires: Maybe<Scalars['Int']>
  specificationsBlurayspelerGewicht: Maybe<Scalars['String']>
  specificationsBlurayspelerHdmi: Maybe<Scalars['String']>
  specificationsBlurayspelerHdr: Maybe<Scalars['Int']>
  specificationsBlurayspelerKleur: Maybe<Scalars['Int']>
  specificationsBlurayspelerLan: Maybe<Scalars['Int']>
  specificationsBlurayspelerMiracast: Maybe<Scalars['Int']>
  specificationsBlurayspelerMultiroom: Maybe<Scalars['Int']>
  specificationsBlurayspelerOndersteundaudioformaat: Maybe<Scalars['String']>
  specificationsBlurayspelerOptisch: Maybe<Scalars['Int']>
  specificationsBlurayspelerOutputkanalen: Maybe<Scalars['String']>
  specificationsBlurayspelerPlayback: Maybe<Scalars['String']>
  specificationsBlurayspelerResolutie: Maybe<Scalars['String']>
  specificationsBlurayspelerSmarttv: Maybe<Scalars['Int']>
  specificationsBlurayspelerSpeeltaf: Maybe<Scalars['String']>
  specificationsBlurayspelerSpeeltvandisc: Maybe<Scalars['String']>
  specificationsBlurayspelerStandaardmeegeleverd: Maybe<Scalars['String']>
  specificationsBlurayspelerStroomverbruik: Maybe<Scalars['String']>
  specificationsBlurayspelerUpscaling: Maybe<Scalars['Int']>
  specificationsBlurayspelerUsb: Maybe<Scalars['String']>
  specificationsBlurayspelerVierkuhd: Maybe<Scalars['Int']>
  specificationsBlurayspelerVierkuhdups: Maybe<Scalars['Int']>
  specificationsBlurayspelerWifi: Maybe<Scalars['Int']>
  specificationsCdspelerAansluitingen: Maybe<Scalars['String']>
  specificationsCdspelerAantalusb: Maybe<Scalars['String']>
  specificationsCdspelerAchterspeakers: Maybe<Scalars['Int']>
  specificationsCdspelerAfmetingen: Maybe<Scalars['String']>
  specificationsCdspelerFabriekscode: Maybe<Scalars['String']>
  specificationsCdspelerGewicht: Maybe<Scalars['String']>
  specificationsCdspelerImpendatie: Maybe<Scalars['String']>
  specificationsCdspelerIntroductiejaar: Maybe<Scalars['String']>
  specificationsCdspelerKanalen: Maybe<Scalars['String']>
  specificationsCdspelerMultiroom: Maybe<Scalars['Int']>
  specificationsCdspelerRadio: Maybe<Scalars['Int']>
  specificationsCdspelerSpeakeraansluiting: Maybe<Scalars['String']>
  specificationsCdspelerSpeeltaf: Maybe<Scalars['String']>
  specificationsCdspelerStandaardmeegeleverd: Maybe<Scalars['String']>
  specificationsCdspelerStreaming: Maybe<Scalars['String']>
  specificationsCdspelerStreamingdiensten: Maybe<Scalars['String']>
  specificationsCdspelerStroomvoorziening: Maybe<Scalars['Int']>
  specificationsCdspelerSubwooferuitgang: Maybe<Scalars['Int']>
  specificationsCdspelerTypeaudio: Maybe<Scalars['Int']>
  specificationsCdspelerVermogen: Maybe<Scalars['String']>
  specificationsDraadlozespeakerAantalspeakers: Maybe<Scalars['String']>
  specificationsDraadlozespeakerAfmetingen: Maybe<Scalars['String']>
  specificationsDraadlozespeakerAirplay2: Maybe<Scalars['Int']>
  specificationsDraadlozespeakerAux: Maybe<Scalars['Int']>
  specificationsDraadlozespeakerBluetooth: Maybe<Scalars['Int']>
  specificationsDraadlozespeakerComponent: Maybe<Scalars['Int']>
  specificationsDraadlozespeakerComposiet: Maybe<Scalars['Int']>
  specificationsDraadlozespeakerFabriekscode: Maybe<Scalars['String']>
  specificationsDraadlozespeakerGebruiksduuraccu: Maybe<Scalars['String']>
  specificationsDraadlozespeakerGewicht: Maybe<Scalars['String']>
  specificationsDraadlozespeakerHdmiin: Maybe<Scalars['String']>
  specificationsDraadlozespeakerHdmiuit: Maybe<Scalars['String']>
  specificationsDraadlozespeakerKanalen: Maybe<Scalars['String']>
  specificationsDraadlozespeakerMinijack: Maybe<Scalars['Int']>
  specificationsDraadlozespeakerMultiroom: Maybe<Scalars['Int']>
  specificationsDraadlozespeakerOptischcoax: Maybe<Scalars['Int']>
  specificationsDraadlozespeakerPlatenspeler: Maybe<Scalars['Int']>
  specificationsDraadlozespeakerSpotifyconnect: Maybe<Scalars['Int']>
  specificationsDraadlozespeakerSubwoofer: Maybe<Scalars['Int']>
  specificationsDraadlozespeakerUsb: Maybe<Scalars['Int']>
  specificationsDraadlozespeakerVoicecontrol: Maybe<Scalars['Int']>
  specificationsDraadlozespeakerWifi: Maybe<Scalars['Int']>
  specificationsHifispeakerAansluitingen: Maybe<Scalars['String']>
  specificationsHifispeakerAantalspeakers: Maybe<Scalars['String']>
  specificationsHifispeakerAantalusb: Maybe<Scalars['String']>
  specificationsHifispeakerAchterspeakers: Maybe<Scalars['Int']>
  specificationsHifispeakerAfmetingen: Maybe<Scalars['String']>
  specificationsHifispeakerAfmetingensubwoofer: Maybe<Scalars['String']>
  specificationsHifispeakerBelastbaarheid: Maybe<Scalars['String']>
  specificationsHifispeakerFabriekscode: Maybe<Scalars['String']>
  specificationsHifispeakerGewicht: Maybe<Scalars['String']>
  specificationsHifispeakerGewichtsubwoofer: Maybe<Scalars['String']>
  specificationsHifispeakerImpendatie: Maybe<Scalars['String']>
  specificationsHifispeakerIntroductiejaar: Maybe<Scalars['String']>
  specificationsHifispeakerKanalen: Maybe<Scalars['String']>
  specificationsHifispeakerKleur: Maybe<Scalars['Int']>
  specificationsHifispeakerMaximalefrequentie: Maybe<Scalars['String']>
  specificationsHifispeakerMinimalefrequentie: Maybe<Scalars['String']>
  specificationsHifispeakerMultiroom: Maybe<Scalars['Int']>
  specificationsHifispeakerSpeakeraansluiting: Maybe<Scalars['String']>
  specificationsHifispeakerSpeakertype: Maybe<Scalars['String']>
  specificationsHifispeakerStandaardmeegeleverd: Maybe<Scalars['String']>
  specificationsHifispeakerStreaming: Maybe<Scalars['String']>
  specificationsHifispeakerStroomvoorziening: Maybe<Scalars['Int']>
  specificationsHifispeakerTypeaudio: Maybe<Scalars['Int']>
  specificationsHifispeakerTypespeaker: Maybe<Scalars['String']>
  specificationsHifispeakerVermogen: Maybe<Scalars['String']>
  specificationsHifispeakerWaterbestendig: Maybe<Scalars['Int']>
  specificationsHomecinemaAansluitingen: Maybe<Scalars['String']>
  specificationsHomecinemaAantalhdmi: Maybe<Scalars['String']>
  specificationsHomecinemaAantalspeakers: Maybe<Scalars['String']>
  specificationsHomecinemaAantalusb: Maybe<Scalars['String']>
  specificationsHomecinemaAchterspeakers: Maybe<Scalars['Int']>
  specificationsHomecinemaAfmetingen: Maybe<Scalars['String']>
  specificationsHomecinemaFabriekscode: Maybe<Scalars['String']>
  specificationsHomecinemaGewicht: Maybe<Scalars['String']>
  specificationsHomecinemaGewichtsubwoofer: Maybe<Scalars['String']>
  specificationsHomecinemaImpendatie: Maybe<Scalars['String']>
  specificationsHomecinemaIntroductiejaar: Maybe<Scalars['String']>
  specificationsHomecinemaKleur: Maybe<Scalars['Int']>
  specificationsHomecinemaMicrofoon: Maybe<Scalars['Int']>
  specificationsHomecinemaMultiroom: Maybe<Scalars['Int']>
  specificationsHomecinemaRadio: Maybe<Scalars['Int']>
  specificationsHomecinemaSpeakeraansluiting: Maybe<Scalars['String']>
  specificationsHomecinemaSpeeltaf: Maybe<Scalars['String']>
  specificationsHomecinemaStandaardmeegeleverd: Maybe<Scalars['String']>
  specificationsHomecinemaStreaming: Maybe<Scalars['String']>
  specificationsHomecinemaStreamingdiensten: Maybe<Scalars['String']>
  specificationsHomecinemaStroomvoorziening: Maybe<Scalars['Int']>
  specificationsHomecinemaSubwooferuitgang: Maybe<Scalars['String']>
  specificationsHomecinemaTypeaudio: Maybe<Scalars['Int']>
  specificationsHomecinemaTypespeaker: Maybe<Scalars['String']>
  specificationsHomecinemaVermogen: Maybe<Scalars['String']>
  specificationsMuurbeugelAantalgradendraaibaar: Maybe<Scalars['String']>
  specificationsMuurbeugelAantalgradenkantelbaar: Maybe<Scalars['String']>
  specificationsMuurbeugelBedieningviaapp: Maybe<Scalars['Int']>
  specificationsMuurbeugelGarantie: Maybe<Scalars['String']>
  specificationsMuurbeugelGeschiktvoorafmetingentv: Maybe<Scalars['String']>
  specificationsMuurbeugelInterfacebreedte: Maybe<Scalars['String']>
  specificationsMuurbeugelInterfacehoogte: Maybe<Scalars['String']>
  specificationsMuurbeugelIntroductiejaar: Maybe<Scalars['String']>
  specificationsMuurbeugelKleur: Maybe<Scalars['Int']>
  specificationsMuurbeugelMaxafstandmuur: Maybe<Scalars['String']>
  specificationsMuurbeugelMaximalegewichttv: Maybe<Scalars['String']>
  specificationsMuurbeugelMerkmuurbeugel: Maybe<Scalars['Int']>
  specificationsMuurbeugelMinafstandmuur: Maybe<Scalars['String']>
  specificationsMuurbeugelSoortmuurbeugel: Maybe<Scalars['Int']>
  specificationsMuurbeugelStandaardmeegeleverd: Maybe<Scalars['String']>
  specificationsMuurbeugelTypemuurbeugel: Maybe<Scalars['String']>
  specificationsMuurbeugelUittrekbaar: Maybe<Scalars['Int']>
  specificationsMuurbeugelVesaafmetingen: Maybe<Scalars['String']>
  specificationsNetwerkspelerAansluitingen: Maybe<Scalars['String']>
  specificationsNetwerkspelerAantalusb: Maybe<Scalars['String']>
  specificationsNetwerkspelerAchterspeakers: Maybe<Scalars['Int']>
  specificationsNetwerkspelerAfmetingen: Maybe<Scalars['String']>
  specificationsNetwerkspelerAfmetingensubwoofer: Maybe<Scalars['String']>
  specificationsNetwerkspelerBelastbaarheid: Maybe<Scalars['String']>
  specificationsNetwerkspelerFabriekscode: Maybe<Scalars['String']>
  specificationsNetwerkspelerGewicht: Maybe<Scalars['String']>
  specificationsNetwerkspelerGewichtsubwoofer: Maybe<Scalars['String']>
  specificationsNetwerkspelerIntroductiejaar: Maybe<Scalars['String']>
  specificationsNetwerkspelerKanalen: Maybe<Scalars['String']>
  specificationsNetwerkspelerKleur: Maybe<Scalars['Int']>
  specificationsNetwerkspelerMultiroom: Maybe<Scalars['Int']>
  specificationsNetwerkspelerRadio: Maybe<Scalars['Int']>
  specificationsNetwerkspelerSpeakeraansluiting: Maybe<Scalars['String']>
  specificationsNetwerkspelerSpeeltaf: Maybe<Scalars['String']>
  specificationsNetwerkspelerStandaardmeegeleverd: Maybe<Scalars['String']>
  specificationsNetwerkspelerStreaming: Maybe<Scalars['String']>
  specificationsNetwerkspelerStreamingdiensten: Maybe<Scalars['String']>
  specificationsNetwerkspelerStroomvoorziening: Maybe<Scalars['Int']>
  specificationsNetwerkspelerSubwoofer: Maybe<Scalars['Int']>
  specificationsNetwerkspelerSubwooferuitgang: Maybe<Scalars['Int']>
  specificationsNetwerkspelerTypeaudio: Maybe<Scalars['Int']>
  specificationsNetwerkspelerVermogen: Maybe<Scalars['String']>
  specificationsOverigeaudioAansluitingen: Maybe<Scalars['String']>
  specificationsOverigeaudioAantalhdmi: Maybe<Scalars['String']>
  specificationsOverigeaudioAantalspeakers: Maybe<Scalars['String']>
  specificationsOverigeaudioAantalusb: Maybe<Scalars['String']>
  specificationsOverigeaudioAfmetingen: Maybe<Scalars['String']>
  specificationsOverigeaudioAfmetingensubwoofer: Maybe<Scalars['String']>
  specificationsOverigeaudioFabriekscode: Maybe<Scalars['String']>
  specificationsOverigeaudioGewicht: Maybe<Scalars['String']>
  specificationsOverigeaudioGewichtsubwoofer: Maybe<Scalars['String']>
  specificationsOverigeaudioIntroductiejaar: Maybe<Scalars['String']>
  specificationsOverigeaudioKanalen: Maybe<Scalars['String']>
  specificationsOverigeaudioKleur: Maybe<Scalars['Int']>
  specificationsOverigeaudioMaximalefrequentie: Maybe<Scalars['String']>
  specificationsOverigeaudioMinimalefrequentie: Maybe<Scalars['String']>
  specificationsOverigeaudioRadio: Maybe<Scalars['String']>
  specificationsOverigeaudioStandaardmeegeleverd: Maybe<Scalars['String']>
  specificationsOverigeaudioStreaming: Maybe<Scalars['String']>
  specificationsOverigeaudioStroomvoorziening: Maybe<Scalars['Int']>
  specificationsOverigeaudioVermogen: Maybe<Scalars['String']>
  specificationsOverigeaudioWaterbestendig: Maybe<Scalars['Int']>
  specificationsPlafondbeugelsAantaldraai: Maybe<Scalars['String']>
  specificationsPlafondbeugelsBeeldformaat: Maybe<Scalars['String']>
  specificationsPlafondbeugelsDraaien: Maybe<Scalars['String']>
  specificationsPlafondbeugelsGarantie: Maybe<Scalars['String']>
  specificationsPlafondbeugelsGroottetv: Maybe<Scalars['String']>
  specificationsPlafondbeugelsHoogte: Maybe<Scalars['String']>
  specificationsPlafondbeugelsHoogteverstelling: Maybe<Scalars['Int']>
  specificationsPlafondbeugelsInterfacebreedte: Maybe<Scalars['String']>
  specificationsPlafondbeugelsInterfacehoogte: Maybe<Scalars['String']>
  specificationsPlafondbeugelsInterfaceoptioneel: Maybe<Scalars['Int']>
  specificationsPlafondbeugelsKabelinlegsysteem: Maybe<Scalars['String']>
  specificationsPlafondbeugelsKantelen: Maybe<Scalars['String']>
  specificationsPlafondbeugelsKleur: Maybe<Scalars['Int']>
  specificationsPlafondbeugelsLengtebuis: Maybe<Scalars['String']>
  specificationsPlafondbeugelsMaxgewicht: Maybe<Scalars['String']>
  specificationsPlafondbeugelsMontagehoek: Maybe<Scalars['String']>
  specificationsPlafondbeugelsProductlijn: Maybe<Scalars['Int']>
  specificationsPlafondbeugelsRoteren: Maybe<Scalars['Int']>
  specificationsPlafondbeugelsSchuineplafondoplossing: Maybe<Scalars['Int']>
  specificationsPlafondbeugelsUitschuifbaar: Maybe<Scalars['Int']>
  specificationsPlafondbeugelsVesamaximaal: Maybe<Scalars['String']>
  specificationsPlafondbeugelsVesaminimaal: Maybe<Scalars['String']>
  specificationsPlafondbeugelsVesanorm: Maybe<Scalars['String']>
  specificationsPlafondbeugelsZwenken: Maybe<Scalars['Int']>
  specificationsReceiverAansluitingen: Maybe<Scalars['String']>
  specificationsReceiverAantalspeakers: Maybe<Scalars['String']>
  specificationsReceiverAchterspeakers: Maybe<Scalars['Int']>
  specificationsReceiverAfmetingen: Maybe<Scalars['String']>
  specificationsReceiverAirplay2: Maybe<Scalars['Int']>
  specificationsReceiverArc: Maybe<Scalars['Int']>
  specificationsReceiverAux: Maybe<Scalars['Int']>
  specificationsReceiverBeeldondersteuning: Maybe<Scalars['String']>
  specificationsReceiverBluetooth: Maybe<Scalars['Int']>
  specificationsReceiverCoax: Maybe<Scalars['String']>
  specificationsReceiverComponent: Maybe<Scalars['Int']>
  specificationsReceiverComposiet: Maybe<Scalars['Int']>
  specificationsReceiverEthernet: Maybe<Scalars['Int']>
  specificationsReceiverFabriekscode: Maybe<Scalars['String']>
  specificationsReceiverGewicht: Maybe<Scalars['String']>
  specificationsReceiverHdmiin: Maybe<Scalars['String']>
  specificationsReceiverHdmiout: Maybe<Scalars['String']>
  specificationsReceiverImpendatie: Maybe<Scalars['String']>
  specificationsReceiverIntroductiejaar: Maybe<Scalars['String']>
  specificationsReceiverKanalen: Maybe<Scalars['String']>
  specificationsReceiverKleur: Maybe<Scalars['Int']>
  specificationsReceiverMinijack: Maybe<Scalars['Int']>
  specificationsReceiverMultiroom: Maybe<Scalars['Int']>
  specificationsReceiverOptisch: Maybe<Scalars['String']>
  specificationsReceiverPlatenspeler: Maybe<Scalars['Int']>
  specificationsReceiverRadio: Maybe<Scalars['String']>
  specificationsReceiverSpeeltaf: Maybe<Scalars['String']>
  specificationsReceiverSpotifyconnect: Maybe<Scalars['Int']>
  specificationsReceiverStreaming: Maybe<Scalars['String']>
  specificationsReceiverStroomvoorziening: Maybe<Scalars['Int']>
  specificationsReceiverSubwoofer: Maybe<Scalars['Int']>
  specificationsReceiverSubwooferuitgang: Maybe<Scalars['String']>
  specificationsReceiverSurroundsystemen: Maybe<Scalars['String']>
  specificationsReceiverTypeaudio: Maybe<Scalars['Int']>
  specificationsReceiverTypereceiver: Maybe<Scalars['Int']>
  specificationsReceiverUsb: Maybe<Scalars['Int']>
  specificationsReceiverVermogen: Maybe<Scalars['String']>
  specificationsReceiverWifi: Maybe<Scalars['Int']>
  specificationsSoundbarAantalspeakers: Maybe<Scalars['String']>
  specificationsSoundbarAfmetingen: Maybe<Scalars['String']>
  specificationsSoundbarAirplay2: Maybe<Scalars['Int']>
  specificationsSoundbarArc: Maybe<Scalars['Int']>
  specificationsSoundbarAux: Maybe<Scalars['Int']>
  specificationsSoundbarBeeldondersteuning: Maybe<Scalars['String']>
  specificationsSoundbarBluetooth: Maybe<Scalars['Int']>
  specificationsSoundbarComponent: Maybe<Scalars['Int']>
  specificationsSoundbarComposiet: Maybe<Scalars['Int']>
  specificationsSoundbarEthernet: Maybe<Scalars['Int']>
  specificationsSoundbarFabriekscode: Maybe<Scalars['String']>
  specificationsSoundbarGewicht: Maybe<Scalars['String']>
  specificationsSoundbarHdmiin: Maybe<Scalars['String']>
  specificationsSoundbarHdmiout: Maybe<Scalars['String']>
  specificationsSoundbarIntroductiejaar: Maybe<Scalars['String']>
  specificationsSoundbarKanalen: Maybe<Scalars['String']>
  specificationsSoundbarKleur: Maybe<Scalars['Int']>
  specificationsSoundbarMinijack: Maybe<Scalars['Int']>
  specificationsSoundbarMultiroom: Maybe<Scalars['Int']>
  specificationsSoundbarOptischcoax: Maybe<Scalars['String']>
  specificationsSoundbarSpeeltaf: Maybe<Scalars['String']>
  specificationsSoundbarSpotifyconnect: Maybe<Scalars['Int']>
  specificationsSoundbarStreaming: Maybe<Scalars['String']>
  specificationsSoundbarStroomvoorziening: Maybe<Scalars['Int']>
  specificationsSoundbarSubwoofer: Maybe<Scalars['Int']>
  specificationsSoundbarTypeaudio: Maybe<Scalars['Int']>
  specificationsSoundbarUsb: Maybe<Scalars['Int']>
  specificationsSoundbarVermogen: Maybe<Scalars['String']>
  specificationsSoundbarWifi: Maybe<Scalars['Int']>
  specificationsStereosetAansluitingen: Maybe<Scalars['String']>
  specificationsStereosetAantalspeakers: Maybe<Scalars['String']>
  specificationsStereosetAantalusb: Maybe<Scalars['String']>
  specificationsStereosetAfmetingen: Maybe<Scalars['String']>
  specificationsStereosetBelastbaarheid: Maybe<Scalars['String']>
  specificationsStereosetFabriekscode: Maybe<Scalars['String']>
  specificationsStereosetGewicht: Maybe<Scalars['String']>
  specificationsStereosetImpendatie: Maybe<Scalars['Int']>
  specificationsStereosetIntroductiejaar: Maybe<Scalars['String']>
  specificationsStereosetKanalen: Maybe<Scalars['String']>
  specificationsStereosetKleur: Maybe<Scalars['Int']>
  specificationsStereosetMaximalefrequentie: Maybe<Scalars['String']>
  specificationsStereosetMinimalefrequentie: Maybe<Scalars['String']>
  specificationsStereosetMultiroom: Maybe<Scalars['Int']>
  specificationsStereosetRadio: Maybe<Scalars['String']>
  specificationsStereosetSpeakeraansluiting: Maybe<Scalars['Int']>
  specificationsStereosetSpeeltaf: Maybe<Scalars['String']>
  specificationsStereosetStandaardmeegeleverd: Maybe<Scalars['String']>
  specificationsStereosetStreaming: Maybe<Scalars['String']>
  specificationsStereosetStroomvoorziening: Maybe<Scalars['Int']>
  specificationsStereosetSubwooferuitgang: Maybe<Scalars['Int']>
  specificationsStereosetTypeaudio: Maybe<Scalars['Int']>
  specificationsStereosetTypespeaker: Maybe<Scalars['Int']>
  specificationsStereosetVermogen: Maybe<Scalars['String']>
  specificationsSubwooferAansluitingen: Maybe<Scalars['String']>
  specificationsSubwooferAantalusb: Maybe<Scalars['String']>
  specificationsSubwooferAfmetingen: Maybe<Scalars['String']>
  specificationsSubwooferAfmetingensubwoofer: Maybe<Scalars['String']>
  specificationsSubwooferBelastbaarheid: Maybe<Scalars['String']>
  specificationsSubwooferFabriekscode: Maybe<Scalars['String']>
  specificationsSubwooferGewicht: Maybe<Scalars['String']>
  specificationsSubwooferGewichtsubwoofer: Maybe<Scalars['String']>
  specificationsSubwooferIntroductiejaar: Maybe<Scalars['String']>
  specificationsSubwooferKanalen: Maybe<Scalars['String']>
  specificationsSubwooferKleur: Maybe<Scalars['Int']>
  specificationsSubwooferMaximalefrequentie: Maybe<Scalars['String']>
  specificationsSubwooferMinimalefrequentie: Maybe<Scalars['String']>
  specificationsSubwooferMultiroom: Maybe<Scalars['Int']>
  specificationsSubwooferRadio: Maybe<Scalars['Int']>
  specificationsSubwooferSpeakeraansluiting: Maybe<Scalars['String']>
  specificationsSubwooferStandaardmeegeleverd: Maybe<Scalars['String']>
  specificationsSubwooferStreaming: Maybe<Scalars['String']>
  specificationsSubwooferStreamingdiensten: Maybe<Scalars['String']>
  specificationsSubwooferStroomvoorziening: Maybe<Scalars['Int']>
  specificationsSubwooferSubwooferuitgang: Maybe<Scalars['Int']>
  specificationsSubwooferTypeaudio: Maybe<Scalars['Int']>
  specificationsSubwooferTypespeaker: Maybe<Scalars['String']>
  specificationsSubwooferVermogen: Maybe<Scalars['String']>
  specificationsSubwooferWaterbestendig: Maybe<Scalars['Int']>
  specificationsTelevisieAfmetingenexclvoet: Maybe<Scalars['String']>
  specificationsTelevisieAfmetingeninclvoet: Maybe<Scalars['String']>
  specificationsTelevisieAirplay: Maybe<Scalars['Int']>
  specificationsTelevisieAmbilight: Maybe<Scalars['Int']>
  specificationsTelevisieBeeldformaat: Maybe<Scalars['Int']>
  specificationsTelevisieBeeldfrequentie: Maybe<Scalars['Int']>
  specificationsTelevisieBluetooth: Maybe<Scalars['Int']>
  specificationsTelevisieCigeschikt: Maybe<Scalars['String']>
  specificationsTelevisieComponent: Maybe<Scalars['Int']>
  specificationsTelevisieComposiet: Maybe<Scalars['Int']>
  specificationsTelevisieDigitaalcoaxaleaansluiting: Maybe<Scalars['Int']>
  specificationsTelevisieDigitaaloptischeaansluiting: Maybe<Scalars['Int']>
  specificationsTelevisieEnergieklasse: Maybe<Scalars['Int']>
  specificationsTelevisieFabriekscode: Maybe<Scalars['String']>
  specificationsTelevisieGewichtexclvoet: Maybe<Scalars['String']>
  specificationsTelevisieGewichtinclvoet: Maybe<Scalars['String']>
  specificationsTelevisieHdmi: Maybe<Scalars['String']>
  specificationsTelevisieHdr: Maybe<Scalars['Int']>
  specificationsTelevisieIntroductiejaar: Maybe<Scalars['String']>
  specificationsTelevisieKleur: Maybe<Scalars['Int']>
  specificationsTelevisieKoptelefoon: Maybe<Scalars['Int']>
  specificationsTelevisieMeegeleverdeaccessoires: Maybe<Scalars['String']>
  specificationsTelevisieMerk: Maybe<Scalars['Int']>
  specificationsTelevisieResolutie: Maybe<Scalars['Int']>
  specificationsTelevisieScart: Maybe<Scalars['Int']>
  specificationsTelevisieSmartplatform: Maybe<Scalars['Int']>
  specificationsTelevisieSmarttv: Maybe<Scalars['Int']>
  specificationsTelevisieSoorttv: Maybe<Scalars['String']>
  specificationsTelevisieSpeakersysteem: Maybe<Scalars['String']>
  specificationsTelevisieSpotifyconnect: Maybe<Scalars['Int']>
  specificationsTelevisieSpraakbesturing: Maybe<Scalars['Int']>
  specificationsTelevisieSubwoofer: Maybe<Scalars['Int']>
  specificationsTelevisieTuner: Maybe<Scalars['String']>
  specificationsTelevisieTypehdr: Maybe<Scalars['String']>
  specificationsTelevisieUsb: Maybe<Scalars['String']>
  specificationsTelevisieVermogen: Maybe<Scalars['String']>
  specificationsTelevisieWifi: Maybe<Scalars['Int']>
  specificationsTvmeubelAfmetingen: Maybe<Scalars['String']>
  specificationsTvmeubelGewicht: Maybe<Scalars['String']>
  specificationsTvmeubelKleur: Maybe<Scalars['Int']>
  specificationsTvmeubelMateriaal: Maybe<Scalars['String']>
  specificationsTvmeubelTypeproduct: Maybe<Scalars['Int']>
  specificationsVersterkerAansluitingen: Maybe<Scalars['String']>
  specificationsVersterkerAantalhdmi: Maybe<Scalars['String']>
  specificationsVersterkerAantalusb: Maybe<Scalars['String']>
  specificationsVersterkerAchterspeakers: Maybe<Scalars['Int']>
  specificationsVersterkerAfmetingen: Maybe<Scalars['String']>
  specificationsVersterkerAfmetingensubwoofer: Maybe<Scalars['String']>
  specificationsVersterkerBelastbaarheid: Maybe<Scalars['String']>
  specificationsVersterkerFabriekscode: Maybe<Scalars['String']>
  specificationsVersterkerGewicht: Maybe<Scalars['String']>
  specificationsVersterkerGewichtsubwoofer: Maybe<Scalars['String']>
  specificationsVersterkerImpendatie: Maybe<Scalars['String']>
  specificationsVersterkerIntroductiejaar: Maybe<Scalars['String']>
  specificationsVersterkerKanalen: Maybe<Scalars['String']>
  specificationsVersterkerKleur: Maybe<Scalars['Int']>
  specificationsVersterkerMultiroom: Maybe<Scalars['Int']>
  specificationsVersterkerRadio: Maybe<Scalars['String']>
  specificationsVersterkerSpeakeraansluiting: Maybe<Scalars['String']>
  specificationsVersterkerSpeeltaf: Maybe<Scalars['String']>
  specificationsVersterkerStandaardmeegeleverd: Maybe<Scalars['String']>
  specificationsVersterkerStreaming: Maybe<Scalars['String']>
  specificationsVersterkerStreamingdiensten: Maybe<Scalars['String']>
  specificationsVersterkerStroomvoorziening: Maybe<Scalars['Int']>
  specificationsVersterkerSubwoofer: Maybe<Scalars['String']>
  specificationsVersterkerSubwooferuitgang: Maybe<Scalars['Int']>
  specificationsVersterkerTypeaudio: Maybe<Scalars['Int']>
  specificationsVersterkerVermogen: Maybe<Scalars['String']>
  specificationsVersterkerWaterbestendig: Maybe<Scalars['Int']>
  specificationsVloerstandaardAfmetingen: Maybe<Scalars['String']>
  specificationsVloerstandaardKleur: Maybe<Scalars['Int']>
  specificationsVloerstandaardProducttype: Maybe<Scalars['Int']>
  specificationsVoedingDraadloosopladen: Maybe<Scalars['Int']>
  specificationsVoedingKabellengte: Maybe<Scalars['String']>
  specificationsVoedingKleur: Maybe<Scalars['Int']>
  specificationsVoedingProducttype: Maybe<Scalars['Int']>
  specificationsWifispeakerAansluitingen: Maybe<Scalars['String']>
  specificationsWifispeakerAantalspeakers: Maybe<Scalars['String']>
  specificationsWifispeakerAantalusb: Maybe<Scalars['String']>
  specificationsWifispeakerAchterspeakers: Maybe<Scalars['Int']>
  specificationsWifispeakerAfmetingen: Maybe<Scalars['String']>
  specificationsWifispeakerAfmetingensubwoofer: Maybe<Scalars['String']>
  specificationsWifispeakerBelastbaarheid: Maybe<Scalars['String']>
  specificationsWifispeakerFabriekscode: Maybe<Scalars['String']>
  specificationsWifispeakerGewicht: Maybe<Scalars['String']>
  specificationsWifispeakerGewichtsubwoofer: Maybe<Scalars['String']>
  specificationsWifispeakerImpendatie: Maybe<Scalars['String']>
  specificationsWifispeakerIntroductiejaar: Maybe<Scalars['String']>
  specificationsWifispeakerKanalen: Maybe<Scalars['String']>
  specificationsWifispeakerKleur: Maybe<Scalars['Int']>
  specificationsWifispeakerMultiroom: Maybe<Scalars['Int']>
  specificationsWifispeakerRadio: Maybe<Scalars['String']>
  specificationsWifispeakerSpeeltaf: Maybe<Scalars['String']>
  specificationsWifispeakerStandaardmeegeleverd: Maybe<Scalars['String']>
  specificationsWifispeakerStreaming: Maybe<Scalars['String']>
  specificationsWifispeakerStreamingdiensten: Maybe<Scalars['String']>
  specificationsWifispeakerStroomvoorziening: Maybe<Scalars['String']>
  specificationsWifispeakerSubwoofer: Maybe<Scalars['String']>
  specificationsWifispeakerSubwooferuitgang: Maybe<Scalars['String']>
  specificationsWifispeakerTypeaudio: Maybe<Scalars['Int']>
  specificationsWifispeakerTypespeaker: Maybe<Scalars['Int']>
  specificationsWifispeakerVermogen: Maybe<Scalars['String']>
  specificationsWifispeakerWaterbestendig: Maybe<Scalars['Int']>
  /** Stock status of the product */
  stockStatus: Maybe<ProductStockStatus>
  strapBags: Maybe<Scalars['String']>
  styleBags: Maybe<Scalars['String']>
  styleBottom: Maybe<Scalars['String']>
  styleGeneral: Maybe<Scalars['String']>
  /** The file name of a swatch image */
  swatchImage: Maybe<Scalars['String']>
  tempcombipakketten: Maybe<Scalars['String']>
  /** The relative path to the product's thumbnail image. */
  thumbnail: Maybe<ProductImage>
  /**
   * The price when tier pricing is in effect and the items purchased threshold has been reached.
   * @deprecated Use price_tiers for product tier price information.
   */
  tierPrice: Maybe<Scalars['Float']>
  /**
   * An array of ProductTierPrices objects.
   * @deprecated Use price_tiers for product tier price information.
   */
  tierPrices: Maybe<Array<Maybe<ProductTierPrices>>>
  top10product: Maybe<Scalars['Int']>
  tot21u: Maybe<Scalars['Int']>
  tweakers: Maybe<Scalars['Int']>
  tweakerstekstad: Maybe<Scalars['String']>
  tweakwisecrossselltemplateid: Maybe<Scalars['String']>
  /**
   * One of simple, virtual, bundle, downloadable, grouped, or configurable.
   * @deprecated Use __typename instead.
   */
  typeId: Maybe<Scalars['String']>
  /** Timestamp indicating when the product was updated. */
  updatedAt: Maybe<Scalars['String']>
  /** Upsell Products */
  upsellProducts: Maybe<Array<Maybe<ProductInterface>>>
  /** The part of the URL that identifies the product */
  urlKey: Scalars['String']
  /** @deprecated Use product's `canonical_url` or url rewrites instead */
  urlPath: Maybe<Scalars['String']>
  /** URL rewrites list */
  urlRewrites: Maybe<Array<Maybe<UrlRewrite>>>
  /** The part of the product URL that is appended after the url key */
  urlSuffix: Maybe<Scalars['String']>
  variant: Maybe<Scalars['Int']>
  variantValue: Maybe<Scalars['String']>
  venditguid: Maybe<Scalars['String']>
  venditpid: Maybe<Scalars['String']>
  voorraadamsterdam: Maybe<Scalars['Int']>
  voorraadarnhem: Maybe<Scalars['Int']>
  voorraadbreda: Maybe<Scalars['Int']>
  voorraaddoetinchem: Maybe<Scalars['Int']>
  voorraadeindhoven: Maybe<Scalars['Int']>
  voorraadgroningen: Maybe<Scalars['Int']>
  voorraadnaarden: Maybe<Scalars['Int']>
  voorraadnijmegen: Maybe<Scalars['Int']>
  voorraadonline: Maybe<Scalars['Int']>
  voorraadutrecht: Maybe<Scalars['Int']>
  voorraadzoeterwoude: Maybe<Scalars['Int']>
  /**
   * An array of websites in which the product is available.
   * @deprecated The field should not be used on the storefront.
   */
  websites: Maybe<Array<Maybe<Website>>>
  /** The weight of the item, in units defined by the store. */
  weight: Maybe<Scalars['Float']>
  zondaglevering: Maybe<Scalars['Int']>
  pimcoreProductData: Maybe<PimcoreProduct>
}

export interface BundleProductCartItemInput {
  bundle_options: Array<Maybe<BundleOptionInput>>
  customizable_options?: Maybe<Array<Maybe<CustomizableOptionInput>>>
  data: CartItemInput
}

export interface Cart {
  __typename?: 'Cart'
  /**
   * An array of coupons that have been applied to the cart
   * @deprecated Use applied_coupons instead
   */
  appliedCoupon: Maybe<AppliedCoupon>
  /** An array of `AppliedCoupon` objects. Each object contains the `code` text attribute, which specifies the coupon code */
  appliedCoupons: Maybe<Array<Maybe<AppliedCoupon>>>
  /** Available payment methods */
  availablePaymentMethods: Maybe<Array<Maybe<AvailablePaymentMethod>>>
  billingAddress: Maybe<BillingCartAddress>
  email: Maybe<Scalars['String']>
  /** The ID of the cart. */
  id: Scalars['ID']
  isVirtual: Scalars['Boolean']
  itemErrors: Array<Maybe<CartItemError>>
  items: Array<Maybe<CartItemInterface>>
  prices: Maybe<CartPrices>
  selectedPaymentMethod: Maybe<SelectedPaymentMethod>
  shippingAddresses: Array<Maybe<ShippingCartAddress>>
  totalQuantity: Scalars['Float']
  postNLOrder: Maybe<PostNlOrder>
}

export interface CartAddressCountry {
  __typename?: 'CartAddressCountry'
  code: Scalars['String']
  label: Scalars['String']
}

export interface CartAddressInput {
  city: Scalars['String']
  company?: Maybe<Scalars['String']>
  country_code: Scalars['String']
  firstname: Scalars['String']
  lastname: Scalars['String']
  postcode?: Maybe<Scalars['String']>
  region?: Maybe<Scalars['String']>
  region_id?: Maybe<Scalars['Int']>
  /** Determines whether to save the address in the customer's address book. The default value is true */
  save_in_address_book?: Maybe<Scalars['Boolean']>
  street: Array<Maybe<Scalars['String']>>
  telephone: Scalars['String']
  vat_number?: Maybe<Scalars['String']>
}

export interface CartAddressInterface {
  city: Scalars['String']
  company: Maybe<Scalars['String']>
  country: CartAddressCountry
  firstname: Scalars['String']
  lastname: Scalars['String']
  postcode: Maybe<Scalars['String']>
  region: Maybe<CartAddressRegion>
  street: Array<Maybe<Scalars['String']>>
  telephone: Scalars['String']
  vatNumber: Maybe<Scalars['String']>
}

export interface CartAddressRegion {
  __typename?: 'CartAddressRegion'
  code: Maybe<Scalars['String']>
  label: Maybe<Scalars['String']>
  regionId: Maybe<Scalars['Int']>
}

export interface CartDiscount {
  __typename?: 'CartDiscount'
  amount: Money
  label: Array<Maybe<Scalars['String']>>
}

export interface CartItemError {
  __typename?: 'CartItemError'
  code: CartItemErrorCode
  id: Scalars['String']
  message: Scalars['String']
}

export enum CartItemErrorCode {
  OUT_OF_STOCK = 'OUT_OF_STOCK',
  NO_SUCH_PRODUCT = 'NO_SUCH_PRODUCT',
  UNKNOWN_ERROR = 'UNKNOWN_ERROR',
}

export interface CartItemInput {
  quantity: Scalars['Float']
  sku: Scalars['String']
}

export interface CartItemInterface {
  id: Scalars['String']
  prices: Maybe<CartItemPrices>
  product: ProductInterface
  quantity: Scalars['Float']
}

export interface CartItemPrices {
  __typename?: 'CartItemPrices'
  /** An array of discounts to be applied to the cart item */
  discounts: Maybe<Array<Maybe<Discount>>>
  price: Money
  rowTotal: Money
  rowTotalIncludingTax: Money
  /** The total of all discounts applied to the item */
  totalItemDiscount: Maybe<Money>
}

/** Deprecated: `cart_items` field of `ShippingCartAddress` returns now  `CartItemInterface` instead of `CartItemQuantity` */
export interface CartItemQuantity {
  __typename?: 'CartItemQuantity'
  /** @deprecated `cart_items` field of `ShippingCartAddress` returns now `CartItemInterface` instead of `CartItemQuantity` */
  cartItemId: Scalars['Int']
  /** @deprecated `cart_items` field of `ShippingCartAddress` returns now `CartItemInterface` instead of `CartItemQuantity` */
  quantity: Scalars['Float']
}

export interface CartItemSelectedOptionValuePrice {
  __typename?: 'CartItemSelectedOptionValuePrice'
  type: PriceTypeEnum
  units: Scalars['String']
  value: Scalars['Float']
}

export interface CartItemUpdateInput {
  cart_item_id: Scalars['Int']
  customizable_options?: Maybe<Array<Maybe<CustomizableOptionInput>>>
  quantity?: Maybe<Scalars['Float']>
}

export interface CartPrices {
  __typename?: 'CartPrices'
  appliedTaxes: Maybe<Array<Maybe<CartTaxItem>>>
  /** @deprecated Use discounts instead  */
  discount: Maybe<CartDiscount>
  /** An array of applied discounts */
  discounts: Maybe<Array<Maybe<Discount>>>
  grandTotal: Maybe<Money>
  subtotalExcludingTax: Maybe<Money>
  subtotalIncludingTax: Maybe<Money>
  subtotalWithDiscountExcludingTax: Maybe<Money>
}

export interface CartTaxItem {
  __typename?: 'CartTaxItem'
  amount: Money
  label: Scalars['String']
}

export interface Category extends Document, Linkable {
  __typename?: 'Category'
  categoryId: Maybe<Scalars['String']>
  body: Maybe<Array<CategoryBody>>
  meta: Meta
  linkType: Maybe<Scalars['String']>
}

export type CategoryBody =
  | CategoryBodyCategoryHeader
  | CategoryBodySeoText
  | CategoryBodyProductList
  | CategoryBodySlimBanner
  | CategoryBodyQuickFilters

export interface CategoryBodyCategoryHeader {
  __typename?: 'CategoryBodyCategoryHeader'
  type: Maybe<Scalars['String']>
  label: Maybe<Scalars['String']>
  primary: Maybe<CategoryBodyCategoryHeaderPrimary>
}

export interface CategoryBodyCategoryHeaderPrimary {
  __typename?: 'CategoryBodyCategoryHeaderPrimary'
  title: Maybe<Scalars['Json']>
  text: Maybe<Scalars['Json']>
}

export interface CategoryBodyProductList {
  __typename?: 'CategoryBodyProductList'
  type: Maybe<Scalars['String']>
  label: Maybe<Scalars['String']>
  fields: Maybe<Array<CategoryBodyProductListFields>>
}

export interface CategoryBodyProductListFields {
  __typename?: 'CategoryBodyProductListFields'
  image: Maybe<PrismicImageType>
  position: Maybe<Scalars['Float']>
  link: Maybe<PrismicHyperlink>
}

export interface CategoryBodyQuickFilters {
  __typename?: 'CategoryBodyQuickFilters'
  type: Maybe<Scalars['String']>
  label: Maybe<Scalars['String']>
  fields: Maybe<Array<CategoryBodyQuickFiltersFields>>
}

export interface CategoryBodyQuickFiltersFields {
  __typename?: 'CategoryBodyQuickFiltersFields'
  filterLink: Maybe<PrismicHyperlink>
  filterTitle: Maybe<Scalars['String']>
}

export interface CategoryBodySeoText {
  __typename?: 'CategoryBodySeoText'
  type: Maybe<Scalars['String']>
  label: Maybe<Scalars['String']>
  primary: Maybe<CategoryBodySeoTextPrimary>
}

export interface CategoryBodySeoTextPrimary {
  __typename?: 'CategoryBodySeoTextPrimary'
  text: Maybe<Scalars['Json']>
}

export interface CategoryBodySlimBanner {
  __typename?: 'CategoryBodySlimBanner'
  type: Maybe<Scalars['String']>
  label: Maybe<Scalars['String']>
  primary: Maybe<CategoryBodySlimBannerPrimary>
}

export interface CategoryBodySlimBannerPrimary {
  __typename?: 'CategoryBodySlimBannerPrimary'
  background: Maybe<Scalars['Json']>
  popout: Maybe<Scalars['Json']>
  leftContent: Maybe<Scalars['Json']>
  rightContent: Maybe<Scalars['Json']>
  buttonLink: Maybe<PrismicHyperlink>
  buttonText: Maybe<Scalars['String']>
}

/** A connection to a list of items. */
export interface CategoryConnectionConnection {
  __typename?: 'CategoryConnectionConnection'
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  /** A list of edges. */
  edges: Maybe<Array<Maybe<CategoryConnectionEdge>>>
  totalCount: Scalars['Long']
}

/** An edge in a connection. */
export interface CategoryConnectionEdge {
  __typename?: 'CategoryConnectionEdge'
  /** The item at the end of the edge. */
  node: Category
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
}

/**
 * CategoryFilterInput defines the filters to be used in the search. A filter
 * contains at least one attribute, a comparison operator, and the value that is
 * being searched for.
 */
export interface CategoryFilterInput {
  /** Filter by category ID that uniquely identifies the category. */
  ids?: Maybe<FilterEqualTypeInput>
  /** Filter by the display name of the category. */
  name?: Maybe<FilterMatchTypeInput>
  /** Filter by the part of the URL that identifies the category. */
  url_key?: Maybe<FilterEqualTypeInput>
  /** Filter by the URL path for the category. */
  url_path?: Maybe<FilterEqualTypeInput>
}

/** CategoryInterface contains the full set of attributes that can be returned in a category search. */
export interface CategoryInterface {
  availableSortBy: Maybe<Array<Maybe<Scalars['String']>>>
  /** Breadcrumbs, parent categories info. */
  breadcrumbs: Maybe<Array<Maybe<Breadcrumb>>>
  /**
   * Relative canonical URL. This value is returned only if the system setting 'Use
   * Canonical Link Meta Tag For Categories' is enabled
   */
  canonicalUrl: Maybe<Scalars['String']>
  childrenCount: Maybe<Scalars['String']>
  /** Category CMS Block. */
  cmsBlock: Maybe<CmsBlock>
  /** Timestamp indicating when the category was created. */
  createdAt: Maybe<Scalars['String']>
  customLayoutUpdateFile: Maybe<Scalars['String']>
  /** The attribute to use for sorting. */
  defaultSortBy: Maybe<Scalars['String']>
  /** An optional description of the category. */
  description: Maybe<Scalars['String']>
  displayMode: Maybe<Scalars['String']>
  filterPriceRange: Maybe<Scalars['Float']>
  /** An ID that uniquely identifies the category. */
  id: Maybe<Scalars['Int']>
  image: Maybe<Scalars['String']>
  includeInMenu: Maybe<Scalars['Int']>
  isAnchor: Maybe<Scalars['Int']>
  landingPage: Maybe<Scalars['Int']>
  /** Indicates the depth of the category within the tree. */
  level: Maybe<Scalars['Int']>
  metaDescription: Maybe<Scalars['String']>
  metaKeywords: Maybe<Scalars['String']>
  metaTitle: Maybe<Scalars['String']>
  /** The display name of the category. */
  name: Maybe<Scalars['String']>
  /** Category Path. */
  path: Maybe<Scalars['String']>
  /** Category path in store. */
  pathInStore: Maybe<Scalars['String']>
  pimcoreId: Maybe<Scalars['Int']>
  /** The position of the category relative to other categories at the same level in tree. */
  position: Maybe<Scalars['Int']>
  /**
   * The number of products in the category that are marked as visible. By default,
   * in complex products, parent products are visible, but their child products are not.
   */
  productCount: Maybe<Scalars['Int']>
  /** The list of products assigned to the category. */
  products: Maybe<CategoryProducts>
  /** Timestamp indicating when the category was updated. */
  updatedAt: Maybe<Scalars['String']>
  /** The url key assigned to the category. */
  urlKey: Maybe<Scalars['String']>
  /** The url path assigned to the category. */
  urlPath: Maybe<Scalars['String']>
  /** The part of the category URL that is appended after the url key */
  urlSuffix: Maybe<Scalars['String']>
  pimcoreCategoryData: Maybe<PimcoreCategory>
}

/** CategoryInterface contains the full set of attributes that can be returned in a category search. */
export interface CategoryInterfaceProductsArgs {
  pageSize?: Maybe<Scalars['Int']>
  currentPage?: Maybe<Scalars['Int']>
  sort?: Maybe<ProductAttributeSortInput>
}

/** The category products object returned in the Category query. */
export interface CategoryProducts {
  __typename?: 'CategoryProducts'
  /** An array of products that are assigned to the category. */
  items: Maybe<Array<Maybe<ProductInterface>>>
  /** An object that includes the page_info and currentPage values specified in the query. */
  pageInfo: Maybe<SearchResultPageInfo>
  /**
   * The number of products in the category that are marked as visible. By default,
   * in complex products, parent products are visible, but their child products are not.
   */
  totalCount: Maybe<Scalars['Int']>
}

/** A collection of CategoryTree objects and pagination information. */
export interface CategoryResult {
  __typename?: 'CategoryResult'
  /** A list of categories that match the filter criteria. */
  items: Maybe<Array<Maybe<CategoryTree>>>
  /** An object that includes the page_info and currentPage values specified in the query. */
  pageInfo: Maybe<SearchResultPageInfo>
  /** The total number of categories that match the criteria. */
  totalCount: Maybe<Scalars['Int']>
}

/** Category Tree implementation. */
export interface CategoryTree extends CategoryInterface {
  __typename?: 'CategoryTree'
  availableSortBy: Maybe<Array<Maybe<Scalars['String']>>>
  /** Breadcrumbs, parent categories info. */
  breadcrumbs: Maybe<Array<Maybe<Breadcrumb>>>
  /**
   * Relative canonical URL. This value is returned only if the system setting 'Use
   * Canonical Link Meta Tag For Categories' is enabled
   */
  canonicalUrl: Maybe<Scalars['String']>
  /** Child categories tree. */
  children: Maybe<Array<Maybe<CategoryTree>>>
  childrenCount: Maybe<Scalars['String']>
  /** Category CMS Block. */
  cmsBlock: Maybe<CmsBlock>
  /** Timestamp indicating when the category was created. */
  createdAt: Maybe<Scalars['String']>
  customLayoutUpdateFile: Maybe<Scalars['String']>
  /** The attribute to use for sorting. */
  defaultSortBy: Maybe<Scalars['String']>
  /** An optional description of the category. */
  description: Maybe<Scalars['String']>
  displayMode: Maybe<Scalars['String']>
  filterPriceRange: Maybe<Scalars['Float']>
  id: Scalars['Int']
  image: Maybe<Scalars['String']>
  includeInMenu: Maybe<Scalars['Int']>
  isAnchor: Maybe<Scalars['Int']>
  landingPage: Maybe<Scalars['Int']>
  /** Indicates the depth of the category within the tree. */
  level: Maybe<Scalars['Int']>
  metaDescription: Maybe<Scalars['String']>
  metaKeywords: Maybe<Scalars['String']>
  metaTitle: Maybe<Scalars['String']>
  name: Scalars['String']
  /** Category Path. */
  path: Maybe<Scalars['String']>
  /** Category path in store. */
  pathInStore: Maybe<Scalars['String']>
  pimcoreId: Maybe<Scalars['Int']>
  /** The position of the category relative to other categories at the same level in tree. */
  position: Maybe<Scalars['Int']>
  /**
   * The number of products in the category that are marked as visible. By default,
   * in complex products, parent products are visible, but their child products are not.
   */
  productCount: Maybe<Scalars['Int']>
  /** The list of products assigned to the category. */
  products: Maybe<CategoryProducts>
  /** Timestamp indicating when the category was updated. */
  updatedAt: Maybe<Scalars['String']>
  urlKey: Scalars['String']
  /** The url path assigned to the category. */
  urlPath: Maybe<Scalars['String']>
  /** The part of the category URL that is appended after the url key */
  urlSuffix: Maybe<Scalars['String']>
  pimcoreCategoryData: Maybe<PimcoreCategory>
}

/** Category Tree implementation. */
export interface CategoryTreeProductsArgs {
  pageSize?: Maybe<Scalars['Int']>
  currentPage?: Maybe<Scalars['Int']>
  sort?: Maybe<ProductAttributeSortInput>
}

/** Defines all Checkout Agreement information */
export interface CheckoutAgreement {
  __typename?: 'CheckoutAgreement'
  /** Checkout Agreement identifier */
  agreementId: Scalars['Int']
  /** Checkout Agreement checkbox text */
  checkboxText: Scalars['String']
  /** Checkout Agreement content */
  content: Scalars['String']
  /** Checkout Agreement content height */
  contentHeight: Maybe<Scalars['String']>
  /** Is Checkout Agreement content in HTML format */
  isHtml: Scalars['Boolean']
  mode: CheckoutAgreementMode
  /** Checkout Agreement name */
  name: Scalars['String']
}

export enum CheckoutAgreementMode {
  AUTO = 'AUTO',
  MANUAL = 'MANUAL',
}

/** An error encountered while adding an item the the cart. */
export interface CheckoutUserInputError {
  __typename?: 'CheckoutUserInputError'
  /** Checkout-specific error code */
  code: CheckoutUserInputErrorCodes
  /** Localized error message */
  message: Scalars['String']
  /**
   * Path to the input field that caused an error. See the GraphQL specification
   * about path errors for details: http://spec.graphql.org/draft/#sec-Errors
   */
  path: Array<Maybe<Scalars['String']>>
}

export enum CheckoutUserInputErrorCodes {
  REORDER_NOT_AVAILABLE = 'REORDER_NOT_AVAILABLE',
  PRODUCT_NOT_FOUND = 'PRODUCT_NOT_FOUND',
  NOT_SALABLE = 'NOT_SALABLE',
  INSUFFICIENT_STOCK = 'INSUFFICIENT_STOCK',
  UNDEFINED = 'UNDEFINED',
}

/** CMS block defines all CMS block information */
export interface CmsBlock {
  __typename?: 'CmsBlock'
  /** CMS block content */
  content: Maybe<Scalars['String']>
  /** CMS block identifier */
  identifier: Maybe<Scalars['String']>
  /** CMS block title */
  title: Maybe<Scalars['String']>
}

/** CMS blocks information */
export interface CmsBlocks {
  __typename?: 'CmsBlocks'
  /** An array of CMS blocks */
  items: Maybe<Array<Maybe<CmsBlock>>>
}

/** CMS page defines all CMS page information */
export interface CmsPage {
  __typename?: 'CmsPage'
  /** CMS page content */
  content: Maybe<Scalars['String']>
  /** CMS page content heading */
  contentHeading: Maybe<Scalars['String']>
  /** Identifier of the CMS page */
  identifier: Maybe<Scalars['String']>
  /** CMS page meta description */
  metaDescription: Maybe<Scalars['String']>
  /** CMS page meta keywords */
  metaKeywords: Maybe<Scalars['String']>
  /** CMS page meta title */
  metaTitle: Maybe<Scalars['String']>
  /** CMS page content heading */
  pageLayout: Maybe<Scalars['String']>
  /** CMS page title */
  title: Maybe<Scalars['String']>
  /** URL key of CMS page */
  urlKey: Maybe<Scalars['String']>
}

export interface ColorSwatch {
  __typename?: 'ColorSwatch'
  type: Scalars['Int']
  value: Scalars['String']
}

export interface ColorSwatchData extends SwatchDataInterface {
  __typename?: 'ColorSwatchData'
  /** Value of swatch item (HEX color code, image link or textual value) */
  value: Maybe<Scalars['String']>
}

export interface Comment {
  __typename?: 'Comment'
  /** Created at. */
  createdAt: Maybe<Scalars['String']>
  /** Customer id. */
  customerId: Maybe<Scalars['Int']>
  /** Email. */
  email: Maybe<Scalars['String']>
  /** Comment id. */
  id: Maybe<Scalars['Int']>
  /** Message. */
  message: Maybe<Scalars['String']>
  /** Nickname. */
  nickname: Maybe<Scalars['String']>
  /** Review id. */
  reviewId: Maybe<Scalars['Int']>
  /** Session id. */
  sessionId: Maybe<Scalars['String']>
  /** Status. */
  status: Maybe<Scalars['Int']>
  /** Store id. */
  storeId: Maybe<Scalars['Int']>
  /** Updated at. */
  updatedAt: Maybe<Scalars['String']>
}

export interface ComplexTextValue {
  __typename?: 'ComplexTextValue'
  /** HTML format */
  html: Scalars['String']
}

/**
 * ConfigurableAttributeOption contains the value_index (and other related
 * information) assigned to a configurable product option
 */
export interface ConfigurableAttributeOption {
  __typename?: 'ConfigurableAttributeOption'
  /** The ID assigned to the attribute */
  code: Maybe<Scalars['String']>
  /** A string that describes the configurable attribute option */
  label: Maybe<Scalars['String']>
  /** A unique index number assigned to the configurable product option */
  valueIndex: Maybe<Scalars['Int']>
}

export interface ConfigurableCartItem extends CartItemInterface {
  __typename?: 'ConfigurableCartItem'
  configurableOptions: Array<Maybe<SelectedConfigurableOption>>
  customizableOptions: Array<Maybe<SelectedCustomizableOption>>
  id: Scalars['String']
  prices: Maybe<CartItemPrices>
  product: ProductInterface
  quantity: Scalars['Float']
}

/** ConfigurableProduct defines basic features of a configurable product and its simple product variants */
export interface ConfigurableProduct
  extends ProductInterface,
    PhysicalProductInterface,
    CustomizableProductInterface {
  __typename?: 'ConfigurableProduct'
  activity: Maybe<Scalars['String']>
  allowcoupon: Maybe<Scalars['Int']>
  allowingenico: Maybe<Scalars['Int']>
  allowpostnllabel: Maybe<Scalars['Int']>
  allowreview: Maybe<Scalars['Int']>
  alternatiefmemo: Maybe<Scalars['String']>
  /** The attribute set assigned to the product. */
  attributeSetId: Maybe<Scalars['Int']>
  /**
   * Relative canonical URL. This value is returned only if the system setting 'Use
   * Canonical Link Meta Tag For Products' is enabled
   */
  canonicalUrl: Maybe<Scalars['String']>
  /** The categories assigned to a product. */
  categories: Maybe<Array<Maybe<CategoryInterface>>>
  categoryGear: Maybe<Scalars['String']>
  climate: Maybe<Scalars['String']>
  collar: Maybe<Scalars['String']>
  color: Maybe<Scalars['Int']>
  /** An array of linked simple product items */
  configurableOptions: Maybe<Array<Maybe<ConfigurableProductOptions>>>
  cons: Maybe<Scalars['String']>
  /** The product's country of origin. */
  countryOfManufacture: Maybe<Scalars['String']>
  /** Timestamp indicating when the product was created. */
  createdAt: Maybe<Scalars['String']>
  /** Crosssell Products */
  crosssellProducts: Maybe<Array<Maybe<ProductInterface>>>
  /** Detailed information about the product. The value can include simple HTML tags. */
  description: Maybe<ComplexTextValue>
  doorverkooppremie: Maybe<Scalars['String']>
  ean: Maybe<Scalars['String']>
  ecoCollection: Maybe<Scalars['Int']>
  enabled: Maybe<Scalars['Int']>
  erinRecommends: Maybe<Scalars['Int']>
  factuurinformatie: Maybe<Scalars['String']>
  featuresBags: Maybe<Scalars['String']>
  fixedprice: Maybe<Scalars['Int']>
  fixeduntil: Maybe<Scalars['String']>
  gebruikbundelproductenprijs: Maybe<Scalars['Int']>
  gender: Maybe<Scalars['String']>
  /** Indicates whether a gift message is available. */
  giftMessageAvailable: Maybe<Scalars['String']>
  google: Maybe<Scalars['Int']>
  /** The ID number assigned to the product. */
  id: Scalars['Int']
  /** The relative path to the main image on the product page. */
  image: Maybe<ProductImage>
  inkoopprijs: Maybe<Scalars['String']>
  isBuitenkansje: Maybe<Scalars['Int']>
  isInStock: Maybe<Scalars['Int']>
  keepproductbuttons: Maybe<Scalars['Int']>
  kenmerken: Maybe<Scalars['String']>
  kieskeurig: Maybe<Scalars['Int']>
  kieskeurigbe: Maybe<Scalars['Int']>
  kieskeurigtekstad: Maybe<Scalars['String']>
  korteomschrijving: Maybe<Scalars['String']>
  korteomschrijving2: Maybe<Scalars['String']>
  langeomschrijving: Maybe<Scalars['String']>
  /** A number representing the product's manufacturer. */
  manufacturer: Maybe<Scalars['Int']>
  material: Maybe<Scalars['String']>
  maxprijsomnia: Maybe<Scalars['String']>
  /** An array of Media Gallery objects. */
  mediaGallery: Maybe<Array<Maybe<MediaGalleryInterface>>>
  /**
   * An array of MediaGalleryEntry objects.
   * @deprecated Use product's `media_gallery` instead
   */
  mediaGalleryEntries: Maybe<Array<Maybe<MediaGalleryEntry>>>
  merk: Maybe<Scalars['Int']>
  /** A brief overview of the product for search results listings, maximum 255 characters. */
  metaDescription: Maybe<Scalars['String']>
  /** A comma-separated list of keywords that are visible only to search engines. */
  metaKeyword: Maybe<Scalars['String']>
  /** A string that is displayed in the title bar and tab of the browser and in search results lists. */
  metaTitle: Maybe<Scalars['String']>
  modeltype: Maybe<Scalars['String']>
  /** The product name. Customers use this name to identify the product. */
  name: Scalars['String']
  new: Maybe<Scalars['Int']>
  /** The beginning date for new product listings, and determines if the product is featured as a new product. */
  newFromDate: Maybe<Scalars['String']>
  /** The end date for new product listings. */
  newToDate: Maybe<Scalars['String']>
  omnia: Maybe<Scalars['Int']>
  /** Product stock only x left count */
  onlyXLeftInStock: Maybe<Scalars['Float']>
  opmerking1: Maybe<Scalars['String']>
  opmerking2: Maybe<Scalars['String']>
  /** An array of options for a customizable product. */
  options: Maybe<Array<Maybe<CustomizableOptionInterface>>>
  /** If the product has multiple options, determines where they appear on the product page. */
  optionsContainer: Maybe<Scalars['String']>
  pattern: Maybe<Scalars['String']>
  percentagekortingopprijsvanbundelproducten: Maybe<Scalars['String']>
  performanceFabric: Maybe<Scalars['Int']>
  pimcoreId: Maybe<Scalars['Int']>
  populariteit: Maybe<Scalars['String']>
  /**
   * A ProductPrices object, indicating the price of an item.
   * @deprecated Use price_range for product price information.
   */
  price: Maybe<ProductPrices>
  /** A PriceRange object, indicating the range of prices for the product */
  priceRange: PriceRange
  /** An array of TierPrice objects. */
  priceTiers: Maybe<Array<Maybe<TierPrice>>>
  prijs: Maybe<Scalars['String']>
  /** An array of ProductLinks objects. */
  productLinks: Maybe<Array<Maybe<ProductLinksInterface>>>
  productnaam: Maybe<Scalars['String']>
  productnaam1: Maybe<Scalars['String']>
  productspideren: Maybe<Scalars['Int']>
  promotekst: Maybe<Scalars['String']>
  pros: Maybe<Scalars['String']>
  /** Related Products */
  relatedProducts: Maybe<Array<Maybe<ProductInterface>>>
  s2m: Maybe<Scalars['Int']>
  sale: Maybe<Scalars['Int']>
  serie: Maybe<Scalars['String']>
  /** A short description of the product. Its use depends on the theme. */
  shortDescription: Maybe<ComplexTextValue>
  size: Maybe<Scalars['Int']>
  /** A number or code assigned to a product to identify the product, options, price, and manufacturer. */
  sku: Scalars['String']
  sleeve: Maybe<Scalars['String']>
  /** The relative path to the small image, which is used on catalog pages. */
  smallImage: Maybe<ProductImage>
  /** The beginning date that a product has a special price. */
  specialFromDate: Maybe<Scalars['String']>
  /** The discounted price of the product. */
  specialPrice: Maybe<Scalars['Float']>
  /** The end date that a product has a special price. */
  specialToDate: Maybe<Scalars['String']>
  specialprice: Maybe<Scalars['String']>
  specificationsBluetoothspeakerAansluitingen: Maybe<Scalars['String']>
  specificationsBluetoothspeakerAantalspeakers: Maybe<Scalars['String']>
  specificationsBluetoothspeakerAantalusb: Maybe<Scalars['String']>
  specificationsBluetoothspeakerAantalusbc: Maybe<Scalars['String']>
  specificationsBluetoothspeakerAfmetingen: Maybe<Scalars['String']>
  specificationsBluetoothspeakerAfmetingensubwoofer: Maybe<Scalars['String']>
  specificationsBluetoothspeakerFabriekscode: Maybe<Scalars['String']>
  specificationsBluetoothspeakerGewicht: Maybe<Scalars['String']>
  specificationsBluetoothspeakerGewichtsubwoofer: Maybe<Scalars['String']>
  specificationsBluetoothspeakerIntroductiejaar: Maybe<Scalars['String']>
  specificationsBluetoothspeakerKanalen: Maybe<Scalars['String']>
  specificationsBluetoothspeakerKleur: Maybe<Scalars['Int']>
  specificationsBluetoothspeakerSpeeltaf: Maybe<Scalars['String']>
  specificationsBluetoothspeakerStandaardmeegeleverd: Maybe<Scalars['String']>
  specificationsBluetoothspeakerStreaming: Maybe<Scalars['String']>
  specificationsBluetoothspeakerStroomvoorziening: Maybe<Scalars['String']>
  specificationsBluetoothspeakerTypeaudio: Maybe<Scalars['Int']>
  specificationsBluetoothspeakerTypespeaker: Maybe<Scalars['String']>
  specificationsBluetoothspeakerVermogen: Maybe<Scalars['String']>
  specificationsBlurayspelerAfmetingen: Maybe<Scalars['String']>
  specificationsBlurayspelerAfspelenvan: Maybe<Scalars['String']>
  specificationsBlurayspelerAnalogeaudio: Maybe<Scalars['String']>
  specificationsBlurayspelerAudioenvideo: Maybe<Scalars['String']>
  specificationsBlurayspelerBdlive: Maybe<Scalars['Int']>
  specificationsBlurayspelerBluetooth: Maybe<Scalars['Int']>
  specificationsBlurayspelerCoaxiaal: Maybe<Scalars['String']>
  specificationsBlurayspelerDecoders: Maybe<Scalars['String']>
  specificationsBlurayspelerDigitaalcoaxaal: Maybe<Scalars['String']>
  specificationsBlurayspelerDigitaaloptisch: Maybe<Scalars['String']>
  specificationsBlurayspelerDigitaleoptisch: Maybe<Scalars['Int']>
  specificationsBlurayspelerDlna: Maybe<Scalars['Int']>
  specificationsBlurayspelerDriedondersteuning: Maybe<Scalars['Int']>
  specificationsBlurayspelerEthernet: Maybe<Scalars['String']>
  specificationsBlurayspelerFormats: Maybe<Scalars['String']>
  specificationsBlurayspelerFuncties: Maybe<Scalars['String']>
  specificationsBlurayspelerGecerthires: Maybe<Scalars['Int']>
  specificationsBlurayspelerGewicht: Maybe<Scalars['String']>
  specificationsBlurayspelerHdmi: Maybe<Scalars['String']>
  specificationsBlurayspelerHdr: Maybe<Scalars['Int']>
  specificationsBlurayspelerKleur: Maybe<Scalars['Int']>
  specificationsBlurayspelerLan: Maybe<Scalars['Int']>
  specificationsBlurayspelerMiracast: Maybe<Scalars['Int']>
  specificationsBlurayspelerMultiroom: Maybe<Scalars['Int']>
  specificationsBlurayspelerOndersteundaudioformaat: Maybe<Scalars['String']>
  specificationsBlurayspelerOptisch: Maybe<Scalars['Int']>
  specificationsBlurayspelerOutputkanalen: Maybe<Scalars['String']>
  specificationsBlurayspelerPlayback: Maybe<Scalars['String']>
  specificationsBlurayspelerResolutie: Maybe<Scalars['String']>
  specificationsBlurayspelerSmarttv: Maybe<Scalars['Int']>
  specificationsBlurayspelerSpeeltaf: Maybe<Scalars['String']>
  specificationsBlurayspelerSpeeltvandisc: Maybe<Scalars['String']>
  specificationsBlurayspelerStandaardmeegeleverd: Maybe<Scalars['String']>
  specificationsBlurayspelerStroomverbruik: Maybe<Scalars['String']>
  specificationsBlurayspelerUpscaling: Maybe<Scalars['Int']>
  specificationsBlurayspelerUsb: Maybe<Scalars['String']>
  specificationsBlurayspelerVierkuhd: Maybe<Scalars['Int']>
  specificationsBlurayspelerVierkuhdups: Maybe<Scalars['Int']>
  specificationsBlurayspelerWifi: Maybe<Scalars['Int']>
  specificationsCdspelerAansluitingen: Maybe<Scalars['String']>
  specificationsCdspelerAantalusb: Maybe<Scalars['String']>
  specificationsCdspelerAchterspeakers: Maybe<Scalars['Int']>
  specificationsCdspelerAfmetingen: Maybe<Scalars['String']>
  specificationsCdspelerFabriekscode: Maybe<Scalars['String']>
  specificationsCdspelerGewicht: Maybe<Scalars['String']>
  specificationsCdspelerImpendatie: Maybe<Scalars['String']>
  specificationsCdspelerIntroductiejaar: Maybe<Scalars['String']>
  specificationsCdspelerKanalen: Maybe<Scalars['String']>
  specificationsCdspelerMultiroom: Maybe<Scalars['Int']>
  specificationsCdspelerRadio: Maybe<Scalars['Int']>
  specificationsCdspelerSpeakeraansluiting: Maybe<Scalars['String']>
  specificationsCdspelerSpeeltaf: Maybe<Scalars['String']>
  specificationsCdspelerStandaardmeegeleverd: Maybe<Scalars['String']>
  specificationsCdspelerStreaming: Maybe<Scalars['String']>
  specificationsCdspelerStreamingdiensten: Maybe<Scalars['String']>
  specificationsCdspelerStroomvoorziening: Maybe<Scalars['Int']>
  specificationsCdspelerSubwooferuitgang: Maybe<Scalars['Int']>
  specificationsCdspelerTypeaudio: Maybe<Scalars['Int']>
  specificationsCdspelerVermogen: Maybe<Scalars['String']>
  specificationsDraadlozespeakerAantalspeakers: Maybe<Scalars['String']>
  specificationsDraadlozespeakerAfmetingen: Maybe<Scalars['String']>
  specificationsDraadlozespeakerAirplay2: Maybe<Scalars['Int']>
  specificationsDraadlozespeakerAux: Maybe<Scalars['Int']>
  specificationsDraadlozespeakerBluetooth: Maybe<Scalars['Int']>
  specificationsDraadlozespeakerComponent: Maybe<Scalars['Int']>
  specificationsDraadlozespeakerComposiet: Maybe<Scalars['Int']>
  specificationsDraadlozespeakerFabriekscode: Maybe<Scalars['String']>
  specificationsDraadlozespeakerGebruiksduuraccu: Maybe<Scalars['String']>
  specificationsDraadlozespeakerGewicht: Maybe<Scalars['String']>
  specificationsDraadlozespeakerHdmiin: Maybe<Scalars['String']>
  specificationsDraadlozespeakerHdmiuit: Maybe<Scalars['String']>
  specificationsDraadlozespeakerKanalen: Maybe<Scalars['String']>
  specificationsDraadlozespeakerMinijack: Maybe<Scalars['Int']>
  specificationsDraadlozespeakerMultiroom: Maybe<Scalars['Int']>
  specificationsDraadlozespeakerOptischcoax: Maybe<Scalars['Int']>
  specificationsDraadlozespeakerPlatenspeler: Maybe<Scalars['Int']>
  specificationsDraadlozespeakerSpotifyconnect: Maybe<Scalars['Int']>
  specificationsDraadlozespeakerSubwoofer: Maybe<Scalars['Int']>
  specificationsDraadlozespeakerUsb: Maybe<Scalars['Int']>
  specificationsDraadlozespeakerVoicecontrol: Maybe<Scalars['Int']>
  specificationsDraadlozespeakerWifi: Maybe<Scalars['Int']>
  specificationsHifispeakerAansluitingen: Maybe<Scalars['String']>
  specificationsHifispeakerAantalspeakers: Maybe<Scalars['String']>
  specificationsHifispeakerAantalusb: Maybe<Scalars['String']>
  specificationsHifispeakerAchterspeakers: Maybe<Scalars['Int']>
  specificationsHifispeakerAfmetingen: Maybe<Scalars['String']>
  specificationsHifispeakerAfmetingensubwoofer: Maybe<Scalars['String']>
  specificationsHifispeakerBelastbaarheid: Maybe<Scalars['String']>
  specificationsHifispeakerFabriekscode: Maybe<Scalars['String']>
  specificationsHifispeakerGewicht: Maybe<Scalars['String']>
  specificationsHifispeakerGewichtsubwoofer: Maybe<Scalars['String']>
  specificationsHifispeakerImpendatie: Maybe<Scalars['String']>
  specificationsHifispeakerIntroductiejaar: Maybe<Scalars['String']>
  specificationsHifispeakerKanalen: Maybe<Scalars['String']>
  specificationsHifispeakerKleur: Maybe<Scalars['Int']>
  specificationsHifispeakerMaximalefrequentie: Maybe<Scalars['String']>
  specificationsHifispeakerMinimalefrequentie: Maybe<Scalars['String']>
  specificationsHifispeakerMultiroom: Maybe<Scalars['Int']>
  specificationsHifispeakerSpeakeraansluiting: Maybe<Scalars['String']>
  specificationsHifispeakerSpeakertype: Maybe<Scalars['String']>
  specificationsHifispeakerStandaardmeegeleverd: Maybe<Scalars['String']>
  specificationsHifispeakerStreaming: Maybe<Scalars['String']>
  specificationsHifispeakerStroomvoorziening: Maybe<Scalars['Int']>
  specificationsHifispeakerTypeaudio: Maybe<Scalars['Int']>
  specificationsHifispeakerTypespeaker: Maybe<Scalars['String']>
  specificationsHifispeakerVermogen: Maybe<Scalars['String']>
  specificationsHifispeakerWaterbestendig: Maybe<Scalars['Int']>
  specificationsHomecinemaAansluitingen: Maybe<Scalars['String']>
  specificationsHomecinemaAantalhdmi: Maybe<Scalars['String']>
  specificationsHomecinemaAantalspeakers: Maybe<Scalars['String']>
  specificationsHomecinemaAantalusb: Maybe<Scalars['String']>
  specificationsHomecinemaAchterspeakers: Maybe<Scalars['Int']>
  specificationsHomecinemaAfmetingen: Maybe<Scalars['String']>
  specificationsHomecinemaFabriekscode: Maybe<Scalars['String']>
  specificationsHomecinemaGewicht: Maybe<Scalars['String']>
  specificationsHomecinemaGewichtsubwoofer: Maybe<Scalars['String']>
  specificationsHomecinemaImpendatie: Maybe<Scalars['String']>
  specificationsHomecinemaIntroductiejaar: Maybe<Scalars['String']>
  specificationsHomecinemaKleur: Maybe<Scalars['Int']>
  specificationsHomecinemaMicrofoon: Maybe<Scalars['Int']>
  specificationsHomecinemaMultiroom: Maybe<Scalars['Int']>
  specificationsHomecinemaRadio: Maybe<Scalars['Int']>
  specificationsHomecinemaSpeakeraansluiting: Maybe<Scalars['String']>
  specificationsHomecinemaSpeeltaf: Maybe<Scalars['String']>
  specificationsHomecinemaStandaardmeegeleverd: Maybe<Scalars['String']>
  specificationsHomecinemaStreaming: Maybe<Scalars['String']>
  specificationsHomecinemaStreamingdiensten: Maybe<Scalars['String']>
  specificationsHomecinemaStroomvoorziening: Maybe<Scalars['Int']>
  specificationsHomecinemaSubwooferuitgang: Maybe<Scalars['String']>
  specificationsHomecinemaTypeaudio: Maybe<Scalars['Int']>
  specificationsHomecinemaTypespeaker: Maybe<Scalars['String']>
  specificationsHomecinemaVermogen: Maybe<Scalars['String']>
  specificationsMuurbeugelAantalgradendraaibaar: Maybe<Scalars['String']>
  specificationsMuurbeugelAantalgradenkantelbaar: Maybe<Scalars['String']>
  specificationsMuurbeugelBedieningviaapp: Maybe<Scalars['Int']>
  specificationsMuurbeugelGarantie: Maybe<Scalars['String']>
  specificationsMuurbeugelGeschiktvoorafmetingentv: Maybe<Scalars['String']>
  specificationsMuurbeugelInterfacebreedte: Maybe<Scalars['String']>
  specificationsMuurbeugelInterfacehoogte: Maybe<Scalars['String']>
  specificationsMuurbeugelIntroductiejaar: Maybe<Scalars['String']>
  specificationsMuurbeugelKleur: Maybe<Scalars['Int']>
  specificationsMuurbeugelMaxafstandmuur: Maybe<Scalars['String']>
  specificationsMuurbeugelMaximalegewichttv: Maybe<Scalars['String']>
  specificationsMuurbeugelMerkmuurbeugel: Maybe<Scalars['Int']>
  specificationsMuurbeugelMinafstandmuur: Maybe<Scalars['String']>
  specificationsMuurbeugelSoortmuurbeugel: Maybe<Scalars['Int']>
  specificationsMuurbeugelStandaardmeegeleverd: Maybe<Scalars['String']>
  specificationsMuurbeugelTypemuurbeugel: Maybe<Scalars['String']>
  specificationsMuurbeugelUittrekbaar: Maybe<Scalars['Int']>
  specificationsMuurbeugelVesaafmetingen: Maybe<Scalars['String']>
  specificationsNetwerkspelerAansluitingen: Maybe<Scalars['String']>
  specificationsNetwerkspelerAantalusb: Maybe<Scalars['String']>
  specificationsNetwerkspelerAchterspeakers: Maybe<Scalars['Int']>
  specificationsNetwerkspelerAfmetingen: Maybe<Scalars['String']>
  specificationsNetwerkspelerAfmetingensubwoofer: Maybe<Scalars['String']>
  specificationsNetwerkspelerBelastbaarheid: Maybe<Scalars['String']>
  specificationsNetwerkspelerFabriekscode: Maybe<Scalars['String']>
  specificationsNetwerkspelerGewicht: Maybe<Scalars['String']>
  specificationsNetwerkspelerGewichtsubwoofer: Maybe<Scalars['String']>
  specificationsNetwerkspelerIntroductiejaar: Maybe<Scalars['String']>
  specificationsNetwerkspelerKanalen: Maybe<Scalars['String']>
  specificationsNetwerkspelerKleur: Maybe<Scalars['Int']>
  specificationsNetwerkspelerMultiroom: Maybe<Scalars['Int']>
  specificationsNetwerkspelerRadio: Maybe<Scalars['Int']>
  specificationsNetwerkspelerSpeakeraansluiting: Maybe<Scalars['String']>
  specificationsNetwerkspelerSpeeltaf: Maybe<Scalars['String']>
  specificationsNetwerkspelerStandaardmeegeleverd: Maybe<Scalars['String']>
  specificationsNetwerkspelerStreaming: Maybe<Scalars['String']>
  specificationsNetwerkspelerStreamingdiensten: Maybe<Scalars['String']>
  specificationsNetwerkspelerStroomvoorziening: Maybe<Scalars['Int']>
  specificationsNetwerkspelerSubwoofer: Maybe<Scalars['Int']>
  specificationsNetwerkspelerSubwooferuitgang: Maybe<Scalars['Int']>
  specificationsNetwerkspelerTypeaudio: Maybe<Scalars['Int']>
  specificationsNetwerkspelerVermogen: Maybe<Scalars['String']>
  specificationsOverigeaudioAansluitingen: Maybe<Scalars['String']>
  specificationsOverigeaudioAantalhdmi: Maybe<Scalars['String']>
  specificationsOverigeaudioAantalspeakers: Maybe<Scalars['String']>
  specificationsOverigeaudioAantalusb: Maybe<Scalars['String']>
  specificationsOverigeaudioAfmetingen: Maybe<Scalars['String']>
  specificationsOverigeaudioAfmetingensubwoofer: Maybe<Scalars['String']>
  specificationsOverigeaudioFabriekscode: Maybe<Scalars['String']>
  specificationsOverigeaudioGewicht: Maybe<Scalars['String']>
  specificationsOverigeaudioGewichtsubwoofer: Maybe<Scalars['String']>
  specificationsOverigeaudioIntroductiejaar: Maybe<Scalars['String']>
  specificationsOverigeaudioKanalen: Maybe<Scalars['String']>
  specificationsOverigeaudioKleur: Maybe<Scalars['Int']>
  specificationsOverigeaudioMaximalefrequentie: Maybe<Scalars['String']>
  specificationsOverigeaudioMinimalefrequentie: Maybe<Scalars['String']>
  specificationsOverigeaudioRadio: Maybe<Scalars['String']>
  specificationsOverigeaudioStandaardmeegeleverd: Maybe<Scalars['String']>
  specificationsOverigeaudioStreaming: Maybe<Scalars['String']>
  specificationsOverigeaudioStroomvoorziening: Maybe<Scalars['Int']>
  specificationsOverigeaudioVermogen: Maybe<Scalars['String']>
  specificationsOverigeaudioWaterbestendig: Maybe<Scalars['Int']>
  specificationsPlafondbeugelsAantaldraai: Maybe<Scalars['String']>
  specificationsPlafondbeugelsBeeldformaat: Maybe<Scalars['String']>
  specificationsPlafondbeugelsDraaien: Maybe<Scalars['String']>
  specificationsPlafondbeugelsGarantie: Maybe<Scalars['String']>
  specificationsPlafondbeugelsGroottetv: Maybe<Scalars['String']>
  specificationsPlafondbeugelsHoogte: Maybe<Scalars['String']>
  specificationsPlafondbeugelsHoogteverstelling: Maybe<Scalars['Int']>
  specificationsPlafondbeugelsInterfacebreedte: Maybe<Scalars['String']>
  specificationsPlafondbeugelsInterfacehoogte: Maybe<Scalars['String']>
  specificationsPlafondbeugelsInterfaceoptioneel: Maybe<Scalars['Int']>
  specificationsPlafondbeugelsKabelinlegsysteem: Maybe<Scalars['String']>
  specificationsPlafondbeugelsKantelen: Maybe<Scalars['String']>
  specificationsPlafondbeugelsKleur: Maybe<Scalars['Int']>
  specificationsPlafondbeugelsLengtebuis: Maybe<Scalars['String']>
  specificationsPlafondbeugelsMaxgewicht: Maybe<Scalars['String']>
  specificationsPlafondbeugelsMontagehoek: Maybe<Scalars['String']>
  specificationsPlafondbeugelsProductlijn: Maybe<Scalars['Int']>
  specificationsPlafondbeugelsRoteren: Maybe<Scalars['Int']>
  specificationsPlafondbeugelsSchuineplafondoplossing: Maybe<Scalars['Int']>
  specificationsPlafondbeugelsUitschuifbaar: Maybe<Scalars['Int']>
  specificationsPlafondbeugelsVesamaximaal: Maybe<Scalars['String']>
  specificationsPlafondbeugelsVesaminimaal: Maybe<Scalars['String']>
  specificationsPlafondbeugelsVesanorm: Maybe<Scalars['String']>
  specificationsPlafondbeugelsZwenken: Maybe<Scalars['Int']>
  specificationsReceiverAansluitingen: Maybe<Scalars['String']>
  specificationsReceiverAantalspeakers: Maybe<Scalars['String']>
  specificationsReceiverAchterspeakers: Maybe<Scalars['Int']>
  specificationsReceiverAfmetingen: Maybe<Scalars['String']>
  specificationsReceiverAirplay2: Maybe<Scalars['Int']>
  specificationsReceiverArc: Maybe<Scalars['Int']>
  specificationsReceiverAux: Maybe<Scalars['Int']>
  specificationsReceiverBeeldondersteuning: Maybe<Scalars['String']>
  specificationsReceiverBluetooth: Maybe<Scalars['Int']>
  specificationsReceiverCoax: Maybe<Scalars['String']>
  specificationsReceiverComponent: Maybe<Scalars['Int']>
  specificationsReceiverComposiet: Maybe<Scalars['Int']>
  specificationsReceiverEthernet: Maybe<Scalars['Int']>
  specificationsReceiverFabriekscode: Maybe<Scalars['String']>
  specificationsReceiverGewicht: Maybe<Scalars['String']>
  specificationsReceiverHdmiin: Maybe<Scalars['String']>
  specificationsReceiverHdmiout: Maybe<Scalars['String']>
  specificationsReceiverImpendatie: Maybe<Scalars['String']>
  specificationsReceiverIntroductiejaar: Maybe<Scalars['String']>
  specificationsReceiverKanalen: Maybe<Scalars['String']>
  specificationsReceiverKleur: Maybe<Scalars['Int']>
  specificationsReceiverMinijack: Maybe<Scalars['Int']>
  specificationsReceiverMultiroom: Maybe<Scalars['Int']>
  specificationsReceiverOptisch: Maybe<Scalars['String']>
  specificationsReceiverPlatenspeler: Maybe<Scalars['Int']>
  specificationsReceiverRadio: Maybe<Scalars['String']>
  specificationsReceiverSpeeltaf: Maybe<Scalars['String']>
  specificationsReceiverSpotifyconnect: Maybe<Scalars['Int']>
  specificationsReceiverStreaming: Maybe<Scalars['String']>
  specificationsReceiverStroomvoorziening: Maybe<Scalars['Int']>
  specificationsReceiverSubwoofer: Maybe<Scalars['Int']>
  specificationsReceiverSubwooferuitgang: Maybe<Scalars['String']>
  specificationsReceiverSurroundsystemen: Maybe<Scalars['String']>
  specificationsReceiverTypeaudio: Maybe<Scalars['Int']>
  specificationsReceiverTypereceiver: Maybe<Scalars['Int']>
  specificationsReceiverUsb: Maybe<Scalars['Int']>
  specificationsReceiverVermogen: Maybe<Scalars['String']>
  specificationsReceiverWifi: Maybe<Scalars['Int']>
  specificationsSoundbarAantalspeakers: Maybe<Scalars['String']>
  specificationsSoundbarAfmetingen: Maybe<Scalars['String']>
  specificationsSoundbarAirplay2: Maybe<Scalars['Int']>
  specificationsSoundbarArc: Maybe<Scalars['Int']>
  specificationsSoundbarAux: Maybe<Scalars['Int']>
  specificationsSoundbarBeeldondersteuning: Maybe<Scalars['String']>
  specificationsSoundbarBluetooth: Maybe<Scalars['Int']>
  specificationsSoundbarComponent: Maybe<Scalars['Int']>
  specificationsSoundbarComposiet: Maybe<Scalars['Int']>
  specificationsSoundbarEthernet: Maybe<Scalars['Int']>
  specificationsSoundbarFabriekscode: Maybe<Scalars['String']>
  specificationsSoundbarGewicht: Maybe<Scalars['String']>
  specificationsSoundbarHdmiin: Maybe<Scalars['String']>
  specificationsSoundbarHdmiout: Maybe<Scalars['String']>
  specificationsSoundbarIntroductiejaar: Maybe<Scalars['String']>
  specificationsSoundbarKanalen: Maybe<Scalars['String']>
  specificationsSoundbarKleur: Maybe<Scalars['Int']>
  specificationsSoundbarMinijack: Maybe<Scalars['Int']>
  specificationsSoundbarMultiroom: Maybe<Scalars['Int']>
  specificationsSoundbarOptischcoax: Maybe<Scalars['String']>
  specificationsSoundbarSpeeltaf: Maybe<Scalars['String']>
  specificationsSoundbarSpotifyconnect: Maybe<Scalars['Int']>
  specificationsSoundbarStreaming: Maybe<Scalars['String']>
  specificationsSoundbarStroomvoorziening: Maybe<Scalars['Int']>
  specificationsSoundbarSubwoofer: Maybe<Scalars['Int']>
  specificationsSoundbarTypeaudio: Maybe<Scalars['Int']>
  specificationsSoundbarUsb: Maybe<Scalars['Int']>
  specificationsSoundbarVermogen: Maybe<Scalars['String']>
  specificationsSoundbarWifi: Maybe<Scalars['Int']>
  specificationsStereosetAansluitingen: Maybe<Scalars['String']>
  specificationsStereosetAantalspeakers: Maybe<Scalars['String']>
  specificationsStereosetAantalusb: Maybe<Scalars['String']>
  specificationsStereosetAfmetingen: Maybe<Scalars['String']>
  specificationsStereosetBelastbaarheid: Maybe<Scalars['String']>
  specificationsStereosetFabriekscode: Maybe<Scalars['String']>
  specificationsStereosetGewicht: Maybe<Scalars['String']>
  specificationsStereosetImpendatie: Maybe<Scalars['Int']>
  specificationsStereosetIntroductiejaar: Maybe<Scalars['String']>
  specificationsStereosetKanalen: Maybe<Scalars['String']>
  specificationsStereosetKleur: Maybe<Scalars['Int']>
  specificationsStereosetMaximalefrequentie: Maybe<Scalars['String']>
  specificationsStereosetMinimalefrequentie: Maybe<Scalars['String']>
  specificationsStereosetMultiroom: Maybe<Scalars['Int']>
  specificationsStereosetRadio: Maybe<Scalars['String']>
  specificationsStereosetSpeakeraansluiting: Maybe<Scalars['Int']>
  specificationsStereosetSpeeltaf: Maybe<Scalars['String']>
  specificationsStereosetStandaardmeegeleverd: Maybe<Scalars['String']>
  specificationsStereosetStreaming: Maybe<Scalars['String']>
  specificationsStereosetStroomvoorziening: Maybe<Scalars['Int']>
  specificationsStereosetSubwooferuitgang: Maybe<Scalars['Int']>
  specificationsStereosetTypeaudio: Maybe<Scalars['Int']>
  specificationsStereosetTypespeaker: Maybe<Scalars['Int']>
  specificationsStereosetVermogen: Maybe<Scalars['String']>
  specificationsSubwooferAansluitingen: Maybe<Scalars['String']>
  specificationsSubwooferAantalusb: Maybe<Scalars['String']>
  specificationsSubwooferAfmetingen: Maybe<Scalars['String']>
  specificationsSubwooferAfmetingensubwoofer: Maybe<Scalars['String']>
  specificationsSubwooferBelastbaarheid: Maybe<Scalars['String']>
  specificationsSubwooferFabriekscode: Maybe<Scalars['String']>
  specificationsSubwooferGewicht: Maybe<Scalars['String']>
  specificationsSubwooferGewichtsubwoofer: Maybe<Scalars['String']>
  specificationsSubwooferIntroductiejaar: Maybe<Scalars['String']>
  specificationsSubwooferKanalen: Maybe<Scalars['String']>
  specificationsSubwooferKleur: Maybe<Scalars['Int']>
  specificationsSubwooferMaximalefrequentie: Maybe<Scalars['String']>
  specificationsSubwooferMinimalefrequentie: Maybe<Scalars['String']>
  specificationsSubwooferMultiroom: Maybe<Scalars['Int']>
  specificationsSubwooferRadio: Maybe<Scalars['Int']>
  specificationsSubwooferSpeakeraansluiting: Maybe<Scalars['String']>
  specificationsSubwooferStandaardmeegeleverd: Maybe<Scalars['String']>
  specificationsSubwooferStreaming: Maybe<Scalars['String']>
  specificationsSubwooferStreamingdiensten: Maybe<Scalars['String']>
  specificationsSubwooferStroomvoorziening: Maybe<Scalars['Int']>
  specificationsSubwooferSubwooferuitgang: Maybe<Scalars['Int']>
  specificationsSubwooferTypeaudio: Maybe<Scalars['Int']>
  specificationsSubwooferTypespeaker: Maybe<Scalars['String']>
  specificationsSubwooferVermogen: Maybe<Scalars['String']>
  specificationsSubwooferWaterbestendig: Maybe<Scalars['Int']>
  specificationsTelevisieAfmetingenexclvoet: Maybe<Scalars['String']>
  specificationsTelevisieAfmetingeninclvoet: Maybe<Scalars['String']>
  specificationsTelevisieAirplay: Maybe<Scalars['Int']>
  specificationsTelevisieAmbilight: Maybe<Scalars['Int']>
  specificationsTelevisieBeeldformaat: Maybe<Scalars['Int']>
  specificationsTelevisieBeeldfrequentie: Maybe<Scalars['Int']>
  specificationsTelevisieBluetooth: Maybe<Scalars['Int']>
  specificationsTelevisieCigeschikt: Maybe<Scalars['String']>
  specificationsTelevisieComponent: Maybe<Scalars['Int']>
  specificationsTelevisieComposiet: Maybe<Scalars['Int']>
  specificationsTelevisieDigitaalcoaxaleaansluiting: Maybe<Scalars['Int']>
  specificationsTelevisieDigitaaloptischeaansluiting: Maybe<Scalars['Int']>
  specificationsTelevisieEnergieklasse: Maybe<Scalars['Int']>
  specificationsTelevisieFabriekscode: Maybe<Scalars['String']>
  specificationsTelevisieGewichtexclvoet: Maybe<Scalars['String']>
  specificationsTelevisieGewichtinclvoet: Maybe<Scalars['String']>
  specificationsTelevisieHdmi: Maybe<Scalars['String']>
  specificationsTelevisieHdr: Maybe<Scalars['Int']>
  specificationsTelevisieIntroductiejaar: Maybe<Scalars['String']>
  specificationsTelevisieKleur: Maybe<Scalars['Int']>
  specificationsTelevisieKoptelefoon: Maybe<Scalars['Int']>
  specificationsTelevisieMeegeleverdeaccessoires: Maybe<Scalars['String']>
  specificationsTelevisieMerk: Maybe<Scalars['Int']>
  specificationsTelevisieResolutie: Maybe<Scalars['Int']>
  specificationsTelevisieScart: Maybe<Scalars['Int']>
  specificationsTelevisieSmartplatform: Maybe<Scalars['Int']>
  specificationsTelevisieSmarttv: Maybe<Scalars['Int']>
  specificationsTelevisieSoorttv: Maybe<Scalars['String']>
  specificationsTelevisieSpeakersysteem: Maybe<Scalars['String']>
  specificationsTelevisieSpotifyconnect: Maybe<Scalars['Int']>
  specificationsTelevisieSpraakbesturing: Maybe<Scalars['Int']>
  specificationsTelevisieSubwoofer: Maybe<Scalars['Int']>
  specificationsTelevisieTuner: Maybe<Scalars['String']>
  specificationsTelevisieTypehdr: Maybe<Scalars['String']>
  specificationsTelevisieUsb: Maybe<Scalars['String']>
  specificationsTelevisieVermogen: Maybe<Scalars['String']>
  specificationsTelevisieWifi: Maybe<Scalars['Int']>
  specificationsTvmeubelAfmetingen: Maybe<Scalars['String']>
  specificationsTvmeubelGewicht: Maybe<Scalars['String']>
  specificationsTvmeubelKleur: Maybe<Scalars['Int']>
  specificationsTvmeubelMateriaal: Maybe<Scalars['String']>
  specificationsTvmeubelTypeproduct: Maybe<Scalars['Int']>
  specificationsVersterkerAansluitingen: Maybe<Scalars['String']>
  specificationsVersterkerAantalhdmi: Maybe<Scalars['String']>
  specificationsVersterkerAantalusb: Maybe<Scalars['String']>
  specificationsVersterkerAchterspeakers: Maybe<Scalars['Int']>
  specificationsVersterkerAfmetingen: Maybe<Scalars['String']>
  specificationsVersterkerAfmetingensubwoofer: Maybe<Scalars['String']>
  specificationsVersterkerBelastbaarheid: Maybe<Scalars['String']>
  specificationsVersterkerFabriekscode: Maybe<Scalars['String']>
  specificationsVersterkerGewicht: Maybe<Scalars['String']>
  specificationsVersterkerGewichtsubwoofer: Maybe<Scalars['String']>
  specificationsVersterkerImpendatie: Maybe<Scalars['String']>
  specificationsVersterkerIntroductiejaar: Maybe<Scalars['String']>
  specificationsVersterkerKanalen: Maybe<Scalars['String']>
  specificationsVersterkerKleur: Maybe<Scalars['Int']>
  specificationsVersterkerMultiroom: Maybe<Scalars['Int']>
  specificationsVersterkerRadio: Maybe<Scalars['String']>
  specificationsVersterkerSpeakeraansluiting: Maybe<Scalars['String']>
  specificationsVersterkerSpeeltaf: Maybe<Scalars['String']>
  specificationsVersterkerStandaardmeegeleverd: Maybe<Scalars['String']>
  specificationsVersterkerStreaming: Maybe<Scalars['String']>
  specificationsVersterkerStreamingdiensten: Maybe<Scalars['String']>
  specificationsVersterkerStroomvoorziening: Maybe<Scalars['Int']>
  specificationsVersterkerSubwoofer: Maybe<Scalars['String']>
  specificationsVersterkerSubwooferuitgang: Maybe<Scalars['Int']>
  specificationsVersterkerTypeaudio: Maybe<Scalars['Int']>
  specificationsVersterkerVermogen: Maybe<Scalars['String']>
  specificationsVersterkerWaterbestendig: Maybe<Scalars['Int']>
  specificationsVloerstandaardAfmetingen: Maybe<Scalars['String']>
  specificationsVloerstandaardKleur: Maybe<Scalars['Int']>
  specificationsVloerstandaardProducttype: Maybe<Scalars['Int']>
  specificationsVoedingDraadloosopladen: Maybe<Scalars['Int']>
  specificationsVoedingKabellengte: Maybe<Scalars['String']>
  specificationsVoedingKleur: Maybe<Scalars['Int']>
  specificationsVoedingProducttype: Maybe<Scalars['Int']>
  specificationsWifispeakerAansluitingen: Maybe<Scalars['String']>
  specificationsWifispeakerAantalspeakers: Maybe<Scalars['String']>
  specificationsWifispeakerAantalusb: Maybe<Scalars['String']>
  specificationsWifispeakerAchterspeakers: Maybe<Scalars['Int']>
  specificationsWifispeakerAfmetingen: Maybe<Scalars['String']>
  specificationsWifispeakerAfmetingensubwoofer: Maybe<Scalars['String']>
  specificationsWifispeakerBelastbaarheid: Maybe<Scalars['String']>
  specificationsWifispeakerFabriekscode: Maybe<Scalars['String']>
  specificationsWifispeakerGewicht: Maybe<Scalars['String']>
  specificationsWifispeakerGewichtsubwoofer: Maybe<Scalars['String']>
  specificationsWifispeakerImpendatie: Maybe<Scalars['String']>
  specificationsWifispeakerIntroductiejaar: Maybe<Scalars['String']>
  specificationsWifispeakerKanalen: Maybe<Scalars['String']>
  specificationsWifispeakerKleur: Maybe<Scalars['Int']>
  specificationsWifispeakerMultiroom: Maybe<Scalars['Int']>
  specificationsWifispeakerRadio: Maybe<Scalars['String']>
  specificationsWifispeakerSpeeltaf: Maybe<Scalars['String']>
  specificationsWifispeakerStandaardmeegeleverd: Maybe<Scalars['String']>
  specificationsWifispeakerStreaming: Maybe<Scalars['String']>
  specificationsWifispeakerStreamingdiensten: Maybe<Scalars['String']>
  specificationsWifispeakerStroomvoorziening: Maybe<Scalars['String']>
  specificationsWifispeakerSubwoofer: Maybe<Scalars['String']>
  specificationsWifispeakerSubwooferuitgang: Maybe<Scalars['String']>
  specificationsWifispeakerTypeaudio: Maybe<Scalars['Int']>
  specificationsWifispeakerTypespeaker: Maybe<Scalars['Int']>
  specificationsWifispeakerVermogen: Maybe<Scalars['String']>
  specificationsWifispeakerWaterbestendig: Maybe<Scalars['Int']>
  /** Stock status of the product */
  stockStatus: Maybe<ProductStockStatus>
  strapBags: Maybe<Scalars['String']>
  styleBags: Maybe<Scalars['String']>
  styleBottom: Maybe<Scalars['String']>
  styleGeneral: Maybe<Scalars['String']>
  /** The file name of a swatch image */
  swatchImage: Maybe<Scalars['String']>
  tempcombipakketten: Maybe<Scalars['String']>
  /** The relative path to the product's thumbnail image. */
  thumbnail: Maybe<ProductImage>
  /**
   * The price when tier pricing is in effect and the items purchased threshold has been reached.
   * @deprecated Use price_tiers for product tier price information.
   */
  tierPrice: Maybe<Scalars['Float']>
  /**
   * An array of ProductTierPrices objects.
   * @deprecated Use price_tiers for product tier price information.
   */
  tierPrices: Maybe<Array<Maybe<ProductTierPrices>>>
  top10product: Maybe<Scalars['Int']>
  tot21u: Maybe<Scalars['Int']>
  tweakers: Maybe<Scalars['Int']>
  tweakerstekstad: Maybe<Scalars['String']>
  tweakwisecrossselltemplateid: Maybe<Scalars['String']>
  /**
   * One of simple, virtual, bundle, downloadable, grouped, or configurable.
   * @deprecated Use __typename instead.
   */
  typeId: Maybe<Scalars['String']>
  /** Timestamp indicating when the product was updated. */
  updatedAt: Maybe<Scalars['String']>
  /** Upsell Products */
  upsellProducts: Maybe<Array<Maybe<ProductInterface>>>
  /** The part of the URL that identifies the product */
  urlKey: Scalars['String']
  /** @deprecated Use product's `canonical_url` or url rewrites instead */
  urlPath: Maybe<Scalars['String']>
  /** URL rewrites list */
  urlRewrites: Maybe<Array<Maybe<UrlRewrite>>>
  /** The part of the product URL that is appended after the url key */
  urlSuffix: Maybe<Scalars['String']>
  variant: Maybe<Scalars['Int']>
  variantValue: Maybe<Scalars['String']>
  /** An array of variants of products */
  variants: Maybe<Array<Maybe<ConfigurableVariant>>>
  venditguid: Maybe<Scalars['String']>
  venditpid: Maybe<Scalars['String']>
  voorraadamsterdam: Maybe<Scalars['Int']>
  voorraadarnhem: Maybe<Scalars['Int']>
  voorraadbreda: Maybe<Scalars['Int']>
  voorraaddoetinchem: Maybe<Scalars['Int']>
  voorraadeindhoven: Maybe<Scalars['Int']>
  voorraadgroningen: Maybe<Scalars['Int']>
  voorraadnaarden: Maybe<Scalars['Int']>
  voorraadnijmegen: Maybe<Scalars['Int']>
  voorraadonline: Maybe<Scalars['Int']>
  voorraadutrecht: Maybe<Scalars['Int']>
  voorraadzoeterwoude: Maybe<Scalars['Int']>
  /**
   * An array of websites in which the product is available.
   * @deprecated The field should not be used on the storefront.
   */
  websites: Maybe<Array<Maybe<Website>>>
  /** The weight of the item, in units defined by the store. */
  weight: Maybe<Scalars['Float']>
  zondaglevering: Maybe<Scalars['Int']>
  pimcoreProductData: Maybe<PimcoreProduct>
}

export interface ConfigurableProductCartItemInput {
  customizable_options?: Maybe<Array<Maybe<CustomizableOptionInput>>>
  data: CartItemInput
  /** Configurable product SKU. */
  parent_sku?: Maybe<Scalars['String']>
  variant_sku?: Maybe<Scalars['String']>
}

/** ConfigurableProductOptions defines configurable attributes for the specified product */
export interface ConfigurableProductOptions {
  __typename?: 'ConfigurableProductOptions'
  /** A string that identifies the attribute */
  attributeCode: Maybe<Scalars['String']>
  /**
   * The ID assigned to the attribute
   * @deprecated Use attribute_id_v2 instead
   */
  attributeId: Maybe<Scalars['String']>
  /** The ID assigned to the attribute */
  attributeIdV2: Maybe<Scalars['Int']>
  /** The configurable option ID number assigned by the system */
  id: Maybe<Scalars['Int']>
  /** A string that describes the configurable product option, which is displayed on the UI */
  label: Maybe<Scalars['String']>
  /** A number that indicates the order in which the attribute is displayed */
  position: Maybe<Scalars['Int']>
  /** This is the same as a product's id field */
  productId: Maybe<Scalars['Int']>
  /** Indicates whether the option is the default */
  useDefault: Maybe<Scalars['Boolean']>
  /** An array that defines the value_index codes assigned to the configurable product */
  values: Maybe<Array<Maybe<ConfigurableProductOptionsValues>>>
}

/** ConfigurableProductOptionsValues contains the index number assigned to a configurable product option */
export interface ConfigurableProductOptionsValues {
  __typename?: 'ConfigurableProductOptionsValues'
  /** The label of the product on the default store */
  defaultLabel: Maybe<Scalars['String']>
  /** The label of the product */
  label: Maybe<Scalars['String']>
  /** The label of the product on the current store */
  storeLabel: Maybe<Scalars['String']>
  /** Swatch data for configurable product option */
  swatchData: Maybe<SwatchDataInterface>
  /** Indicates whether to use the default_label */
  useDefaultValue: Maybe<Scalars['Boolean']>
  /** A unique index number assigned to the configurable product option */
  valueIndex: Maybe<Scalars['Int']>
}

/** An array containing all the simple product variants of a configurable product */
export interface ConfigurableVariant {
  __typename?: 'ConfigurableVariant'
  attributes: Maybe<Array<Maybe<ConfigurableAttributeOption>>>
  product: Maybe<SimpleProduct>
}

export interface Country {
  __typename?: 'Country'
  availableRegions: Maybe<Array<Maybe<Region>>>
  fullNameEnglish: Maybe<Scalars['String']>
  fullNameLocale: Maybe<Scalars['String']>
  id: Maybe<Scalars['String']>
  threeLetterAbbreviation: Maybe<Scalars['String']>
  twoLetterAbbreviation: Maybe<Scalars['String']>
}

/** The list of countries codes */
export enum CountryCodeEnum {
  /** Afghanistan */
  AF = 'AF',
  /** Åland Islands */
  AX = 'AX',
  /** Albania */
  AL = 'AL',
  /** Algeria */
  DZ = 'DZ',
  /** American Samoa */
  AS = 'AS',
  /** Andorra */
  AD = 'AD',
  /** Angola */
  AO = 'AO',
  /** Anguilla */
  AI = 'AI',
  /** Antarctica */
  AQ = 'AQ',
  /** Antigua & Barbuda */
  AG = 'AG',
  /** Argentina */
  AR = 'AR',
  /** Armenia */
  AM = 'AM',
  /** Aruba */
  AW = 'AW',
  /** Australia */
  AU = 'AU',
  /** Austria */
  AT = 'AT',
  /** Azerbaijan */
  AZ = 'AZ',
  /** Bahamas */
  BS = 'BS',
  /** Bahrain */
  BH = 'BH',
  /** Bangladesh */
  BD = 'BD',
  /** Barbados */
  BB = 'BB',
  /** Belarus */
  BY = 'BY',
  /** Belgium */
  BE = 'BE',
  /** Belize */
  BZ = 'BZ',
  /** Benin */
  BJ = 'BJ',
  /** Bermuda */
  BM = 'BM',
  /** Bhutan */
  BT = 'BT',
  /** Bolivia */
  BO = 'BO',
  /** Bosnia & Herzegovina */
  BA = 'BA',
  /** Botswana */
  BW = 'BW',
  /** Bouvet Island */
  BV = 'BV',
  /** Brazil */
  BR = 'BR',
  /** British Indian Ocean Territory */
  IO = 'IO',
  /** British Virgin Islands */
  VG = 'VG',
  /** Brunei */
  BN = 'BN',
  /** Bulgaria */
  BG = 'BG',
  /** Burkina Faso */
  BF = 'BF',
  /** Burundi */
  BI = 'BI',
  /** Cambodia */
  KH = 'KH',
  /** Cameroon */
  CM = 'CM',
  /** Canada */
  CA = 'CA',
  /** Cape Verde */
  CV = 'CV',
  /** Cayman Islands */
  KY = 'KY',
  /** Central African Republic */
  CF = 'CF',
  /** Chad */
  TD = 'TD',
  /** Chile */
  CL = 'CL',
  /** China */
  CN = 'CN',
  /** Christmas Island */
  CX = 'CX',
  /** Cocos (Keeling) Islands */
  CC = 'CC',
  /** Colombia */
  CO = 'CO',
  /** Comoros */
  KM = 'KM',
  /** Congo-Brazzaville */
  CG = 'CG',
  /** Congo-Kinshasa */
  CD = 'CD',
  /** Cook Islands */
  CK = 'CK',
  /** Costa Rica */
  CR = 'CR',
  /** Côte d’Ivoire */
  CI = 'CI',
  /** Croatia */
  HR = 'HR',
  /** Cuba */
  CU = 'CU',
  /** Cyprus */
  CY = 'CY',
  /** Czech Republic */
  CZ = 'CZ',
  /** Denmark */
  DK = 'DK',
  /** Djibouti */
  DJ = 'DJ',
  /** Dominica */
  DM = 'DM',
  /** Dominican Republic */
  DO = 'DO',
  /** Ecuador */
  EC = 'EC',
  /** Egypt */
  EG = 'EG',
  /** El Salvador */
  SV = 'SV',
  /** Equatorial Guinea */
  GQ = 'GQ',
  /** Eritrea */
  ER = 'ER',
  /** Estonia */
  EE = 'EE',
  /** Ethiopia */
  ET = 'ET',
  /** Falkland Islands */
  FK = 'FK',
  /** Faroe Islands */
  FO = 'FO',
  /** Fiji */
  FJ = 'FJ',
  /** Finland */
  FI = 'FI',
  /** France */
  FR = 'FR',
  /** French Guiana */
  GF = 'GF',
  /** French Polynesia */
  PF = 'PF',
  /** French Southern Territories */
  TF = 'TF',
  /** Gabon */
  GA = 'GA',
  /** Gambia */
  GM = 'GM',
  /** Georgia */
  GE = 'GE',
  /** Germany */
  DE = 'DE',
  /** Ghana */
  GH = 'GH',
  /** Gibraltar */
  GI = 'GI',
  /** Greece */
  GR = 'GR',
  /** Greenland */
  GL = 'GL',
  /** Grenada */
  GD = 'GD',
  /** Guadeloupe */
  GP = 'GP',
  /** Guam */
  GU = 'GU',
  /** Guatemala */
  GT = 'GT',
  /** Guernsey */
  GG = 'GG',
  /** Guinea */
  GN = 'GN',
  /** Guinea-Bissau */
  GW = 'GW',
  /** Guyana */
  GY = 'GY',
  /** Haiti */
  HT = 'HT',
  /** Heard &amp; McDonald Islands */
  HM = 'HM',
  /** Honduras */
  HN = 'HN',
  /** Hong Kong SAR China */
  HK = 'HK',
  /** Hungary */
  HU = 'HU',
  /** Iceland */
  IS = 'IS',
  /** India */
  IN = 'IN',
  /** Indonesia */
  ID = 'ID',
  /** Iran */
  IR = 'IR',
  /** Iraq */
  IQ = 'IQ',
  /** Ireland */
  IE = 'IE',
  /** Isle of Man */
  IM = 'IM',
  /** Israel */
  IL = 'IL',
  /** Italy */
  IT = 'IT',
  /** Jamaica */
  JM = 'JM',
  /** Japan */
  JP = 'JP',
  /** Jersey */
  JE = 'JE',
  /** Jordan */
  JO = 'JO',
  /** Kazakhstan */
  KZ = 'KZ',
  /** Kenya */
  KE = 'KE',
  /** Kiribati */
  KI = 'KI',
  /** Kuwait */
  KW = 'KW',
  /** Kyrgyzstan */
  KG = 'KG',
  /** Laos */
  LA = 'LA',
  /** Latvia */
  LV = 'LV',
  /** Lebanon */
  LB = 'LB',
  /** Lesotho */
  LS = 'LS',
  /** Liberia */
  LR = 'LR',
  /** Libya */
  LY = 'LY',
  /** Liechtenstein */
  LI = 'LI',
  /** Lithuania */
  LT = 'LT',
  /** Luxembourg */
  LU = 'LU',
  /** Macau SAR China */
  MO = 'MO',
  /** Macedonia */
  MK = 'MK',
  /** Madagascar */
  MG = 'MG',
  /** Malawi */
  MW = 'MW',
  /** Malaysia */
  MY = 'MY',
  /** Maldives */
  MV = 'MV',
  /** Mali */
  ML = 'ML',
  /** Malta */
  MT = 'MT',
  /** Marshall Islands */
  MH = 'MH',
  /** Martinique */
  MQ = 'MQ',
  /** Mauritania */
  MR = 'MR',
  /** Mauritius */
  MU = 'MU',
  /** Mayotte */
  YT = 'YT',
  /** Mexico */
  MX = 'MX',
  /** Micronesia */
  FM = 'FM',
  /** Moldova */
  MD = 'MD',
  /** Monaco */
  MC = 'MC',
  /** Mongolia */
  MN = 'MN',
  /** Montenegro */
  ME = 'ME',
  /** Montserrat */
  MS = 'MS',
  /** Morocco */
  MA = 'MA',
  /** Mozambique */
  MZ = 'MZ',
  /** Myanmar (Burma) */
  MM = 'MM',
  /** Namibia */
  NA = 'NA',
  /** Nauru */
  NR = 'NR',
  /** Nepal */
  NP = 'NP',
  /** Netherlands */
  NL = 'NL',
  /** Netherlands Antilles */
  AN = 'AN',
  /** New Caledonia */
  NC = 'NC',
  /** New Zealand */
  NZ = 'NZ',
  /** Nicaragua */
  NI = 'NI',
  /** Niger */
  NE = 'NE',
  /** Nigeria */
  NG = 'NG',
  /** Niue */
  NU = 'NU',
  /** Norfolk Island */
  NF = 'NF',
  /** Northern Mariana Islands */
  MP = 'MP',
  /** North Korea */
  KP = 'KP',
  /** Norway */
  NO = 'NO',
  /** Oman */
  OM = 'OM',
  /** Pakistan */
  PK = 'PK',
  /** Palau */
  PW = 'PW',
  /** Palestinian Territories */
  PS = 'PS',
  /** Panama */
  PA = 'PA',
  /** Papua New Guinea */
  PG = 'PG',
  /** Paraguay */
  PY = 'PY',
  /** Peru */
  PE = 'PE',
  /** Philippines */
  PH = 'PH',
  /** Pitcairn Islands */
  PN = 'PN',
  /** Poland */
  PL = 'PL',
  /** Portugal */
  PT = 'PT',
  /** Qatar */
  QA = 'QA',
  /** Réunion */
  RE = 'RE',
  /** Romania */
  RO = 'RO',
  /** Russia */
  RU = 'RU',
  /** Rwanda */
  RW = 'RW',
  /** Samoa */
  WS = 'WS',
  /** San Marino */
  SM = 'SM',
  /** São Tomé & Príncipe */
  ST = 'ST',
  /** Saudi Arabia */
  SA = 'SA',
  /** Senegal */
  SN = 'SN',
  /** Serbia */
  RS = 'RS',
  /** Seychelles */
  SC = 'SC',
  /** Sierra Leone */
  SL = 'SL',
  /** Singapore */
  SG = 'SG',
  /** Slovakia */
  SK = 'SK',
  /** Slovenia */
  SI = 'SI',
  /** Solomon Islands */
  SB = 'SB',
  /** Somalia */
  SO = 'SO',
  /** South Africa */
  ZA = 'ZA',
  /** South Georgia & South Sandwich Islands */
  GS = 'GS',
  /** South Korea */
  KR = 'KR',
  /** Spain */
  ES = 'ES',
  /** Sri Lanka */
  LK = 'LK',
  /** St. Barthélemy */
  BL = 'BL',
  /** St. Helena */
  SH = 'SH',
  /** St. Kitts & Nevis */
  KN = 'KN',
  /** St. Lucia */
  LC = 'LC',
  /** St. Martin */
  MF = 'MF',
  /** St. Pierre & Miquelon */
  PM = 'PM',
  /** St. Vincent & Grenadines */
  VC = 'VC',
  /** Sudan */
  SD = 'SD',
  /** Suriname */
  SR = 'SR',
  /** Svalbard & Jan Mayen */
  SJ = 'SJ',
  /** Swaziland */
  SZ = 'SZ',
  /** Sweden */
  SE = 'SE',
  /** Switzerland */
  CH = 'CH',
  /** Syria */
  SY = 'SY',
  /** Taiwan */
  TW = 'TW',
  /** Tajikistan */
  TJ = 'TJ',
  /** Tanzania */
  TZ = 'TZ',
  /** Thailand */
  TH = 'TH',
  /** Timor-Leste */
  TL = 'TL',
  /** Togo */
  TG = 'TG',
  /** Tokelau */
  TK = 'TK',
  /** Tonga */
  TO = 'TO',
  /** Trinidad & Tobago */
  TT = 'TT',
  /** Tunisia */
  TN = 'TN',
  /** Turkey */
  TR = 'TR',
  /** Turkmenistan */
  TM = 'TM',
  /** Turks & Caicos Islands */
  TC = 'TC',
  /** Tuvalu */
  TV = 'TV',
  /** Uganda */
  UG = 'UG',
  /** Ukraine */
  UA = 'UA',
  /** United Arab Emirates */
  AE = 'AE',
  /** United Kingdom */
  GB = 'GB',
  /** United States */
  US = 'US',
  /** Uruguay */
  UY = 'UY',
  /** U.S. Outlying Islands */
  UM = 'UM',
  /** U.S. Virgin Islands */
  VI = 'VI',
  /** Uzbekistan */
  UZ = 'UZ',
  /** Vanuatu */
  VU = 'VU',
  /** Vatican City */
  VA = 'VA',
  /** Venezuela */
  VE = 'VE',
  /** Vietnam */
  VN = 'VN',
  /** Wallis & Futuna */
  WF = 'WF',
  /** Western Sahara */
  EH = 'EH',
  /** Yemen */
  YE = 'YE',
  /** Zambia */
  ZM = 'ZM',
  /** Zimbabwe */
  ZW = 'ZW',
}

export interface CreateEmptyCartInput {
  cart_id?: Maybe<Scalars['String']>
}

export interface CreateProductReviewInput {
  /** Review admin answer. */
  answer?: Maybe<Scalars['String']>
  /** Review detail. */
  detail?: Maybe<Scalars['String']>
  /** Recommended. */
  is_recommended?: Maybe<Scalars['Boolean']>
  /** Advantages */
  like_about?: Maybe<Array<Maybe<PreLikeInput>>>
  /** Reviewer name. */
  nickname?: Maybe<Scalars['String']>
  /** Disadvantages */
  not_like_about?: Maybe<Array<Maybe<PreLikeInput>>>
  /** Ratings details by category. e.g price: 5, quality: 4 etc */
  rating_votes: Array<Maybe<ProductReviewRatingInput>>
  /** The SKU of the product that the review is assigned */
  sku: Scalars['String']
  /** Store ID */
  storeId?: Maybe<Scalars['Int']>
  /** Review title. */
  title?: Maybe<Scalars['String']>
  /** Verified buyer. */
  verified_buyer?: Maybe<Scalars['Int']>
}

export interface CreateProductReviewResponse {
  __typename?: 'CreateProductReviewResponse'
  review: Review
}

export interface Currency {
  __typename?: 'Currency'
  availableCurrencyCodes: Maybe<Array<Maybe<Scalars['String']>>>
  baseCurrencyCode: Maybe<Scalars['String']>
  baseCurrencySymbol: Maybe<Scalars['String']>
  /** @deprecated Symbol was missed. Use `default_display_currency_code`. */
  defaultDisplayCurrecyCode: Maybe<Scalars['String']>
  /** @deprecated Symbol was missed. Use `default_display_currency_symbol`. */
  defaultDisplayCurrecySymbol: Maybe<Scalars['String']>
  defaultDisplayCurrencyCode: Maybe<Scalars['String']>
  defaultDisplayCurrencySymbol: Maybe<Scalars['String']>
  exchangeRates: Maybe<Array<Maybe<ExchangeRate>>>
}

/** The list of available currency codes */
export enum CurrencyEnum {
  AFN = 'AFN',
  ALL = 'ALL',
  AZN = 'AZN',
  DZD = 'DZD',
  AOA = 'AOA',
  ARS = 'ARS',
  AMD = 'AMD',
  AWG = 'AWG',
  AUD = 'AUD',
  BSD = 'BSD',
  BHD = 'BHD',
  BDT = 'BDT',
  BBD = 'BBD',
  BYN = 'BYN',
  BZD = 'BZD',
  BMD = 'BMD',
  BTN = 'BTN',
  BOB = 'BOB',
  BAM = 'BAM',
  BWP = 'BWP',
  BRL = 'BRL',
  GBP = 'GBP',
  BND = 'BND',
  BGN = 'BGN',
  BUK = 'BUK',
  BIF = 'BIF',
  KHR = 'KHR',
  CAD = 'CAD',
  CVE = 'CVE',
  CZK = 'CZK',
  KYD = 'KYD',
  GQE = 'GQE',
  CLP = 'CLP',
  CNY = 'CNY',
  COP = 'COP',
  KMF = 'KMF',
  CDF = 'CDF',
  CRC = 'CRC',
  HRK = 'HRK',
  CUP = 'CUP',
  DKK = 'DKK',
  DJF = 'DJF',
  DOP = 'DOP',
  XCD = 'XCD',
  EGP = 'EGP',
  SVC = 'SVC',
  ERN = 'ERN',
  EEK = 'EEK',
  ETB = 'ETB',
  EUR = 'EUR',
  FKP = 'FKP',
  FJD = 'FJD',
  GMD = 'GMD',
  GEK = 'GEK',
  GEL = 'GEL',
  GHS = 'GHS',
  GIP = 'GIP',
  GTQ = 'GTQ',
  GNF = 'GNF',
  GYD = 'GYD',
  HTG = 'HTG',
  HNL = 'HNL',
  HKD = 'HKD',
  HUF = 'HUF',
  ISK = 'ISK',
  INR = 'INR',
  IDR = 'IDR',
  IRR = 'IRR',
  IQD = 'IQD',
  ILS = 'ILS',
  JMD = 'JMD',
  JPY = 'JPY',
  JOD = 'JOD',
  KZT = 'KZT',
  KES = 'KES',
  KWD = 'KWD',
  KGS = 'KGS',
  LAK = 'LAK',
  LVL = 'LVL',
  LBP = 'LBP',
  LSL = 'LSL',
  LRD = 'LRD',
  LYD = 'LYD',
  LTL = 'LTL',
  MOP = 'MOP',
  MKD = 'MKD',
  MGA = 'MGA',
  MWK = 'MWK',
  MYR = 'MYR',
  MVR = 'MVR',
  LSM = 'LSM',
  MRO = 'MRO',
  MUR = 'MUR',
  MXN = 'MXN',
  MDL = 'MDL',
  MNT = 'MNT',
  MAD = 'MAD',
  MZN = 'MZN',
  MMK = 'MMK',
  NAD = 'NAD',
  NPR = 'NPR',
  ANG = 'ANG',
  YTL = 'YTL',
  NZD = 'NZD',
  NIC = 'NIC',
  NGN = 'NGN',
  KPW = 'KPW',
  NOK = 'NOK',
  OMR = 'OMR',
  PKR = 'PKR',
  PAB = 'PAB',
  PGK = 'PGK',
  PYG = 'PYG',
  PEN = 'PEN',
  PHP = 'PHP',
  PLN = 'PLN',
  QAR = 'QAR',
  RHD = 'RHD',
  RON = 'RON',
  RUB = 'RUB',
  RWF = 'RWF',
  SHP = 'SHP',
  STD = 'STD',
  SAR = 'SAR',
  RSD = 'RSD',
  SCR = 'SCR',
  SLL = 'SLL',
  SGD = 'SGD',
  SKK = 'SKK',
  SBD = 'SBD',
  SOS = 'SOS',
  ZAR = 'ZAR',
  KRW = 'KRW',
  LKR = 'LKR',
  SDG = 'SDG',
  SRD = 'SRD',
  SZL = 'SZL',
  SEK = 'SEK',
  CHF = 'CHF',
  SYP = 'SYP',
  TWD = 'TWD',
  TJS = 'TJS',
  TZS = 'TZS',
  THB = 'THB',
  TOP = 'TOP',
  TTD = 'TTD',
  TND = 'TND',
  TMM = 'TMM',
  USD = 'USD',
  UGX = 'UGX',
  UAH = 'UAH',
  AED = 'AED',
  UYU = 'UYU',
  UZS = 'UZS',
  VUV = 'VUV',
  VEB = 'VEB',
  VEF = 'VEF',
  VND = 'VND',
  CHE = 'CHE',
  CHW = 'CHW',
  XOF = 'XOF',
  WST = 'WST',
  YER = 'YER',
  ZMK = 'ZMK',
  ZWD = 'ZWD',
  TRY = 'TRY',
  AZM = 'AZM',
  ROL = 'ROL',
  TRL = 'TRL',
  XPF = 'XPF',
}

/** CustomAttributeMetadata defines an array of attribute_codes and entity_types */
export interface CustomAttributeMetadata {
  __typename?: 'CustomAttributeMetadata'
  /** An array of attributes */
  items: Maybe<Array<Maybe<Attribute>>>
}

/** Customer defines the customer name and address and other details */
export interface Customer {
  __typename?: 'Customer'
  /** An array containing the customer's shipping and billing addresses */
  addresses: Maybe<Array<Maybe<CustomerAddress>>>
  /** Timestamp indicating when the account was created */
  createdAt: Maybe<Scalars['String']>
  /** The customer's date of birth */
  dateOfBirth: Maybe<Scalars['String']>
  /** The ID assigned to the billing address */
  defaultBilling: Maybe<Scalars['String']>
  /** The ID assigned to the shipping address */
  defaultShipping: Maybe<Scalars['String']>
  /**
   * The customer's date of birth
   * @deprecated Use `date_of_birth` instead
   */
  dob: Maybe<Scalars['String']>
  /** The customer's email address. Required */
  email: Maybe<Scalars['String']>
  /** The customer's first name */
  firstname: Maybe<Scalars['String']>
  /** The customer's gender (Male - 1, Female - 2) */
  gender: Maybe<Scalars['Int']>
  /** @deprecated Customer group should not be exposed in the storefront scenarios */
  groupId: Maybe<Scalars['Int']>
  /**
   * The ID assigned to the customer
   * @deprecated id is not needed as part of Customer because on server side it can be identified based on customer token used for authentication. There is no need to know customer ID on the client side.
   */
  id: Maybe<Scalars['Int']>
  /** Indicates whether the customer is subscribed to the company's newsletter */
  isSubscribed: Maybe<Scalars['Boolean']>
  /** The customer's family name */
  lastname: Maybe<Scalars['String']>
  /** The customer's middle name */
  middlename: Maybe<Scalars['String']>
  /** An honorific, such as Dr., Mr., or Mrs. */
  prefix: Maybe<Scalars['String']>
  /** A value such as Sr., Jr., or III */
  suffix: Maybe<Scalars['String']>
  /** The customer's Value-added tax (VAT) number (for corporate customers) */
  taxvat: Maybe<Scalars['String']>
  /** The wishlist query returns the contents of a customer's wish lists */
  wishlist: Wishlist
}

/** CustomerAddress contains detailed information about a customer's billing and shipping addresses */
export interface CustomerAddress {
  __typename?: 'CustomerAddress'
  /** The city or town */
  city: Maybe<Scalars['String']>
  /** The customer's company */
  company: Maybe<Scalars['String']>
  /** The customer's country */
  countryCode: Maybe<CountryCodeEnum>
  /**
   * The customer's country
   * @deprecated Use `country_code` instead.
   */
  countryId: Maybe<Scalars['String']>
  /** @deprecated Custom attributes should not be put into container */
  customAttributes: Maybe<Array<Maybe<CustomerAddressAttribute>>>
  /**
   * The customer ID
   * @deprecated customer_id is not needed as part of CustomerAddress, address ID (id) is unique identifier for the addresses.
   */
  customerId: Maybe<Scalars['Int']>
  /** Indicates whether the address is the default billing address */
  defaultBilling: Maybe<Scalars['Boolean']>
  /** Indicates whether the address is the default shipping address */
  defaultShipping: Maybe<Scalars['Boolean']>
  /** Address extension attributes */
  extensionAttributes: Maybe<Array<Maybe<CustomerAddressAttribute>>>
  /** The fax number */
  fax: Maybe<Scalars['String']>
  /** The first name of the person associated with the shipping/billing address */
  firstname: Maybe<Scalars['String']>
  /** The ID assigned to the address object */
  id: Maybe<Scalars['Int']>
  /** The family name of the person associated with the shipping/billing address */
  lastname: Maybe<Scalars['String']>
  /** The middle name of the person associated with the shipping/billing address */
  middlename: Maybe<Scalars['String']>
  /** The customer's ZIP or postal code */
  postcode: Maybe<Scalars['String']>
  /** An honorific, such as Dr., Mr., or Mrs. */
  prefix: Maybe<Scalars['String']>
  /** An object containing the region name, region code, and region ID */
  region: Maybe<CustomerAddressRegion>
  /** The unique ID for a pre-defined region */
  regionId: Maybe<Scalars['Int']>
  /** An array of strings that define the street number and name */
  street: Maybe<Array<Maybe<Scalars['String']>>>
  /** A value such as Sr., Jr., or III */
  suffix: Maybe<Scalars['String']>
  /** The telephone number */
  telephone: Maybe<Scalars['String']>
  /** The customer's Value-added tax (VAT) number (for corporate customers) */
  vatId: Maybe<Scalars['String']>
}

export interface CustomerAddressAttribute {
  __typename?: 'CustomerAddressAttribute'
  /** Attribute code */
  attributeCode: Maybe<Scalars['String']>
  /** Attribute value */
  value: Maybe<Scalars['String']>
}

export interface CustomerAddressAttributeInput {
  /** Attribute code */
  attribute_code: Scalars['String']
  /** Attribute value */
  value: Scalars['String']
}

export interface CustomerAddressInput {
  /** The city or town */
  city?: Maybe<Scalars['String']>
  /** The customer's company */
  company?: Maybe<Scalars['String']>
  /** The customer's country */
  country_code?: Maybe<CountryCodeEnum>
  /** Deprecated: use `country_code` instead. */
  country_id?: Maybe<CountryCodeEnum>
  /** Deprecated: Custom attributes should not be put into container. */
  custom_attributes?: Maybe<Array<Maybe<CustomerAddressAttributeInput>>>
  /** Indicates whether the address is the default billing address */
  default_billing?: Maybe<Scalars['Boolean']>
  /** Indicates whether the address is the default shipping address */
  default_shipping?: Maybe<Scalars['Boolean']>
  /** The fax number */
  fax?: Maybe<Scalars['String']>
  /** The first name of the person associated with the shipping/billing address */
  firstname?: Maybe<Scalars['String']>
  /** The family name of the person associated with the shipping/billing address */
  lastname?: Maybe<Scalars['String']>
  /** The middle name of the person associated with the shipping/billing address */
  middlename?: Maybe<Scalars['String']>
  /** The customer's ZIP or postal code */
  postcode?: Maybe<Scalars['String']>
  /** An honorific, such as Dr., Mr., or Mrs. */
  prefix?: Maybe<Scalars['String']>
  /** An object containing the region name, region code, and region ID */
  region?: Maybe<CustomerAddressRegionInput>
  /** An array of strings that define the street number and name */
  street?: Maybe<Array<Maybe<Scalars['String']>>>
  /** A value such as Sr., Jr., or III */
  suffix?: Maybe<Scalars['String']>
  /** The telephone number */
  telephone?: Maybe<Scalars['String']>
  /** The customer's Tax/VAT number (for corporate customers) */
  vat_id?: Maybe<Scalars['String']>
}

/** CustomerAddressRegion defines the customer's state or province */
export interface CustomerAddressRegion {
  __typename?: 'CustomerAddressRegion'
  /** The state or province name */
  region: Maybe<Scalars['String']>
  /** The address region code */
  regionCode: Maybe<Scalars['String']>
  /** The unique ID for a pre-defined region */
  regionId: Maybe<Scalars['Int']>
}

/** CustomerAddressRegionInput defines the customer's state or province */
export interface CustomerAddressRegionInput {
  /** The state or province name */
  region?: Maybe<Scalars['String']>
  /** The address region code */
  region_code?: Maybe<Scalars['String']>
  /** The unique ID for a pre-defined region */
  region_id?: Maybe<Scalars['Int']>
}

export interface CustomerInput {
  /** The customer's date of birth */
  date_of_birth?: Maybe<Scalars['String']>
  /** Deprecated: Use `date_of_birth` instead */
  dob?: Maybe<Scalars['String']>
  /** The customer's email address. Required for customer creation */
  email?: Maybe<Scalars['String']>
  /** The customer's first name */
  firstname?: Maybe<Scalars['String']>
  /** The customer's gender (Male - 1, Female - 2) */
  gender?: Maybe<Scalars['Int']>
  /** Indicates whether the customer is subscribed to the company's newsletter */
  is_subscribed?: Maybe<Scalars['Boolean']>
  /** The customer's family name */
  lastname?: Maybe<Scalars['String']>
  /** The customer's middle name */
  middlename?: Maybe<Scalars['String']>
  /** The customer's password */
  password?: Maybe<Scalars['String']>
  /** An honorific, such as Dr., Mr., or Mrs. */
  prefix?: Maybe<Scalars['String']>
  /** A value such as Sr., Jr., or III */
  suffix?: Maybe<Scalars['String']>
  /** The customer's Tax/VAT number (for corporate customers) */
  taxvat?: Maybe<Scalars['String']>
}

/** Customer order details */
export interface CustomerOrder {
  __typename?: 'CustomerOrder'
  billingAddress: CustomerOrderAddress
  createdAt: Maybe<Scalars['String']>
  customerNote: Maybe<Scalars['String']>
  discountAmount: Maybe<Money>
  discountDescription: Maybe<Scalars['String']>
  entityId: Scalars['Int']
  grandTotal: Maybe<Scalars['Float']>
  id: Maybe<Scalars['Int']>
  /** @deprecated Use the order_number instead. */
  incrementId: Maybe<Scalars['String']>
  items: Array<Maybe<CustomerOrderItem>>
  /** Delivery date of the order */
  orderDeliveryDate: Maybe<Scalars['String']>
  /** The order number */
  orderNumber: Scalars['String']
  payment: Maybe<CustomerOrderPayment>
  shipment: Maybe<Array<Maybe<CustomerOrderShipment>>>
  shippingAmount: Money
  shippingDiscountAmount: Maybe<Money>
  shippingInclTax: Money
  shippingTaxAmount: Money
  state: CustomerOrderStateEnum
  status: Scalars['String']
  subtotal: Money
  subtotalInclTax: Money
  taxAmount: Money
  totalDue: Money
  totalItemCount: Scalars['Float']
  totalPaid: Maybe<Money>
  totalQtyOrdered: Scalars['Float']
  updatedAt: Maybe<Scalars['String']>
}

/** Customer order shipment tracking information */
export interface CustomerOrderAddress {
  __typename?: 'CustomerOrderAddress'
  city: Scalars['String']
  company: Maybe<Scalars['String']>
  countryId: Scalars['String']
  email: Maybe<Scalars['String']>
  firstname: Scalars['String']
  lastname: Scalars['String']
  middlename: Maybe<Scalars['String']>
  postcode: Scalars['String']
  prefix: Maybe<Scalars['String']>
  region: Maybe<Region>
  street: Array<Maybe<Scalars['String']>>
  suffix: Maybe<Scalars['String']>
  telephone: Maybe<Scalars['String']>
  vatId: Maybe<Scalars['String']>
}

/** Customer order items */
export interface CustomerOrderItem {
  __typename?: 'CustomerOrderItem'
  amountRefunded: Maybe<Money>
  createdAt: Scalars['String']
  description: Maybe<Scalars['String']>
  discountAmount: Maybe<Money>
  discountInvoiced: Maybe<Money>
  discountPercent: Maybe<Scalars['Float']>
  discountRefunded: Maybe<Money>
  itemId: Scalars['Int']
  name: Maybe<Scalars['String']>
  originalPrice: Maybe<Money>
  parentItemId: Maybe<Scalars['Int']>
  price: Maybe<Money>
  priceInclTax: Maybe<Money>
  product: Maybe<ProductInterface>
  productOption: Maybe<Scalars['String']>
  qtyBackordered: Maybe<Scalars['Float']>
  qtyCanceled: Maybe<Scalars['Float']>
  qtyInvoiced: Maybe<Scalars['Float']>
  qtyOrdered: Maybe<Scalars['Float']>
  qtyRefunded: Maybe<Scalars['Float']>
  qtyReturned: Maybe<Scalars['Float']>
  qtyShipped: Maybe<Scalars['Float']>
  rowInvoiced: Maybe<Money>
  rowTotal: Maybe<Money>
  rowTotalInclTax: Maybe<Money>
  rowWeight: Maybe<Scalars['String']>
  sku: Scalars['String']
  taxAmount: Maybe<Money>
  taxBeforeDiscount: Maybe<Money>
  taxInvoiced: Maybe<Money>
  taxPercent: Maybe<Scalars['Float']>
  taxRefunded: Maybe<Money>
  updatedAt: Maybe<Scalars['String']>
  weight: Maybe<Scalars['Float']>
}

/** Customer order payment info */
export interface CustomerOrderPayment {
  __typename?: 'CustomerOrderPayment'
  amountPaid: Maybe<Money>
  amountRefunded: Maybe<Money>
  entityId: Scalars['Int']
  method: Scalars['String']
  methodTitle: Maybe<Scalars['String']>
  shippingAmount: Maybe<Money>
  shippingCaptured: Maybe<Money>
}

/** Customer order result */
export interface CustomerOrderResult {
  __typename?: 'CustomerOrderResult'
  items: Maybe<Array<Maybe<CustomerOrder>>>
  totalCount: Maybe<Scalars['Int']>
}

export interface CustomerOrders {
  __typename?: 'CustomerOrders'
  /** Array of orders */
  items: Maybe<Array<Maybe<CustomerOrder>>>
}

/** Customer order shipment */
export interface CustomerOrderShipment {
  __typename?: 'CustomerOrderShipment'
  billingAddress: Maybe<CustomerOrderAddress>
  createdAt: Scalars['String']
  /** Date of delivery */
  deliveryDate: Maybe<Scalars['String']>
  /** Ending of delivery timeslot */
  deliveryTimeEnd: Maybe<Scalars['String']>
  /** Beginning of delivery timeslot */
  deliveryTimeStart: Maybe<Scalars['String']>
  entityId: Scalars['Int']
  incrementId: Scalars['String']
  items: Maybe<Array<Maybe<CustomerOrderShippingItem>>>
  /** Pick-up Location Code */
  pickupLocationCode: Maybe<Scalars['String']>
  /** Pick-up Retail Network ID */
  pickupRetailNetworkId: Maybe<Scalars['String']>
  /** Pick-up Order Address ID */
  pickupStoreId: Maybe<Scalars['String']>
  shippingAddress: Maybe<CustomerOrderAddress>
  shippingLabel: Maybe<Scalars['String']>
  /** Pick-up or delivery */
  shippingMethod: Maybe<Scalars['String']>
  /** Type of delivery, like: Morning, Daytime, Evening */
  shippingType: Maybe<Scalars['String']>
  status: Maybe<Scalars['String']>
  /** Store where order will be picked up */
  storeLocation: Maybe<Scalars['String']>
  totalQty: Scalars['Float']
  totalWeight: Maybe<Scalars['Float']>
  tracks: Maybe<Array<Maybe<CustomerOrderShippingTrack>>>
  updatedAt: Maybe<Scalars['String']>
}

/** Customer order shipment item */
export interface CustomerOrderShippingItem {
  __typename?: 'CustomerOrderShippingItem'
  description: Maybe<Scalars['String']>
  name: Maybe<Scalars['String']>
  price: Money
  product: Maybe<ProductInterface>
  qty: Maybe<Scalars['Float']>
  rowTotal: Maybe<Money>
  sku: Scalars['String']
  weight: Maybe<Scalars['Float']>
}

/** Customer order shipment tracking information */
export interface CustomerOrderShippingTrack {
  __typename?: 'CustomerOrderShippingTrack'
  carrierCode: Maybe<Scalars['String']>
  createdAt: Scalars['String']
  description: Maybe<Scalars['String']>
  qty: Maybe<Scalars['Float']>
  title: Maybe<Scalars['String']>
  trackingNumber: Maybe<Scalars['String']>
  updatedAt: Maybe<Scalars['String']>
  weight: Maybe<Scalars['Float']>
}

/** Possible order states */
export enum CustomerOrderStateEnum {
  NEW = 'NEW',
  PENDING_PAYMENT = 'PENDING_PAYMENT',
  PROCESSING = 'PROCESSING',
  COMPLETE = 'COMPLETE',
  CLOSED = 'CLOSED',
  CANCELED = 'CANCELED',
  HOLDED = 'HOLDED',
  PAYMENT_REVIEW = 'PAYMENT_REVIEW',
}

export interface CustomerOutput {
  __typename?: 'CustomerOutput'
  customer: Customer
}

export interface CustomerToken {
  __typename?: 'CustomerToken'
  /** The customer token */
  token: Maybe<Scalars['String']>
}

/** CustomizableAreaOption contains information about a text area that is defined as part of a customizable option. */
export interface CustomizableAreaOption extends CustomizableOptionInterface {
  __typename?: 'CustomizableAreaOption'
  /** Option ID. */
  optionId: Maybe<Scalars['Int']>
  /** The Stock Keeping Unit of the base product. */
  productSku: Maybe<Scalars['String']>
  /** Indicates whether the option is required. */
  required: Maybe<Scalars['Boolean']>
  /** The order in which the option is displayed. */
  sortOrder: Maybe<Scalars['Int']>
  /** The display name for this option. */
  title: Maybe<Scalars['String']>
  /** An object that defines a text area. */
  value: Maybe<CustomizableAreaValue>
}

/** CustomizableAreaValue defines the price and sku of a product whose page contains a customized text area. */
export interface CustomizableAreaValue {
  __typename?: 'CustomizableAreaValue'
  /** The maximum number of characters that can be entered for this customizable option. */
  maxCharacters: Maybe<Scalars['Int']>
  /** The price assigned to this option. */
  price: Maybe<Scalars['Float']>
  /** FIXED, PERCENT, or DYNAMIC. */
  priceType: Maybe<PriceTypeEnum>
  /** The Stock Keeping Unit for this option. */
  sku: Maybe<Scalars['String']>
}

/**
 * CustomizableCheckbbixOption contains information about a set of checkbox values
 * that are defined as part of a customizable option.
 */
export interface CustomizableCheckboxOption
  extends CustomizableOptionInterface {
  __typename?: 'CustomizableCheckboxOption'
  /** Option ID. */
  optionId: Maybe<Scalars['Int']>
  /** Indicates whether the option is required. */
  required: Maybe<Scalars['Boolean']>
  /** The order in which the option is displayed. */
  sortOrder: Maybe<Scalars['Int']>
  /** The display name for this option. */
  title: Maybe<Scalars['String']>
  /** An array that defines a set of checkbox values. */
  value: Maybe<Array<Maybe<CustomizableCheckboxValue>>>
}

/** CustomizableCheckboxValue defines the price and sku of a product whose page contains a customized set of checkbox values. */
export interface CustomizableCheckboxValue {
  __typename?: 'CustomizableCheckboxValue'
  /** The ID assigned to the value. */
  optionTypeId: Maybe<Scalars['Int']>
  /** The price assigned to this option. */
  price: Maybe<Scalars['Float']>
  /** FIXED, PERCENT, or DYNAMIC. */
  priceType: Maybe<PriceTypeEnum>
  /** The Stock Keeping Unit for this option. */
  sku: Maybe<Scalars['String']>
  /** The order in which the checkbox value is displayed. */
  sortOrder: Maybe<Scalars['Int']>
  /** The display name for this option. */
  title: Maybe<Scalars['String']>
}

/** CustomizableDateOption contains information about a date picker that is defined as part of a customizable option. */
export interface CustomizableDateOption extends CustomizableOptionInterface {
  __typename?: 'CustomizableDateOption'
  /** Option ID. */
  optionId: Maybe<Scalars['Int']>
  /** The Stock Keeping Unit of the base product. */
  productSku: Maybe<Scalars['String']>
  /** Indicates whether the option is required. */
  required: Maybe<Scalars['Boolean']>
  /** The order in which the option is displayed. */
  sortOrder: Maybe<Scalars['Int']>
  /** The display name for this option. */
  title: Maybe<Scalars['String']>
  /** An object that defines a date field in a customizable option. */
  value: Maybe<CustomizableDateValue>
}

/** CustomizableDateValue defines the price and sku of a product whose page contains a customized date picker. */
export interface CustomizableDateValue {
  __typename?: 'CustomizableDateValue'
  /** The price assigned to this option. */
  price: Maybe<Scalars['Float']>
  /** FIXED, PERCENT, or DYNAMIC. */
  priceType: Maybe<PriceTypeEnum>
  /** The Stock Keeping Unit for this option. */
  sku: Maybe<Scalars['String']>
}

/** CustomizableDropDownOption contains information about a drop down menu that is defined as part of a customizable option. */
export interface CustomizableDropDownOption
  extends CustomizableOptionInterface {
  __typename?: 'CustomizableDropDownOption'
  /** Option ID. */
  optionId: Maybe<Scalars['Int']>
  /** Indicates whether the option is required. */
  required: Maybe<Scalars['Boolean']>
  /** The order in which the option is displayed. */
  sortOrder: Maybe<Scalars['Int']>
  /** The display name for this option. */
  title: Maybe<Scalars['String']>
  /** An array that defines the set of options for a drop down menu. */
  value: Maybe<Array<Maybe<CustomizableDropDownValue>>>
}

/** CustomizableDropDownValue defines the price and sku of a product whose page contains a customized drop down menu. */
export interface CustomizableDropDownValue {
  __typename?: 'CustomizableDropDownValue'
  /** The ID assigned to the value. */
  optionTypeId: Maybe<Scalars['Int']>
  /** The price assigned to this option. */
  price: Maybe<Scalars['Float']>
  /** FIXED, PERCENT, or DYNAMIC. */
  priceType: Maybe<PriceTypeEnum>
  /** The Stock Keeping Unit for this option. */
  sku: Maybe<Scalars['String']>
  /** The order in which the option is displayed. */
  sortOrder: Maybe<Scalars['Int']>
  /** The display name for this option. */
  title: Maybe<Scalars['String']>
}

/** CustomizableFieldOption contains information about a text field that is defined as part of a customizable option. */
export interface CustomizableFieldOption extends CustomizableOptionInterface {
  __typename?: 'CustomizableFieldOption'
  /** Option ID. */
  optionId: Maybe<Scalars['Int']>
  /** The Stock Keeping Unit of the base product. */
  productSku: Maybe<Scalars['String']>
  /** Indicates whether the option is required. */
  required: Maybe<Scalars['Boolean']>
  /** The order in which the option is displayed. */
  sortOrder: Maybe<Scalars['Int']>
  /** The display name for this option. */
  title: Maybe<Scalars['String']>
  /** An object that defines a text field. */
  value: Maybe<CustomizableFieldValue>
}

/** CustomizableFieldValue defines the price and sku of a product whose page contains a customized text field. */
export interface CustomizableFieldValue {
  __typename?: 'CustomizableFieldValue'
  /** The maximum number of characters that can be entered for this customizable option. */
  maxCharacters: Maybe<Scalars['Int']>
  /** The price of the custom value. */
  price: Maybe<Scalars['Float']>
  /** FIXED, PERCENT, or DYNAMIC. */
  priceType: Maybe<PriceTypeEnum>
  /** The Stock Keeping Unit for this option. */
  sku: Maybe<Scalars['String']>
}

/** CustomizableFileOption contains information about a file picker that is defined as part of a customizable option. */
export interface CustomizableFileOption extends CustomizableOptionInterface {
  __typename?: 'CustomizableFileOption'
  /** Option ID. */
  optionId: Maybe<Scalars['Int']>
  /** The Stock Keeping Unit of the base product. */
  productSku: Maybe<Scalars['String']>
  /** Indicates whether the option is required. */
  required: Maybe<Scalars['Boolean']>
  /** The order in which the option is displayed. */
  sortOrder: Maybe<Scalars['Int']>
  /** The display name for this option. */
  title: Maybe<Scalars['String']>
  /** An object that defines a file value. */
  value: Maybe<CustomizableFileValue>
}

/** CustomizableFileValue defines the price and sku of a product whose page contains a customized file picker. */
export interface CustomizableFileValue {
  __typename?: 'CustomizableFileValue'
  /** The file extension to accept. */
  fileExtension: Maybe<Scalars['String']>
  /** The maximum width of an image. */
  imageSizeX: Maybe<Scalars['Int']>
  /** The maximum height of an image. */
  imageSizeY: Maybe<Scalars['Int']>
  /** The price assigned to this option. */
  price: Maybe<Scalars['Float']>
  /** FIXED, PERCENT, or DYNAMIC. */
  priceType: Maybe<PriceTypeEnum>
  /** The Stock Keeping Unit for this option. */
  sku: Maybe<Scalars['String']>
}

/** CustomizableMultipleOption contains information about a multiselect that is defined as part of a customizable option. */
export interface CustomizableMultipleOption
  extends CustomizableOptionInterface {
  __typename?: 'CustomizableMultipleOption'
  /** Option ID. */
  optionId: Maybe<Scalars['Int']>
  /** Indicates whether the option is required. */
  required: Maybe<Scalars['Boolean']>
  /** The order in which the option is displayed. */
  sortOrder: Maybe<Scalars['Int']>
  /** The display name for this option. */
  title: Maybe<Scalars['String']>
  /** An array that defines the set of options for a multiselect. */
  value: Maybe<Array<Maybe<CustomizableMultipleValue>>>
}

/** CustomizableMultipleValue defines the price and sku of a product whose page contains a customized multiselect. */
export interface CustomizableMultipleValue {
  __typename?: 'CustomizableMultipleValue'
  /** The ID assigned to the value. */
  optionTypeId: Maybe<Scalars['Int']>
  /** The price assigned to this option. */
  price: Maybe<Scalars['Float']>
  /** FIXED, PERCENT, or DYNAMIC. */
  priceType: Maybe<PriceTypeEnum>
  /** The Stock Keeping Unit for this option. */
  sku: Maybe<Scalars['String']>
  /** The order in which the option is displayed. */
  sortOrder: Maybe<Scalars['Int']>
  /** The display name for this option. */
  title: Maybe<Scalars['String']>
}

export interface CustomizableOptionInput {
  id: Scalars['Int']
  value_string: Scalars['String']
}

/**
 * The CustomizableOptionInterface contains basic information about a customizable
 * option. It can be implemented by several types of configurable options.
 */
export interface CustomizableOptionInterface {
  /** Option ID. */
  optionId: Maybe<Scalars['Int']>
  /** Indicates whether the option is required. */
  required: Maybe<Scalars['Boolean']>
  /** The order in which the option is displayed. */
  sortOrder: Maybe<Scalars['Int']>
  /** The display name for this option. */
  title: Maybe<Scalars['String']>
}

/** CustomizableProductInterface contains information about customizable product options. */
export interface CustomizableProductInterface {
  /** An array of options for a customizable product. */
  options: Maybe<Array<Maybe<CustomizableOptionInterface>>>
}

/** CustomizableRadioOption contains information about a set of radio buttons that are defined as part of a customizable option. */
export interface CustomizableRadioOption extends CustomizableOptionInterface {
  __typename?: 'CustomizableRadioOption'
  /** Option ID. */
  optionId: Maybe<Scalars['Int']>
  /** Indicates whether the option is required. */
  required: Maybe<Scalars['Boolean']>
  /** The order in which the option is displayed. */
  sortOrder: Maybe<Scalars['Int']>
  /** The display name for this option. */
  title: Maybe<Scalars['String']>
  /** An array that defines a set of radio buttons. */
  value: Maybe<Array<Maybe<CustomizableRadioValue>>>
}

/** CustomizableRadioValue defines the price and sku of a product whose page contains a customized set of radio buttons. */
export interface CustomizableRadioValue {
  __typename?: 'CustomizableRadioValue'
  /** The ID assigned to the value. */
  optionTypeId: Maybe<Scalars['Int']>
  /** The price assigned to this option. */
  price: Maybe<Scalars['Float']>
  /** FIXED, PERCENT, or DYNAMIC. */
  priceType: Maybe<PriceTypeEnum>
  /** The Stock Keeping Unit for this option. */
  sku: Maybe<Scalars['String']>
  /** The order in which the radio button is displayed. */
  sortOrder: Maybe<Scalars['Int']>
  /** The display name for this option. */
  title: Maybe<Scalars['String']>
}

export interface DetailedSummary {
  __typename?: 'DetailedSummary'
  /** Five stars. */
  five: Maybe<Scalars['Int']>
  /** Four stars. */
  four: Maybe<Scalars['Int']>
  /** One star. */
  one: Maybe<Scalars['Int']>
  /** Three stars. */
  three: Maybe<Scalars['Int']>
  /** Two stars. */
  two: Maybe<Scalars['Int']>
}

/** Defines an individual discount. A discount can be applied to the cart as a whole or to an item. */
export interface Discount {
  __typename?: 'Discount'
  /** The amount of the discount */
  amount: Money
  /** A description of the discount */
  label: Scalars['String']
}

/** A prismic document */
export interface Document {
  meta: Meta
}

/** A connection to a list of items. */
export interface DocumentConnection {
  __typename?: 'DocumentConnection'
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  /** A list of edges. */
  edges: Maybe<Array<Maybe<DocumentEdge>>>
  totalCount: Scalars['Long']
}

/** An edge in a connection. */
export interface DocumentEdge {
  __typename?: 'DocumentEdge'
  /** The item at the end of the edge. */
  node: Document
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
}

/** EntityUrl is an output object containing the `id`, `relative_url`, and `type` attributes */
export interface EntityUrl {
  __typename?: 'EntityUrl'
  /** @deprecated The canonical_url field is deprecated, use relative_url instead. */
  canonicalUrl: Maybe<Scalars['String']>
  /** The ID assigned to the object associated with the specified url. This could be a product ID, category ID, or page ID. */
  id: Maybe<Scalars['Int']>
  /** 301 or 302 HTTP code for url permanent or temporary redirect or 0 for the 200 no redirect */
  redirectCode: Maybe<Scalars['Int']>
  /** The internal relative URL. If the specified  url is a redirect, the query returns the redirected URL, not the original. */
  relativeUrl: Maybe<Scalars['String']>
  /** One of PRODUCT, CATEGORY, or CMS_PAGE. */
  type: Maybe<UrlRewriteEntityTypeEnum>
  prismicType: Maybe<Scalars['String']>
  authRequired: Maybe<Scalars['Boolean']>
  product: Maybe<ProductInterface>
}

export interface ExchangeRate {
  __typename?: 'ExchangeRate'
  currencyTo: Maybe<Scalars['String']>
  rate: Maybe<Scalars['Float']>
}

/** An external link */
export interface ExternalLink extends Linkable {
  __typename?: 'ExternalLink'
  url: Scalars['String']
  target: Maybe<Scalars['String']>
  linkType: Maybe<Scalars['String']>
}

export interface FacetSettings {
  __typename?: 'FacetSettings'
  facetId: Scalars['Int']
  isVisible: Scalars['Boolean']
  attributeName: Scalars['ID']
  urlKey: Scalars['String']
  title: Scalars['String']
  isCollapsible: Scalars['Boolean']
  isCollapsed: Scalars['Boolean']
  nrOfShownAttributes: Scalars['Int']
  expandText: Scalars['String']
  collapseText: Scalars['String']
  isMultiSelect: Scalars['Boolean']
  multiSelectLogic: Maybe<Scalars['TODO']>
  selectionType: Scalars['String']
  nrOfColumns: Scalars['Int']
  isNrOfResultsVisible: Scalars['Boolean']
  isInfoVisible: Scalars['Boolean']
  infoText: Maybe<Scalars['String']>
  containsClickPoints: Scalars['Boolean']
  containsBuckets: Scalars['Boolean']
  source: Scalars['String']
  prefix: Maybe<Scalars['String']>
  postfix: Maybe<Scalars['String']>
  cssClass: Maybe<Scalars['String']>
}

export interface Faqcategory extends Document, Linkable {
  __typename?: 'Faqcategory'
  categoryName: Maybe<Scalars['String']>
  icon: Maybe<Scalars['Json']>
  categoryOrder: Maybe<Scalars['Float']>
  meta: Meta
  linkType: Maybe<Scalars['String']>
}

/** A connection to a list of items. */
export interface FaqcategoryConnectionConnection {
  __typename?: 'FaqcategoryConnectionConnection'
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  /** A list of edges. */
  edges: Maybe<Array<Maybe<FaqcategoryConnectionEdge>>>
  totalCount: Scalars['Long']
}

/** An edge in a connection. */
export interface FaqcategoryConnectionEdge {
  __typename?: 'FaqcategoryConnectionEdge'
  /** The item at the end of the edge. */
  node: Faqcategory
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
}

export interface Faqsubject extends Document, Linkable {
  __typename?: 'Faqsubject'
  subjectName: Maybe<Scalars['String']>
  subjectCategory: Maybe<PrismicHyperlink>
  subjectOrder: Maybe<Scalars['Float']>
  body: Maybe<Array<FaqsubjectBody>>
  meta: Meta
  linkType: Maybe<Scalars['String']>
}

export type FaqsubjectBody = FaqsubjectBodyFaqsubject

export interface FaqsubjectBodyFaqsubject {
  __typename?: 'FaqsubjectBodyFaqsubject'
  type: Maybe<Scalars['String']>
  label: Maybe<Scalars['String']>
  fields: Maybe<Array<FaqsubjectBodyFaqsubjectFields>>
}

export interface FaqsubjectBodyFaqsubjectFields {
  __typename?: 'FaqsubjectBodyFaqsubjectFields'
  question: Maybe<Scalars['String']>
  answer: Maybe<Scalars['Json']>
  highlighted: Maybe<Scalars['Json']>
  questionOrder: Maybe<Scalars['Float']>
}

/** A connection to a list of items. */
export interface FaqsubjectConnectionConnection {
  __typename?: 'FaqsubjectConnectionConnection'
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  /** A list of edges. */
  edges: Maybe<Array<Maybe<FaqsubjectConnectionEdge>>>
  totalCount: Scalars['Long']
}

/** An edge in a connection. */
export interface FaqsubjectConnectionEdge {
  __typename?: 'FaqsubjectConnectionEdge'
  /** The item at the end of the edge. */
  node: Faqsubject
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
}

/** A linked file */
export interface FileLink extends Linkable {
  __typename?: 'FileLink'
  name: Scalars['String']
  url: Scalars['String']
  size: Scalars['Long']
  linkType: Maybe<Scalars['String']>
}

/** Defines a filter that matches the input exactly. */
export interface FilterEqualTypeInput {
  /** A string to filter on */
  eq?: Maybe<Scalars['String']>
  /** An array of values to filter on */
  in?: Maybe<Array<Maybe<Scalars['String']>>>
}

/** Defines a filter that performs a fuzzy search. */
export interface FilterMatchTypeInput {
  /** One or more words to filter on */
  match?: Maybe<Scalars['String']>
}

/** Defines a filter that matches a range of values, such as prices or dates. */
export interface FilterRangeTypeInput {
  /** The beginning of the range */
  from?: Maybe<Scalars['String']>
  /** The end of the range */
  to?: Maybe<Scalars['String']>
}

/** FilterTypeInput specifies which action will be performed in a query  */
export interface FilterTypeInput {
  /** Equals */
  eq?: Maybe<Scalars['String']>
  finset?: Maybe<Array<Maybe<Scalars['String']>>>
  /** From. Must be used with 'to' */
  from?: Maybe<Scalars['String']>
  /** Greater than */
  gt?: Maybe<Scalars['String']>
  /** Greater than or equal to */
  gteq?: Maybe<Scalars['String']>
  /** In. The value can contain a set of comma-separated values */
  in?: Maybe<Array<Maybe<Scalars['String']>>>
  /** Like. The specified value can contain % (percent signs) to allow matching of 0 or more characters */
  like?: Maybe<Scalars['String']>
  /** Less than */
  lt?: Maybe<Scalars['String']>
  /** Less than or equal to */
  lteq?: Maybe<Scalars['String']>
  /** More than or equal to */
  moreq?: Maybe<Scalars['String']>
  /** Not equal to */
  neq?: Maybe<Scalars['String']>
  /** Not in. The value can contain a set of comma-separated values */
  nin?: Maybe<Array<Maybe<Scalars['String']>>>
  /** Not null */
  notnull?: Maybe<Scalars['String']>
  /** Is null */
  null?: Maybe<Scalars['String']>
  /** To. Must be used with 'from' */
  to?: Maybe<Scalars['String']>
}

/** A single FPT that can be applied to a product price. */
export interface FixedProductTax {
  __typename?: 'FixedProductTax'
  /** Amount of the FPT as a money object. */
  amount: Maybe<Money>
  /** The label assigned to the FPT to be displayed on the frontend. */
  label: Maybe<Scalars['String']>
}

/** This enumeration display settings for the fixed product tax */
export enum FixedProductTaxDisplaySettings {
  /**
   * The displayed price includes the FPT amount without displaying the
   * ProductPrice.fixed_product_taxes values. This value corresponds to 'Including FPT only'
   */
  INCLUDE_FPT_WITHOUT_DETAILS = 'INCLUDE_FPT_WITHOUT_DETAILS',
  /**
   * The displayed price includes the FPT amount while displaying the values of
   * ProductPrice.fixed_product_taxes separately. This value corresponds to
   * 'Including FPT and FPT description'
   */
  INCLUDE_FPT_WITH_DETAILS = 'INCLUDE_FPT_WITH_DETAILS',
  /**
   * The displayed price does not include the FPT amount. The values of
   * ProductPrice.fixed_product_taxes and the price including the FPT are displayed
   * separately. This value corresponds to 'Excluding FPT, Including FPT
   * description and final price'
   */
  EXCLUDE_FPT_AND_INCLUDE_WITH_DETAILS = 'EXCLUDE_FPT_AND_INCLUDE_WITH_DETAILS',
  /**
   * The displayed price does not include the FPT amount. The values from
   * ProductPrice.fixed_product_taxes are not displayed. This value corresponds to
   * 'Excluding FPT'
   */
  EXCLUDE_FPT_WITHOUT_DETAILS = 'EXCLUDE_FPT_WITHOUT_DETAILS',
  /** The FPT feature is not enabled. You can omit  ProductPrice.fixed_product_taxes from your query */
  FPT_DISABLED = 'FPT_DISABLED',
}

export interface Form extends Document, Linkable {
  __typename?: 'Form'
  title: Maybe<Scalars['Json']>
  explanation: Maybe<Scalars['Json']>
  submit: Maybe<Scalars['String']>
  successMessage: Maybe<Scalars['Json']>
  productHeaderSubtitle: Maybe<Scalars['String']>
  twoColumnGridOnDesktop: Maybe<Scalars['Json']>
  body: Maybe<Array<FormBody>>
  meta: Meta
  linkType: Maybe<Scalars['String']>
}

export type FormBody =
  | FormBodyTextField
  | FormBodySelectField
  | FormBodyRadioField
  | FormBodyCheckboxField
  | FormBodyTextareaField
  | FormBodyHiddenField
  | FormBodyEmailField
  | FormBodyTelephoneField
  | FormBodyProductIdField

export interface FormBodyCheckboxField {
  __typename?: 'FormBodyCheckboxField'
  type: Maybe<Scalars['String']>
  label: Maybe<Scalars['String']>
  primary: Maybe<FormBodyCheckboxFieldPrimary>
}

export interface FormBodyCheckboxFieldPrimary {
  __typename?: 'FormBodyCheckboxFieldPrimary'
  key: Maybe<Scalars['String']>
  label: Maybe<Scalars['String']>
  required: Maybe<Scalars['Json']>
}

export interface FormBodyEmailField {
  __typename?: 'FormBodyEmailField'
  type: Maybe<Scalars['String']>
  label: Maybe<Scalars['String']>
  primary: Maybe<FormBodyEmailFieldPrimary>
}

export interface FormBodyEmailFieldPrimary {
  __typename?: 'FormBodyEmailFieldPrimary'
  key: Maybe<Scalars['String']>
  label: Maybe<Scalars['String']>
  required: Maybe<Scalars['Json']>
}

export interface FormBodyHiddenField {
  __typename?: 'FormBodyHiddenField'
  type: Maybe<Scalars['String']>
  label: Maybe<Scalars['String']>
  primary: Maybe<FormBodyHiddenFieldPrimary>
}

export interface FormBodyHiddenFieldPrimary {
  __typename?: 'FormBodyHiddenFieldPrimary'
  key: Maybe<Scalars['String']>
  value: Maybe<Scalars['String']>
}

export interface FormBodyProductIdField {
  __typename?: 'FormBodyProductIdField'
  type: Maybe<Scalars['String']>
  label: Maybe<Scalars['String']>
  primary: Maybe<FormBodyProductIdFieldPrimary>
}

export interface FormBodyProductIdFieldPrimary {
  __typename?: 'FormBodyProductIdFieldPrimary'
  key: Maybe<Scalars['String']>
}

export interface FormBodyRadioField {
  __typename?: 'FormBodyRadioField'
  type: Maybe<Scalars['String']>
  label: Maybe<Scalars['String']>
  primary: Maybe<FormBodyRadioFieldPrimary>
  fields: Maybe<Array<FormBodyRadioFieldFields>>
}

export interface FormBodyRadioFieldFields {
  __typename?: 'FormBodyRadioFieldFields'
  option: Maybe<Scalars['String']>
}

export interface FormBodyRadioFieldPrimary {
  __typename?: 'FormBodyRadioFieldPrimary'
  key: Maybe<Scalars['String']>
  label: Maybe<Scalars['String']>
}

export interface FormBodySelectField {
  __typename?: 'FormBodySelectField'
  type: Maybe<Scalars['String']>
  label: Maybe<Scalars['String']>
  primary: Maybe<FormBodySelectFieldPrimary>
  fields: Maybe<Array<FormBodySelectFieldFields>>
}

export interface FormBodySelectFieldFields {
  __typename?: 'FormBodySelectFieldFields'
  option: Maybe<Scalars['String']>
}

export interface FormBodySelectFieldPrimary {
  __typename?: 'FormBodySelectFieldPrimary'
  key: Maybe<Scalars['String']>
  label: Maybe<Scalars['String']>
  required: Maybe<Scalars['Json']>
}

export interface FormBodyTelephoneField {
  __typename?: 'FormBodyTelephoneField'
  type: Maybe<Scalars['String']>
  label: Maybe<Scalars['String']>
  primary: Maybe<FormBodyTelephoneFieldPrimary>
}

export interface FormBodyTelephoneFieldPrimary {
  __typename?: 'FormBodyTelephoneFieldPrimary'
  key: Maybe<Scalars['String']>
  label: Maybe<Scalars['String']>
  required: Maybe<Scalars['Json']>
}

export interface FormBodyTextareaField {
  __typename?: 'FormBodyTextareaField'
  type: Maybe<Scalars['String']>
  label: Maybe<Scalars['String']>
  primary: Maybe<FormBodyTextareaFieldPrimary>
}

export interface FormBodyTextareaFieldPrimary {
  __typename?: 'FormBodyTextareaFieldPrimary'
  key: Maybe<Scalars['String']>
  label: Maybe<Scalars['String']>
  required: Maybe<Scalars['Json']>
}

export interface FormBodyTextField {
  __typename?: 'FormBodyTextField'
  type: Maybe<Scalars['String']>
  label: Maybe<Scalars['String']>
  primary: Maybe<FormBodyTextFieldPrimary>
}

export interface FormBodyTextFieldPrimary {
  __typename?: 'FormBodyTextFieldPrimary'
  key: Maybe<Scalars['String']>
  label: Maybe<Scalars['String']>
  required: Maybe<Scalars['Json']>
}

/** A connection to a list of items. */
export interface FormConnectionConnection {
  __typename?: 'FormConnectionConnection'
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  /** A list of edges. */
  edges: Maybe<Array<Maybe<FormConnectionEdge>>>
  totalCount: Scalars['Long']
}

/** An edge in a connection. */
export interface FormConnectionEdge {
  __typename?: 'FormConnectionEdge'
  /** The item at the end of the edge. */
  node: Form
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
}

export interface GatewayOrderResultFormField {
  __typename?: 'GatewayOrderResultFormField'
  field: Scalars['String']
  value: Scalars['String']
}

export interface GoogleAccount {
  __typename?: 'GoogleAccount'
  name: Scalars['String']
  accountName: Scalars['String']
  accountNumber: Scalars['ID']
}

export interface GoogleLocationAddress {
  __typename?: 'GoogleLocationAddress'
  regionCode: Maybe<Scalars['String']>
  languageCode: Maybe<Scalars['String']>
  postalCode: Maybe<Scalars['String']>
  locality: Maybe<Scalars['String']>
  sublocality: Maybe<Scalars['String']>
  addressLines: Maybe<Array<Scalars['String']>>
  recipients: Maybe<Array<Scalars['String']>>
  organization: Maybe<Scalars['String']>
}

export interface GoogleLocationAssociation {
  __typename?: 'GoogleLocationAssociation'
  category: Maybe<GoogleLocationAssociationCategory>
  priceListItemId: Maybe<Scalars['String']>
}

export enum GoogleLocationAssociationCategory {
  CATEGORY_UNSPECIFIED = 'CATEGORY_UNSPECIFIED',
  COVER = 'COVER',
  PROFILE = 'PROFILE',
  LOGO = 'LOGO',
  EXTERIOR = 'EXTERIOR',
  INTERIOR = 'INTERIOR',
  PRODUCT = 'PRODUCT',
  AT_WORK = 'AT_WORK',
  FOOD_AND_DRINK = 'FOOD_AND_DRINK',
  MENU = 'MENU',
  COMMON_AREA = 'COMMON_AREA',
  ROOMS = 'ROOMS',
  TEAMS = 'TEAMS',
  ADDITIONAL = 'ADDITIONAL',
}

export interface GoogleLocationCategory {
  __typename?: 'GoogleLocationCategory'
  displayName: Maybe<Scalars['String']>
  categoryId: Maybe<Scalars['String']>
  serviceTypes: Maybe<Array<GoogleLocationServiceType>>
}

export interface GoogleLocationDate {
  __typename?: 'GoogleLocationDate'
  year: Maybe<Scalars['Int']>
  month: Maybe<Scalars['Int']>
  day: Maybe<Scalars['Int']>
}

export enum GoogleLocationDayOfWeek {
  DAY_OF_WEEK_UNSPECIFIED = 'DAY_OF_WEEK_UNSPECIFIED',
  MONDAY = 'MONDAY',
  TUESDAY = 'TUESDAY',
  WEDNESDAY = 'WEDNESDAY',
  THURSDAY = 'THURSDAY',
  FRIDAY = 'FRIDAY',
  SATURDAY = 'SATURDAY',
  SUNDAY = 'SUNDAY',
}

export interface GoogleLocationInfo {
  __typename?: 'GoogleLocationInfo'
  /**
   * The Unique location name belonging to the GMB User/Group
   * This is also used for get location queries
   */
  name: Scalars['ID']
  languageCode: Scalars['String']
  /** Internal Google StoreCode */
  storeCode: Maybe<Scalars['ID']>
  /** The read-only location name specified by the business owner */
  locationName: Scalars['String']
  /** Contains info about the Google Places API location */
  primaryPhone: Maybe<Scalars['String']>
  additionalPhones: Maybe<Array<Scalars['String']>>
  address: Maybe<GoogleLocationAddress>
  primaryCategory: Maybe<GoogleLocationCategory>
  additionalCategories: Maybe<Array<GoogleLocationCategory>>
  websiteUrl: Maybe<Scalars['String']>
  regularHours: Maybe<GoogleLocationRegularHours>
  specialHours: Maybe<GoogleLocationSpecialHours>
  locationKey: Maybe<GoogleLocationKey>
  labels: Maybe<Array<Scalars['String']>>
  latlng: Maybe<GoogleLocationLatLong>
  openInfo: Maybe<GoogleLocationOpenInfo>
  locationState: Maybe<GoogleLocationState>
  metadata: Maybe<GoogleLocationMetaData>
  profile: Maybe<GoogleLocationProfile>
  relationshipData: Maybe<GoogleLocationRelationshipData>
  /** Retrieves the COVER image url from the Location media */
  coverUrl: Maybe<Scalars['String']>
  /** Retrieves the COVER thumbnail image url from the Location media */
  coverThumbnailUrl: Maybe<Scalars['String']>
  /** Retrieves all Location media */
  media: GoogleLocationMedia
}

export interface GoogleLocationKey {
  __typename?: 'GoogleLocationKey'
  plusPageId: Maybe<Scalars['String']>
  placeId: Maybe<Scalars['ID']>
  explicitNoPlaceId: Maybe<Scalars['Boolean']>
  requestId: Scalars['ID']
}

export interface GoogleLocationLatLong {
  __typename?: 'GoogleLocationLatLong'
  latitude: Maybe<Scalars['Float']>
  longitude: Maybe<Scalars['Float']>
}

export interface GoogleLocationMedia {
  __typename?: 'GoogleLocationMedia'
  mediaItems: Maybe<Array<GoogleLocationMediaItem>>
  totalMediaItemCount: Maybe<Scalars['Int']>
}

export interface GoogleLocationMediaAttribution {
  __typename?: 'GoogleLocationMediaAttribution'
  profileName: Maybe<Scalars['String']>
  profilePhotoUrl: Maybe<Scalars['String']>
  takedownUrl: Maybe<Scalars['String']>
  profileUrl: Maybe<Scalars['String']>
}

export interface GoogleLocationMediaDimensions {
  __typename?: 'GoogleLocationMediaDimensions'
  widthPixels: Maybe<Scalars['Int']>
  heightPixels: Maybe<Scalars['Int']>
}

export enum GoogleLocationMediaFormat {
  MEDIA_FORMAT_UNSPECIFIED = 'MEDIA_FORMAT_UNSPECIFIED',
  PHOTO = 'PHOTO',
  VIDEO = 'VIDEO',
}

export interface GoogleLocationMediaInsights {
  __typename?: 'GoogleLocationMediaInsights'
  viewCount: Maybe<Scalars['String']>
}

export interface GoogleLocationMediaItem {
  __typename?: 'GoogleLocationMediaItem'
  name: Maybe<Scalars['String']>
  mediaFormat: Maybe<GoogleLocationMediaFormat>
  locationAssociation: Maybe<GoogleLocationAssociation>
  googleUrl: Maybe<Scalars['String']>
  thumbnailUrl: Maybe<Scalars['String']>
  createTime: Maybe<Scalars['String']>
  dimensions: Maybe<GoogleLocationMediaDimensions>
  insights: Maybe<GoogleLocationMediaInsights>
  attribution: Maybe<GoogleLocationMediaAttribution>
  description: Maybe<Scalars['String']>
  sourceUrl: Maybe<Scalars['String']>
}

export interface GoogleLocationMetaData {
  __typename?: 'GoogleLocationMetaData'
  mapsUrl: Maybe<Scalars['String']>
  newReviewUrl: Maybe<Scalars['String']>
}

export enum GoogleLocationOpenForBusiness {
  OPEN_FOR_BUSINESS_UNSPECIFIED = 'OPEN_FOR_BUSINESS_UNSPECIFIED',
  OPEN = 'OPEN',
  CLOSED_PERMANENTLY = 'CLOSED_PERMANENTLY',
  CLOSED_TEMPORARILY = 'CLOSED_TEMPORARILY',
}

export interface GoogleLocationOpenInfo {
  __typename?: 'GoogleLocationOpenInfo'
  status: Maybe<GoogleLocationOpenForBusiness>
  canReopen: Maybe<Scalars['Boolean']>
  openingDate: Maybe<GoogleLocationDate>
}

export interface GoogleLocationProfile {
  __typename?: 'GoogleLocationProfile'
  description: Maybe<Scalars['String']>
}

export interface GoogleLocationRegularHours {
  __typename?: 'GoogleLocationRegularHours'
  periods: Maybe<Array<GoogleLocationTimePeriod>>
}

export interface GoogleLocationRelationshipData {
  __typename?: 'GoogleLocationRelationshipData'
  parentChain: Maybe<Scalars['String']>
}

export interface GoogleLocationServiceType {
  __typename?: 'GoogleLocationServiceType'
  serviceTypeId: Maybe<Scalars['String']>
  displayName: Maybe<Scalars['String']>
}

export interface GoogleLocationSpecialHourPeriod {
  __typename?: 'GoogleLocationSpecialHourPeriod'
  startDate: Maybe<GoogleLocationDate>
  openTime: Maybe<Scalars['String']>
  endDate: Maybe<GoogleLocationDate>
  closeTime: Maybe<Scalars['String']>
  isClosed: Maybe<Scalars['Boolean']>
}

export interface GoogleLocationSpecialHours {
  __typename?: 'GoogleLocationSpecialHours'
  specialHourPeriods: Maybe<Array<GoogleLocationSpecialHourPeriod>>
}

export interface GoogleLocationState {
  __typename?: 'GoogleLocationState'
  isGoogleUpdated: Maybe<Scalars['Boolean']>
  isSuspended: Maybe<Scalars['Boolean']>
  isDuplicate: Maybe<Scalars['Boolean']>
  canUpdate: Maybe<Scalars['Boolean']>
  canDelete: Maybe<Scalars['Boolean']>
  isVerified: Maybe<Scalars['Boolean']>
  needsReverification: Maybe<Scalars['Boolean']>
  isPendingReview: Maybe<Scalars['Boolean']>
  isDisabled: Maybe<Scalars['Boolean']>
  isPublished: Maybe<Scalars['Boolean']>
  isDisconnected: Maybe<Scalars['Boolean']>
  isLocalPostApiDisabled: Maybe<Scalars['Boolean']>
  canModifyServiceList: Maybe<Scalars['Boolean']>
  canHaveFoodMenus: Maybe<Scalars['Boolean']>
  hasPendingEdits: Maybe<Scalars['Boolean']>
  hasPendingVerification: Maybe<Scalars['Boolean']>
}

export interface GoogleLocationTimePeriod {
  __typename?: 'GoogleLocationTimePeriod'
  openDay: Maybe<GoogleLocationDayOfWeek>
  openTime: Maybe<Scalars['String']>
  closeDay: Maybe<GoogleLocationDayOfWeek>
  closeTime: Maybe<Scalars['String']>
}

export interface GoogleMapsDistanceDestination {
  __typename?: 'GoogleMapsDistanceDestination'
  destination: Maybe<Scalars['String']>
  distances: Maybe<Array<Maybe<GoogleMapsTravelDistanceElements>>>
}

export interface GoogleMapsDistanceDestinationInput {
  destination: Scalars['String']
  lat: Scalars['Float']
  lng: Scalars['Float']
}

export interface GoogleMapsDistanceDestinationsInput {
  origin: GoogleMapsGeocodeLocationInput
  destinations: Array<GoogleMapsDistanceDestinationInput>
}

export interface GoogleMapsGeocodeGeometry {
  __typename?: 'GoogleMapsGeocodeGeometry'
  location: Maybe<GoogleMapsGeocodeLocation>
}

export interface GoogleMapsGeocodeLocation {
  __typename?: 'GoogleMapsGeocodeLocation'
  lat: Maybe<Scalars['Float']>
  lng: Maybe<Scalars['Float']>
}

export interface GoogleMapsGeocodeLocationInput {
  lat?: Maybe<Scalars['Float']>
  lng?: Maybe<Scalars['Float']>
}

export interface GoogleMapsGeocodeResult {
  __typename?: 'GoogleMapsGeocodeResult'
  geometry: Maybe<GoogleMapsGeocodeGeometry>
  formattedAddress: Maybe<Scalars['String']>
  placeId: Maybe<Scalars['String']>
}

export interface GoogleMapsTravelDistance {
  __typename?: 'GoogleMapsTravelDistance'
  elements: Maybe<Array<Maybe<GoogleMapsTravelDistanceElements>>>
}

export interface GoogleMapsTravelDistanceDuration {
  __typename?: 'GoogleMapsTravelDistanceDuration'
  value: Maybe<Scalars['Int']>
  text: Maybe<Scalars['String']>
}

export interface GoogleMapsTravelDistanceElements {
  __typename?: 'GoogleMapsTravelDistanceElements'
  status: Maybe<Scalars['String']>
  duration: Maybe<GoogleMapsTravelDistanceDuration>
  distance: Maybe<GoogleMapsTravelDistanceLength>
}

export interface GoogleMapsTravelDistanceLength {
  __typename?: 'GoogleMapsTravelDistanceLength'
  value: Maybe<Scalars['Int']>
  text: Maybe<Scalars['String']>
}

/** GroupedProduct defines a grouped product */
export interface GroupedProduct
  extends ProductInterface,
    PhysicalProductInterface {
  __typename?: 'GroupedProduct'
  activity: Maybe<Scalars['String']>
  allowcoupon: Maybe<Scalars['Int']>
  allowingenico: Maybe<Scalars['Int']>
  allowpostnllabel: Maybe<Scalars['Int']>
  allowreview: Maybe<Scalars['Int']>
  alternatiefmemo: Maybe<Scalars['String']>
  /** The attribute set assigned to the product. */
  attributeSetId: Maybe<Scalars['Int']>
  /**
   * Relative canonical URL. This value is returned only if the system setting 'Use
   * Canonical Link Meta Tag For Products' is enabled
   */
  canonicalUrl: Maybe<Scalars['String']>
  /** The categories assigned to a product. */
  categories: Maybe<Array<Maybe<CategoryInterface>>>
  categoryGear: Maybe<Scalars['String']>
  climate: Maybe<Scalars['String']>
  collar: Maybe<Scalars['String']>
  color: Maybe<Scalars['Int']>
  cons: Maybe<Scalars['String']>
  /** The product's country of origin. */
  countryOfManufacture: Maybe<Scalars['String']>
  /** Timestamp indicating when the product was created. */
  createdAt: Maybe<Scalars['String']>
  /** Crosssell Products */
  crosssellProducts: Maybe<Array<Maybe<ProductInterface>>>
  /** Detailed information about the product. The value can include simple HTML tags. */
  description: Maybe<ComplexTextValue>
  doorverkooppremie: Maybe<Scalars['String']>
  ean: Maybe<Scalars['String']>
  ecoCollection: Maybe<Scalars['Int']>
  enabled: Maybe<Scalars['Int']>
  erinRecommends: Maybe<Scalars['Int']>
  factuurinformatie: Maybe<Scalars['String']>
  featuresBags: Maybe<Scalars['String']>
  fixedprice: Maybe<Scalars['Int']>
  fixeduntil: Maybe<Scalars['String']>
  gebruikbundelproductenprijs: Maybe<Scalars['Int']>
  gender: Maybe<Scalars['String']>
  /** Indicates whether a gift message is available. */
  giftMessageAvailable: Maybe<Scalars['String']>
  google: Maybe<Scalars['Int']>
  /** The ID number assigned to the product. */
  id: Scalars['Int']
  /** The relative path to the main image on the product page. */
  image: Maybe<ProductImage>
  inkoopprijs: Maybe<Scalars['String']>
  isBuitenkansje: Maybe<Scalars['Int']>
  isInStock: Maybe<Scalars['Int']>
  /** An array containing grouped product items */
  items: Maybe<Array<Maybe<GroupedProductItem>>>
  keepproductbuttons: Maybe<Scalars['Int']>
  kenmerken: Maybe<Scalars['String']>
  kieskeurig: Maybe<Scalars['Int']>
  kieskeurigbe: Maybe<Scalars['Int']>
  kieskeurigtekstad: Maybe<Scalars['String']>
  korteomschrijving: Maybe<Scalars['String']>
  korteomschrijving2: Maybe<Scalars['String']>
  langeomschrijving: Maybe<Scalars['String']>
  /** A number representing the product's manufacturer. */
  manufacturer: Maybe<Scalars['Int']>
  material: Maybe<Scalars['String']>
  maxprijsomnia: Maybe<Scalars['String']>
  /** An array of Media Gallery objects. */
  mediaGallery: Maybe<Array<Maybe<MediaGalleryInterface>>>
  /**
   * An array of MediaGalleryEntry objects.
   * @deprecated Use product's `media_gallery` instead
   */
  mediaGalleryEntries: Maybe<Array<Maybe<MediaGalleryEntry>>>
  merk: Maybe<Scalars['Int']>
  /** A brief overview of the product for search results listings, maximum 255 characters. */
  metaDescription: Maybe<Scalars['String']>
  /** A comma-separated list of keywords that are visible only to search engines. */
  metaKeyword: Maybe<Scalars['String']>
  /** A string that is displayed in the title bar and tab of the browser and in search results lists. */
  metaTitle: Maybe<Scalars['String']>
  modeltype: Maybe<Scalars['String']>
  /** The product name. Customers use this name to identify the product. */
  name: Scalars['String']
  new: Maybe<Scalars['Int']>
  /** The beginning date for new product listings, and determines if the product is featured as a new product. */
  newFromDate: Maybe<Scalars['String']>
  /** The end date for new product listings. */
  newToDate: Maybe<Scalars['String']>
  omnia: Maybe<Scalars['Int']>
  /** Product stock only x left count */
  onlyXLeftInStock: Maybe<Scalars['Float']>
  opmerking1: Maybe<Scalars['String']>
  opmerking2: Maybe<Scalars['String']>
  /** If the product has multiple options, determines where they appear on the product page. */
  optionsContainer: Maybe<Scalars['String']>
  pattern: Maybe<Scalars['String']>
  percentagekortingopprijsvanbundelproducten: Maybe<Scalars['String']>
  performanceFabric: Maybe<Scalars['Int']>
  pimcoreId: Maybe<Scalars['Int']>
  populariteit: Maybe<Scalars['String']>
  /**
   * A ProductPrices object, indicating the price of an item.
   * @deprecated Use price_range for product price information.
   */
  price: Maybe<ProductPrices>
  /** A PriceRange object, indicating the range of prices for the product */
  priceRange: PriceRange
  /** An array of TierPrice objects. */
  priceTiers: Maybe<Array<Maybe<TierPrice>>>
  prijs: Maybe<Scalars['String']>
  /** An array of ProductLinks objects. */
  productLinks: Maybe<Array<Maybe<ProductLinksInterface>>>
  productnaam: Maybe<Scalars['String']>
  productnaam1: Maybe<Scalars['String']>
  productspideren: Maybe<Scalars['Int']>
  promotekst: Maybe<Scalars['String']>
  pros: Maybe<Scalars['String']>
  /** Related Products */
  relatedProducts: Maybe<Array<Maybe<ProductInterface>>>
  s2m: Maybe<Scalars['Int']>
  sale: Maybe<Scalars['Int']>
  serie: Maybe<Scalars['String']>
  /** A short description of the product. Its use depends on the theme. */
  shortDescription: Maybe<ComplexTextValue>
  size: Maybe<Scalars['Int']>
  /** A number or code assigned to a product to identify the product, options, price, and manufacturer. */
  sku: Scalars['String']
  sleeve: Maybe<Scalars['String']>
  /** The relative path to the small image, which is used on catalog pages. */
  smallImage: Maybe<ProductImage>
  /** The beginning date that a product has a special price. */
  specialFromDate: Maybe<Scalars['String']>
  /** The discounted price of the product. */
  specialPrice: Maybe<Scalars['Float']>
  /** The end date that a product has a special price. */
  specialToDate: Maybe<Scalars['String']>
  specialprice: Maybe<Scalars['String']>
  specificationsBluetoothspeakerAansluitingen: Maybe<Scalars['String']>
  specificationsBluetoothspeakerAantalspeakers: Maybe<Scalars['String']>
  specificationsBluetoothspeakerAantalusb: Maybe<Scalars['String']>
  specificationsBluetoothspeakerAantalusbc: Maybe<Scalars['String']>
  specificationsBluetoothspeakerAfmetingen: Maybe<Scalars['String']>
  specificationsBluetoothspeakerAfmetingensubwoofer: Maybe<Scalars['String']>
  specificationsBluetoothspeakerFabriekscode: Maybe<Scalars['String']>
  specificationsBluetoothspeakerGewicht: Maybe<Scalars['String']>
  specificationsBluetoothspeakerGewichtsubwoofer: Maybe<Scalars['String']>
  specificationsBluetoothspeakerIntroductiejaar: Maybe<Scalars['String']>
  specificationsBluetoothspeakerKanalen: Maybe<Scalars['String']>
  specificationsBluetoothspeakerKleur: Maybe<Scalars['Int']>
  specificationsBluetoothspeakerSpeeltaf: Maybe<Scalars['String']>
  specificationsBluetoothspeakerStandaardmeegeleverd: Maybe<Scalars['String']>
  specificationsBluetoothspeakerStreaming: Maybe<Scalars['String']>
  specificationsBluetoothspeakerStroomvoorziening: Maybe<Scalars['String']>
  specificationsBluetoothspeakerTypeaudio: Maybe<Scalars['Int']>
  specificationsBluetoothspeakerTypespeaker: Maybe<Scalars['String']>
  specificationsBluetoothspeakerVermogen: Maybe<Scalars['String']>
  specificationsBlurayspelerAfmetingen: Maybe<Scalars['String']>
  specificationsBlurayspelerAfspelenvan: Maybe<Scalars['String']>
  specificationsBlurayspelerAnalogeaudio: Maybe<Scalars['String']>
  specificationsBlurayspelerAudioenvideo: Maybe<Scalars['String']>
  specificationsBlurayspelerBdlive: Maybe<Scalars['Int']>
  specificationsBlurayspelerBluetooth: Maybe<Scalars['Int']>
  specificationsBlurayspelerCoaxiaal: Maybe<Scalars['String']>
  specificationsBlurayspelerDecoders: Maybe<Scalars['String']>
  specificationsBlurayspelerDigitaalcoaxaal: Maybe<Scalars['String']>
  specificationsBlurayspelerDigitaaloptisch: Maybe<Scalars['String']>
  specificationsBlurayspelerDigitaleoptisch: Maybe<Scalars['Int']>
  specificationsBlurayspelerDlna: Maybe<Scalars['Int']>
  specificationsBlurayspelerDriedondersteuning: Maybe<Scalars['Int']>
  specificationsBlurayspelerEthernet: Maybe<Scalars['String']>
  specificationsBlurayspelerFormats: Maybe<Scalars['String']>
  specificationsBlurayspelerFuncties: Maybe<Scalars['String']>
  specificationsBlurayspelerGecerthires: Maybe<Scalars['Int']>
  specificationsBlurayspelerGewicht: Maybe<Scalars['String']>
  specificationsBlurayspelerHdmi: Maybe<Scalars['String']>
  specificationsBlurayspelerHdr: Maybe<Scalars['Int']>
  specificationsBlurayspelerKleur: Maybe<Scalars['Int']>
  specificationsBlurayspelerLan: Maybe<Scalars['Int']>
  specificationsBlurayspelerMiracast: Maybe<Scalars['Int']>
  specificationsBlurayspelerMultiroom: Maybe<Scalars['Int']>
  specificationsBlurayspelerOndersteundaudioformaat: Maybe<Scalars['String']>
  specificationsBlurayspelerOptisch: Maybe<Scalars['Int']>
  specificationsBlurayspelerOutputkanalen: Maybe<Scalars['String']>
  specificationsBlurayspelerPlayback: Maybe<Scalars['String']>
  specificationsBlurayspelerResolutie: Maybe<Scalars['String']>
  specificationsBlurayspelerSmarttv: Maybe<Scalars['Int']>
  specificationsBlurayspelerSpeeltaf: Maybe<Scalars['String']>
  specificationsBlurayspelerSpeeltvandisc: Maybe<Scalars['String']>
  specificationsBlurayspelerStandaardmeegeleverd: Maybe<Scalars['String']>
  specificationsBlurayspelerStroomverbruik: Maybe<Scalars['String']>
  specificationsBlurayspelerUpscaling: Maybe<Scalars['Int']>
  specificationsBlurayspelerUsb: Maybe<Scalars['String']>
  specificationsBlurayspelerVierkuhd: Maybe<Scalars['Int']>
  specificationsBlurayspelerVierkuhdups: Maybe<Scalars['Int']>
  specificationsBlurayspelerWifi: Maybe<Scalars['Int']>
  specificationsCdspelerAansluitingen: Maybe<Scalars['String']>
  specificationsCdspelerAantalusb: Maybe<Scalars['String']>
  specificationsCdspelerAchterspeakers: Maybe<Scalars['Int']>
  specificationsCdspelerAfmetingen: Maybe<Scalars['String']>
  specificationsCdspelerFabriekscode: Maybe<Scalars['String']>
  specificationsCdspelerGewicht: Maybe<Scalars['String']>
  specificationsCdspelerImpendatie: Maybe<Scalars['String']>
  specificationsCdspelerIntroductiejaar: Maybe<Scalars['String']>
  specificationsCdspelerKanalen: Maybe<Scalars['String']>
  specificationsCdspelerMultiroom: Maybe<Scalars['Int']>
  specificationsCdspelerRadio: Maybe<Scalars['Int']>
  specificationsCdspelerSpeakeraansluiting: Maybe<Scalars['String']>
  specificationsCdspelerSpeeltaf: Maybe<Scalars['String']>
  specificationsCdspelerStandaardmeegeleverd: Maybe<Scalars['String']>
  specificationsCdspelerStreaming: Maybe<Scalars['String']>
  specificationsCdspelerStreamingdiensten: Maybe<Scalars['String']>
  specificationsCdspelerStroomvoorziening: Maybe<Scalars['Int']>
  specificationsCdspelerSubwooferuitgang: Maybe<Scalars['Int']>
  specificationsCdspelerTypeaudio: Maybe<Scalars['Int']>
  specificationsCdspelerVermogen: Maybe<Scalars['String']>
  specificationsDraadlozespeakerAantalspeakers: Maybe<Scalars['String']>
  specificationsDraadlozespeakerAfmetingen: Maybe<Scalars['String']>
  specificationsDraadlozespeakerAirplay2: Maybe<Scalars['Int']>
  specificationsDraadlozespeakerAux: Maybe<Scalars['Int']>
  specificationsDraadlozespeakerBluetooth: Maybe<Scalars['Int']>
  specificationsDraadlozespeakerComponent: Maybe<Scalars['Int']>
  specificationsDraadlozespeakerComposiet: Maybe<Scalars['Int']>
  specificationsDraadlozespeakerFabriekscode: Maybe<Scalars['String']>
  specificationsDraadlozespeakerGebruiksduuraccu: Maybe<Scalars['String']>
  specificationsDraadlozespeakerGewicht: Maybe<Scalars['String']>
  specificationsDraadlozespeakerHdmiin: Maybe<Scalars['String']>
  specificationsDraadlozespeakerHdmiuit: Maybe<Scalars['String']>
  specificationsDraadlozespeakerKanalen: Maybe<Scalars['String']>
  specificationsDraadlozespeakerMinijack: Maybe<Scalars['Int']>
  specificationsDraadlozespeakerMultiroom: Maybe<Scalars['Int']>
  specificationsDraadlozespeakerOptischcoax: Maybe<Scalars['Int']>
  specificationsDraadlozespeakerPlatenspeler: Maybe<Scalars['Int']>
  specificationsDraadlozespeakerSpotifyconnect: Maybe<Scalars['Int']>
  specificationsDraadlozespeakerSubwoofer: Maybe<Scalars['Int']>
  specificationsDraadlozespeakerUsb: Maybe<Scalars['Int']>
  specificationsDraadlozespeakerVoicecontrol: Maybe<Scalars['Int']>
  specificationsDraadlozespeakerWifi: Maybe<Scalars['Int']>
  specificationsHifispeakerAansluitingen: Maybe<Scalars['String']>
  specificationsHifispeakerAantalspeakers: Maybe<Scalars['String']>
  specificationsHifispeakerAantalusb: Maybe<Scalars['String']>
  specificationsHifispeakerAchterspeakers: Maybe<Scalars['Int']>
  specificationsHifispeakerAfmetingen: Maybe<Scalars['String']>
  specificationsHifispeakerAfmetingensubwoofer: Maybe<Scalars['String']>
  specificationsHifispeakerBelastbaarheid: Maybe<Scalars['String']>
  specificationsHifispeakerFabriekscode: Maybe<Scalars['String']>
  specificationsHifispeakerGewicht: Maybe<Scalars['String']>
  specificationsHifispeakerGewichtsubwoofer: Maybe<Scalars['String']>
  specificationsHifispeakerImpendatie: Maybe<Scalars['String']>
  specificationsHifispeakerIntroductiejaar: Maybe<Scalars['String']>
  specificationsHifispeakerKanalen: Maybe<Scalars['String']>
  specificationsHifispeakerKleur: Maybe<Scalars['Int']>
  specificationsHifispeakerMaximalefrequentie: Maybe<Scalars['String']>
  specificationsHifispeakerMinimalefrequentie: Maybe<Scalars['String']>
  specificationsHifispeakerMultiroom: Maybe<Scalars['Int']>
  specificationsHifispeakerSpeakeraansluiting: Maybe<Scalars['String']>
  specificationsHifispeakerSpeakertype: Maybe<Scalars['String']>
  specificationsHifispeakerStandaardmeegeleverd: Maybe<Scalars['String']>
  specificationsHifispeakerStreaming: Maybe<Scalars['String']>
  specificationsHifispeakerStroomvoorziening: Maybe<Scalars['Int']>
  specificationsHifispeakerTypeaudio: Maybe<Scalars['Int']>
  specificationsHifispeakerTypespeaker: Maybe<Scalars['String']>
  specificationsHifispeakerVermogen: Maybe<Scalars['String']>
  specificationsHifispeakerWaterbestendig: Maybe<Scalars['Int']>
  specificationsHomecinemaAansluitingen: Maybe<Scalars['String']>
  specificationsHomecinemaAantalhdmi: Maybe<Scalars['String']>
  specificationsHomecinemaAantalspeakers: Maybe<Scalars['String']>
  specificationsHomecinemaAantalusb: Maybe<Scalars['String']>
  specificationsHomecinemaAchterspeakers: Maybe<Scalars['Int']>
  specificationsHomecinemaAfmetingen: Maybe<Scalars['String']>
  specificationsHomecinemaFabriekscode: Maybe<Scalars['String']>
  specificationsHomecinemaGewicht: Maybe<Scalars['String']>
  specificationsHomecinemaGewichtsubwoofer: Maybe<Scalars['String']>
  specificationsHomecinemaImpendatie: Maybe<Scalars['String']>
  specificationsHomecinemaIntroductiejaar: Maybe<Scalars['String']>
  specificationsHomecinemaKleur: Maybe<Scalars['Int']>
  specificationsHomecinemaMicrofoon: Maybe<Scalars['Int']>
  specificationsHomecinemaMultiroom: Maybe<Scalars['Int']>
  specificationsHomecinemaRadio: Maybe<Scalars['Int']>
  specificationsHomecinemaSpeakeraansluiting: Maybe<Scalars['String']>
  specificationsHomecinemaSpeeltaf: Maybe<Scalars['String']>
  specificationsHomecinemaStandaardmeegeleverd: Maybe<Scalars['String']>
  specificationsHomecinemaStreaming: Maybe<Scalars['String']>
  specificationsHomecinemaStreamingdiensten: Maybe<Scalars['String']>
  specificationsHomecinemaStroomvoorziening: Maybe<Scalars['Int']>
  specificationsHomecinemaSubwooferuitgang: Maybe<Scalars['String']>
  specificationsHomecinemaTypeaudio: Maybe<Scalars['Int']>
  specificationsHomecinemaTypespeaker: Maybe<Scalars['String']>
  specificationsHomecinemaVermogen: Maybe<Scalars['String']>
  specificationsMuurbeugelAantalgradendraaibaar: Maybe<Scalars['String']>
  specificationsMuurbeugelAantalgradenkantelbaar: Maybe<Scalars['String']>
  specificationsMuurbeugelBedieningviaapp: Maybe<Scalars['Int']>
  specificationsMuurbeugelGarantie: Maybe<Scalars['String']>
  specificationsMuurbeugelGeschiktvoorafmetingentv: Maybe<Scalars['String']>
  specificationsMuurbeugelInterfacebreedte: Maybe<Scalars['String']>
  specificationsMuurbeugelInterfacehoogte: Maybe<Scalars['String']>
  specificationsMuurbeugelIntroductiejaar: Maybe<Scalars['String']>
  specificationsMuurbeugelKleur: Maybe<Scalars['Int']>
  specificationsMuurbeugelMaxafstandmuur: Maybe<Scalars['String']>
  specificationsMuurbeugelMaximalegewichttv: Maybe<Scalars['String']>
  specificationsMuurbeugelMerkmuurbeugel: Maybe<Scalars['Int']>
  specificationsMuurbeugelMinafstandmuur: Maybe<Scalars['String']>
  specificationsMuurbeugelSoortmuurbeugel: Maybe<Scalars['Int']>
  specificationsMuurbeugelStandaardmeegeleverd: Maybe<Scalars['String']>
  specificationsMuurbeugelTypemuurbeugel: Maybe<Scalars['String']>
  specificationsMuurbeugelUittrekbaar: Maybe<Scalars['Int']>
  specificationsMuurbeugelVesaafmetingen: Maybe<Scalars['String']>
  specificationsNetwerkspelerAansluitingen: Maybe<Scalars['String']>
  specificationsNetwerkspelerAantalusb: Maybe<Scalars['String']>
  specificationsNetwerkspelerAchterspeakers: Maybe<Scalars['Int']>
  specificationsNetwerkspelerAfmetingen: Maybe<Scalars['String']>
  specificationsNetwerkspelerAfmetingensubwoofer: Maybe<Scalars['String']>
  specificationsNetwerkspelerBelastbaarheid: Maybe<Scalars['String']>
  specificationsNetwerkspelerFabriekscode: Maybe<Scalars['String']>
  specificationsNetwerkspelerGewicht: Maybe<Scalars['String']>
  specificationsNetwerkspelerGewichtsubwoofer: Maybe<Scalars['String']>
  specificationsNetwerkspelerIntroductiejaar: Maybe<Scalars['String']>
  specificationsNetwerkspelerKanalen: Maybe<Scalars['String']>
  specificationsNetwerkspelerKleur: Maybe<Scalars['Int']>
  specificationsNetwerkspelerMultiroom: Maybe<Scalars['Int']>
  specificationsNetwerkspelerRadio: Maybe<Scalars['Int']>
  specificationsNetwerkspelerSpeakeraansluiting: Maybe<Scalars['String']>
  specificationsNetwerkspelerSpeeltaf: Maybe<Scalars['String']>
  specificationsNetwerkspelerStandaardmeegeleverd: Maybe<Scalars['String']>
  specificationsNetwerkspelerStreaming: Maybe<Scalars['String']>
  specificationsNetwerkspelerStreamingdiensten: Maybe<Scalars['String']>
  specificationsNetwerkspelerStroomvoorziening: Maybe<Scalars['Int']>
  specificationsNetwerkspelerSubwoofer: Maybe<Scalars['Int']>
  specificationsNetwerkspelerSubwooferuitgang: Maybe<Scalars['Int']>
  specificationsNetwerkspelerTypeaudio: Maybe<Scalars['Int']>
  specificationsNetwerkspelerVermogen: Maybe<Scalars['String']>
  specificationsOverigeaudioAansluitingen: Maybe<Scalars['String']>
  specificationsOverigeaudioAantalhdmi: Maybe<Scalars['String']>
  specificationsOverigeaudioAantalspeakers: Maybe<Scalars['String']>
  specificationsOverigeaudioAantalusb: Maybe<Scalars['String']>
  specificationsOverigeaudioAfmetingen: Maybe<Scalars['String']>
  specificationsOverigeaudioAfmetingensubwoofer: Maybe<Scalars['String']>
  specificationsOverigeaudioFabriekscode: Maybe<Scalars['String']>
  specificationsOverigeaudioGewicht: Maybe<Scalars['String']>
  specificationsOverigeaudioGewichtsubwoofer: Maybe<Scalars['String']>
  specificationsOverigeaudioIntroductiejaar: Maybe<Scalars['String']>
  specificationsOverigeaudioKanalen: Maybe<Scalars['String']>
  specificationsOverigeaudioKleur: Maybe<Scalars['Int']>
  specificationsOverigeaudioMaximalefrequentie: Maybe<Scalars['String']>
  specificationsOverigeaudioMinimalefrequentie: Maybe<Scalars['String']>
  specificationsOverigeaudioRadio: Maybe<Scalars['String']>
  specificationsOverigeaudioStandaardmeegeleverd: Maybe<Scalars['String']>
  specificationsOverigeaudioStreaming: Maybe<Scalars['String']>
  specificationsOverigeaudioStroomvoorziening: Maybe<Scalars['Int']>
  specificationsOverigeaudioVermogen: Maybe<Scalars['String']>
  specificationsOverigeaudioWaterbestendig: Maybe<Scalars['Int']>
  specificationsPlafondbeugelsAantaldraai: Maybe<Scalars['String']>
  specificationsPlafondbeugelsBeeldformaat: Maybe<Scalars['String']>
  specificationsPlafondbeugelsDraaien: Maybe<Scalars['String']>
  specificationsPlafondbeugelsGarantie: Maybe<Scalars['String']>
  specificationsPlafondbeugelsGroottetv: Maybe<Scalars['String']>
  specificationsPlafondbeugelsHoogte: Maybe<Scalars['String']>
  specificationsPlafondbeugelsHoogteverstelling: Maybe<Scalars['Int']>
  specificationsPlafondbeugelsInterfacebreedte: Maybe<Scalars['String']>
  specificationsPlafondbeugelsInterfacehoogte: Maybe<Scalars['String']>
  specificationsPlafondbeugelsInterfaceoptioneel: Maybe<Scalars['Int']>
  specificationsPlafondbeugelsKabelinlegsysteem: Maybe<Scalars['String']>
  specificationsPlafondbeugelsKantelen: Maybe<Scalars['String']>
  specificationsPlafondbeugelsKleur: Maybe<Scalars['Int']>
  specificationsPlafondbeugelsLengtebuis: Maybe<Scalars['String']>
  specificationsPlafondbeugelsMaxgewicht: Maybe<Scalars['String']>
  specificationsPlafondbeugelsMontagehoek: Maybe<Scalars['String']>
  specificationsPlafondbeugelsProductlijn: Maybe<Scalars['Int']>
  specificationsPlafondbeugelsRoteren: Maybe<Scalars['Int']>
  specificationsPlafondbeugelsSchuineplafondoplossing: Maybe<Scalars['Int']>
  specificationsPlafondbeugelsUitschuifbaar: Maybe<Scalars['Int']>
  specificationsPlafondbeugelsVesamaximaal: Maybe<Scalars['String']>
  specificationsPlafondbeugelsVesaminimaal: Maybe<Scalars['String']>
  specificationsPlafondbeugelsVesanorm: Maybe<Scalars['String']>
  specificationsPlafondbeugelsZwenken: Maybe<Scalars['Int']>
  specificationsReceiverAansluitingen: Maybe<Scalars['String']>
  specificationsReceiverAantalspeakers: Maybe<Scalars['String']>
  specificationsReceiverAchterspeakers: Maybe<Scalars['Int']>
  specificationsReceiverAfmetingen: Maybe<Scalars['String']>
  specificationsReceiverAirplay2: Maybe<Scalars['Int']>
  specificationsReceiverArc: Maybe<Scalars['Int']>
  specificationsReceiverAux: Maybe<Scalars['Int']>
  specificationsReceiverBeeldondersteuning: Maybe<Scalars['String']>
  specificationsReceiverBluetooth: Maybe<Scalars['Int']>
  specificationsReceiverCoax: Maybe<Scalars['String']>
  specificationsReceiverComponent: Maybe<Scalars['Int']>
  specificationsReceiverComposiet: Maybe<Scalars['Int']>
  specificationsReceiverEthernet: Maybe<Scalars['Int']>
  specificationsReceiverFabriekscode: Maybe<Scalars['String']>
  specificationsReceiverGewicht: Maybe<Scalars['String']>
  specificationsReceiverHdmiin: Maybe<Scalars['String']>
  specificationsReceiverHdmiout: Maybe<Scalars['String']>
  specificationsReceiverImpendatie: Maybe<Scalars['String']>
  specificationsReceiverIntroductiejaar: Maybe<Scalars['String']>
  specificationsReceiverKanalen: Maybe<Scalars['String']>
  specificationsReceiverKleur: Maybe<Scalars['Int']>
  specificationsReceiverMinijack: Maybe<Scalars['Int']>
  specificationsReceiverMultiroom: Maybe<Scalars['Int']>
  specificationsReceiverOptisch: Maybe<Scalars['String']>
  specificationsReceiverPlatenspeler: Maybe<Scalars['Int']>
  specificationsReceiverRadio: Maybe<Scalars['String']>
  specificationsReceiverSpeeltaf: Maybe<Scalars['String']>
  specificationsReceiverSpotifyconnect: Maybe<Scalars['Int']>
  specificationsReceiverStreaming: Maybe<Scalars['String']>
  specificationsReceiverStroomvoorziening: Maybe<Scalars['Int']>
  specificationsReceiverSubwoofer: Maybe<Scalars['Int']>
  specificationsReceiverSubwooferuitgang: Maybe<Scalars['String']>
  specificationsReceiverSurroundsystemen: Maybe<Scalars['String']>
  specificationsReceiverTypeaudio: Maybe<Scalars['Int']>
  specificationsReceiverTypereceiver: Maybe<Scalars['Int']>
  specificationsReceiverUsb: Maybe<Scalars['Int']>
  specificationsReceiverVermogen: Maybe<Scalars['String']>
  specificationsReceiverWifi: Maybe<Scalars['Int']>
  specificationsSoundbarAantalspeakers: Maybe<Scalars['String']>
  specificationsSoundbarAfmetingen: Maybe<Scalars['String']>
  specificationsSoundbarAirplay2: Maybe<Scalars['Int']>
  specificationsSoundbarArc: Maybe<Scalars['Int']>
  specificationsSoundbarAux: Maybe<Scalars['Int']>
  specificationsSoundbarBeeldondersteuning: Maybe<Scalars['String']>
  specificationsSoundbarBluetooth: Maybe<Scalars['Int']>
  specificationsSoundbarComponent: Maybe<Scalars['Int']>
  specificationsSoundbarComposiet: Maybe<Scalars['Int']>
  specificationsSoundbarEthernet: Maybe<Scalars['Int']>
  specificationsSoundbarFabriekscode: Maybe<Scalars['String']>
  specificationsSoundbarGewicht: Maybe<Scalars['String']>
  specificationsSoundbarHdmiin: Maybe<Scalars['String']>
  specificationsSoundbarHdmiout: Maybe<Scalars['String']>
  specificationsSoundbarIntroductiejaar: Maybe<Scalars['String']>
  specificationsSoundbarKanalen: Maybe<Scalars['String']>
  specificationsSoundbarKleur: Maybe<Scalars['Int']>
  specificationsSoundbarMinijack: Maybe<Scalars['Int']>
  specificationsSoundbarMultiroom: Maybe<Scalars['Int']>
  specificationsSoundbarOptischcoax: Maybe<Scalars['String']>
  specificationsSoundbarSpeeltaf: Maybe<Scalars['String']>
  specificationsSoundbarSpotifyconnect: Maybe<Scalars['Int']>
  specificationsSoundbarStreaming: Maybe<Scalars['String']>
  specificationsSoundbarStroomvoorziening: Maybe<Scalars['Int']>
  specificationsSoundbarSubwoofer: Maybe<Scalars['Int']>
  specificationsSoundbarTypeaudio: Maybe<Scalars['Int']>
  specificationsSoundbarUsb: Maybe<Scalars['Int']>
  specificationsSoundbarVermogen: Maybe<Scalars['String']>
  specificationsSoundbarWifi: Maybe<Scalars['Int']>
  specificationsStereosetAansluitingen: Maybe<Scalars['String']>
  specificationsStereosetAantalspeakers: Maybe<Scalars['String']>
  specificationsStereosetAantalusb: Maybe<Scalars['String']>
  specificationsStereosetAfmetingen: Maybe<Scalars['String']>
  specificationsStereosetBelastbaarheid: Maybe<Scalars['String']>
  specificationsStereosetFabriekscode: Maybe<Scalars['String']>
  specificationsStereosetGewicht: Maybe<Scalars['String']>
  specificationsStereosetImpendatie: Maybe<Scalars['Int']>
  specificationsStereosetIntroductiejaar: Maybe<Scalars['String']>
  specificationsStereosetKanalen: Maybe<Scalars['String']>
  specificationsStereosetKleur: Maybe<Scalars['Int']>
  specificationsStereosetMaximalefrequentie: Maybe<Scalars['String']>
  specificationsStereosetMinimalefrequentie: Maybe<Scalars['String']>
  specificationsStereosetMultiroom: Maybe<Scalars['Int']>
  specificationsStereosetRadio: Maybe<Scalars['String']>
  specificationsStereosetSpeakeraansluiting: Maybe<Scalars['Int']>
  specificationsStereosetSpeeltaf: Maybe<Scalars['String']>
  specificationsStereosetStandaardmeegeleverd: Maybe<Scalars['String']>
  specificationsStereosetStreaming: Maybe<Scalars['String']>
  specificationsStereosetStroomvoorziening: Maybe<Scalars['Int']>
  specificationsStereosetSubwooferuitgang: Maybe<Scalars['Int']>
  specificationsStereosetTypeaudio: Maybe<Scalars['Int']>
  specificationsStereosetTypespeaker: Maybe<Scalars['Int']>
  specificationsStereosetVermogen: Maybe<Scalars['String']>
  specificationsSubwooferAansluitingen: Maybe<Scalars['String']>
  specificationsSubwooferAantalusb: Maybe<Scalars['String']>
  specificationsSubwooferAfmetingen: Maybe<Scalars['String']>
  specificationsSubwooferAfmetingensubwoofer: Maybe<Scalars['String']>
  specificationsSubwooferBelastbaarheid: Maybe<Scalars['String']>
  specificationsSubwooferFabriekscode: Maybe<Scalars['String']>
  specificationsSubwooferGewicht: Maybe<Scalars['String']>
  specificationsSubwooferGewichtsubwoofer: Maybe<Scalars['String']>
  specificationsSubwooferIntroductiejaar: Maybe<Scalars['String']>
  specificationsSubwooferKanalen: Maybe<Scalars['String']>
  specificationsSubwooferKleur: Maybe<Scalars['Int']>
  specificationsSubwooferMaximalefrequentie: Maybe<Scalars['String']>
  specificationsSubwooferMinimalefrequentie: Maybe<Scalars['String']>
  specificationsSubwooferMultiroom: Maybe<Scalars['Int']>
  specificationsSubwooferRadio: Maybe<Scalars['Int']>
  specificationsSubwooferSpeakeraansluiting: Maybe<Scalars['String']>
  specificationsSubwooferStandaardmeegeleverd: Maybe<Scalars['String']>
  specificationsSubwooferStreaming: Maybe<Scalars['String']>
  specificationsSubwooferStreamingdiensten: Maybe<Scalars['String']>
  specificationsSubwooferStroomvoorziening: Maybe<Scalars['Int']>
  specificationsSubwooferSubwooferuitgang: Maybe<Scalars['Int']>
  specificationsSubwooferTypeaudio: Maybe<Scalars['Int']>
  specificationsSubwooferTypespeaker: Maybe<Scalars['String']>
  specificationsSubwooferVermogen: Maybe<Scalars['String']>
  specificationsSubwooferWaterbestendig: Maybe<Scalars['Int']>
  specificationsTelevisieAfmetingenexclvoet: Maybe<Scalars['String']>
  specificationsTelevisieAfmetingeninclvoet: Maybe<Scalars['String']>
  specificationsTelevisieAirplay: Maybe<Scalars['Int']>
  specificationsTelevisieAmbilight: Maybe<Scalars['Int']>
  specificationsTelevisieBeeldformaat: Maybe<Scalars['Int']>
  specificationsTelevisieBeeldfrequentie: Maybe<Scalars['Int']>
  specificationsTelevisieBluetooth: Maybe<Scalars['Int']>
  specificationsTelevisieCigeschikt: Maybe<Scalars['String']>
  specificationsTelevisieComponent: Maybe<Scalars['Int']>
  specificationsTelevisieComposiet: Maybe<Scalars['Int']>
  specificationsTelevisieDigitaalcoaxaleaansluiting: Maybe<Scalars['Int']>
  specificationsTelevisieDigitaaloptischeaansluiting: Maybe<Scalars['Int']>
  specificationsTelevisieEnergieklasse: Maybe<Scalars['Int']>
  specificationsTelevisieFabriekscode: Maybe<Scalars['String']>
  specificationsTelevisieGewichtexclvoet: Maybe<Scalars['String']>
  specificationsTelevisieGewichtinclvoet: Maybe<Scalars['String']>
  specificationsTelevisieHdmi: Maybe<Scalars['String']>
  specificationsTelevisieHdr: Maybe<Scalars['Int']>
  specificationsTelevisieIntroductiejaar: Maybe<Scalars['String']>
  specificationsTelevisieKleur: Maybe<Scalars['Int']>
  specificationsTelevisieKoptelefoon: Maybe<Scalars['Int']>
  specificationsTelevisieMeegeleverdeaccessoires: Maybe<Scalars['String']>
  specificationsTelevisieMerk: Maybe<Scalars['Int']>
  specificationsTelevisieResolutie: Maybe<Scalars['Int']>
  specificationsTelevisieScart: Maybe<Scalars['Int']>
  specificationsTelevisieSmartplatform: Maybe<Scalars['Int']>
  specificationsTelevisieSmarttv: Maybe<Scalars['Int']>
  specificationsTelevisieSoorttv: Maybe<Scalars['String']>
  specificationsTelevisieSpeakersysteem: Maybe<Scalars['String']>
  specificationsTelevisieSpotifyconnect: Maybe<Scalars['Int']>
  specificationsTelevisieSpraakbesturing: Maybe<Scalars['Int']>
  specificationsTelevisieSubwoofer: Maybe<Scalars['Int']>
  specificationsTelevisieTuner: Maybe<Scalars['String']>
  specificationsTelevisieTypehdr: Maybe<Scalars['String']>
  specificationsTelevisieUsb: Maybe<Scalars['String']>
  specificationsTelevisieVermogen: Maybe<Scalars['String']>
  specificationsTelevisieWifi: Maybe<Scalars['Int']>
  specificationsTvmeubelAfmetingen: Maybe<Scalars['String']>
  specificationsTvmeubelGewicht: Maybe<Scalars['String']>
  specificationsTvmeubelKleur: Maybe<Scalars['Int']>
  specificationsTvmeubelMateriaal: Maybe<Scalars['String']>
  specificationsTvmeubelTypeproduct: Maybe<Scalars['Int']>
  specificationsVersterkerAansluitingen: Maybe<Scalars['String']>
  specificationsVersterkerAantalhdmi: Maybe<Scalars['String']>
  specificationsVersterkerAantalusb: Maybe<Scalars['String']>
  specificationsVersterkerAchterspeakers: Maybe<Scalars['Int']>
  specificationsVersterkerAfmetingen: Maybe<Scalars['String']>
  specificationsVersterkerAfmetingensubwoofer: Maybe<Scalars['String']>
  specificationsVersterkerBelastbaarheid: Maybe<Scalars['String']>
  specificationsVersterkerFabriekscode: Maybe<Scalars['String']>
  specificationsVersterkerGewicht: Maybe<Scalars['String']>
  specificationsVersterkerGewichtsubwoofer: Maybe<Scalars['String']>
  specificationsVersterkerImpendatie: Maybe<Scalars['String']>
  specificationsVersterkerIntroductiejaar: Maybe<Scalars['String']>
  specificationsVersterkerKanalen: Maybe<Scalars['String']>
  specificationsVersterkerKleur: Maybe<Scalars['Int']>
  specificationsVersterkerMultiroom: Maybe<Scalars['Int']>
  specificationsVersterkerRadio: Maybe<Scalars['String']>
  specificationsVersterkerSpeakeraansluiting: Maybe<Scalars['String']>
  specificationsVersterkerSpeeltaf: Maybe<Scalars['String']>
  specificationsVersterkerStandaardmeegeleverd: Maybe<Scalars['String']>
  specificationsVersterkerStreaming: Maybe<Scalars['String']>
  specificationsVersterkerStreamingdiensten: Maybe<Scalars['String']>
  specificationsVersterkerStroomvoorziening: Maybe<Scalars['Int']>
  specificationsVersterkerSubwoofer: Maybe<Scalars['String']>
  specificationsVersterkerSubwooferuitgang: Maybe<Scalars['Int']>
  specificationsVersterkerTypeaudio: Maybe<Scalars['Int']>
  specificationsVersterkerVermogen: Maybe<Scalars['String']>
  specificationsVersterkerWaterbestendig: Maybe<Scalars['Int']>
  specificationsVloerstandaardAfmetingen: Maybe<Scalars['String']>
  specificationsVloerstandaardKleur: Maybe<Scalars['Int']>
  specificationsVloerstandaardProducttype: Maybe<Scalars['Int']>
  specificationsVoedingDraadloosopladen: Maybe<Scalars['Int']>
  specificationsVoedingKabellengte: Maybe<Scalars['String']>
  specificationsVoedingKleur: Maybe<Scalars['Int']>
  specificationsVoedingProducttype: Maybe<Scalars['Int']>
  specificationsWifispeakerAansluitingen: Maybe<Scalars['String']>
  specificationsWifispeakerAantalspeakers: Maybe<Scalars['String']>
  specificationsWifispeakerAantalusb: Maybe<Scalars['String']>
  specificationsWifispeakerAchterspeakers: Maybe<Scalars['Int']>
  specificationsWifispeakerAfmetingen: Maybe<Scalars['String']>
  specificationsWifispeakerAfmetingensubwoofer: Maybe<Scalars['String']>
  specificationsWifispeakerBelastbaarheid: Maybe<Scalars['String']>
  specificationsWifispeakerFabriekscode: Maybe<Scalars['String']>
  specificationsWifispeakerGewicht: Maybe<Scalars['String']>
  specificationsWifispeakerGewichtsubwoofer: Maybe<Scalars['String']>
  specificationsWifispeakerImpendatie: Maybe<Scalars['String']>
  specificationsWifispeakerIntroductiejaar: Maybe<Scalars['String']>
  specificationsWifispeakerKanalen: Maybe<Scalars['String']>
  specificationsWifispeakerKleur: Maybe<Scalars['Int']>
  specificationsWifispeakerMultiroom: Maybe<Scalars['Int']>
  specificationsWifispeakerRadio: Maybe<Scalars['String']>
  specificationsWifispeakerSpeeltaf: Maybe<Scalars['String']>
  specificationsWifispeakerStandaardmeegeleverd: Maybe<Scalars['String']>
  specificationsWifispeakerStreaming: Maybe<Scalars['String']>
  specificationsWifispeakerStreamingdiensten: Maybe<Scalars['String']>
  specificationsWifispeakerStroomvoorziening: Maybe<Scalars['String']>
  specificationsWifispeakerSubwoofer: Maybe<Scalars['String']>
  specificationsWifispeakerSubwooferuitgang: Maybe<Scalars['String']>
  specificationsWifispeakerTypeaudio: Maybe<Scalars['Int']>
  specificationsWifispeakerTypespeaker: Maybe<Scalars['Int']>
  specificationsWifispeakerVermogen: Maybe<Scalars['String']>
  specificationsWifispeakerWaterbestendig: Maybe<Scalars['Int']>
  /** Stock status of the product */
  stockStatus: Maybe<ProductStockStatus>
  strapBags: Maybe<Scalars['String']>
  styleBags: Maybe<Scalars['String']>
  styleBottom: Maybe<Scalars['String']>
  styleGeneral: Maybe<Scalars['String']>
  /** The file name of a swatch image */
  swatchImage: Maybe<Scalars['String']>
  tempcombipakketten: Maybe<Scalars['String']>
  /** The relative path to the product's thumbnail image. */
  thumbnail: Maybe<ProductImage>
  /**
   * The price when tier pricing is in effect and the items purchased threshold has been reached.
   * @deprecated Use price_tiers for product tier price information.
   */
  tierPrice: Maybe<Scalars['Float']>
  /**
   * An array of ProductTierPrices objects.
   * @deprecated Use price_tiers for product tier price information.
   */
  tierPrices: Maybe<Array<Maybe<ProductTierPrices>>>
  top10product: Maybe<Scalars['Int']>
  tot21u: Maybe<Scalars['Int']>
  tweakers: Maybe<Scalars['Int']>
  tweakerstekstad: Maybe<Scalars['String']>
  tweakwisecrossselltemplateid: Maybe<Scalars['String']>
  /**
   * One of simple, virtual, bundle, downloadable, grouped, or configurable.
   * @deprecated Use __typename instead.
   */
  typeId: Maybe<Scalars['String']>
  /** Timestamp indicating when the product was updated. */
  updatedAt: Maybe<Scalars['String']>
  /** Upsell Products */
  upsellProducts: Maybe<Array<Maybe<ProductInterface>>>
  /** The part of the URL that identifies the product */
  urlKey: Scalars['String']
  /** @deprecated Use product's `canonical_url` or url rewrites instead */
  urlPath: Maybe<Scalars['String']>
  /** URL rewrites list */
  urlRewrites: Maybe<Array<Maybe<UrlRewrite>>>
  /** The part of the product URL that is appended after the url key */
  urlSuffix: Maybe<Scalars['String']>
  variant: Maybe<Scalars['Int']>
  variantValue: Maybe<Scalars['String']>
  venditguid: Maybe<Scalars['String']>
  venditpid: Maybe<Scalars['String']>
  voorraadamsterdam: Maybe<Scalars['Int']>
  voorraadarnhem: Maybe<Scalars['Int']>
  voorraadbreda: Maybe<Scalars['Int']>
  voorraaddoetinchem: Maybe<Scalars['Int']>
  voorraadeindhoven: Maybe<Scalars['Int']>
  voorraadgroningen: Maybe<Scalars['Int']>
  voorraadnaarden: Maybe<Scalars['Int']>
  voorraadnijmegen: Maybe<Scalars['Int']>
  voorraadonline: Maybe<Scalars['Int']>
  voorraadutrecht: Maybe<Scalars['Int']>
  voorraadzoeterwoude: Maybe<Scalars['Int']>
  /**
   * An array of websites in which the product is available.
   * @deprecated The field should not be used on the storefront.
   */
  websites: Maybe<Array<Maybe<Website>>>
  /** The weight of the item, in units defined by the store. */
  weight: Maybe<Scalars['Float']>
  zondaglevering: Maybe<Scalars['Int']>
  pimcoreProductData: Maybe<PimcoreProduct>
}

/** GroupedProductItem contains information about an individual grouped product item */
export interface GroupedProductItem {
  __typename?: 'GroupedProductItem'
  /** The relative position of this item compared to the other group items */
  position: Maybe<Scalars['Int']>
  /** The ProductInterface object, which contains details about this product option */
  product: Maybe<ProductInterface>
  /** The quantity of this grouped product item */
  qty: Maybe<Scalars['Float']>
}

/** The object details of target path parameters */
export interface HttpQueryParameter {
  __typename?: 'HttpQueryParameter'
  /** Parameter name */
  name: Maybe<Scalars['String']>
  /** Parameter value */
  value: Maybe<Scalars['String']>
}

/** A linked image */
export interface ImageLink extends Linkable {
  __typename?: 'ImageLink'
  name: Scalars['String']
  url: Scalars['String']
  size: Scalars['Long']
  height: Scalars['Int']
  width: Scalars['Int']
  linkType: Maybe<Scalars['String']>
}

export interface Images {
  __typename?: 'Images'
  /** Image full path. */
  fullPath: Maybe<Scalars['String']>
  /** Resized image path. */
  resizedPath: Maybe<Scalars['String']>
}

export interface ImageSwatchData extends SwatchDataInterface {
  __typename?: 'ImageSwatchData'
  /** Thumbnail swatch image URL */
  thumbnail: Maybe<Scalars['String']>
  /** Value of swatch item (HEX color code, image link or textual value) */
  value: Maybe<Scalars['String']>
}

export interface IsEmailAvailableOutput {
  __typename?: 'IsEmailAvailableOutput'
  /** Is email availabel value */
  isEmailAvailable: Maybe<Scalars['Boolean']>
}

export interface LayerFilter {
  __typename?: 'LayerFilter'
  /**
   * Array of filter items.
   * @deprecated Use Aggregation.options instead.
   */
  filterItems: Maybe<Array<Maybe<LayerFilterItemInterface>>>
  /**
   * Count of filter items in filter group.
   * @deprecated Use Aggregation.count instead.
   */
  filterItemsCount: Maybe<Scalars['Int']>
  /**
   * Layered navigation filter name.
   * @deprecated Use Aggregation.label instead.
   */
  name: Maybe<Scalars['String']>
  /**
   * Request variable name for filter query.
   * @deprecated Use Aggregation.attribute_code instead.
   */
  requestVar: Maybe<Scalars['String']>
}

export interface LayerFilterItem extends LayerFilterItemInterface {
  __typename?: 'LayerFilterItem'
  /**
   * Count of items by filter.
   * @deprecated Use AggregationOption.count instead.
   */
  itemsCount: Maybe<Scalars['Int']>
  /**
   * Filter label.
   * @deprecated Use AggregationOption.label instead.
   */
  label: Maybe<Scalars['String']>
  /**
   * Value for filter request variable to be used in query.
   * @deprecated Use AggregationOption.value instead.
   */
  valueString: Maybe<Scalars['String']>
}

export interface LayerFilterItemInterface {
  /**
   * Count of items by filter.
   * @deprecated Use AggregationOption.count instead.
   */
  itemsCount: Maybe<Scalars['Int']>
  /**
   * Filter label.
   * @deprecated Use AggregationOption.label instead.
   */
  label: Maybe<Scalars['String']>
  /**
   * Value for filter request variable to be used in query.
   * @deprecated Use AggregationOption.value instead.
   */
  valueString: Maybe<Scalars['String']>
}

export interface Like {
  __typename?: 'Like'
  /** Advantages of disadvantages description */
  value: Maybe<Scalars['String']>
}

export interface LikeInput {
  /** Like value. */
  value: Scalars['String']
}

/** A prismic link */
export interface Linkable {
  linkType: Maybe<Scalars['String']>
}

export interface Main extends Document, Linkable {
  __typename?: 'Main'
  body: Maybe<Array<MainBody>>
  meta: Meta
  linkType: Maybe<Scalars['String']>
}

export type MainBody =
  | MainBodyHeaderNotice
  | MainBodyFooterContact
  | MainBodyFooterService
  | MainBodyFooterInfo
  | MainBodyFooterSocial
  | MainBodyFooterMenu1
  | MainBodyFooterMenu2
  | MainBodyFooterMenu3
  | MainBodyFooterPayment
  | MainBodyFooterRatings
  | MainBodyCartCheckout
  | MainBodyCheckoutHeader
  | MainBodyCheckoutReview
  | MainBodyFaqHeader
  | MainBodyCheckoutPayment
  | MainBodyCheckoutSuccess
  | MainBodyGmbstorestoexclude
  | MainBodyShopAlert
  | MainBodyUspBanner
  | MainBodyFooterMenuMobile
  | MainBodyStoreStockStatusMessages

export interface MainBodyCartCheckout {
  __typename?: 'MainBodyCartCheckout'
  type: Maybe<Scalars['String']>
  label: Maybe<Scalars['String']>
  primary: Maybe<MainBodyCartCheckoutPrimary>
  fields: Maybe<Array<MainBodyCartCheckoutFields>>
}

export interface MainBodyCartCheckoutFields {
  __typename?: 'MainBodyCartCheckoutFields'
  paymentMethod: Maybe<Scalars['Json']>
  paymentMethodTitle: Maybe<Scalars['String']>
}

export interface MainBodyCartCheckoutPrimary {
  __typename?: 'MainBodyCartCheckoutPrimary'
  safeConnection: Maybe<Scalars['String']>
  placeOrder: Maybe<Scalars['String']>
  continueShopping: Maybe<Scalars['String']>
  continueShoppingLink: Maybe<PrismicHyperlink>
  lifetimeSupportTitle: Maybe<Scalars['String']>
  lifetimeSupportSubtitle: Maybe<Scalars['String']>
  lifetimeSupportInformationButton: Maybe<Scalars['String']>
  lifetimeSupportInformationText: Maybe<Scalars['Json']>
  lifetimeSupportImage: Maybe<Scalars['Json']>
  tweakwiseRecommendationsTitle: Maybe<Scalars['Json']>
  tweakwiseTemplateId: Maybe<Scalars['String']>
}

export interface MainBodyCheckoutHeader {
  __typename?: 'MainBodyCheckoutHeader'
  type: Maybe<Scalars['String']>
  label: Maybe<Scalars['String']>
  primary: Maybe<MainBodyCheckoutHeaderPrimary>
}

export interface MainBodyCheckoutHeaderPrimary {
  __typename?: 'MainBodyCheckoutHeaderPrimary'
  highlightUsp: Maybe<Scalars['Json']>
  usp1: Maybe<Scalars['Json']>
  usp1Link: Maybe<PrismicHyperlink>
  usp2: Maybe<Scalars['Json']>
  usp2Link: Maybe<PrismicHyperlink>
  usp3: Maybe<Scalars['Json']>
  usp3Link: Maybe<PrismicHyperlink>
  usp4: Maybe<Scalars['Json']>
  usp4Link: Maybe<PrismicHyperlink>
}

export interface MainBodyCheckoutPayment {
  __typename?: 'MainBodyCheckoutPayment'
  type: Maybe<Scalars['String']>
  label: Maybe<Scalars['String']>
  primary: Maybe<MainBodyCheckoutPaymentPrimary>
}

export interface MainBodyCheckoutPaymentPrimary {
  __typename?: 'MainBodyCheckoutPaymentPrimary'
  ideal: Maybe<Scalars['Json']>
  mastercard: Maybe<Scalars['Json']>
  visa: Maybe<Scalars['Json']>
  bancontact: Maybe<Scalars['Json']>
  iban: Maybe<Scalars['Json']>
  paypal: Maybe<Scalars['Json']>
  rembours: Maybe<Scalars['Json']>
  pin: Maybe<Scalars['Json']>
}

export interface MainBodyCheckoutReview {
  __typename?: 'MainBodyCheckoutReview'
  type: Maybe<Scalars['String']>
  label: Maybe<Scalars['String']>
  primary: Maybe<MainBodyCheckoutReviewPrimary>
}

export interface MainBodyCheckoutReviewPrimary {
  __typename?: 'MainBodyCheckoutReviewPrimary'
  idealPaymentIcon: Maybe<Scalars['Json']>
  bancontactPaymentIcon: Maybe<Scalars['Json']>
  mastercardPaymentIcon: Maybe<Scalars['Json']>
  visaPaymentIcon: Maybe<Scalars['Json']>
  pickupPostnlDeliveryText: Maybe<Scalars['Json']>
  pickupStoreDeliveryText: Maybe<Scalars['Json']>
  flatrateDeliveryText: Maybe<Scalars['Json']>
  placeOrderButtonText: Maybe<Scalars['String']>
  termsAndConditionsNotice: Maybe<Scalars['Json']>
}

export interface MainBodyCheckoutSuccess {
  __typename?: 'MainBodyCheckoutSuccess'
  type: Maybe<Scalars['String']>
  label: Maybe<Scalars['String']>
  primary: Maybe<MainBodyCheckoutSuccessPrimary>
}

export interface MainBodyCheckoutSuccessPrimary {
  __typename?: 'MainBodyCheckoutSuccessPrimary'
  enjoyYourPurchaseText: Maybe<Scalars['Json']>
  tweakwiseRecommendationsTitle: Maybe<Scalars['Json']>
  tweakwiseRecommendationsTemplateId: Maybe<Scalars['String']>
}

export interface MainBodyFaqHeader {
  __typename?: 'MainBodyFaqHeader'
  type: Maybe<Scalars['String']>
  label: Maybe<Scalars['String']>
  primary: Maybe<MainBodyFaqHeaderPrimary>
}

export interface MainBodyFaqHeaderPrimary {
  __typename?: 'MainBodyFaqHeaderPrimary'
  title: Maybe<Scalars['Json']>
  content: Maybe<Scalars['Json']>
  image: Maybe<PrismicImageType>
}

export interface MainBodyFooterContact {
  __typename?: 'MainBodyFooterContact'
  type: Maybe<Scalars['String']>
  label: Maybe<Scalars['String']>
  primary: Maybe<MainBodyFooterContactPrimary>
}

export interface MainBodyFooterContactPrimary {
  __typename?: 'MainBodyFooterContactPrimary'
  contactBlockTitleMobile: Maybe<Scalars['Json']>
  contactBlockSubtitleMobile: Maybe<Scalars['Json']>
  contactBlockImageMobile: Maybe<Scalars['Json']>
  contactBlockTitle: Maybe<Scalars['Json']>
  chatTitle: Maybe<Scalars['Json']>
  chatSubtitle: Maybe<Scalars['String']>
  chatIcon: Maybe<Scalars['Json']>
  telephoneTitle: Maybe<Scalars['Json']>
  telephoneSubtitle: Maybe<Scalars['String']>
  telephoneNumber: Maybe<Scalars['String']>
  telephoneIcon: Maybe<Scalars['Json']>
  whatsappTitle: Maybe<Scalars['Json']>
  whatsappSubtitle: Maybe<Scalars['String']>
  whatsappPhoneNumber: Maybe<Scalars['String']>
  whatsappPreFilledWelcomeChatMessage: Maybe<Scalars['String']>
  whatsappIcon: Maybe<Scalars['Json']>
  emailTitle: Maybe<Scalars['Json']>
  emailSubtitle: Maybe<Scalars['String']>
  emailAddress: Maybe<Scalars['String']>
  eMailSubject: Maybe<Scalars['String']>
  emailIcon: Maybe<Scalars['Json']>
  serviceBanner: Maybe<Scalars['Json']>
  storesTitle: Maybe<Scalars['Json']>
}

export interface MainBodyFooterInfo {
  __typename?: 'MainBodyFooterInfo'
  type: Maybe<Scalars['String']>
  label: Maybe<Scalars['String']>
  primary: Maybe<MainBodyFooterInfoPrimary>
  fields: Maybe<Array<MainBodyFooterInfoFields>>
}

export interface MainBodyFooterInfoFields {
  __typename?: 'MainBodyFooterInfoFields'
  title: Maybe<Scalars['Json']>
  link: Maybe<PrismicHyperlink>
}

export interface MainBodyFooterInfoPrimary {
  __typename?: 'MainBodyFooterInfoPrimary'
  text: Maybe<Scalars['Json']>
}

export interface MainBodyFooterMenu1 {
  __typename?: 'MainBodyFooterMenu1'
  type: Maybe<Scalars['String']>
  label: Maybe<Scalars['String']>
  primary: Maybe<MainBodyFooterMenu1Primary>
  fields: Maybe<Array<MainBodyFooterMenu1Fields>>
}

export interface MainBodyFooterMenu1Fields {
  __typename?: 'MainBodyFooterMenu1Fields'
  link: Maybe<PrismicHyperlink>
  title: Maybe<Scalars['Json']>
}

export interface MainBodyFooterMenu1Primary {
  __typename?: 'MainBodyFooterMenu1Primary'
  title: Maybe<Scalars['Json']>
}

export interface MainBodyFooterMenu2 {
  __typename?: 'MainBodyFooterMenu2'
  type: Maybe<Scalars['String']>
  label: Maybe<Scalars['String']>
  primary: Maybe<MainBodyFooterMenu2Primary>
  fields: Maybe<Array<MainBodyFooterMenu2Fields>>
}

export interface MainBodyFooterMenu2Fields {
  __typename?: 'MainBodyFooterMenu2Fields'
  link: Maybe<PrismicHyperlink>
  title: Maybe<Scalars['Json']>
}

export interface MainBodyFooterMenu2Primary {
  __typename?: 'MainBodyFooterMenu2Primary'
  title: Maybe<Scalars['Json']>
}

export interface MainBodyFooterMenu3 {
  __typename?: 'MainBodyFooterMenu3'
  type: Maybe<Scalars['String']>
  label: Maybe<Scalars['String']>
  primary: Maybe<MainBodyFooterMenu3Primary>
  fields: Maybe<Array<MainBodyFooterMenu3Fields>>
}

export interface MainBodyFooterMenu3Fields {
  __typename?: 'MainBodyFooterMenu3Fields'
  link: Maybe<PrismicHyperlink>
  title: Maybe<Scalars['Json']>
}

export interface MainBodyFooterMenu3Primary {
  __typename?: 'MainBodyFooterMenu3Primary'
  title: Maybe<Scalars['Json']>
}

export interface MainBodyFooterMenuMobile {
  __typename?: 'MainBodyFooterMenuMobile'
  type: Maybe<Scalars['String']>
  label: Maybe<Scalars['String']>
  fields: Maybe<Array<MainBodyFooterMenuMobileFields>>
}

export interface MainBodyFooterMenuMobileFields {
  __typename?: 'MainBodyFooterMenuMobileFields'
  link: Maybe<PrismicHyperlink>
  title: Maybe<Scalars['Json']>
}

export interface MainBodyFooterPayment {
  __typename?: 'MainBodyFooterPayment'
  type: Maybe<Scalars['String']>
  label: Maybe<Scalars['String']>
  fields: Maybe<Array<MainBodyFooterPaymentFields>>
}

export interface MainBodyFooterPaymentFields {
  __typename?: 'MainBodyFooterPaymentFields'
  image: Maybe<PrismicImageType>
}

export interface MainBodyFooterRatings {
  __typename?: 'MainBodyFooterRatings'
  type: Maybe<Scalars['String']>
  label: Maybe<Scalars['String']>
  fields: Maybe<Array<MainBodyFooterRatingsFields>>
}

export interface MainBodyFooterRatingsFields {
  __typename?: 'MainBodyFooterRatingsFields'
  image: Maybe<PrismicImageType>
  ratingserviceid: Maybe<Scalars['String']>
  link: Maybe<PrismicHyperlink>
  score: Maybe<Scalars['Float']>
  displayStars: Maybe<Scalars['Json']>
  subText: Maybe<Scalars['Json']>
}

export interface MainBodyFooterService {
  __typename?: 'MainBodyFooterService'
  type: Maybe<Scalars['String']>
  label: Maybe<Scalars['String']>
  primary: Maybe<MainBodyFooterServicePrimary>
}

export interface MainBodyFooterServicePrimary {
  __typename?: 'MainBodyFooterServicePrimary'
  uspTitle: Maybe<Scalars['Json']>
  footerReviewsLogo: Maybe<Scalars['Json']>
  service1Icon: Maybe<Scalars['Json']>
  service1Text: Maybe<Scalars['Json']>
  service1Link: Maybe<PrismicHyperlink>
  service2Icon: Maybe<Scalars['Json']>
  service2Text: Maybe<Scalars['Json']>
  service2Link: Maybe<PrismicHyperlink>
  service3Icon: Maybe<Scalars['Json']>
  service3Text: Maybe<Scalars['Json']>
  service3Link: Maybe<PrismicHyperlink>
  service4Icon: Maybe<Scalars['Json']>
  service4Text: Maybe<Scalars['Json']>
  service4Link: Maybe<PrismicHyperlink>
  serviceBanner: Maybe<Scalars['Json']>
  storesTitle: Maybe<Scalars['Json']>
}

export interface MainBodyFooterSocial {
  __typename?: 'MainBodyFooterSocial'
  type: Maybe<Scalars['String']>
  label: Maybe<Scalars['String']>
  primary: Maybe<MainBodyFooterSocialPrimary>
  fields: Maybe<Array<MainBodyFooterSocialFields>>
}

export interface MainBodyFooterSocialFields {
  __typename?: 'MainBodyFooterSocialFields'
  image: Maybe<PrismicImageType>
  link: Maybe<PrismicHyperlink>
}

export interface MainBodyFooterSocialPrimary {
  __typename?: 'MainBodyFooterSocialPrimary'
  newsletterText: Maybe<Scalars['Json']>
  newsletterButtonText: Maybe<Scalars['Json']>
  socialTitle: Maybe<Scalars['Json']>
  socialTitleMobile: Maybe<Scalars['Json']>
}

export interface MainBodyGmbstorestoexclude {
  __typename?: 'MainBodyGmbstorestoexclude'
  type: Maybe<Scalars['String']>
  label: Maybe<Scalars['String']>
  primary: Maybe<MainBodyGmbstorestoexcludePrimary>
  fields: Maybe<Array<MainBodyGmbstorestoexcludeFields>>
}

export interface MainBodyGmbstorestoexcludeFields {
  __typename?: 'MainBodyGmbstorestoexcludeFields'
  storecode: Maybe<Scalars['String']>
}

export interface MainBodyGmbstorestoexcludePrimary {
  __typename?: 'MainBodyGmbstorestoexcludePrimary'
  customerServiceStorecode: Maybe<Scalars['String']>
}

export interface MainBodyHeaderNotice {
  __typename?: 'MainBodyHeaderNotice'
  type: Maybe<Scalars['String']>
  label: Maybe<Scalars['String']>
  primary: Maybe<MainBodyHeaderNoticePrimary>
}

export interface MainBodyHeaderNoticePrimary {
  __typename?: 'MainBodyHeaderNoticePrimary'
  notice: Maybe<Scalars['Json']>
}

export interface MainBodyShopAlert {
  __typename?: 'MainBodyShopAlert'
  type: Maybe<Scalars['String']>
  label: Maybe<Scalars['String']>
  fields: Maybe<Array<MainBodyShopAlertFields>>
}

export interface MainBodyShopAlertFields {
  __typename?: 'MainBodyShopAlertFields'
  title: Maybe<Scalars['Json']>
  text: Maybe<Scalars['Json']>
  alertBackgroundColor: Maybe<Scalars['String']>
}

export interface MainBodyStoreStockStatusMessages {
  __typename?: 'MainBodyStoreStockStatusMessages'
  type: Maybe<Scalars['String']>
  label: Maybe<Scalars['String']>
  primary: Maybe<MainBodyStoreStockStatusMessagesPrimary>
}

export interface MainBodyStoreStockStatusMessagesPrimary {
  __typename?: 'MainBodyStoreStockStatusMessagesPrimary'
  inStockTitle: Maybe<Scalars['Json']>
  inStockMessage: Maybe<Scalars['Json']>
  lowOnStockTitle: Maybe<Scalars['Json']>
  lowOnStockMessage: Maybe<Scalars['Json']>
  outOfStockTitle: Maybe<Scalars['Json']>
  outOfStockMessage: Maybe<Scalars['Json']>
}

export interface MainBodyUspBanner {
  __typename?: 'MainBodyUspBanner'
  type: Maybe<Scalars['String']>
  label: Maybe<Scalars['String']>
  primary: Maybe<MainBodyUspBannerPrimary>
}

export interface MainBodyUspBannerPrimary {
  __typename?: 'MainBodyUspBannerPrimary'
  slogan: Maybe<Scalars['Json']>
  uspMobile: Maybe<Scalars['Json']>
  uspMobileLink: Maybe<PrismicHyperlink>
  usp1: Maybe<Scalars['Json']>
  usp1Link: Maybe<PrismicHyperlink>
  usp2: Maybe<Scalars['Json']>
  usp2Link: Maybe<PrismicHyperlink>
  usp3: Maybe<Scalars['Json']>
  usp3Link: Maybe<PrismicHyperlink>
  usp4: Maybe<Scalars['Json']>
  usp4Link: Maybe<PrismicHyperlink>
  link1Title: Maybe<Scalars['Json']>
  link1: Maybe<PrismicHyperlink>
  link2Title: Maybe<Scalars['Json']>
  link2: Maybe<PrismicHyperlink>
  image: Maybe<PrismicImageType>
}

/** A connection to a list of items. */
export interface MainConnectionConnection {
  __typename?: 'MainConnectionConnection'
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  /** A list of edges. */
  edges: Maybe<Array<Maybe<MainConnectionEdge>>>
  totalCount: Scalars['Long']
}

/** An edge in a connection. */
export interface MainConnectionEdge {
  __typename?: 'MainConnectionEdge'
  /** The item at the end of the edge. */
  node: Main
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
}

/** MediaGalleryEntry defines characteristics about images and videos associated with a specific product. */
export interface MediaGalleryEntry {
  __typename?: 'MediaGalleryEntry'
  /** Contains a ProductMediaGalleryEntriesContent object. */
  content: Maybe<ProductMediaGalleryEntriesContent>
  /** Whether the image is hidden from view. */
  disabled: Maybe<Scalars['Boolean']>
  /** The path of the image on the server. */
  file: Maybe<Scalars['String']>
  /** The identifier assigned to the object. */
  id: Maybe<Scalars['Int']>
  /** The alt text displayed on the UI when the user points to the image. */
  label: Maybe<Scalars['String']>
  /** image or video. */
  mediaType: Maybe<Scalars['String']>
  /** The media item's position after it has been sorted. */
  position: Maybe<Scalars['Int']>
  /** Array of image types. It can have the following values: image, small_image, thumbnail. */
  types: Maybe<Array<Maybe<Scalars['String']>>>
  /** Contains a ProductMediaGalleryEntriesVideoContent object. */
  videoContent: Maybe<ProductMediaGalleryEntriesVideoContent>
}

/** Contains basic information about a product image or video. */
export interface MediaGalleryInterface {
  /** Whether the image is hidden from view. */
  disabled: Maybe<Scalars['Boolean']>
  /** The label of the product image or video. */
  label: Maybe<Scalars['String']>
  /** The media item's position after it has been sorted. */
  position: Maybe<Scalars['Int']>
  /** The URL of the product image or video. */
  url: Maybe<Scalars['String']>
}

export interface Meta {
  __typename?: 'Meta'
  /** The id of the document. */
  id: Scalars['String']
  /** The uid of the document. */
  uid: Maybe<Scalars['String']>
  /** The type of the document. */
  type: Scalars['String']
  /** The tags of the document. */
  tags: Array<Scalars['String']>
  /** The language of the document. */
  lang: Scalars['String']
  /** Alternate languages the document. */
  alternateLanguages: Array<RelatedDocument>
  /** The first publication date of the document. */
  firstPublicationDate: Maybe<Scalars['DateTime']>
  /** The last publication date of the document. */
  lastPublicationDate: Maybe<Scalars['DateTime']>
}

/** A Money object defines a monetary value, including a numeric value and a currency code. */
export interface Money {
  __typename?: 'Money'
  /** A three-letter currency code, such as USD or EUR */
  currency: CurrencyEnum
  /** A number expressing a monetary value */
  value: Scalars['Float']
}

export interface Mutation {
  __typename?: 'Mutation'
  /** Add comment */
  addAdvComment: Maybe<AddAdvCommentOutput>
  /** Add review */
  addAdvReview: Maybe<AddAdvReviewOutput>
  /** Add vote */
  addAdvVote: Maybe<AddAdvVoteOutput>
  addBundleProductsToCart: Maybe<AddBundleProductsToCartOutput>
  addConfigurableProductsToCart: Maybe<AddConfigurableProductsToCartOutput>
  addSimpleProductsToCart: Maybe<AddSimpleProductsToCartOutput>
  addVirtualProductsToCart: Maybe<AddVirtualProductsToCartOutput>
  applyCouponToCart: Maybe<ApplyCouponToCartOutput>
  /** Changes the password for the logged-in customer */
  changeCustomerPassword: Maybe<Customer>
  /** Create customer account */
  createCustomer: Maybe<CustomerOutput>
  /** Create customer address */
  createCustomerAddress: Maybe<CustomerAddress>
  /** Creates an empty shopping cart for a guest or logged in user */
  createEmptyCart: Maybe<Scalars['String']>
  /** Delete customer address */
  deleteCustomerAddress: Maybe<Scalars['Boolean']>
  /** Retrieve the customer token */
  generateCustomerToken: Maybe<CustomerToken>
  /** Merges the source cart into the destination cart */
  mergeCarts: Cart
  placeOrder: Maybe<PlaceOrderOutput>
  placeOrderAndGetPaymentInformation: Maybe<PlaceOrderAndGetPaymentInformationOutput>
  removeCouponFromCart: Maybe<RemoveCouponFromCartOutput>
  removeItemFromCart: Maybe<RemoveItemFromCartOutput>
  /** Adds all products from a customer's previous order to the cart. */
  reorderItems: Maybe<ReorderItemsOutput>
  /** Request an email with a reset password token for the registered customer identified by the specified email. */
  requestPasswordResetEmail: Maybe<Scalars['Boolean']>
  /**
   * Reset a customer's password using the reset password token that the customer
   * received in an email after requesting it using requestPasswordResetEmail.
   */
  resetPassword: Maybe<Scalars['Boolean']>
  /** Revoke the customer token */
  revokeCustomerToken: Maybe<RevokeCustomerTokenOutput>
  /** Recommends Product by Sending Single/Multiple Email */
  sendEmailToFriend: Maybe<SendEmailToFriendOutput>
  setBillingAddressOnCart: Maybe<SetBillingAddressOnCartOutput>
  setGuestEmailOnCart: Maybe<SetGuestEmailOnCartOutput>
  /** @deprecated Should use setPaymentMethodOnCart and placeOrder mutations in single request. */
  setPaymentMethodAndPlaceOrder: Maybe<PlaceOrderOutput>
  setPaymentMethodOnCart: Maybe<SetPaymentMethodOnCartOutput>
  setShippingAddressesOnCart: Maybe<SetShippingAddressesOnCartOutput>
  setShippingMethodsOnCart: Maybe<SetShippingMethodsOnCartOutput>
  /** Subscribes the specified email to a newsletter */
  subscribeEmailToNewsletter: Maybe<SubscribeEmailToNewsletterOutput>
  updateCartItems: Maybe<UpdateCartItemsOutput>
  /** Update the customer's personal information */
  updateCustomer: Maybe<CustomerOutput>
  /** Update customer address */
  updateCustomerAddress: Maybe<CustomerAddress>
  /** Saves the provided PostNL Delivery Time for home delivery */
  savePostNLDeliveryTime: Cart
  /**
   * Saves PostNL home delivery fallback (as soon as possible). Can be used when
   * the PostNL API is down.
   */
  savePostNLDeliveryFallback: Cart
  /** Saves the provided PostNL pickup location for pickup point delivery */
  savePostNLPickupLocation: Cart
}

export interface MutationAddAdvCommentArgs {
  input?: Maybe<AddAdvCommentInput>
}

export interface MutationAddAdvReviewArgs {
  input?: Maybe<AddAdvReviewInput>
}

export interface MutationAddAdvVoteArgs {
  input?: Maybe<AddAdvVoteInput>
}

export interface MutationAddBundleProductsToCartArgs {
  input?: Maybe<AddBundleProductsToCartInput>
}

export interface MutationAddConfigurableProductsToCartArgs {
  input?: Maybe<AddConfigurableProductsToCartInput>
}

export interface MutationAddSimpleProductsToCartArgs {
  input?: Maybe<AddSimpleProductsToCartInput>
}

export interface MutationAddVirtualProductsToCartArgs {
  input?: Maybe<AddVirtualProductsToCartInput>
}

export interface MutationApplyCouponToCartArgs {
  input?: Maybe<ApplyCouponToCartInput>
}

export interface MutationChangeCustomerPasswordArgs {
  currentPassword: Scalars['String']
  newPassword: Scalars['String']
}

export interface MutationCreateCustomerArgs {
  input: CustomerInput
}

export interface MutationCreateCustomerAddressArgs {
  input: CustomerAddressInput
}

export interface MutationCreateEmptyCartArgs {
  input?: Maybe<CreateEmptyCartInput>
}

export interface MutationDeleteCustomerAddressArgs {
  id: Scalars['Int']
}

export interface MutationGenerateCustomerTokenArgs {
  email: Scalars['String']
  password: Scalars['String']
}

export interface MutationMergeCartsArgs {
  source_cart_id: Scalars['String']
  destination_cart_id: Scalars['String']
}

export interface MutationPlaceOrderArgs {
  input?: Maybe<PlaceOrderInput>
}

export interface MutationPlaceOrderAndGetPaymentInformationArgs {
  input?: Maybe<PlaceOrderAndGetPaymentInformationInput>
}

export interface MutationRemoveCouponFromCartArgs {
  input?: Maybe<RemoveCouponFromCartInput>
}

export interface MutationRemoveItemFromCartArgs {
  input?: Maybe<RemoveItemFromCartInput>
}

export interface MutationReorderItemsArgs {
  orderNumber: Scalars['String']
}

export interface MutationRequestPasswordResetEmailArgs {
  email: Scalars['String']
}

export interface MutationResetPasswordArgs {
  email: Scalars['String']
  resetPasswordToken: Scalars['String']
  newPassword: Scalars['String']
}

export interface MutationSendEmailToFriendArgs {
  input?: Maybe<SendEmailToFriendInput>
}

export interface MutationSetBillingAddressOnCartArgs {
  input?: Maybe<SetBillingAddressOnCartInput>
}

export interface MutationSetGuestEmailOnCartArgs {
  input?: Maybe<SetGuestEmailOnCartInput>
}

export interface MutationSetPaymentMethodAndPlaceOrderArgs {
  input?: Maybe<SetPaymentMethodAndPlaceOrderInput>
}

export interface MutationSetPaymentMethodOnCartArgs {
  input?: Maybe<SetPaymentMethodOnCartInput>
}

export interface MutationSetShippingAddressesOnCartArgs {
  input?: Maybe<SetShippingAddressesOnCartInput>
}

export interface MutationSetShippingMethodsOnCartArgs {
  input?: Maybe<SetShippingMethodsOnCartInput>
}

export interface MutationSubscribeEmailToNewsletterArgs {
  email: Scalars['String']
}

export interface MutationUpdateCartItemsArgs {
  input?: Maybe<UpdateCartItemsInput>
}

export interface MutationUpdateCustomerArgs {
  input: CustomerInput
}

export interface MutationUpdateCustomerAddressArgs {
  id: Scalars['Int']
  input?: Maybe<CustomerAddressInput>
}

export interface MutationSavePostNlDeliveryTimeArgs {
  input: PostNlDeliveryInput
}

export interface MutationSavePostNlDeliveryFallbackArgs {
  input: PostNlDeliveryFallbackInput
}

export interface MutationSavePostNlPickupLocationArgs {
  input: PostNlPickupInput
}

export interface NearestPostNlLocationsInput {
  /** Fetches the PostNL locations by a specified address */
  address: PostNlSearchAddress
  /** TODO: Fetch locations by latitude + longitude */
  geolocation?: Maybe<Scalars['String']>
}

export interface Order {
  __typename?: 'Order'
  maskedOrderId: Maybe<Scalars['String']>
  /** @deprecated The order_id field is deprecated, use order_number instead. */
  orderId: Maybe<Scalars['String']>
  orderNumber: Scalars['String']
}

export interface Page extends Document, Linkable {
  __typename?: 'Page'
  urlKey: Maybe<Scalars['String']>
  seoTitle: Maybe<Scalars['Json']>
  seoDescription: Maybe<Scalars['Json']>
  seoKeywords: Maybe<Scalars['Json']>
  body: Maybe<Array<PageBody>>
  meta: Meta
  linkType: Maybe<Scalars['String']>
}

export type PageBody =
  | PageBodyPlain
  | PageBodyBannerHalfHalf
  | PageBodyBrands
  | PageBodySeoText
  | PageBodyMasonryBanner
  | PageBodySlimBanner
  | PageBodyCategoryBanner
  | PageBodyHighlightBanner
  | PageBodyUspBanner
  | PageBodyServiceBanner
  | PageBodyHero
  | PageBodyProductRecommendations
  | PageBodyShopAlert
  | PageBodyHtml
  | PageBodyTable2Rows
  | PageBodyTable3Rows
  | PageBodyTable4Rows
  | PageBodyTable5Rows
  | PageBodyForm
  | PageBodyStorelocator
  | PageBodyContact
  | PageBodyBreadcrumbs
  | PageBodyStoreCover
  | PageBodyStoreContact
  | PageBodyStoreGoogleMap
  | PageBodyStoreText
  | PageBodyStoreUsp
  | PageBodyStoreImages
  | PageBodyCompare
  | PageBodyFaq
  | PageBodyUspTextBanner
  | PageBodyText2Cols
  | PageBodyImageContentColumns
  | PageBodyImage2Cols
  | PageBodyHighlightImageText
  | PageBodyImageContentTile
  | PageBodyDiscoverBrand
  | PageBodyYoutubeVideo
  | PageBodyFeaturedLinks
  | PageBodyIframe

export interface PageBodyBannerHalfHalf {
  __typename?: 'PageBodyBannerHalfHalf'
  type: Maybe<Scalars['String']>
  label: Maybe<Scalars['String']>
  primary: Maybe<PageBodyBannerHalfHalfPrimary>
}

export interface PageBodyBannerHalfHalfPrimary {
  __typename?: 'PageBodyBannerHalfHalfPrimary'
  image1: Maybe<Scalars['Json']>
  buttonText1: Maybe<Scalars['String']>
  buttonLink1: Maybe<PrismicHyperlink>
  content1: Maybe<Scalars['Json']>
  image2: Maybe<Scalars['Json']>
  buttonText2: Maybe<Scalars['String']>
  buttonLink2: Maybe<PrismicHyperlink>
  content2: Maybe<Scalars['Json']>
}

export interface PageBodyBrands {
  __typename?: 'PageBodyBrands'
  type: Maybe<Scalars['String']>
  label: Maybe<Scalars['String']>
  primary: Maybe<PageBodyBrandsPrimary>
  fields: Maybe<Array<PageBodyBrandsFields>>
}

export interface PageBodyBrandsFields {
  __typename?: 'PageBodyBrandsFields'
  image: Maybe<PrismicImageType>
  link: Maybe<PrismicHyperlink>
}

export interface PageBodyBrandsPrimary {
  __typename?: 'PageBodyBrandsPrimary'
  title: Maybe<Scalars['Json']>
}

export interface PageBodyBreadcrumbs {
  __typename?: 'PageBodyBreadcrumbs'
  type: Maybe<Scalars['String']>
  label: Maybe<Scalars['String']>
  fields: Maybe<Array<PageBodyBreadcrumbsFields>>
}

export interface PageBodyBreadcrumbsFields {
  __typename?: 'PageBodyBreadcrumbsFields'
  name: Maybe<Scalars['String']>
  link: Maybe<PrismicHyperlink>
}

export interface PageBodyCategoryBanner {
  __typename?: 'PageBodyCategoryBanner'
  type: Maybe<Scalars['String']>
  label: Maybe<Scalars['String']>
  primary: Maybe<PageBodyCategoryBannerPrimary>
  fields: Maybe<Array<PageBodyCategoryBannerFields>>
}

export interface PageBodyCategoryBannerFields {
  __typename?: 'PageBodyCategoryBannerFields'
  image: Maybe<PrismicImageType>
  title: Maybe<Scalars['Json']>
  link: Maybe<PrismicHyperlink>
}

export interface PageBodyCategoryBannerPrimary {
  __typename?: 'PageBodyCategoryBannerPrimary'
  title: Maybe<Scalars['Json']>
}

export interface PageBodyCompare {
  __typename?: 'PageBodyCompare'
  type: Maybe<Scalars['String']>
  label: Maybe<Scalars['String']>
  primary: Maybe<PageBodyComparePrimary>
}

export interface PageBodyComparePrimary {
  __typename?: 'PageBodyComparePrimary'
  title: Maybe<Scalars['Json']>
}

export interface PageBodyContact {
  __typename?: 'PageBodyContact'
  type: Maybe<Scalars['String']>
  label: Maybe<Scalars['String']>
  primary: Maybe<PageBodyContactPrimary>
}

export interface PageBodyContactPrimary {
  __typename?: 'PageBodyContactPrimary'
  contactBlockTitle: Maybe<Scalars['Json']>
  chatTitle: Maybe<Scalars['Json']>
  chatSubtitle: Maybe<Scalars['String']>
  chatIcon: Maybe<Scalars['Json']>
  telephoneTitle: Maybe<Scalars['Json']>
  telephoneSubtitle: Maybe<Scalars['String']>
  telephoneNumber: Maybe<Scalars['String']>
  telephoneIcon: Maybe<Scalars['Json']>
  whatsappTitle: Maybe<Scalars['Json']>
  whatsappSubtitle: Maybe<Scalars['String']>
  whatsappPhoneNumber: Maybe<Scalars['String']>
  whatsappPreFilledWelcomeChatMessage: Maybe<Scalars['String']>
  whatsappIcon: Maybe<Scalars['Json']>
  emailTitle: Maybe<Scalars['Json']>
  emailSubtitle: Maybe<Scalars['String']>
  emailAddress: Maybe<Scalars['String']>
  eMailSubject: Maybe<Scalars['String']>
  emailIcon: Maybe<Scalars['Json']>
}

export interface PageBodyDiscoverBrand {
  __typename?: 'PageBodyDiscoverBrand'
  type: Maybe<Scalars['String']>
  label: Maybe<Scalars['String']>
  primary: Maybe<PageBodyDiscoverBrandPrimary>
  fields: Maybe<Array<PageBodyDiscoverBrandFields>>
}

export interface PageBodyDiscoverBrandFields {
  __typename?: 'PageBodyDiscoverBrandFields'
  brandLinkText: Maybe<Scalars['String']>
  brandLink: Maybe<PrismicHyperlink>
}

export interface PageBodyDiscoverBrandPrimary {
  __typename?: 'PageBodyDiscoverBrandPrimary'
  title: Maybe<Scalars['Json']>
  logoImage: Maybe<Scalars['Json']>
  mobileImage: Maybe<Scalars['Json']>
  image: Maybe<PrismicImageType>
}

export interface PageBodyFaq {
  __typename?: 'PageBodyFaq'
  type: Maybe<Scalars['String']>
  label: Maybe<Scalars['String']>
}

export interface PageBodyFeaturedLinks {
  __typename?: 'PageBodyFeaturedLinks'
  type: Maybe<Scalars['String']>
  label: Maybe<Scalars['String']>
  primary: Maybe<PageBodyFeaturedLinksPrimary>
  fields: Maybe<Array<PageBodyFeaturedLinksFields>>
}

export interface PageBodyFeaturedLinksFields {
  __typename?: 'PageBodyFeaturedLinksFields'
  image: Maybe<PrismicImageType>
  linkTitle: Maybe<Scalars['Json']>
  link: Maybe<PrismicHyperlink>
}

export interface PageBodyFeaturedLinksPrimary {
  __typename?: 'PageBodyFeaturedLinksPrimary'
  title: Maybe<Scalars['Json']>
}

export interface PageBodyForm {
  __typename?: 'PageBodyForm'
  type: Maybe<Scalars['String']>
  label: Maybe<Scalars['String']>
  primary: Maybe<PageBodyFormPrimary>
}

export interface PageBodyFormPrimary {
  __typename?: 'PageBodyFormPrimary'
  form: Maybe<PrismicHyperlink>
}

export interface PageBodyHero {
  __typename?: 'PageBodyHero'
  type: Maybe<Scalars['String']>
  label: Maybe<Scalars['String']>
  primary: Maybe<PageBodyHeroPrimary>
}

export interface PageBodyHeroPrimary {
  __typename?: 'PageBodyHeroPrimary'
  menuTitle: Maybe<Scalars['Json']>
  menuLink1Title: Maybe<Scalars['Json']>
  menuLink1: Maybe<PrismicHyperlink>
  menuLink1DisplayOnMobile: Maybe<Scalars['Json']>
  menuLink2Title: Maybe<Scalars['Json']>
  menuLink2: Maybe<PrismicHyperlink>
  menuLink2DisplayOnMobile: Maybe<Scalars['Json']>
  menuLink3Title: Maybe<Scalars['Json']>
  menuLink3: Maybe<PrismicHyperlink>
  menuLink3DisplayOnMobile: Maybe<Scalars['Json']>
  menuLink4Title: Maybe<Scalars['Json']>
  menuLink4: Maybe<PrismicHyperlink>
  menuLink4DisplayOnMobile: Maybe<Scalars['Json']>
  menuLink5Title: Maybe<Scalars['Json']>
  menuLink5: Maybe<PrismicHyperlink>
  menuLink5DisplayOnMobile: Maybe<Scalars['Json']>
  menuLink6Title: Maybe<Scalars['Json']>
  menuLink6: Maybe<PrismicHyperlink>
  menuLink6DisplayOnMobile: Maybe<Scalars['Json']>
  menuLink7Title: Maybe<Scalars['Json']>
  menuLink7: Maybe<PrismicHyperlink>
  menuLink7DisplayOnMobile: Maybe<Scalars['Json']>
  menuLink8Title: Maybe<Scalars['Json']>
  menuLink8: Maybe<PrismicHyperlink>
  menuLink8DisplayOnMobile: Maybe<Scalars['Json']>
  menuLink9Title: Maybe<Scalars['Json']>
  menuLink9: Maybe<PrismicHyperlink>
  menuLink9DisplayOnMobile: Maybe<Scalars['Json']>
  heroSlide1Text: Maybe<Scalars['Json']>
  heroSlide1ButtonTitle: Maybe<Scalars['Json']>
  heroSlide1Name: Maybe<Scalars['Json']>
  heroSlide1Link: Maybe<PrismicHyperlink>
  heroSlide1Image: Maybe<Scalars['Json']>
  heroSlide2Text: Maybe<Scalars['Json']>
  heroSlide2ButtonTitle: Maybe<Scalars['Json']>
  heroSlide2Name: Maybe<Scalars['Json']>
  heroSlide2Link: Maybe<PrismicHyperlink>
  heroSlide2Image: Maybe<Scalars['Json']>
  heroSlide3Text: Maybe<Scalars['Json']>
  heroSlide3ButtonTitle: Maybe<Scalars['Json']>
  heroSlide3Name: Maybe<Scalars['Json']>
  heroSlide3Link: Maybe<PrismicHyperlink>
  heroSlide3Image: Maybe<Scalars['Json']>
  heroSlide4Text: Maybe<Scalars['Json']>
  heroSlide4ButtonTitle: Maybe<Scalars['Json']>
  heroSlide4Name: Maybe<Scalars['Json']>
  heroSlide4Link: Maybe<PrismicHyperlink>
  heroSlide4Image: Maybe<Scalars['Json']>
  storeBannerText: Maybe<Scalars['Json']>
  storeBannerHighlight: Maybe<Scalars['Json']>
  storeBannerImage: Maybe<Scalars['Json']>
}

export interface PageBodyHighlightBanner {
  __typename?: 'PageBodyHighlightBanner'
  type: Maybe<Scalars['String']>
  label: Maybe<Scalars['String']>
  fields: Maybe<Array<PageBodyHighlightBannerFields>>
}

export interface PageBodyHighlightBannerFields {
  __typename?: 'PageBodyHighlightBannerFields'
  image: Maybe<PrismicImageType>
  title: Maybe<Scalars['Json']>
  subtitle: Maybe<Scalars['Json']>
  text: Maybe<Scalars['Json']>
  link: Maybe<PrismicHyperlink>
  linkTitle: Maybe<Scalars['String']>
  imageAlignment: Maybe<Scalars['Json']>
}

export interface PageBodyHighlightImageText {
  __typename?: 'PageBodyHighlightImageText'
  type: Maybe<Scalars['String']>
  label: Maybe<Scalars['String']>
  primary: Maybe<PageBodyHighlightImageTextPrimary>
}

export interface PageBodyHighlightImageTextPrimary {
  __typename?: 'PageBodyHighlightImageTextPrimary'
  title: Maybe<Scalars['Json']>
  text: Maybe<Scalars['Json']>
  contentAlignment: Maybe<Scalars['Json']>
  image: Maybe<PrismicImageType>
}

export interface PageBodyHtml {
  __typename?: 'PageBodyHtml'
  type: Maybe<Scalars['String']>
  label: Maybe<Scalars['String']>
  primary: Maybe<PageBodyHtmlPrimary>
}

export interface PageBodyHtmlPrimary {
  __typename?: 'PageBodyHtmlPrimary'
  html: Maybe<Scalars['Json']>
}

export interface PageBodyIframe {
  __typename?: 'PageBodyIframe'
  type: Maybe<Scalars['String']>
  label: Maybe<Scalars['String']>
  primary: Maybe<PageBodyIframePrimary>
}

export interface PageBodyIframePrimary {
  __typename?: 'PageBodyIframePrimary'
  sourceurl: Maybe<PrismicHyperlink>
  width: Maybe<Scalars['Float']>
  height: Maybe<Scalars['Float']>
}

export interface PageBodyImage2Cols {
  __typename?: 'PageBodyImage2Cols'
  type: Maybe<Scalars['String']>
  label: Maybe<Scalars['String']>
  fields: Maybe<Array<PageBodyImage2ColsFields>>
}

export interface PageBodyImage2ColsFields {
  __typename?: 'PageBodyImage2ColsFields'
  image: Maybe<PrismicImageType>
}

export interface PageBodyImageContentColumns {
  __typename?: 'PageBodyImageContentColumns'
  type: Maybe<Scalars['String']>
  label: Maybe<Scalars['String']>
  fields: Maybe<Array<PageBodyImageContentColumnsFields>>
}

export interface PageBodyImageContentColumnsFields {
  __typename?: 'PageBodyImageContentColumnsFields'
  image: Maybe<PrismicImageType>
  title: Maybe<Scalars['Json']>
  text: Maybe<Scalars['Json']>
  secondaryButtonText: Maybe<Scalars['String']>
  secondaryButtonLink: Maybe<PrismicHyperlink>
  primaryButtonText: Maybe<Scalars['String']>
  primaryButtonLink: Maybe<PrismicHyperlink>
  imageAlignment: Maybe<Scalars['Json']>
}

export interface PageBodyImageContentTile {
  __typename?: 'PageBodyImageContentTile'
  type: Maybe<Scalars['String']>
  label: Maybe<Scalars['String']>
  primary: Maybe<PageBodyImageContentTilePrimary>
}

export interface PageBodyImageContentTilePrimary {
  __typename?: 'PageBodyImageContentTilePrimary'
  title: Maybe<Scalars['Json']>
  subtitle: Maybe<Scalars['Json']>
  text: Maybe<Scalars['Json']>
  imageAlignment: Maybe<Scalars['Json']>
  image: Maybe<PrismicImageType>
}

export interface PageBodyMasonryBanner {
  __typename?: 'PageBodyMasonryBanner'
  type: Maybe<Scalars['String']>
  label: Maybe<Scalars['String']>
  fields: Maybe<Array<PageBodyMasonryBannerFields>>
}

export interface PageBodyMasonryBannerFields {
  __typename?: 'PageBodyMasonryBannerFields'
  image: Maybe<PrismicImageType>
  linkTitle: Maybe<Scalars['Json']>
  link: Maybe<PrismicHyperlink>
  text: Maybe<Scalars['Json']>
  spanWidth: Maybe<Scalars['Json']>
}

export interface PageBodyPlain {
  __typename?: 'PageBodyPlain'
  type: Maybe<Scalars['String']>
  label: Maybe<Scalars['String']>
  primary: Maybe<PageBodyPlainPrimary>
}

export interface PageBodyPlainPrimary {
  __typename?: 'PageBodyPlainPrimary'
  title: Maybe<Scalars['Json']>
  text: Maybe<Scalars['Json']>
  isNarrow: Maybe<Scalars['Json']>
  textAlignment: Maybe<Scalars['Json']>
  image: Maybe<PrismicImageType>
}

export interface PageBodyProductRecommendations {
  __typename?: 'PageBodyProductRecommendations'
  type: Maybe<Scalars['String']>
  label: Maybe<Scalars['String']>
  primary: Maybe<PageBodyProductRecommendationsPrimary>
}

export interface PageBodyProductRecommendationsPrimary {
  __typename?: 'PageBodyProductRecommendationsPrimary'
  title: Maybe<Scalars['Json']>
  templateId: Maybe<Scalars['String']>
}

export interface PageBodySeoText {
  __typename?: 'PageBodySeoText'
  type: Maybe<Scalars['String']>
  label: Maybe<Scalars['String']>
  primary: Maybe<PageBodySeoTextPrimary>
}

export interface PageBodySeoTextPrimary {
  __typename?: 'PageBodySeoTextPrimary'
  text: Maybe<Scalars['Json']>
}

export interface PageBodyServiceBanner {
  __typename?: 'PageBodyServiceBanner'
  type: Maybe<Scalars['String']>
  label: Maybe<Scalars['String']>
  fields: Maybe<Array<PageBodyServiceBannerFields>>
}

export interface PageBodyServiceBannerFields {
  __typename?: 'PageBodyServiceBannerFields'
  image: Maybe<PrismicImageType>
  icon: Maybe<Scalars['Json']>
  link: Maybe<PrismicHyperlink>
  title: Maybe<Scalars['Json']>
  text: Maybe<Scalars['Json']>
  backgroundColor: Maybe<Scalars['Json']>
  arrowIconColor: Maybe<Scalars['Json']>
}

export interface PageBodyShopAlert {
  __typename?: 'PageBodyShopAlert'
  type: Maybe<Scalars['String']>
  label: Maybe<Scalars['String']>
  fields: Maybe<Array<PageBodyShopAlertFields>>
}

export interface PageBodyShopAlertFields {
  __typename?: 'PageBodyShopAlertFields'
  title: Maybe<Scalars['Json']>
  text: Maybe<Scalars['Json']>
  alertBackgroundColor: Maybe<Scalars['String']>
}

export interface PageBodySlimBanner {
  __typename?: 'PageBodySlimBanner'
  type: Maybe<Scalars['String']>
  label: Maybe<Scalars['String']>
  primary: Maybe<PageBodySlimBannerPrimary>
}

export interface PageBodySlimBannerPrimary {
  __typename?: 'PageBodySlimBannerPrimary'
  background: Maybe<Scalars['Json']>
  popout: Maybe<Scalars['Json']>
  leftContent: Maybe<Scalars['Json']>
  rightContent: Maybe<Scalars['Json']>
  buttonLink: Maybe<PrismicHyperlink>
  buttonText: Maybe<Scalars['String']>
}

export interface PageBodyStoreContact {
  __typename?: 'PageBodyStoreContact'
  type: Maybe<Scalars['String']>
  label: Maybe<Scalars['String']>
  primary: Maybe<PageBodyStoreContactPrimary>
  fields: Maybe<Array<PageBodyStoreContactFields>>
}

export interface PageBodyStoreContactFields {
  __typename?: 'PageBodyStoreContactFields'
  specialist: Maybe<Scalars['Json']>
}

export interface PageBodyStoreContactPrimary {
  __typename?: 'PageBodyStoreContactPrimary'
  mobileOrder: Maybe<Scalars['Float']>
  telephoneTitle: Maybe<Scalars['String']>
  telephoneSubtitle: Maybe<Scalars['String']>
  telephoneNumber: Maybe<Scalars['String']>
  whatsappTitle: Maybe<Scalars['String']>
  whatsappSubtitle: Maybe<Scalars['String']>
  whatsappNumber: Maybe<Scalars['String']>
  whatsappChatMessage: Maybe<Scalars['String']>
  emailTitle: Maybe<Scalars['String']>
  emailSubtitle: Maybe<Scalars['String']>
  emailAddress: Maybe<Scalars['String']>
  specialistTitle: Maybe<Scalars['String']>
}

export interface PageBodyStoreCover {
  __typename?: 'PageBodyStoreCover'
  type: Maybe<Scalars['String']>
  label: Maybe<Scalars['String']>
  primary: Maybe<PageBodyStoreCoverPrimary>
  fields: Maybe<Array<PageBodyStoreCoverFields>>
}

export interface PageBodyStoreCoverFields {
  __typename?: 'PageBodyStoreCoverFields'
  specialDateText: Maybe<Scalars['String']>
  specialDate: Maybe<Scalars['Date']>
}

export interface PageBodyStoreCoverPrimary {
  __typename?: 'PageBodyStoreCoverPrimary'
  mobileOrder: Maybe<Scalars['Float']>
  title: Maybe<Scalars['String']>
  label: Maybe<Scalars['String']>
  openTill: Maybe<Scalars['String']>
  businessHoursTitle: Maybe<Scalars['Json']>
  image: Maybe<PrismicImageType>
}

export interface PageBodyStoreGoogleMap {
  __typename?: 'PageBodyStoreGoogleMap'
  type: Maybe<Scalars['String']>
  label: Maybe<Scalars['String']>
  primary: Maybe<PageBodyStoreGoogleMapPrimary>
}

export interface PageBodyStoreGoogleMapPrimary {
  __typename?: 'PageBodyStoreGoogleMapPrimary'
  mobileOrder: Maybe<Scalars['Float']>
  latitude: Maybe<Scalars['String']>
  longitude: Maybe<Scalars['String']>
}

export interface PageBodyStoreImages {
  __typename?: 'PageBodyStoreImages'
  type: Maybe<Scalars['String']>
  label: Maybe<Scalars['String']>
  primary: Maybe<PageBodyStoreImagesPrimary>
  fields: Maybe<Array<PageBodyStoreImagesFields>>
}

export interface PageBodyStoreImagesFields {
  __typename?: 'PageBodyStoreImagesFields'
  image: Maybe<PrismicImageType>
  videoId: Maybe<Scalars['String']>
}

export interface PageBodyStoreImagesPrimary {
  __typename?: 'PageBodyStoreImagesPrimary'
  mobileOrder: Maybe<Scalars['Float']>
}

export interface PageBodyStorelocator {
  __typename?: 'PageBodyStorelocator'
  type: Maybe<Scalars['String']>
  label: Maybe<Scalars['String']>
  primary: Maybe<PageBodyStorelocatorPrimary>
  fields: Maybe<Array<PageBodyStorelocatorFields>>
}

export interface PageBodyStorelocatorFields {
  __typename?: 'PageBodyStorelocatorFields'
  storecode: Maybe<Scalars['String']>
  latitude: Maybe<Scalars['String']>
  longitude: Maybe<Scalars['String']>
}

export interface PageBodyStorelocatorPrimary {
  __typename?: 'PageBodyStorelocatorPrimary'
  title: Maybe<Scalars['Json']>
  text: Maybe<Scalars['Json']>
  image: Maybe<PrismicImageType>
}

export interface PageBodyStoreText {
  __typename?: 'PageBodyStoreText'
  type: Maybe<Scalars['String']>
  label: Maybe<Scalars['String']>
  primary: Maybe<PageBodyStoreTextPrimary>
}

export interface PageBodyStoreTextPrimary {
  __typename?: 'PageBodyStoreTextPrimary'
  mobileOrder: Maybe<Scalars['Float']>
  image: Maybe<PrismicImageType>
  text: Maybe<Scalars['Json']>
}

export interface PageBodyStoreUsp {
  __typename?: 'PageBodyStoreUsp'
  type: Maybe<Scalars['String']>
  label: Maybe<Scalars['String']>
  primary: Maybe<PageBodyStoreUspPrimary>
  fields: Maybe<Array<PageBodyStoreUspFields>>
}

export interface PageBodyStoreUspFields {
  __typename?: 'PageBodyStoreUspFields'
  icon: Maybe<Scalars['Json']>
  title: Maybe<Scalars['String']>
  text: Maybe<Scalars['Json']>
}

export interface PageBodyStoreUspPrimary {
  __typename?: 'PageBodyStoreUspPrimary'
  mobileOrder: Maybe<Scalars['Float']>
}

export interface PageBodyTable2Rows {
  __typename?: 'PageBodyTable2Rows'
  type: Maybe<Scalars['String']>
  label: Maybe<Scalars['String']>
  primary: Maybe<PageBodyTable2RowsPrimary>
  fields: Maybe<Array<PageBodyTable2RowsFields>>
}

export interface PageBodyTable2RowsFields {
  __typename?: 'PageBodyTable2RowsFields'
  column1: Maybe<Scalars['Json']>
  column1Icon: Maybe<Scalars['String']>
  column1Align: Maybe<Scalars['String']>
  column1Header: Maybe<Scalars['Json']>
  column1Border: Maybe<Scalars['Json']>
  column2: Maybe<Scalars['Json']>
  column2Icon: Maybe<Scalars['String']>
  column2Align: Maybe<Scalars['String']>
  column2Header: Maybe<Scalars['Json']>
  column2Border: Maybe<Scalars['Json']>
}

export interface PageBodyTable2RowsPrimary {
  __typename?: 'PageBodyTable2RowsPrimary'
  title: Maybe<Scalars['Json']>
  width: Maybe<Scalars['Float']>
  showBorders: Maybe<Scalars['Json']>
}

export interface PageBodyTable3Rows {
  __typename?: 'PageBodyTable3Rows'
  type: Maybe<Scalars['String']>
  label: Maybe<Scalars['String']>
  primary: Maybe<PageBodyTable3RowsPrimary>
  fields: Maybe<Array<PageBodyTable3RowsFields>>
}

export interface PageBodyTable3RowsFields {
  __typename?: 'PageBodyTable3RowsFields'
  column1: Maybe<Scalars['Json']>
  column1Icon: Maybe<Scalars['String']>
  column1Align: Maybe<Scalars['String']>
  column1Header: Maybe<Scalars['Json']>
  column1Border: Maybe<Scalars['Json']>
  column2: Maybe<Scalars['Json']>
  column2Icon: Maybe<Scalars['String']>
  column2Align: Maybe<Scalars['String']>
  column2Header: Maybe<Scalars['Json']>
  column2Border: Maybe<Scalars['Json']>
  column3: Maybe<Scalars['Json']>
  column3Icon: Maybe<Scalars['String']>
  column3Align: Maybe<Scalars['String']>
  column3Header: Maybe<Scalars['Json']>
  column3Border: Maybe<Scalars['Json']>
}

export interface PageBodyTable3RowsPrimary {
  __typename?: 'PageBodyTable3RowsPrimary'
  title: Maybe<Scalars['Json']>
  width: Maybe<Scalars['Float']>
  showBorders: Maybe<Scalars['Json']>
}

export interface PageBodyTable4Rows {
  __typename?: 'PageBodyTable4Rows'
  type: Maybe<Scalars['String']>
  label: Maybe<Scalars['String']>
  primary: Maybe<PageBodyTable4RowsPrimary>
  fields: Maybe<Array<PageBodyTable4RowsFields>>
}

export interface PageBodyTable4RowsFields {
  __typename?: 'PageBodyTable4RowsFields'
  column1: Maybe<Scalars['Json']>
  column1Icon: Maybe<Scalars['String']>
  column1Align: Maybe<Scalars['String']>
  column1Header: Maybe<Scalars['Json']>
  column1Border: Maybe<Scalars['Json']>
  column2: Maybe<Scalars['Json']>
  column2Icon: Maybe<Scalars['String']>
  column2Align: Maybe<Scalars['String']>
  column2Header: Maybe<Scalars['Json']>
  column2Border: Maybe<Scalars['Json']>
  column3: Maybe<Scalars['Json']>
  column3Icon: Maybe<Scalars['String']>
  column3Align: Maybe<Scalars['String']>
  column3Header: Maybe<Scalars['Json']>
  column3Border: Maybe<Scalars['Json']>
  column4: Maybe<Scalars['Json']>
  column4Icon: Maybe<Scalars['String']>
  column4Align: Maybe<Scalars['String']>
  column4Header: Maybe<Scalars['Json']>
  column4Border: Maybe<Scalars['Json']>
}

export interface PageBodyTable4RowsPrimary {
  __typename?: 'PageBodyTable4RowsPrimary'
  title: Maybe<Scalars['Json']>
  width: Maybe<Scalars['Float']>
  showBorders: Maybe<Scalars['Json']>
}

export interface PageBodyTable5Rows {
  __typename?: 'PageBodyTable5Rows'
  type: Maybe<Scalars['String']>
  label: Maybe<Scalars['String']>
  primary: Maybe<PageBodyTable5RowsPrimary>
  fields: Maybe<Array<PageBodyTable5RowsFields>>
}

export interface PageBodyTable5RowsFields {
  __typename?: 'PageBodyTable5RowsFields'
  column1: Maybe<Scalars['Json']>
  column1Icon: Maybe<Scalars['String']>
  column1Align: Maybe<Scalars['String']>
  column1Header: Maybe<Scalars['Json']>
  column1Border: Maybe<Scalars['Json']>
  column2: Maybe<Scalars['Json']>
  column2Icon: Maybe<Scalars['String']>
  column2Align: Maybe<Scalars['String']>
  column2Header: Maybe<Scalars['Json']>
  column2Border: Maybe<Scalars['Json']>
  column3: Maybe<Scalars['Json']>
  column3Icon: Maybe<Scalars['String']>
  column3Align: Maybe<Scalars['String']>
  column3Header: Maybe<Scalars['Json']>
  column3Border: Maybe<Scalars['Json']>
  column4: Maybe<Scalars['Json']>
  column4Icon: Maybe<Scalars['String']>
  column4Align: Maybe<Scalars['String']>
  column4Header: Maybe<Scalars['Json']>
  column4Border: Maybe<Scalars['Json']>
  column5: Maybe<Scalars['Json']>
  column5Icon: Maybe<Scalars['String']>
  column5Align: Maybe<Scalars['String']>
  column5Header: Maybe<Scalars['Json']>
  column5Border: Maybe<Scalars['Json']>
}

export interface PageBodyTable5RowsPrimary {
  __typename?: 'PageBodyTable5RowsPrimary'
  title: Maybe<Scalars['Json']>
  width: Maybe<Scalars['Float']>
  showBorders: Maybe<Scalars['Json']>
}

export interface PageBodyText2Cols {
  __typename?: 'PageBodyText2Cols'
  type: Maybe<Scalars['String']>
  label: Maybe<Scalars['String']>
  primary: Maybe<PageBodyText2ColsPrimary>
  fields: Maybe<Array<PageBodyText2ColsFields>>
}

export interface PageBodyText2ColsFields {
  __typename?: 'PageBodyText2ColsFields'
  title: Maybe<Scalars['Json']>
  text: Maybe<Scalars['Json']>
}

export interface PageBodyText2ColsPrimary {
  __typename?: 'PageBodyText2ColsPrimary'
  sectionTitle: Maybe<Scalars['Json']>
  isNarrow: Maybe<Scalars['Json']>
}

export interface PageBodyUspBanner {
  __typename?: 'PageBodyUspBanner'
  type: Maybe<Scalars['String']>
  label: Maybe<Scalars['String']>
  primary: Maybe<PageBodyUspBannerPrimary>
}

export interface PageBodyUspBannerPrimary {
  __typename?: 'PageBodyUspBannerPrimary'
  slogan: Maybe<Scalars['Json']>
  uspMobile: Maybe<Scalars['Json']>
  uspMobileLink: Maybe<PrismicHyperlink>
  usp1: Maybe<Scalars['Json']>
  usp1Link: Maybe<PrismicHyperlink>
  usp2: Maybe<Scalars['Json']>
  usp2Link: Maybe<PrismicHyperlink>
  usp3: Maybe<Scalars['Json']>
  usp3Link: Maybe<PrismicHyperlink>
  usp4: Maybe<Scalars['Json']>
  usp4Link: Maybe<PrismicHyperlink>
  link1Title: Maybe<Scalars['Json']>
  link1: Maybe<PrismicHyperlink>
  link2Title: Maybe<Scalars['Json']>
  link2: Maybe<PrismicHyperlink>
  image: Maybe<PrismicImageType>
}

export interface PageBodyUspTextBanner {
  __typename?: 'PageBodyUspTextBanner'
  type: Maybe<Scalars['String']>
  label: Maybe<Scalars['String']>
  primary: Maybe<PageBodyUspTextBannerPrimary>
  fields: Maybe<Array<PageBodyUspTextBannerFields>>
}

export interface PageBodyUspTextBannerFields {
  __typename?: 'PageBodyUspTextBannerFields'
  upsListItem: Maybe<Scalars['String']>
}

export interface PageBodyUspTextBannerPrimary {
  __typename?: 'PageBodyUspTextBannerPrimary'
  title: Maybe<Scalars['String']>
  image: Maybe<PrismicImageType>
  mobileImage: Maybe<Scalars['Json']>
}

export interface PageBodyYoutubeVideo {
  __typename?: 'PageBodyYoutubeVideo'
  type: Maybe<Scalars['String']>
  label: Maybe<Scalars['String']>
  primary: Maybe<PageBodyYoutubeVideoPrimary>
}

export interface PageBodyYoutubeVideoPrimary {
  __typename?: 'PageBodyYoutubeVideoPrimary'
  youtubeId: Maybe<Scalars['String']>
  videoThumbnail: Maybe<Scalars['Json']>
}

/** A connection to a list of items. */
export interface PageConnectionConnection {
  __typename?: 'PageConnectionConnection'
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  /** A list of edges. */
  edges: Maybe<Array<Maybe<PageConnectionEdge>>>
  totalCount: Scalars['Long']
}

/** An edge in a connection. */
export interface PageConnectionEdge {
  __typename?: 'PageConnectionEdge'
  /** The item at the end of the edge. */
  node: Page
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
}

/** Information about pagination in a connection. */
export interface PageInfo {
  __typename?: 'PageInfo'
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']
  /** When paginating backwards, the cursor to continue. */
  startCursor: Maybe<Scalars['String']>
  /** When paginating forwards, the cursor to continue. */
  endCursor: Maybe<Scalars['String']>
}

export interface PaymentInformation {
  __typename?: 'PaymentInformation'
  gatewayRedirectFormAction: Maybe<Scalars['String']>
  gatewayRedirectFormFields: Maybe<Array<Maybe<GatewayOrderResultFormField>>>
  gatewayRedirectUrl: Maybe<Scalars['String']>
}

export interface PaymentMethodInput {
  additional_data?: Maybe<Array<Maybe<AdditionalDataField>>>
  /** Payment method code */
  code: Scalars['String']
  /** Purchase order number */
  purchase_order_number?: Maybe<Scalars['String']>
}

/** PhysicalProductInterface contains attributes specific to tangible products. */
export interface PhysicalProductInterface {
  /** The weight of the item, in units defined by the store. */
  weight: Maybe<Scalars['Float']>
}

/** Defines Pickup Location information. */
export interface PickupLocation {
  __typename?: 'PickupLocation'
  city: Maybe<Scalars['String']>
  contactName: Maybe<Scalars['String']>
  countryId: Maybe<Scalars['String']>
  description: Maybe<Scalars['String']>
  email: Maybe<Scalars['String']>
  fax: Maybe<Scalars['String']>
  latitude: Maybe<Scalars['Float']>
  longitude: Maybe<Scalars['Float']>
  name: Maybe<Scalars['String']>
  phone: Maybe<Scalars['String']>
  pickupLocationCode: Maybe<Scalars['String']>
  postcode: Maybe<Scalars['String']>
  region: Maybe<Scalars['String']>
  regionId: Maybe<Scalars['Int']>
  street: Maybe<Scalars['String']>
}

/** PickupLocationFilterInput defines the list of attributes and filters for the search. */
export interface PickupLocationFilterInput {
  /** Filter by city. */
  city?: Maybe<FilterTypeInput>
  /** Filter by country. */
  country_id?: Maybe<FilterTypeInput>
  /** Filter by pickup location name. */
  name?: Maybe<FilterTypeInput>
  /** Filter by pickup location code. */
  pickup_location_code?: Maybe<FilterTypeInput>
  /** Filter by postcode. */
  postcode?: Maybe<FilterTypeInput>
  /** Filter by region. */
  region?: Maybe<FilterTypeInput>
  /** Filter by region id. */
  region_id?: Maybe<FilterTypeInput>
  /** Filter by street. */
  street?: Maybe<FilterTypeInput>
}

/** Top level object returned in a pickup locations search. */
export interface PickupLocations {
  __typename?: 'PickupLocations'
  /** An array of pickup locations that match the specific search request. */
  items: Maybe<Array<Maybe<PickupLocation>>>
  /** An object that includes the page_info and currentPage values specified in the query. */
  pageInfo: Maybe<SearchResultPageInfo>
  /** The number of products returned. */
  totalCount: Maybe<Scalars['Int']>
}

/**
 * PickupLocationSortInput specifies attribute to use for sorting search results
 * and indicates whether the results are sorted in ascending or descending order.
 */
export interface PickupLocationSortInput {
  /** City where pickup location is placed. */
  city?: Maybe<SortEnum>
  /** Name of the contact person. */
  contact_name?: Maybe<SortEnum>
  /** Id of the country in two letters. */
  country_id?: Maybe<SortEnum>
  /** Description of the pickup location. */
  description?: Maybe<SortEnum>
  /**
   * Distance to the address, requested by distance filter. Applicable only with
   * distance filter. If distance sort order is present, all other sort orders will be ignored.
   */
  distance?: Maybe<SortEnum>
  /** Contact email of the pickup location. */
  email?: Maybe<SortEnum>
  /** Contact fax of the pickup location. */
  fax?: Maybe<SortEnum>
  /** Geographic latitude where pickup location is placed. */
  latitude?: Maybe<SortEnum>
  /** Geographic longitude where pickup location is placed. */
  longitude?: Maybe<SortEnum>
  /** The pickup location name. Customer use this to identify the pickup location. */
  name?: Maybe<SortEnum>
  /** Contact phone number of the pickup location. */
  phone?: Maybe<SortEnum>
  /** A code assigned to pickup location to identify the source. */
  pickup_location_code?: Maybe<SortEnum>
  /** Postcode where pickup location is placed. */
  postcode?: Maybe<SortEnum>
  /** Name of the region. */
  region?: Maybe<SortEnum>
  /** Id of the region. */
  region_id?: Maybe<SortEnum>
  /** Street where pickup location is placed. */
  street?: Maybe<SortEnum>
}

export interface PimcoreAsset {
  __typename?: 'PimcoreAsset'
  creationDate: Maybe<Scalars['Int']>
  id: Maybe<Scalars['ID']>
  filename: Maybe<Scalars['String']>
  fullpath: Maybe<Scalars['String']>
  resolutions: Maybe<Array<Maybe<PimcoreResolutions>>>
  srcset: Maybe<Array<Maybe<PimcoreSrcset>>>
  mimetype: Maybe<Scalars['String']>
  modificationDate: Maybe<Scalars['Int']>
  type: Maybe<Scalars['String']>
  filesize: Maybe<Scalars['Int']>
  data: Maybe<Scalars['String']>
  metadata: Maybe<Array<Maybe<PimcoreAssetMetadataItem>>>
  properties: Maybe<Array<Maybe<PimcoreElementProperty>>>
  parent: Maybe<PimcoreAssetTree>
  children: Maybe<Array<Maybe<PimcoreAssetTree>>>
  siblings: Maybe<Array<Maybe<PimcoreAssetTree>>>
}

export interface PimcoreAssetFullpathArgs {
  thumbnail?: Maybe<Scalars['String']>
}

export interface PimcoreAssetResolutionsArgs {
  thumbnail: Scalars['String']
  types?: Maybe<Array<Maybe<Scalars['Float']>>>
}

export interface PimcoreAssetSrcsetArgs {
  thumbnail: Scalars['String']
}

export interface PimcoreAssetDataArgs {
  thumbnail?: Maybe<Scalars['String']>
}

export interface PimcoreAssetMetadataArgs {
  language?: Maybe<Scalars['String']>
  ignore_language?: Maybe<Scalars['Boolean']>
}

export interface PimcoreAssetPropertiesArgs {
  keys?: Maybe<Array<Maybe<Scalars['String']>>>
}

export interface PimcoreAssetConnection {
  __typename?: 'PimcoreAssetConnection'
  edges: Maybe<Array<Maybe<PimcoreAssetEdge>>>
  /** The total count of all queryable assets for this schema listing */
  totalCount: Maybe<Scalars['Int']>
}

export interface PimcoreAssetEdge {
  __typename?: 'PimcoreAssetEdge'
  cursor: Maybe<Scalars['String']>
  node: Maybe<PimcoreAssetTree>
}

export interface PimcoreAssetFolder {
  __typename?: 'PimcoreAssetFolder'
  id: Maybe<Scalars['ID']>
  filename: Maybe<Scalars['String']>
  fullpath: Maybe<Scalars['String']>
  creationDate: Maybe<Scalars['Int']>
  modificationDateDate: Maybe<Scalars['Int']>
  properties: Maybe<Array<Maybe<PimcoreElementProperty>>>
  parent: Maybe<PimcoreAssetFolder>
  children: Maybe<Array<Maybe<PimcoreAssetTree>>>
  siblings: Maybe<Array<Maybe<PimcoreAssetTree>>>
}

export interface PimcoreAssetFolderFullpathArgs {
  thumbnail?: Maybe<Scalars['String']>
}

export interface PimcoreAssetFolderPropertiesArgs {
  keys?: Maybe<Array<Maybe<Scalars['String']>>>
}

export interface PimcoreAssetMetadataItem {
  __typename?: 'PimcoreAssetMetadataItem'
  name: Maybe<Scalars['String']>
  type: Maybe<Scalars['String']>
  data: Maybe<Scalars['String']>
  language: Maybe<Scalars['String']>
}

export type PimcoreAssetTree = PimcoreAsset | PimcoreAssetFolder

export interface PimcoreBlockConfigurationShortSpecsEntry {
  __typename?: 'PimcoreBlockConfigurationShortSpecsEntry'
  specName: Maybe<Scalars['String']>
  brickName: Maybe<Scalars['String']>
}

export interface PimcoreBuitenkansjesConnection {
  __typename?: 'PimcoreBuitenkansjesConnection'
  edges: Maybe<Array<Maybe<PimcoreBuitenkansjesEdge>>>
  /** The total count of all queryable objects for this schema listing */
  totalCount: Maybe<Scalars['Int']>
}

export interface PimcoreBuitenkansjesEdge {
  __typename?: 'PimcoreBuitenkansjesEdge'
  cursor: Maybe<Scalars['String']>
  node: Maybe<PimcoreObjectBuitenkansjes>
}

export interface PimcoreCategorieenConnection {
  __typename?: 'PimcoreCategorieenConnection'
  edges: Maybe<Array<Maybe<PimcoreCategorieenEdge>>>
  /** The total count of all queryable objects for this schema listing */
  totalCount: Maybe<Scalars['Int']>
}

export interface PimcoreCategorieenEdge {
  __typename?: 'PimcoreCategorieenEdge'
  cursor: Maybe<Scalars['String']>
  node: Maybe<PimcoreCategory>
}

export interface PimcoreCategory extends PimcoreElement {
  __typename?: 'PimcoreCategory'
  name: Maybe<Scalars['String']>
  siblings: Maybe<Array<Maybe<PimcoreObjectTree>>>
  children: Maybe<Array<Maybe<PimcoreObjectTree>>>
  childrenSortBy: Maybe<Scalars['String']>
  classname: Maybe<Scalars['String']>
  id: Maybe<Scalars['ID']>
  image: Maybe<PimcoreAsset>
  index: Maybe<Scalars['Int']>
  isActive: Maybe<Scalars['Boolean']>
  key: Maybe<Scalars['String']>
  parent: Maybe<PimcoreObjectTree>
  promotions: Maybe<Array<Maybe<PimcoreObjectCategorieenPromotions>>>
  properties: Maybe<Array<Maybe<PimcoreElementProperty>>>
  urlKey: Maybe<Scalars['String']>
}

export interface PimcoreCategorySiblingsArgs {
  objectTypes?: Maybe<Array<Maybe<Scalars['String']>>>
}

export interface PimcoreCategoryChildrenArgs {
  objectTypes?: Maybe<Array<Maybe<Scalars['String']>>>
}

export interface PimcoreCategoryPropertiesArgs {
  keys?: Maybe<Array<Maybe<Scalars['String']>>>
}

export interface PimcoreCombiDealConnection {
  __typename?: 'PimcoreCombiDealConnection'
  edges: Maybe<Array<Maybe<PimcoreCombiDealEdge>>>
  /** The total count of all queryable objects for this schema listing */
  totalCount: Maybe<Scalars['Int']>
}

export interface PimcoreCombiDealEdge {
  __typename?: 'PimcoreCombiDealEdge'
  cursor: Maybe<Scalars['String']>
  node: Maybe<PimcoreObjectCombiDeal>
}

export interface PimcoreConfigurationConnection {
  __typename?: 'PimcoreConfigurationConnection'
  edges: Maybe<Array<Maybe<PimcoreConfigurationEdge>>>
  /** The total count of all queryable objects for this schema listing */
  totalCount: Maybe<Scalars['Int']>
}

export interface PimcoreConfigurationEdge {
  __typename?: 'PimcoreConfigurationEdge'
  cursor: Maybe<Scalars['String']>
  node: Maybe<PimcoreObjectConfiguration>
}

export interface PimcoreDeliverytimesConnection {
  __typename?: 'PimcoreDeliverytimesConnection'
  edges: Maybe<Array<Maybe<PimcoreDeliverytimesEdge>>>
  /** The total count of all queryable objects for this schema listing */
  totalCount: Maybe<Scalars['Int']>
}

export interface PimcoreDeliverytimesEdge {
  __typename?: 'PimcoreDeliverytimesEdge'
  cursor: Maybe<Scalars['String']>
  node: Maybe<PimcoreObjectDeliverytimes>
}

export interface PimcoreElement {
  id: Maybe<Scalars['ID']>
}

export type PimcoreElementProperty =
  | PimcorePropertyCheckbox
  | PimcorePropertyText
  | PimcorePropertyAsset
  | PimcorePropertyAssetfolder
  | PimcorePropertyObject
  | PimcorePropertyObjectfolder

export type PimcoreFieldType =
  | PimcoreSpecificationsObjectBrickAttributeString
  | PimcoreSpecificationsObjectBrickAttributeStrings
  | PimcoreSpecificationsObjectBrickAttributeFloat
  | PimcoreSpecificationsObjectBrickAttributeBoolean
  | PimcoreSpecificationsObjectBrickAttributeInt

export type PimcoreHotspotMetadataObject =
  | PimcoreProduct
  | PimcoreObjectPrismicSlice
  | PimcoreObjectProductButton
  | PimcoreCategory
  | PimcoreObjectBuitenkansjes
  | PimcoreObjectPromotion
  | PimcoreObjectSpecialist
  | PimcoreObjectProductAddon
  | PimcoreObjectConfiguration
  | PimcoreObjectCombiDeal
  | PimcoreObjectRelatedCategories
  | PimcoreObjectDeliverytimes
  | PimcoreAsset
  | PimcoreAssetFolder

export interface PimcoreObjectBuitenkansjes extends PimcoreElement {
  __typename?: 'PimcoreObjectBuitenkansjes'
  buitenkansjeprijs: Maybe<Scalars['Float']>
  condition: Maybe<Scalars['String']>
  pid: Maybe<Scalars['Float']>
  siblings: Maybe<Array<Maybe<PimcoreObjectTree>>>
  children: Maybe<Array<Maybe<PimcoreObjectTree>>>
  childrenSortBy: Maybe<Scalars['String']>
  classname: Maybe<Scalars['String']>
  fullpath: Maybe<Scalars['String']>
  id: Maybe<Scalars['ID']>
  index: Maybe<Scalars['Int']>
  parent: Maybe<PimcoreObjectTree>
  products: Maybe<Scalars['String']>
  properties: Maybe<Array<Maybe<PimcoreElementProperty>>>
}

export interface PimcoreObjectBuitenkansjesSiblingsArgs {
  objectTypes?: Maybe<Array<Maybe<Scalars['String']>>>
}

export interface PimcoreObjectBuitenkansjesChildrenArgs {
  objectTypes?: Maybe<Array<Maybe<Scalars['String']>>>
}

export interface PimcoreObjectBuitenkansjesPropertiesArgs {
  keys?: Maybe<Array<Maybe<Scalars['String']>>>
}

export type PimcoreObjectCategorieenPromotions = PimcoreObjectPromotion

export interface PimcoreObjectCombiDeal extends PimcoreElement {
  __typename?: 'PimcoreObjectCombiDeal'
  siblings: Maybe<Array<Maybe<PimcoreObjectTree>>>
  children: Maybe<Array<Maybe<PimcoreObjectTree>>>
  childrenSortBy: Maybe<Scalars['String']>
  classname: Maybe<Scalars['String']>
  combiProducts: Maybe<Array<Maybe<PimcoreObjectCombiDealCombiProducts>>>
  discountPercentage: Maybe<Scalars['Float']>
  fullpath: Maybe<Scalars['String']>
  id: Maybe<Scalars['ID']>
  index: Maybe<Scalars['Int']>
  order: Maybe<Scalars['Float']>
  parent: Maybe<PimcoreObjectTree>
  products: Maybe<Array<Maybe<PimcoreProduct>>>
  properties: Maybe<Array<Maybe<PimcoreElementProperty>>>
}

export interface PimcoreObjectCombiDealSiblingsArgs {
  objectTypes?: Maybe<Array<Maybe<Scalars['String']>>>
}

export interface PimcoreObjectCombiDealChildrenArgs {
  objectTypes?: Maybe<Array<Maybe<Scalars['String']>>>
}

export interface PimcoreObjectCombiDealPropertiesArgs {
  keys?: Maybe<Array<Maybe<Scalars['String']>>>
}

export type PimcoreObjectCombiDealCombiProducts = PimcoreProduct

export interface PimcoreObjectConfiguration extends PimcoreElement {
  __typename?: 'PimcoreObjectConfiguration'
  siblings: Maybe<Array<Maybe<PimcoreObjectTree>>>
  children: Maybe<Array<Maybe<PimcoreObjectTree>>>
  childrenSortBy: Maybe<Scalars['String']>
  classname: Maybe<Scalars['String']>
  id: Maybe<Scalars['ID']>
  index: Maybe<Scalars['Int']>
  parent: Maybe<PimcoreObjectTree>
  properties: Maybe<Array<Maybe<PimcoreElementProperty>>>
  shortSpecs: Maybe<Array<Maybe<PimcoreBlockConfigurationShortSpecsEntry>>>
}

export interface PimcoreObjectConfigurationSiblingsArgs {
  objectTypes?: Maybe<Array<Maybe<Scalars['String']>>>
}

export interface PimcoreObjectConfigurationChildrenArgs {
  objectTypes?: Maybe<Array<Maybe<Scalars['String']>>>
}

export interface PimcoreObjectConfigurationPropertiesArgs {
  keys?: Maybe<Array<Maybe<Scalars['String']>>>
}

export interface PimcoreObjectDeliverytimes extends PimcoreElement {
  __typename?: 'PimcoreObjectDeliverytimes'
  templatetitle: Maybe<Scalars['String']>
  siblings: Maybe<Array<Maybe<PimcoreObjectTree>>>
  children: Maybe<Array<Maybe<PimcoreObjectTree>>>
  childrenSortBy: Maybe<Scalars['String']>
  classname: Maybe<Scalars['String']>
  color: Maybe<Scalars['String']>
  deliveryText: Maybe<Scalars['String']>
  deliveryTextShort: Maybe<Scalars['String']>
  deliveryTextWeekend: Maybe<Scalars['String']>
  deliveryTextWeekendShort: Maybe<Scalars['String']>
  id: Maybe<Scalars['ID']>
  index: Maybe<Scalars['Int']>
  parent: Maybe<PimcoreObjectTree>
  properties: Maybe<Array<Maybe<PimcoreElementProperty>>>
  templatetitleweekend: Maybe<Scalars['String']>
}

export interface PimcoreObjectDeliverytimesSiblingsArgs {
  objectTypes?: Maybe<Array<Maybe<Scalars['String']>>>
}

export interface PimcoreObjectDeliverytimesChildrenArgs {
  objectTypes?: Maybe<Array<Maybe<Scalars['String']>>>
}

export interface PimcoreObjectDeliverytimesPropertiesArgs {
  keys?: Maybe<Array<Maybe<Scalars['String']>>>
}

export interface PimcoreObjectFolder {
  __typename?: 'PimcoreObjectFolder'
  id: Maybe<Scalars['ID']>
  key: Maybe<Scalars['String']>
  fullpath: Maybe<Scalars['String']>
  creationDate: Maybe<Scalars['Int']>
  modificationDateDate: Maybe<Scalars['Int']>
  parent: Maybe<PimcoreObjectTree>
  index: Maybe<Scalars['Int']>
  childrenSortBy: Maybe<Scalars['String']>
  children: Maybe<Array<Maybe<PimcoreObjectTree>>>
  properties: Maybe<Array<Maybe<PimcoreElementProperty>>>
  siblings: Maybe<Array<Maybe<PimcoreObjectTree>>>
}

export interface PimcoreObjectFolderChildrenArgs {
  objectTypes?: Maybe<Array<Maybe<Scalars['String']>>>
}

export interface PimcoreObjectFolderPropertiesArgs {
  keys?: Maybe<Array<Maybe<Scalars['String']>>>
}

export interface PimcoreObjectFolderSiblingsArgs {
  objectTypes?: Maybe<Array<Maybe<Scalars['String']>>>
}

export interface PimcoreObjectPrismicSlice extends PimcoreElement {
  __typename?: 'PimcoreObjectPrismicSlice'
  as: Maybe<Scalars['String']>
  siblings: Maybe<Array<Maybe<PimcoreObjectTree>>>
  children: Maybe<Array<Maybe<PimcoreObjectTree>>>
  childrenSortBy: Maybe<Scalars['String']>
  classname: Maybe<Scalars['String']>
  id: Maybe<Scalars['ID']>
  index: Maybe<Scalars['Int']>
  key: Maybe<Scalars['String']>
  parent: Maybe<PimcoreObjectTree>
  prismicType: Maybe<Scalars['String']>
  prismicUid: Maybe<Scalars['String']>
  properties: Maybe<Array<Maybe<PimcoreElementProperty>>>
}

export interface PimcoreObjectPrismicSliceSiblingsArgs {
  objectTypes?: Maybe<Array<Maybe<Scalars['String']>>>
}

export interface PimcoreObjectPrismicSliceChildrenArgs {
  objectTypes?: Maybe<Array<Maybe<Scalars['String']>>>
}

export interface PimcoreObjectPrismicSlicePropertiesArgs {
  keys?: Maybe<Array<Maybe<Scalars['String']>>>
}

export interface PimcoreObjectProductAddon extends PimcoreElement {
  __typename?: 'PimcoreObjectProductAddon'
  siblings: Maybe<Array<Maybe<PimcoreObjectTree>>>
  children: Maybe<Array<Maybe<PimcoreObjectTree>>>
  childrenSortBy: Maybe<Scalars['String']>
  classname: Maybe<Scalars['String']>
  description: Maybe<Scalars['String']>
  id: Maybe<Scalars['ID']>
  image: Maybe<PimcoreAsset>
  index: Maybe<Scalars['Int']>
  informationText: Maybe<Scalars['String']>
  informationTitle: Maybe<Scalars['String']>
  parent: Maybe<PimcoreObjectTree>
  product: Maybe<PimcoreObjectProductAddonProduct>
  properties: Maybe<Array<Maybe<PimcoreElementProperty>>>
  title: Maybe<Scalars['String']>
}

export interface PimcoreObjectProductAddonSiblingsArgs {
  objectTypes?: Maybe<Array<Maybe<Scalars['String']>>>
}

export interface PimcoreObjectProductAddonChildrenArgs {
  objectTypes?: Maybe<Array<Maybe<Scalars['String']>>>
}

export interface PimcoreObjectProductAddonPropertiesArgs {
  keys?: Maybe<Array<Maybe<Scalars['String']>>>
}

/** pseudo class for field product */
export type PimcoreObjectProductAddonProduct = PimcoreProduct

export type PimcoreObjectProductBuitenkansjes = PimcoreProduct

export interface PimcoreObjectProductButton extends PimcoreElement {
  __typename?: 'PimcoreObjectProductButton'
  siblings: Maybe<Array<Maybe<PimcoreObjectTree>>>
  children: Maybe<Array<Maybe<PimcoreObjectTree>>>
  childrenSortBy: Maybe<Scalars['String']>
  classname: Maybe<Scalars['String']>
  enabled1: Maybe<Scalars['Boolean']>
  enabled2: Maybe<Scalars['Boolean']>
  hideAddToCart: Maybe<Scalars['Boolean']>
  icon1: Maybe<Scalars['String']>
  icon2: Maybe<Scalars['String']>
  id: Maybe<Scalars['ID']>
  index: Maybe<Scalars['Int']>
  key: Maybe<Scalars['String']>
  link1: Maybe<Scalars['String']>
  link2: Maybe<Scalars['String']>
  openIn1: Maybe<Scalars['String']>
  openIn2: Maybe<Scalars['String']>
  parent: Maybe<PimcoreObjectTree>
  properties: Maybe<Array<Maybe<PimcoreElementProperty>>>
  showTooltip: Maybe<Scalars['Boolean']>
  text1: Maybe<Scalars['String']>
  text2: Maybe<Scalars['String']>
  title: Maybe<Scalars['String']>
  tooltip: Maybe<Scalars['String']>
  usps: Maybe<Scalars['String']>
  variant1: Maybe<Scalars['String']>
  variant2: Maybe<Scalars['String']>
}

export interface PimcoreObjectProductButtonSiblingsArgs {
  objectTypes?: Maybe<Array<Maybe<Scalars['String']>>>
}

export interface PimcoreObjectProductButtonChildrenArgs {
  objectTypes?: Maybe<Array<Maybe<Scalars['String']>>>
}

export interface PimcoreObjectProductButtonPropertiesArgs {
  keys?: Maybe<Array<Maybe<Scalars['String']>>>
}

export type PimcoreObjectProductCategoryIds = PimcoreCategory

export type PimcoreObjectProductCombinations = PimcoreObjectCombiDeal

/** pseudo class for field DeliveryTimetemplate */
export type PimcoreObjectProductDeliveryTimetemplate = PimcoreObjectDeliverytimes

/** pseudo class for field primaryPromotion */
export type PimcoreObjectProductPrimaryPromotion = PimcoreObjectPromotion

export type PimcoreObjectProductPrismicSlices = PimcoreObjectPrismicSlice

/** pseudo class for field productButtons */
export type PimcoreObjectProductProductButtons = PimcoreObjectProductButton

export type PimcoreObjectProductPromotions = PimcoreObjectPromotion

/** pseudo class for field related_categories */
export type PimcoreObjectProductRelatedCategories = PimcoreObjectRelatedCategories

/** pseudo class for field specialist */
export type PimcoreObjectProductSpecialist = PimcoreObjectSpecialist

export interface PimcoreObjectPromotion extends PimcoreElement {
  __typename?: 'PimcoreObjectPromotion'
  siblings: Maybe<Array<Maybe<PimcoreObjectTree>>>
  categories: Maybe<Array<Maybe<PimcoreCategory>>>
  children: Maybe<Array<Maybe<PimcoreObjectTree>>>
  childrenSortBy: Maybe<Scalars['String']>
  classname: Maybe<Scalars['String']>
  fullpath: Maybe<Scalars['String']>
  id: Maybe<Scalars['ID']>
  image: Maybe<PimcoreAsset>
  index: Maybe<Scalars['Int']>
  label: Maybe<Scalars['String']>
  link: Maybe<Scalars['String']>
  parent: Maybe<PimcoreObjectTree>
  prismicSlices: Maybe<Array<Maybe<PimcoreObjectPromotionPrismicSlices>>>
  productAddons: Maybe<Array<Maybe<PimcoreObjectPromotionProductAddons>>>
  products: Maybe<Array<Maybe<PimcoreProduct>>>
  properties: Maybe<Array<Maybe<PimcoreElementProperty>>>
  text: Maybe<Scalars['String']>
  title: Maybe<Scalars['String']>
}

export interface PimcoreObjectPromotionSiblingsArgs {
  objectTypes?: Maybe<Array<Maybe<Scalars['String']>>>
}

export interface PimcoreObjectPromotionChildrenArgs {
  objectTypes?: Maybe<Array<Maybe<Scalars['String']>>>
}

export interface PimcoreObjectPromotionPropertiesArgs {
  keys?: Maybe<Array<Maybe<Scalars['String']>>>
}

export type PimcoreObjectPromotionPrismicSlices = PimcoreObjectPrismicSlice

export type PimcoreObjectPromotionProductAddons = PimcoreObjectProductAddon

export interface PimcoreObjectRelatedCategories extends PimcoreElement {
  __typename?: 'PimcoreObjectRelatedCategories'
  siblings: Maybe<Array<Maybe<PimcoreObjectTree>>>
  categories: Maybe<Array<Maybe<PimcoreObjectRelatedCategoriesCategories>>>
  children: Maybe<Array<Maybe<PimcoreObjectTree>>>
  childrenSortBy: Maybe<Scalars['String']>
  classname: Maybe<Scalars['String']>
  id: Maybe<Scalars['ID']>
  index: Maybe<Scalars['Int']>
  parent: Maybe<PimcoreObjectTree>
  properties: Maybe<Array<Maybe<PimcoreElementProperty>>>
  viewAllLink: Maybe<Scalars['String']>
  viewAllTitle: Maybe<Scalars['String']>
}

export interface PimcoreObjectRelatedCategoriesSiblingsArgs {
  objectTypes?: Maybe<Array<Maybe<Scalars['String']>>>
}

export interface PimcoreObjectRelatedCategoriesChildrenArgs {
  objectTypes?: Maybe<Array<Maybe<Scalars['String']>>>
}

export interface PimcoreObjectRelatedCategoriesPropertiesArgs {
  keys?: Maybe<Array<Maybe<Scalars['String']>>>
}

export type PimcoreObjectRelatedCategoriesCategories = PimcoreCategory

export interface PimcoreObjectSpecialist extends PimcoreElement {
  __typename?: 'PimcoreObjectSpecialist'
  siblings: Maybe<Array<Maybe<PimcoreObjectTree>>>
  children: Maybe<Array<Maybe<PimcoreObjectTree>>>
  childrenSortBy: Maybe<Scalars['String']>
  classname: Maybe<Scalars['String']>
  id: Maybe<Scalars['ID']>
  image: Maybe<PimcoreAsset>
  index: Maybe<Scalars['Int']>
  location: Maybe<Scalars['String']>
  name: Maybe<Scalars['String']>
  parent: Maybe<PimcoreObjectTree>
  properties: Maybe<Array<Maybe<PimcoreElementProperty>>>
}

export interface PimcoreObjectSpecialistSiblingsArgs {
  objectTypes?: Maybe<Array<Maybe<Scalars['String']>>>
}

export interface PimcoreObjectSpecialistChildrenArgs {
  objectTypes?: Maybe<Array<Maybe<Scalars['String']>>>
}

export interface PimcoreObjectSpecialistPropertiesArgs {
  keys?: Maybe<Array<Maybe<Scalars['String']>>>
}

export type PimcoreObjectTree =
  | PimcoreProduct
  | PimcoreObjectPrismicSlice
  | PimcoreObjectProductButton
  | PimcoreCategory
  | PimcoreObjectBuitenkansjes
  | PimcoreObjectPromotion
  | PimcoreObjectSpecialist
  | PimcoreObjectProductAddon
  | PimcoreObjectConfiguration
  | PimcoreObjectCombiDeal
  | PimcoreObjectRelatedCategories
  | PimcoreObjectDeliverytimes
  | PimcoreObjectFolder

export interface PimcorePrismicSliceConnection {
  __typename?: 'PimcorePrismicSliceConnection'
  edges: Maybe<Array<Maybe<PimcorePrismicSliceEdge>>>
  /** The total count of all queryable objects for this schema listing */
  totalCount: Maybe<Scalars['Int']>
}

export interface PimcorePrismicSliceEdge {
  __typename?: 'PimcorePrismicSliceEdge'
  cursor: Maybe<Scalars['String']>
  node: Maybe<PimcoreObjectPrismicSlice>
}

export interface PimcoreProduct extends PimcoreElement {
  __typename?: 'PimcoreProduct'
  beeldformaat: Maybe<Scalars['String']>
  buitenkansjes: Maybe<Array<Maybe<PimcoreObjectProductBuitenkansjes>>>
  deliveryTimetemplate: Maybe<PimcoreObjectProductDeliveryTimetemplate>
  doorverkooppremie: Maybe<Scalars['Float']>
  ean: Maybe<Scalars['String']>
  inkoopprijs: Maybe<Scalars['Float']>
  keepproductbuttons: Maybe<Scalars['Boolean']>
  korteomschrijving: Maybe<Scalars['String']>
  korteomschrijving2: Maybe<Scalars['String']>
  main2: Maybe<PimcoreAsset>
  merk: Maybe<Scalars['String']>
  modeltype: Maybe<Scalars['String']>
  productnaam: Maybe<Scalars['String']>
  productvideo1: Maybe<PimcoreVideo>
  productvideo2: Maybe<PimcoreVideo>
  productvideo3: Maybe<PimcoreVideo>
  productvideo4: Maybe<PimcoreVideo>
  specialprice: Maybe<Scalars['Float']>
  stockoverlay: Maybe<Scalars['String']>
  tweakwiseCrossSellTemplateId: Maybe<Scalars['String']>
  voorraadAmsterdam: Maybe<Scalars['String']>
  voorraadArnhem: Maybe<Scalars['String']>
  voorraadBreda: Maybe<Scalars['String']>
  voorraadDoetinchem: Maybe<Scalars['String']>
  voorraadEindhoven: Maybe<Scalars['String']>
  voorraadGroningen: Maybe<Scalars['String']>
  voorraadNaarden: Maybe<Scalars['String']>
  voorraadNijmegen: Maybe<Scalars['String']>
  voorraadOnline: Maybe<Scalars['String']>
  voorraadUtrecht: Maybe<Scalars['String']>
  voorraadZoeterwoude: Maybe<Scalars['String']>
  zondaglevering: Maybe<Scalars['Boolean']>
  siblings: Maybe<Array<Maybe<PimcoreObjectTree>>>
  categoryIds: Maybe<Array<Maybe<PimcoreObjectProductCategoryIds>>>
  children: Maybe<Array<Maybe<PimcoreObjectTree>>>
  childrenSortBy: Maybe<Scalars['String']>
  classname: Maybe<Scalars['String']>
  combinations: Maybe<Array<Maybe<PimcoreObjectProductCombinations>>>
  cons: Maybe<Scalars['String']>
  id: Maybe<Scalars['ID']>
  index: Maybe<Scalars['Int']>
  isActiveInPim: Maybe<Scalars['Boolean']>
  isBuitenkansje: Maybe<Scalars['Boolean']>
  kenmerken: Maybe<Scalars['String']>
  key: Maybe<Scalars['String']>
  langeomschrijving: Maybe<Scalars['String']>
  muurbeugelKleur: Maybe<Scalars['String']>
  parent: Maybe<PimcoreObjectTree>
  price: Maybe<Scalars['Float']>
  primaryPromotion: Maybe<PimcoreObjectProductPrimaryPromotion>
  prismicSlices: Maybe<Array<Maybe<PimcoreObjectProductPrismicSlices>>>
  productButtons: Maybe<PimcoreObjectProductProductButtons>
  promotions: Maybe<Array<Maybe<PimcoreObjectProductPromotions>>>
  properties: Maybe<Array<Maybe<PimcoreElementProperty>>>
  pros: Maybe<Scalars['String']>
  receiverKleur: Maybe<Scalars['String']>
  relatedCategories: Maybe<PimcoreObjectProductRelatedCategories>
  screenSize: Maybe<Scalars['String']>
  soundbarKleur: Maybe<Scalars['String']>
  specialist: Maybe<PimcoreObjectProductSpecialist>
  televisieKleur: Maybe<Scalars['String']>
  tot21u: Maybe<Scalars['Boolean']>
  urlKey: Maybe<Scalars['String']>
  variant: Maybe<Scalars['String']>
  variantValue: Maybe<Scalars['String']>
  specifications: Maybe<Array<Maybe<PimcoreSpecificationsObjectBrickAttribute>>>
}

export interface PimcoreProductSiblingsArgs {
  objectTypes?: Maybe<Array<Maybe<Scalars['String']>>>
}

export interface PimcoreProductChildrenArgs {
  objectTypes?: Maybe<Array<Maybe<Scalars['String']>>>
}

export interface PimcoreProductPropertiesArgs {
  keys?: Maybe<Array<Maybe<Scalars['String']>>>
}

export interface PimcoreProductSpecificationsArgs {
  excludeNullValues?: Maybe<Scalars['Boolean']>
}

export interface PimcoreProductAddonConnection {
  __typename?: 'PimcoreProductAddonConnection'
  edges: Maybe<Array<Maybe<PimcoreProductAddonEdge>>>
  /** The total count of all queryable objects for this schema listing */
  totalCount: Maybe<Scalars['Int']>
}

export interface PimcoreProductAddonEdge {
  __typename?: 'PimcoreProductAddonEdge'
  cursor: Maybe<Scalars['String']>
  node: Maybe<PimcoreObjectProductAddon>
}

export interface PimcoreProductButtonConnection {
  __typename?: 'PimcoreProductButtonConnection'
  edges: Maybe<Array<Maybe<PimcoreProductButtonEdge>>>
  /** The total count of all queryable objects for this schema listing */
  totalCount: Maybe<Scalars['Int']>
}

export interface PimcoreProductButtonEdge {
  __typename?: 'PimcoreProductButtonEdge'
  cursor: Maybe<Scalars['String']>
  node: Maybe<PimcoreObjectProductButton>
}

export interface PimcoreProductConnection {
  __typename?: 'PimcoreProductConnection'
  edges: Maybe<Array<Maybe<PimcoreProductEdge>>>
  /** The total count of all queryable objects for this schema listing */
  totalCount: Maybe<Scalars['Int']>
}

export interface PimcoreProductEdge {
  __typename?: 'PimcoreProductEdge'
  cursor: Maybe<Scalars['String']>
  node: Maybe<PimcoreProduct>
}

export interface PimcorePromotionConnection {
  __typename?: 'PimcorePromotionConnection'
  edges: Maybe<Array<Maybe<PimcorePromotionEdge>>>
  /** The total count of all queryable objects for this schema listing */
  totalCount: Maybe<Scalars['Int']>
}

export interface PimcorePromotionEdge {
  __typename?: 'PimcorePromotionEdge'
  cursor: Maybe<Scalars['String']>
  node: Maybe<PimcoreObjectPromotion>
}

export interface PimcorePropertyAsset {
  __typename?: 'PimcorePropertyAsset'
  name: Maybe<Scalars['String']>
  type: Maybe<Scalars['String']>
  asset: Maybe<PimcoreAsset>
}

export interface PimcorePropertyAssetfolder {
  __typename?: 'PimcorePropertyAssetfolder'
  name: Maybe<Scalars['String']>
  type: Maybe<Scalars['String']>
  asset: Maybe<PimcoreAssetFolder>
}

export interface PimcorePropertyCheckbox {
  __typename?: 'PimcorePropertyCheckbox'
  name: Maybe<Scalars['String']>
  type: Maybe<Scalars['String']>
  checked: Maybe<Scalars['Boolean']>
}

export interface PimcorePropertyObject {
  __typename?: 'PimcorePropertyObject'
  name: Maybe<Scalars['String']>
  type: Maybe<Scalars['String']>
  object: Maybe<PimcoreHotspotMetadataObject>
}

export interface PimcorePropertyObjectfolder {
  __typename?: 'PimcorePropertyObjectfolder'
  name: Maybe<Scalars['String']>
  type: Maybe<Scalars['String']>
  object: Maybe<PimcoreObjectFolder>
}

export interface PimcorePropertyText {
  __typename?: 'PimcorePropertyText'
  name: Maybe<Scalars['String']>
  type: Maybe<Scalars['String']>
  text: Maybe<Scalars['String']>
}

export interface PimcoreRelatedCategoriesConnection {
  __typename?: 'PimcoreRelatedCategoriesConnection'
  edges: Maybe<Array<Maybe<PimcoreRelatedCategoriesEdge>>>
  /** The total count of all queryable objects for this schema listing */
  totalCount: Maybe<Scalars['Int']>
}

export interface PimcoreRelatedCategoriesEdge {
  __typename?: 'PimcoreRelatedCategoriesEdge'
  cursor: Maybe<Scalars['String']>
  node: Maybe<PimcoreObjectRelatedCategories>
}

export interface PimcoreResolutions {
  __typename?: 'PimcoreResolutions'
  url: Maybe<Scalars['String']>
  resolution: Maybe<Scalars['Float']>
}

export interface PimcoreSpecialistConnection {
  __typename?: 'PimcoreSpecialistConnection'
  edges: Maybe<Array<Maybe<PimcoreSpecialistEdge>>>
  /** The total count of all queryable objects for this schema listing */
  totalCount: Maybe<Scalars['Int']>
}

export interface PimcoreSpecialistEdge {
  __typename?: 'PimcoreSpecialistEdge'
  cursor: Maybe<Scalars['String']>
  node: Maybe<PimcoreObjectSpecialist>
}

export interface PimcoreSpecificationsObjectBrickAttribute {
  __typename?: 'PimcoreSpecificationsObjectBrickAttribute'
  field: Maybe<Scalars['String']>
  fieldType: Scalars['String']
  fieldTitle: Maybe<Scalars['String']>
  fieldTooltip: Maybe<Scalars['String']>
  objectBrick: Maybe<Scalars['String']>
  sectionName: Maybe<Scalars['String']>
  sectionTitle: Maybe<Scalars['String']>
  value: Maybe<PimcoreFieldType>
}

export interface PimcoreSpecificationsObjectBrickAttributeBoolean {
  __typename?: 'PimcoreSpecificationsObjectBrickAttributeBoolean'
  value: Maybe<Scalars['Boolean']>
  displayValue: Maybe<Scalars['String']>
}

export interface PimcoreSpecificationsObjectBrickAttributeFloat {
  __typename?: 'PimcoreSpecificationsObjectBrickAttributeFloat'
  value: Maybe<Scalars['Float']>
  displayValue: Maybe<Scalars['String']>
}

export interface PimcoreSpecificationsObjectBrickAttributeInt {
  __typename?: 'PimcoreSpecificationsObjectBrickAttributeInt'
  value: Maybe<Scalars['Int']>
  displayValue: Maybe<Scalars['String']>
}

export interface PimcoreSpecificationsObjectBrickAttributeString {
  __typename?: 'PimcoreSpecificationsObjectBrickAttributeString'
  value: Maybe<Scalars['String']>
  displayValue: Maybe<Scalars['String']>
}

export interface PimcoreSpecificationsObjectBrickAttributeStrings {
  __typename?: 'PimcoreSpecificationsObjectBrickAttributeStrings'
  value: Maybe<Array<Maybe<Scalars['String']>>>
  displayValue: Maybe<Scalars['String']>
  displayValues: Maybe<Array<Maybe<Scalars['String']>>>
}

export interface PimcoreSrcset {
  __typename?: 'PimcoreSrcset'
  descriptor: Maybe<Scalars['String']>
  url: Maybe<Scalars['String']>
  resolutions: Maybe<Array<Maybe<PimcoreResolutions>>>
}

export interface PimcoreSrcsetResolutionsArgs {
  types?: Maybe<Array<Maybe<Scalars['Float']>>>
}

export interface PimcoreVideo {
  __typename?: 'PimcoreVideo'
  type: Maybe<Scalars['String']>
  data: Maybe<PimcoreVideoData>
  poster: Maybe<PimcoreAsset>
  title: Maybe<Scalars['String']>
  description: Maybe<Scalars['String']>
}

export type PimcoreVideoData = PimcoreVideoDataDescriptor | PimcoreAsset

export interface PimcoreVideoDataDescriptor {
  __typename?: 'PimcoreVideoDataDescriptor'
  /** external ID */
  id: Maybe<Scalars['String']>
}

export interface PlaceOrderAndGetPaymentInformationInput {
  cart_id: Scalars['String']
}

export interface PlaceOrderAndGetPaymentInformationOutput {
  __typename?: 'PlaceOrderAndGetPaymentInformationOutput'
  order: Order
  paymentInformation: PaymentInformation
}

export interface PlaceOrderInput {
  cart_id: Scalars['String']
}

export interface PlaceOrderOutput {
  __typename?: 'PlaceOrderOutput'
  order: Order
}

/** Reponse for postcode lookup */
export interface PostcodeNlAddress {
  __typename?: 'PostcodeNLAddress'
  /**
   * Street name in accordance with "BAG (Basisregistraties adressen en
   * gebouwen)". In capital and lowercase letters, including punctuation marks
   * and accents. This field is at most 80 characters in length. Filled with
   * "Postbus" in case it is a range of PO boxes.
   */
  street: Scalars['String']
  /**
   * Street name in NEN-5825 notation, which has a lower maximum length. In
   * capital and lowercase letters, including punctuation marks and accents.
   * This field is at most 24 characters in length. Filled with "Postbus" in case
   * it is a range of PO boxes.
   */
  streetNen: Scalars['String']
  /**
   * House number of a perceel. In case of a Postbus match the house number will
   * always be 0. Range: 0-99999
   */
  houseNumber: Scalars['Int']
  /**
   * Addition of the house number to uniquely define a location. These additions
   * are officially recognized by the municipality. This field is at most
   * 6 characters in length and null if addition not found (see
   * houseNumberAdditions result field).
   */
  houseNumberAddition: Maybe<Scalars['String']>
  /**
   * Four digit neighborhood code (first part of a postcode). Range: 1000-9999
   * plus two character letter combination (second part of a postcode).
   * Range: "AA"-"ZZ"
   */
  postcode: Scalars['String']
  /**
   * Official city name in accordance with "BAG (Basisregistraties adressen en
   * gebouwen)". In capital and lowercase letters, including punctuation marks
   * and accents. This field is at most 80 characters in length.
   */
  city: Scalars['String']
  /**
   * City name, shortened to fit a lower maximum length. In capital and lowercase
   * letters, including punctuation marks and accents. This field is at most 24
   * characters in length.
   */
  cityShort: Scalars['String']
  /**
   * Municipality name in accordance with "BAG (Basisregistraties adressen en
   * gebouwen)". In capital and lowercase letters, including punctuation marks
   * and accents. This field is at most 80 characters in length. Examples:
   * "Baarle-Nassau", "'s-Gravenhage", "Haarlemmerliede en Spaarnwoude".
   */
  municipality: Scalars['String']
  /**
   * Municipality name, shortened to fit a lower maximum length. In capital and
   * lowercase letters, including punctuation marks and accents. This field is at
   * most 24 characters in length. Examples: "Baarle-Nassau", "'s-Gravenhage",
   * "Haarlemmerliede c.a.".
   */
  municipalityShort: Scalars['String']
  /** Official name of the province, correctly cased and with dashes where applicable. */
  province: Scalars['String']
  /**
   * X coordinate according to Dutch Rijksdriehoeksmeting "(EPSG)
   * 28992 Amersfoort / RD New". Values range from 0 to 300000 meters.
   * Null for PO Boxes.
   */
  rdX: Maybe<Scalars['Int']>
  /**
   * Y coordinate according to Dutch Rijksdriehoeksmeting "(EPSG)
   * 28992 Amersfoort / RD New". Values range from 300000 to 620000 meters.
   * Null for PO Boxes.
   */
  rdY: Maybe<Scalars['Int']>
  /** Latitude of address. Null for PO Boxes. */
  latitude: Maybe<Scalars['Float']>
  /** Longitude of address. Null for PO Boxes. */
  longitude: Maybe<Scalars['Float']>
  /** Dutch term used in BAG: "nummeraanduiding id". */
  bagNumberDesignationId: Maybe<Scalars['String']>
  /**
   * Dutch term used in BAG: "adresseerbaar object id". Unique identification for
   * objects which have 'building', 'house boat site', or 'mobile home site' as addressType.
   */
  bagAddressableObjectId: Maybe<Scalars['String']>
  /** Type of this address. */
  addressType: Scalars['String']
  /**
   * List of all purposes (Dutch: "gebruiksdoelen"). Null or an array of
   * text values.
   */
  purposes: Maybe<Array<Maybe<Scalars['String']>>>
  /** Surface in square meters. Null for PO Boxes. */
  surfaceArea: Maybe<Scalars['Float']>
  /**
   * List of all house number additions having the postcode and houseNumber
   * which was input.
   */
  houseNumberAdditions: Array<Maybe<Scalars['String']>>
}

export interface PostNlAddress {
  __typename?: 'PostNLAddress'
  countryCode: PostNlCountryCode
  postalCode: Scalars['String']
  houseNumber: Scalars['Int']
  street: Scalars['String']
  city: Scalars['String']
  remark: Maybe<Scalars['String']>
}

export interface PostNlAddressInput {
  postalCode: Scalars['String']
  countryCode: PostNlCountryCode
  street: Scalars['String']
  houseNumber: Scalars['Int']
  houseNumberExt: Scalars['String']
  firstName: Scalars['String']
  lastName: Scalars['String']
  phoneNumber: Scalars['String']
}

export enum PostNlCountryCode {
  NL = 'NL',
  BE = 'BE',
}

export interface PostNlDeliveryDate {
  __typename?: 'PostNLDeliveryDate'
  /** The date. Format: dd-mm-yyyy */
  date: Scalars['String']
  timeframes: Array<PostNlDeliveryTimeframe>
}

export interface PostNlDeliveryFallbackInput {
  /** The guestCartId or customerCartId */
  cartId: Scalars['ID']
  /** The current customer shipping address */
  address: PostNlAddressInput
  /** If true the package won't be delivered to neighbours */
  doNotDeliverToNeighbours?: Maybe<Scalars['Boolean']>
}

export interface PostNlDeliveryInput {
  /** The guestCartId or customerCartId */
  cartId: Scalars['ID']
  /** The current customer shipping address */
  address: PostNlAddressInput
  /** Format: dd-mm-yyyy */
  date: Scalars['String']
  /** The selected timeframe option */
  option: PostNlTimeframeOption
  /** Format: hh:mm:ss. */
  from: Scalars['String']
  /** Format: hh:mm:ss. */
  to: Scalars['String']
  /** If true the package won't be delivered to neighbours */
  doNotDeliverToNeighbours?: Maybe<Scalars['Boolean']>
}

export enum PostNlDeliveryOption {
  PG = 'PG',
  PGE = 'PGE',
}

export interface PostNlDeliveryTimeframe {
  __typename?: 'PostNLDeliveryTimeframe'
  /** Format: hh:mm:ss. */
  from: Scalars['String']
  /** Format: hh:mm:ss. */
  to: Scalars['String']
  options: Array<Maybe<PostNlTimeframeOption>>
}

export interface PostNlDeliveryTimeframeInput {
  /**
   * Datetime an order needs to be placed for next day delivery in ISO8601 format. Format:yyyy-MM-ddTHH:mm:ssZ
   * If no cutoffTime is provided today at 18:00 hours is used.
   */
  cutoffTime?: Maybe<Scalars['String']>
  /** Datetime of the cutoff time for same day delivery in ISO8601 format. Format:yyyy-MM-ddTHH:mm:ssZ */
  sameDayCutoffTime?: Maybe<Scalars['String']>
  /** Datetime of the cutoff time for shipping on Saturday in ISO8601 format. Format:yyyy-MM-ddTHH:mm:ssZ */
  saturdayCuttoffTime?: Maybe<Scalars['String']>
  /** Datetime of the cutoff time for shipping on Sunday in ISO8601 format. Format:yyyy-MM-ddTHH:mm:ssZ */
  sundayCutoffTime?: Maybe<Scalars['String']>
  /** Maximum number of days to return delivery timeframes for. */
  maximumDeliveryDays?: Scalars['Int']
  /** The number of days that it takes for the order to be shipped after the order is placed. */
  shippingDuration?: Scalars['Int']
  /**
   * Datetime of the beginning of the timeframe in ISO8601 format. Format:yyyy-MM-ddTHH:mm:ssZ
   * If empty the current date and time will be used.
   */
  startDate?: Maybe<Scalars['String']>
  /**
   * Datetime of the enddate of the timeframe in ISO8601 format. Format:yyyy-MM-ddTHH:mm:ssZ
   * Enddate may not be before StartDate. If empty startDate + 7 days will be set as the end date.
   */
  endDate?: Maybe<Scalars['String']>
  /**
   * The delivery options for which timeframes should be returned.
   * At least one delivery option must be specified.
   */
  options: Array<PostNlTimeframeOption>
  /** Whether or not the requesting party allows for Sunday sorting (which leads to delivery on Monday). */
  allowSundaySorting?: Scalars['Boolean']
  /**
   * The ISO2 country code
   * Available values: NL, BE
   */
  countryCode: PostNlCountryCode
  postalCode: Scalars['String']
  houseNumber: Scalars['Int']
  houseNumberExt?: Maybe<Scalars['String']>
  street?: Maybe<Scalars['String']>
  city?: Maybe<Scalars['String']>
  /**
   * Optional filter for MyTime shipments (possible values: 60/30);
   * choose 60 if you only want ‘whole hour’ timeframes returned
   */
  interval?: Maybe<Scalars['Int']>
  /**
   * Optional filter for MyTime shipments; format hh:mm-hh:mm.
   * Specifies which timeframes you want returned in the response
   */
  timeframeRange?: Maybe<Scalars['String']>
}

export interface PostNlDeliveryTimeframeResponse {
  __typename?: 'PostNLDeliveryTimeframeResponse'
  /** An array containing the delivery dates */
  deliveryDates: Maybe<Array<PostNlDeliveryDate>>
  /**
   * An array containing delivery dates where delivery isn't possible
   * TODO::This is not yet implemented.
   */
  noDeliveryDates: Maybe<Array<PostNlNoDeliveryDate>>
}

export enum PostNlDeliveryType {
  DELIVERY = 'Delivery',
  PICKUP = 'Pickup',
  FALLBACK = 'Fallback',
}

export interface PostNlLocation {
  __typename?: 'PostNLLocation'
  locationCode: Scalars['ID']
  name: Scalars['String']
  distance: Scalars['Float']
  latitude: Scalars['Float']
  longitude: Scalars['Float']
  address: PostNlAddress
  /**
   * The delivery options UL, PU and DO can be shown in the response.
   * Please ignore these codes. These codes are internal PostNL codes.
   */
  deliveryOptions: Maybe<Array<Scalars['String']>>
  openingHours: PostNlOpeningHours
  partnerName: Scalars['String']
  phoneNumber: Scalars['String']
  /** The network ID used for this retail location */
  retailNetworkID: Scalars['ID']
  salesChannel: Scalars['String']
  terminalType: Scalars['String']
}

export interface PostNlLocationError {
  __typename?: 'PostNLLocationError'
  errorMsg: Scalars['String']
  errorNumber: Scalars['Int']
}

export interface PostNlLocationResponse {
  __typename?: 'PostNLLocationResponse'
  locations: Maybe<Array<PostNlLocation>>
  /** Returned when an invalid address has been sent or invalid PostNL location options. */
  error: Maybe<Array<PostNlLocationError>>
}

export interface PostNlNoDeliveryDate {
  __typename?: 'PostNLNoDeliveryDate'
  code: Scalars['String']
  /** The date. Format: dd-mm-yyyy */
  date: Scalars['String']
  description: Scalars['String']
  options: Array<PostNlTimeframeOption>
}

export interface PostNlOpeningHours {
  __typename?: 'PostNLOpeningHours'
  monday: Maybe<Array<Scalars['String']>>
  tuesday: Maybe<Array<Scalars['String']>>
  wednesday: Maybe<Array<Scalars['String']>>
  thursday: Maybe<Array<Scalars['String']>>
  friday: Maybe<Array<Scalars['String']>>
  saturday: Maybe<Array<Scalars['String']>>
  sunday: Maybe<Array<Scalars['String']>>
}

export interface PostNlOrder {
  __typename?: 'PostNLOrder'
  entityId: Scalars['ID']
  quoteId: Scalars['ID']
  orderId: Maybe<Scalars['ID']>
  type: PostNlDeliveryType
  timeframeOption: Maybe<PostNlTimeframeOption>
  acCharacteristic: Maybe<Scalars['String']>
  acOption: Maybe<Scalars['String']>
  deliveryDate: Maybe<Scalars['String']>
  expectedDeliveryTimeStart: Maybe<Scalars['String']>
  expectedDeliveryTimeEnd: Maybe<Scalars['String']>
  isPakjegemak: Maybe<Scalars['Boolean']>
  isStatedAddressOnly: Maybe<Scalars['Boolean']>
  pgOrderAddressId: Maybe<Scalars['ID']>
  pgLocationCode: Maybe<Scalars['ID']>
  pgRetailNetworkId: Maybe<Scalars['ID']>
  productCode: Maybe<Scalars['Int']>
  fee: Maybe<Scalars['Int']>
  shipAt: Maybe<Scalars['String']>
  confirmedAt: Maybe<Scalars['String']>
  confirmed: Maybe<Scalars['Boolean']>
  parcelCount: Maybe<Scalars['Int']>
  shippingDuration: Maybe<Scalars['Int']>
}

export interface PostNlPickupInput {
  /** The guestCartId or customerCartId */
  cartId: Scalars['ID']
  /** The current customer shipping address */
  address: PostNlAddressInput
  /** The unique location code */
  locationCode: Scalars['ID']
  /**
   * RetailNetworkID information.
   * Always PNPNL-01 for Dutch locations. For Belgium locations use LD-01.
   */
  retailNetworkID: Scalars['ID']
}

export interface PostNlSearchAddress {
  /**
   * The ISO2 country code
   * Available values: NL, BE
   */
  countryCode: PostNlCountryCode
  postalCode: Scalars['String']
  houseNumber?: Maybe<Scalars['Int']>
  street?: Maybe<Scalars['String']>
  city?: Maybe<Scalars['String']>
  /**
   * The date of the earliest delivery date. Format: dd-mm-yyyy
   * Note: this date cannot be in the past, otherwise an error is returned.
   */
  deliveryDate?: Maybe<Scalars['String']>
  /**
   * Time of opening. Format: hh:mm:ss.
   * This field will be used to filter the locations on opening hours.
   */
  openingTime?: Maybe<Scalars['String']>
  /**
   * One or more delivery options (related to the product).
   * See Guidelines on this page for possible values.
   *
   * Default value: PG
   *
   * Available values : PG, PGE
   * PG: Pick up at PostNL location (in Dutch: Ophalen bij PostNL Locatie)
   * PGE: ??? Not documented in PostNL API docs
   */
  deliveryOptions?: Array<PostNlDeliveryOption>
}

export enum PostNlTimeframeOption {
  /** Daytime delivery */
  DAYTIME = 'Daytime',
  /** Sameday delivery (must be used in combination with Evening) */
  SAMEDAY = 'Sameday',
  /** Evening delivery */
  EVENING = 'Evening',
  /** Morning delivery before 10:00 */
  MORNING = 'Morning',
  /** Morning delivery before 10:00 */
  NOON = 'Noon',
  /** Sunday delivery */
  SUNDAY = 'Sunday',
  /** Afternoon delivery before 17:00 */
  AFTERNOON = 'Afternoon',
  /** MyTime delivery (Delivery on demand) */
  MY_TIME = 'MyTime',
}

export interface PreLike {
  __typename?: 'PreLike'
  /** Like value. */
  value: Maybe<Scalars['String']>
}

export interface PreLikeInput {
  /** Like value. */
  value?: Maybe<Scalars['String']>
}

/**
 * Price is deprecated, replaced by ProductPrice. The Price object defines the
 * price of a product as well as any tax-related adjustments.
 */
export interface Price {
  __typename?: 'Price'
  /**
   * An array that provides information about tax, weee, or weee_tax adjustments.
   * @deprecated Price is deprecated, use ProductPrice.
   */
  adjustments: Maybe<Array<Maybe<PriceAdjustment>>>
  /**
   * The price of a product plus a three-letter currency code.
   * @deprecated Price is deprecated, use ProductPrice.
   */
  amount: Maybe<Money>
}

/**
 * PriceAdjustment is deprecated. Taxes will be included or excluded in the price.
 * The PricedAdjustment object defines the amount of money to apply as an
 * adjustment, the type of adjustment to apply, and whether the item is included or
 * excluded from the adjustment.
 */
export interface PriceAdjustment {
  __typename?: 'PriceAdjustment'
  /** The amount of the price adjustment and its currency code. */
  amount: Maybe<Money>
  /**
   * Indicates whether the adjustment involves tax, weee, or weee_tax.
   * @deprecated PriceAdjustment is deprecated.
   */
  code: Maybe<PriceAdjustmentCodesEnum>
  /**
   * Indicates whether the entity described by the code attribute is included or excluded from the adjustment.
   * @deprecated PriceAdjustment is deprecated.
   */
  description: Maybe<PriceAdjustmentDescriptionEnum>
}

/** PriceAdjustment.code is deprecated. This enumeration contains values defined in modules other than the Catalog module. */
export enum PriceAdjustmentCodesEnum {
  TAX = 'TAX',
  WEEE = 'WEEE',
  WEEE_TAX = 'WEEE_TAX',
}

/** PriceAdjustmentDescriptionEnum is deprecated. This enumeration states whether a price adjustment is included or excluded. */
export enum PriceAdjustmentDescriptionEnum {
  INCLUDED = 'INCLUDED',
  EXCLUDED = 'EXCLUDED',
}

/** Price range for a product. If the product has a single price, the minimum and maximum price will be the same. */
export interface PriceRange {
  __typename?: 'PriceRange'
  /** The highest possible price for the product. */
  maximumPrice: Maybe<ProductPrice>
  /** The lowest possible price for the product. */
  minimumPrice: ProductPrice
}

/** This enumeration the price type. */
export enum PriceTypeEnum {
  FIXED = 'FIXED',
  PERCENT = 'PERCENT',
  DYNAMIC = 'DYNAMIC',
}

/** This enumeration defines whether a bundle product's price is displayed as the lowest possible value or as a range. */
export enum PriceViewEnum {
  PRICE_RANGE = 'PRICE_RANGE',
  AS_LOW_AS = 'AS_LOW_AS',
}

export interface PrismicDocument {
  __typename?: 'PrismicDocument'
  data: Maybe<Scalars['JSON']>
}

export interface PrismicPredicateManyValues {
  key: Scalars['String']
  values: Array<Scalars['String']>
}

export interface PrismicPredicateOneValue {
  key: Scalars['String']
  value: Scalars['String']
}

export interface Product extends Document, Linkable {
  __typename?: 'Product'
  serie: Maybe<Scalars['String']>
  product: Maybe<Scalars['String']>
  requestDiscountButton: Maybe<Scalars['Json']>
  tradeOldTv: Maybe<Scalars['Json']>
  body: Maybe<Array<ProductBody>>
  meta: Meta
  linkType: Maybe<Scalars['String']>
}

/**
 * ProductAttributeFilterInput defines the filters to be used in the search. A
 * filter contains at least one attribute, a comparison operator, and the value
 * that is being searched for.
 */
export interface ProductAttributeFilterInput {
  /** Attribute label: Activity */
  activity?: Maybe<FilterEqualTypeInput>
  /** Attribute label: AllowCoupon */
  allowcoupon?: Maybe<FilterEqualTypeInput>
  /** Attribute label: AllowIngenico */
  allowingenico?: Maybe<FilterEqualTypeInput>
  /** Attribute label: AllowPostNLlabel */
  allowpostnllabel?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Allow review */
  allowreview?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Alternatief memo */
  alternatiefmemo?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Category Gear */
  category_gear?: Maybe<FilterEqualTypeInput>
  /** Filter product by category id */
  category_id?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Climate */
  climate?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Collar */
  collar?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Color */
  color?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Minpunten */
  cons?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Korte omschrijving */
  description?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Doorverkooppremie */
  doorverkooppremie?: Maybe<FilterMatchTypeInput>
  /** Attribute label: EAN */
  ean?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Eco Collection */
  eco_collection?: Maybe<FilterEqualTypeInput>
  /** Attribute label: is_active_in_pim */
  enabled?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Erin Recommends */
  erin_recommends?: Maybe<FilterEqualTypeInput>
  /** Attribute label: FactuurInformatie */
  factuurinformatie?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Features */
  features_bags?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Fixed price */
  fixedprice?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Fixed until */
  fixeduntil?: Maybe<FilterRangeTypeInput>
  /** Attribute label: Gebruik Bundel productenprijs */
  gebruikbundelproductenprijs?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Gender */
  gender?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Google */
  google?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Inkoopprijs */
  inkoopprijs?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Is Buitenkansje */
  is_buitenkansje?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Stock Status(Magento) */
  is_in_stock?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Keep product buttons */
  keepproductbuttons?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Kenmerken */
  kenmerken?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Kieskeurig */
  kieskeurig?: Maybe<FilterEqualTypeInput>
  /** Attribute label: KieskeurigBE */
  kieskeurigbe?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Kieskeurig TextAD */
  kieskeurigtekstad?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Korte omschrijving */
  korteomschrijving?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Korte omschrijving2 */
  korteomschrijving2?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Lange omschrijving */
  langeomschrijving?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Material */
  material?: Maybe<FilterEqualTypeInput>
  /** Attribute label: MaxprijsOmnia */
  maxprijsomnia?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Leverancier */
  merk?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Modeltype */
  modeltype?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Product Name */
  name?: Maybe<FilterMatchTypeInput>
  /** Attribute label: New */
  new?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Omnia */
  omnia?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Opmerking1 */
  opmerking1?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Opmerking2 */
  opmerking2?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Pattern */
  pattern?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Percentage korting op prijs van bundelproducten */
  percentagekortingopprijsvanbundelproducten?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Performance Fabric */
  performance_fabric?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Pimcore Product ID */
  pimcore_id?: Maybe<FilterMatchTypeInput>
  /** Attribute label: populariteit */
  populariteit?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Price */
  price?: Maybe<FilterRangeTypeInput>
  /** Attribute label: Prijs */
  prijs?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Productnaam */
  productnaam?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Productnaam */
  productnaam1?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Product spideren */
  productspideren?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Promotekst */
  promotekst?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Pluspunten */
  pros?: Maybe<FilterMatchTypeInput>
  /** Attribute label: S2M */
  s2m?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Sale */
  sale?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Serie */
  serie?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Productnaam */
  short_description?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Size */
  size?: Maybe<FilterEqualTypeInput>
  /** Attribute label: SKU */
  sku?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Sleeve */
  sleeve?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Specialprice */
  specialprice?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Aansluitingen */
  specifications_bluetoothspeaker_aansluitingen?: Maybe<FilterEqualTypeInput>
  /** Attribute label: AantalSpeakers */
  specifications_bluetoothspeaker_aantalspeakers?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Aantal USB */
  specifications_bluetoothspeaker_aantalusb?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Aantal USB-C */
  specifications_bluetoothspeaker_aantalusbc?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Afmetingen */
  specifications_bluetoothspeaker_afmetingen?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Afmetingen subwoofer */
  specifications_bluetoothspeaker_afmetingensubwoofer?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Fabriekscode */
  specifications_bluetoothspeaker_fabriekscode?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Gewicht */
  specifications_bluetoothspeaker_gewicht?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Gewicht Subwoofer */
  specifications_bluetoothspeaker_gewichtsubwoofer?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Introductiejaar */
  specifications_bluetoothspeaker_introductiejaar?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Kanalen */
  specifications_bluetoothspeaker_kanalen?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Kleur */
  specifications_bluetoothspeaker_kleur?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Speelt af */
  specifications_bluetoothspeaker_speeltaf?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Standaard Meegeleverd */
  specifications_bluetoothspeaker_standaardmeegeleverd?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Streaming */
  specifications_bluetoothspeaker_streaming?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Stroomvoorziening */
  specifications_bluetoothspeaker_stroomvoorziening?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Type Audio */
  specifications_bluetoothspeaker_typeaudio?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Type speaker */
  specifications_bluetoothspeaker_typespeaker?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Vermogen */
  specifications_bluetoothspeaker_vermogen?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Afmetingen */
  specifications_blurayspeler_afmetingen?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Afspelen Van */
  specifications_blurayspeler_afspelenvan?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Analoge Audio-uitgang */
  specifications_blurayspeler_analogeaudio?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Audio & Video Functies */
  specifications_blurayspeler_audioenvideo?: Maybe<FilterEqualTypeInput>
  /** Attribute label: BDLive */
  specifications_blurayspeler_bdlive?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Bluetooth */
  specifications_blurayspeler_bluetooth?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Coaxiaal */
  specifications_blurayspeler_coaxiaal?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Decoders */
  specifications_blurayspeler_decoders?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Digitale audio uitgang coaxaal */
  specifications_blurayspeler_digitaalcoaxaal?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Digitale audio uitgang optisch */
  specifications_blurayspeler_digitaaloptisch?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Digitale audio uitgang optisch */
  specifications_blurayspeler_digitaleoptisch?: Maybe<FilterEqualTypeInput>
  /** Attribute label: DLNA */
  specifications_blurayspeler_dlna?: Maybe<FilterEqualTypeInput>
  /** Attribute label: 3D Ondersteuning */
  specifications_blurayspeler_driedondersteuning?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Ethernetaansluiting */
  specifications_blurayspeler_ethernet?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Formats */
  specifications_blurayspeler_formats?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Functies */
  specifications_blurayspeler_functies?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Gecertificeerde Hi-Res Audio */
  specifications_blurayspeler_gecerthires?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Gewicht */
  specifications_blurayspeler_gewicht?: Maybe<FilterMatchTypeInput>
  /** Attribute label: HDMI */
  specifications_blurayspeler_hdmi?: Maybe<FilterMatchTypeInput>
  /** Attribute label: HDR */
  specifications_blurayspeler_hdr?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Kleur */
  specifications_blurayspeler_kleur?: Maybe<FilterEqualTypeInput>
  /** Attribute label: LAN */
  specifications_blurayspeler_lan?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Miracast */
  specifications_blurayspeler_miracast?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Multiroom */
  specifications_blurayspeler_multiroom?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Ondersteund audioformaat */
  specifications_blurayspeler_ondersteundaudioformaat?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Optisch */
  specifications_blurayspeler_optisch?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Output kanalen */
  specifications_blurayspeler_outputkanalen?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Playback */
  specifications_blurayspeler_playback?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Resolutie */
  specifications_blurayspeler_resolutie?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Smart TV */
  specifications_blurayspeler_smarttv?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Speelt af */
  specifications_blurayspeler_speeltaf?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Speelt van disc */
  specifications_blurayspeler_speeltvandisc?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Standaard Meegeleverd */
  specifications_blurayspeler_standaardmeegeleverd?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Stroomverbruik (in standby) */
  specifications_blurayspeler_stroomverbruik?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Upscaling */
  specifications_blurayspeler_upscaling?: Maybe<FilterEqualTypeInput>
  /** Attribute label: USB */
  specifications_blurayspeler_usb?: Maybe<FilterMatchTypeInput>
  /** Attribute label: 4K UHD */
  specifications_blurayspeler_vierkuhd?: Maybe<FilterEqualTypeInput>
  /** Attribute label: 4K UHD Upscaling */
  specifications_blurayspeler_vierkuhdups?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Wifi */
  specifications_blurayspeler_wifi?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Aansluitingen */
  specifications_cdspeler_aansluitingen?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Aantal USB */
  specifications_cdspeler_aantalusb?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Achterspeakers */
  specifications_cdspeler_achterspeakers?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Afmetingen */
  specifications_cdspeler_afmetingen?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Fabriekscode */
  specifications_cdspeler_fabriekscode?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Gewicht */
  specifications_cdspeler_gewicht?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Impendatie */
  specifications_cdspeler_impendatie?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Introductiejaar */
  specifications_cdspeler_introductiejaar?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Kanalen */
  specifications_cdspeler_kanalen?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Multiroom */
  specifications_cdspeler_multiroom?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Radio */
  specifications_cdspeler_radio?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Speaker aansluiting */
  specifications_cdspeler_speakeraansluiting?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Speelt Af */
  specifications_cdspeler_speeltaf?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Standaard Meegeleverd */
  specifications_cdspeler_standaardmeegeleverd?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Streaming */
  specifications_cdspeler_streaming?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Streaming diensten */
  specifications_cdspeler_streamingdiensten?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Stroomvoorziening */
  specifications_cdspeler_stroomvoorziening?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Subwoofer uitgang */
  specifications_cdspeler_subwooferuitgang?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Type Audio */
  specifications_cdspeler_typeaudio?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Vermogen */
  specifications_cdspeler_vermogen?: Maybe<FilterMatchTypeInput>
  /** Attribute label: AantalSpeakers */
  specifications_draadlozespeaker_aantalspeakers?: Maybe<FilterMatchTypeInput>
  /** Attribute label: afmetingen */
  specifications_draadlozespeaker_afmetingen?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Airplay2 */
  specifications_draadlozespeaker_airplay2?: Maybe<FilterEqualTypeInput>
  /** Attribute label: aux */
  specifications_draadlozespeaker_aux?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Bluetooth */
  specifications_draadlozespeaker_bluetooth?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Component */
  specifications_draadlozespeaker_component?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Composiet */
  specifications_draadlozespeaker_composiet?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Fabriekscode */
  specifications_draadlozespeaker_fabriekscode?: Maybe<FilterMatchTypeInput>
  /** Attribute label: gebruiksduur accu */
  specifications_draadlozespeaker_gebruiksduuraccu?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Gewicht */
  specifications_draadlozespeaker_gewicht?: Maybe<FilterMatchTypeInput>
  /** Attribute label: HDMIin */
  specifications_draadlozespeaker_hdmiin?: Maybe<FilterMatchTypeInput>
  /** Attribute label: HDMIuit */
  specifications_draadlozespeaker_hdmiuit?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Kanalen */
  specifications_draadlozespeaker_kanalen?: Maybe<FilterMatchTypeInput>
  /** Attribute label: minijack */
  specifications_draadlozespeaker_minijack?: Maybe<FilterEqualTypeInput>
  /** Attribute label: MultiRoom */
  specifications_draadlozespeaker_multiroom?: Maybe<FilterEqualTypeInput>
  /** Attribute label: OptischCoax */
  specifications_draadlozespeaker_optischcoax?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Platenspeler */
  specifications_draadlozespeaker_platenspeler?: Maybe<FilterEqualTypeInput>
  /** Attribute label: SpotifyConnect */
  specifications_draadlozespeaker_spotifyconnect?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Subwoofer */
  specifications_draadlozespeaker_subwoofer?: Maybe<FilterEqualTypeInput>
  /** Attribute label: USB */
  specifications_draadlozespeaker_usb?: Maybe<FilterEqualTypeInput>
  /** Attribute label: voice-control */
  specifications_draadlozespeaker_voicecontrol?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Wifi */
  specifications_draadlozespeaker_wifi?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Aansluitingen */
  specifications_hifispeaker_aansluitingen?: Maybe<FilterEqualTypeInput>
  /** Attribute label: AantalSpeakers */
  specifications_hifispeaker_aantalspeakers?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Aantal USB */
  specifications_hifispeaker_aantalusb?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Achterspeakers */
  specifications_hifispeaker_achterspeakers?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Afmetingen */
  specifications_hifispeaker_afmetingen?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Afmetingen subwoofer */
  specifications_hifispeaker_afmetingensubwoofer?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Belastbaarheid */
  specifications_hifispeaker_belastbaarheid?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Fabriekscode */
  specifications_hifispeaker_fabriekscode?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Gewicht */
  specifications_hifispeaker_gewicht?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Gewicht Subwoofer */
  specifications_hifispeaker_gewichtsubwoofer?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Impendatie */
  specifications_hifispeaker_impendatie?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Introductiejaar */
  specifications_hifispeaker_introductiejaar?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Kanalen */
  specifications_hifispeaker_kanalen?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Kleur */
  specifications_hifispeaker_kleur?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Maximale frequentie */
  specifications_hifispeaker_maximalefrequentie?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Minimale frequentie */
  specifications_hifispeaker_minimalefrequentie?: Maybe<FilterMatchTypeInput>
  /** Attribute label: MultiRoom */
  specifications_hifispeaker_multiroom?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Speaker aansluiting */
  specifications_hifispeaker_speakeraansluiting?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Speaker type */
  specifications_hifispeaker_speakertype?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Standaard Meegeleverd */
  specifications_hifispeaker_standaardmeegeleverd?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Streaming */
  specifications_hifispeaker_streaming?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Stroomvoorziening */
  specifications_hifispeaker_stroomvoorziening?: Maybe<FilterEqualTypeInput>
  /** Attribute label: TypeAudio */
  specifications_hifispeaker_typeaudio?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Type speaker */
  specifications_hifispeaker_typespeaker?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Vermogen */
  specifications_hifispeaker_vermogen?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Waterbestendig */
  specifications_hifispeaker_waterbestendig?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Aansluitingen */
  specifications_homecinema_aansluitingen?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Aantal HDMI */
  specifications_homecinema_aantalhdmi?: Maybe<FilterMatchTypeInput>
  /** Attribute label: AantalSpeakers */
  specifications_homecinema_aantalspeakers?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Aantal USB */
  specifications_homecinema_aantalusb?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Achterspeakers */
  specifications_homecinema_achterspeakers?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Afmetingen */
  specifications_homecinema_afmetingen?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Fabriekscode */
  specifications_homecinema_fabriekscode?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Gewicht */
  specifications_homecinema_gewicht?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Gewicht Subwoofer */
  specifications_homecinema_gewichtsubwoofer?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Impendatie */
  specifications_homecinema_impendatie?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Introductiejaar */
  specifications_homecinema_introductiejaar?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Kleur */
  specifications_homecinema_kleur?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Microfoon */
  specifications_homecinema_microfoon?: Maybe<FilterEqualTypeInput>
  /** Attribute label: MultiRoom */
  specifications_homecinema_multiroom?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Radio */
  specifications_homecinema_radio?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Speaker aansluiting */
  specifications_homecinema_speakeraansluiting?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Speelt Af */
  specifications_homecinema_speeltaf?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Standaard Meegeleverd */
  specifications_homecinema_standaardmeegeleverd?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Streaming */
  specifications_homecinema_streaming?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Streaming diensten */
  specifications_homecinema_streamingdiensten?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Stroomvoorziening */
  specifications_homecinema_stroomvoorziening?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Subwoofer uitgang */
  specifications_homecinema_subwooferuitgang?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Type Audio */
  specifications_homecinema_typeaudio?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Type speaker */
  specifications_homecinema_typespeaker?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Vermogen */
  specifications_homecinema_vermogen?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Aantalgradendraaibaar */
  specifications_muurbeugel_aantalgradendraaibaar?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Aantalgradenkantelbaar */
  specifications_muurbeugel_aantalgradenkantelbaar?: Maybe<FilterMatchTypeInput>
  /** Attribute label: BedieningviaApp */
  specifications_muurbeugel_bedieningviaapp?: Maybe<FilterEqualTypeInput>
  /** Attribute label: garantie */
  specifications_muurbeugel_garantie?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Geschikt voor afmetingen TV */
  specifications_muurbeugel_geschiktvoorafmetingentv?: Maybe<FilterEqualTypeInput>
  /** Attribute label: interfacebreedte */
  specifications_muurbeugel_interfacebreedte?: Maybe<FilterMatchTypeInput>
  /** Attribute label: interfacehoogte */
  specifications_muurbeugel_interfacehoogte?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Introductiejaar */
  specifications_muurbeugel_introductiejaar?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Kleur */
  specifications_muurbeugel_kleur?: Maybe<FilterEqualTypeInput>
  /** Attribute label: maxafstandmuur */
  specifications_muurbeugel_maxafstandmuur?: Maybe<FilterMatchTypeInput>
  /** Attribute label: maximalegewichtTV */
  specifications_muurbeugel_maximalegewichttv?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Merk Muurbeugel */
  specifications_muurbeugel_merkmuurbeugel?: Maybe<FilterEqualTypeInput>
  /** Attribute label: minafstandmuur */
  specifications_muurbeugel_minafstandmuur?: Maybe<FilterMatchTypeInput>
  /** Attribute label: SoortMuurbeugel */
  specifications_muurbeugel_soortmuurbeugel?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Standaardmeegeleverd */
  specifications_muurbeugel_standaardmeegeleverd?: Maybe<FilterEqualTypeInput>
  /** Attribute label: TypeMuurbeugel */
  specifications_muurbeugel_typemuurbeugel?: Maybe<FilterEqualTypeInput>
  /** Attribute label: uittrekbaar */
  specifications_muurbeugel_uittrekbaar?: Maybe<FilterEqualTypeInput>
  /** Attribute label: vesaafmetingen */
  specifications_muurbeugel_vesaafmetingen?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Aansluitingen */
  specifications_netwerkspeler_aansluitingen?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Aantal USB */
  specifications_netwerkspeler_aantalusb?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Achterspeakers */
  specifications_netwerkspeler_achterspeakers?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Afmetingen */
  specifications_netwerkspeler_afmetingen?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Afmetingen subwoofer */
  specifications_netwerkspeler_afmetingensubwoofer?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Belastbaarheid */
  specifications_netwerkspeler_belastbaarheid?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Fabriekscode */
  specifications_netwerkspeler_fabriekscode?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Gewicht */
  specifications_netwerkspeler_gewicht?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Gewicht Subwoofer */
  specifications_netwerkspeler_gewichtsubwoofer?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Introductiejaar */
  specifications_netwerkspeler_introductiejaar?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Kanalen */
  specifications_netwerkspeler_kanalen?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Kleur */
  specifications_netwerkspeler_kleur?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Multiroom */
  specifications_netwerkspeler_multiroom?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Radio */
  specifications_netwerkspeler_radio?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Speaker aansluiting */
  specifications_netwerkspeler_speakeraansluiting?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Speelt af */
  specifications_netwerkspeler_speeltaf?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Standaard Meegeleverd */
  specifications_netwerkspeler_standaardmeegeleverd?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Streaming */
  specifications_netwerkspeler_streaming?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Streaming diensten */
  specifications_netwerkspeler_streamingdiensten?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Stroomvoorziening */
  specifications_netwerkspeler_stroomvoorziening?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Subwoofer */
  specifications_netwerkspeler_subwoofer?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Subwoofer uitgang */
  specifications_netwerkspeler_subwooferuitgang?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Type Audio */
  specifications_netwerkspeler_typeaudio?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Vermogen */
  specifications_netwerkspeler_vermogen?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Aansluitingen */
  specifications_overigeaudio_aansluitingen?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Aantal HDMI */
  specifications_overigeaudio_aantalhdmi?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Aantal Speakers */
  specifications_overigeaudio_aantalspeakers?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Aantal USB */
  specifications_overigeaudio_aantalusb?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Afmetingen */
  specifications_overigeaudio_afmetingen?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Afmetingen subwoofer */
  specifications_overigeaudio_afmetingensubwoofer?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Fabriekscode */
  specifications_overigeaudio_fabriekscode?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Gewicht */
  specifications_overigeaudio_gewicht?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Gewicht Subwoofer */
  specifications_overigeaudio_gewichtsubwoofer?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Introductiejaar */
  specifications_overigeaudio_introductiejaar?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Kanalen */
  specifications_overigeaudio_kanalen?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Kleur */
  specifications_overigeaudio_kleur?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Maximale frequentie */
  specifications_overigeaudio_maximalefrequentie?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Minimale frequentie */
  specifications_overigeaudio_minimalefrequentie?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Radio */
  specifications_overigeaudio_radio?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Standaard Meegeleverd */
  specifications_overigeaudio_standaardmeegeleverd?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Streaming */
  specifications_overigeaudio_streaming?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Stroomvoorziening */
  specifications_overigeaudio_stroomvoorziening?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Vermogen */
  specifications_overigeaudio_vermogen?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Waterbestendig */
  specifications_overigeaudio_waterbestendig?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Aantal draaipunten */
  specifications_plafondbeugels_aantaldraai?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Beeldformaat */
  specifications_plafondbeugels_beeldformaat?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Draaien */
  specifications_plafondbeugels_draaien?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Garantie */
  specifications_plafondbeugels_garantie?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Grootte TV */
  specifications_plafondbeugels_groottetv?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Hoogte */
  specifications_plafondbeugels_hoogte?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Hoogteverstelling */
  specifications_plafondbeugels_hoogteverstelling?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Interface breedte */
  specifications_plafondbeugels_interfacebreedte?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Interface hoogte */
  specifications_plafondbeugels_interfacehoogte?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Interface optioneel */
  specifications_plafondbeugels_interfaceoptioneel?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Kabel inlegsysteem */
  specifications_plafondbeugels_kabelinlegsysteem?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Kantelen */
  specifications_plafondbeugels_kantelen?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Kleur */
  specifications_plafondbeugels_kleur?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Lengte buis */
  specifications_plafondbeugels_lengtebuis?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Max gewicht */
  specifications_plafondbeugels_maxgewicht?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Montagehoek plafond */
  specifications_plafondbeugels_montagehoek?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Productlijn */
  specifications_plafondbeugels_productlijn?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Roteren */
  specifications_plafondbeugels_roteren?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Schuine plafondoplossing */
  specifications_plafondbeugels_schuineplafondoplossing?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Uitschuifbaar */
  specifications_plafondbeugels_uitschuifbaar?: Maybe<FilterEqualTypeInput>
  /** Attribute label: VESA maximaal */
  specifications_plafondbeugels_vesamaximaal?: Maybe<FilterMatchTypeInput>
  /** Attribute label: VESA minimaal */
  specifications_plafondbeugels_vesaminimaal?: Maybe<FilterMatchTypeInput>
  /** Attribute label: VESA norm */
  specifications_plafondbeugels_vesanorm?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Zwenken */
  specifications_plafondbeugels_zwenken?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Aansluitingen */
  specifications_receiver_aansluitingen?: Maybe<FilterEqualTypeInput>
  /** Attribute label: AantalSpeakers */
  specifications_receiver_aantalspeakers?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Achterspeakers */
  specifications_receiver_achterspeakers?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Afmetingen */
  specifications_receiver_afmetingen?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Airplay2 */
  specifications_receiver_airplay2?: Maybe<FilterEqualTypeInput>
  /** Attribute label: ARC */
  specifications_receiver_arc?: Maybe<FilterEqualTypeInput>
  /** Attribute label: aux */
  specifications_receiver_aux?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Beeldondersteuning */
  specifications_receiver_beeldondersteuning?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Bluetooth */
  specifications_receiver_bluetooth?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Coax */
  specifications_receiver_coax?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Component */
  specifications_receiver_component?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Composiet */
  specifications_receiver_composiet?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Ethernet */
  specifications_receiver_ethernet?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Fabriekscode */
  specifications_receiver_fabriekscode?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Gewicht */
  specifications_receiver_gewicht?: Maybe<FilterMatchTypeInput>
  /** Attribute label: HDMI in */
  specifications_receiver_hdmiin?: Maybe<FilterMatchTypeInput>
  /** Attribute label: HDMI out */
  specifications_receiver_hdmiout?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Impendatie */
  specifications_receiver_impendatie?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Introductiejaar */
  specifications_receiver_introductiejaar?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Kanalen */
  specifications_receiver_kanalen?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Kleur */
  specifications_receiver_kleur?: Maybe<FilterEqualTypeInput>
  /** Attribute label: minijack */
  specifications_receiver_minijack?: Maybe<FilterEqualTypeInput>
  /** Attribute label: MultiRoom */
  specifications_receiver_multiroom?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Optisch */
  specifications_receiver_optisch?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Platenspeler */
  specifications_receiver_platenspeler?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Radio */
  specifications_receiver_radio?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Speelt Af */
  specifications_receiver_speeltaf?: Maybe<FilterEqualTypeInput>
  /** Attribute label: SpotifyConnect */
  specifications_receiver_spotifyconnect?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Streaming */
  specifications_receiver_streaming?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Stroomvoorziening */
  specifications_receiver_stroomvoorziening?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Subwoofer */
  specifications_receiver_subwoofer?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Subwoofer uitgang */
  specifications_receiver_subwooferuitgang?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Surround systemen */
  specifications_receiver_surroundsystemen?: Maybe<FilterEqualTypeInput>
  /** Attribute label: TypeAudio */
  specifications_receiver_typeaudio?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Type receiver */
  specifications_receiver_typereceiver?: Maybe<FilterEqualTypeInput>
  /** Attribute label: USB */
  specifications_receiver_usb?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Vermogen */
  specifications_receiver_vermogen?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Wifi */
  specifications_receiver_wifi?: Maybe<FilterEqualTypeInput>
  /** Attribute label: AantalSpeakers */
  specifications_soundbar_aantalspeakers?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Afmetingen */
  specifications_soundbar_afmetingen?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Airplay2 */
  specifications_soundbar_airplay2?: Maybe<FilterEqualTypeInput>
  /** Attribute label: ARC */
  specifications_soundbar_arc?: Maybe<FilterEqualTypeInput>
  /** Attribute label: aux */
  specifications_soundbar_aux?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Beeldondersteuning */
  specifications_soundbar_beeldondersteuning?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Bluetooth */
  specifications_soundbar_bluetooth?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Component */
  specifications_soundbar_component?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Composiet */
  specifications_soundbar_composiet?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Ethernet */
  specifications_soundbar_ethernet?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Fabriekscode */
  specifications_soundbar_fabriekscode?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Gewicht */
  specifications_soundbar_gewicht?: Maybe<FilterMatchTypeInput>
  /** Attribute label: HDMI in */
  specifications_soundbar_hdmiin?: Maybe<FilterMatchTypeInput>
  /** Attribute label: HDMI out */
  specifications_soundbar_hdmiout?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Introductiejaar */
  specifications_soundbar_introductiejaar?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Kanalen */
  specifications_soundbar_kanalen?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Kleur */
  specifications_soundbar_kleur?: Maybe<FilterEqualTypeInput>
  /** Attribute label: minijack */
  specifications_soundbar_minijack?: Maybe<FilterEqualTypeInput>
  /** Attribute label: MultiRoom */
  specifications_soundbar_multiroom?: Maybe<FilterEqualTypeInput>
  /** Attribute label: OptischCoax */
  specifications_soundbar_optischcoax?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Speelt Af */
  specifications_soundbar_speeltaf?: Maybe<FilterEqualTypeInput>
  /** Attribute label: SpotifyConnect */
  specifications_soundbar_spotifyconnect?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Streaming */
  specifications_soundbar_streaming?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Stroomvoorziening */
  specifications_soundbar_stroomvoorziening?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Subwoofer */
  specifications_soundbar_subwoofer?: Maybe<FilterEqualTypeInput>
  /** Attribute label: TypeAudio */
  specifications_soundbar_typeaudio?: Maybe<FilterEqualTypeInput>
  /** Attribute label: USB */
  specifications_soundbar_usb?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Vermogen */
  specifications_soundbar_vermogen?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Wifi */
  specifications_soundbar_wifi?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Aansluitingen */
  specifications_stereoset_aansluitingen?: Maybe<FilterEqualTypeInput>
  /** Attribute label: AantalSpeakers */
  specifications_stereoset_aantalspeakers?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Aantal USB */
  specifications_stereoset_aantalusb?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Afmetingen */
  specifications_stereoset_afmetingen?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Belastbaarheid */
  specifications_stereoset_belastbaarheid?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Fabriekscode */
  specifications_stereoset_fabriekscode?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Gewicht */
  specifications_stereoset_gewicht?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Impendatie */
  specifications_stereoset_impendatie?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Introductiejaar */
  specifications_stereoset_introductiejaar?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Kanalen */
  specifications_stereoset_kanalen?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Kleur */
  specifications_stereoset_kleur?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Maximale frequentie */
  specifications_stereoset_maximalefrequentie?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Minimale frequentie */
  specifications_stereoset_minimalefrequentie?: Maybe<FilterMatchTypeInput>
  /** Attribute label: MultiRoom */
  specifications_stereoset_multiroom?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Radio */
  specifications_stereoset_radio?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Speaker aansluiting */
  specifications_stereoset_speakeraansluiting?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Speelt Af */
  specifications_stereoset_speeltaf?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Standaard Meegeleverd */
  specifications_stereoset_standaardmeegeleverd?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Streaming */
  specifications_stereoset_streaming?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Stroomvoorziening */
  specifications_stereoset_stroomvoorziening?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Subwoofer uitgang */
  specifications_stereoset_subwooferuitgang?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Type Audio */
  specifications_stereoset_typeaudio?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Type speaker */
  specifications_stereoset_typespeaker?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Vermogen */
  specifications_stereoset_vermogen?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Aansluitingen */
  specifications_subwoofer_aansluitingen?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Aantal USB */
  specifications_subwoofer_aantalusb?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Afmetingen */
  specifications_subwoofer_afmetingen?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Afmetingen subwoofer */
  specifications_subwoofer_afmetingensubwoofer?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Belastbaarheid */
  specifications_subwoofer_belastbaarheid?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Fabriekscode */
  specifications_subwoofer_fabriekscode?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Gewicht */
  specifications_subwoofer_gewicht?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Gewicht Subwoofer */
  specifications_subwoofer_gewichtsubwoofer?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Introductiejaar */
  specifications_subwoofer_introductiejaar?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Kanalen */
  specifications_subwoofer_kanalen?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Kleur */
  specifications_subwoofer_kleur?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Maximale frequentie */
  specifications_subwoofer_maximalefrequentie?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Minimale frequentie */
  specifications_subwoofer_minimalefrequentie?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Multiroom */
  specifications_subwoofer_multiroom?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Radio */
  specifications_subwoofer_radio?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Speaker aansluiting */
  specifications_subwoofer_speakeraansluiting?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Standaard Meegeleverd */
  specifications_subwoofer_standaardmeegeleverd?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Streaming */
  specifications_subwoofer_streaming?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Streaming diensten */
  specifications_subwoofer_streamingdiensten?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Stroomvoorziening */
  specifications_subwoofer_stroomvoorziening?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Subwoofer uitgang */
  specifications_subwoofer_subwooferuitgang?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Type Audio */
  specifications_subwoofer_typeaudio?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Type speaker */
  specifications_subwoofer_typespeaker?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Vermogen */
  specifications_subwoofer_vermogen?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Waterbestendig */
  specifications_subwoofer_waterbestendig?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Afmetingen excl. voet */
  specifications_televisie_afmetingenexclvoet?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Afmetingen incl. voet */
  specifications_televisie_afmetingeninclvoet?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Airplay */
  specifications_televisie_airplay?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Ambilight */
  specifications_televisie_ambilight?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Beeldformaat */
  specifications_televisie_beeldformaat?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Beeldfrequentie */
  specifications_televisie_beeldfrequentie?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Bluetooth */
  specifications_televisie_bluetooth?: Maybe<FilterEqualTypeInput>
  /** Attribute label: CI+ geschikt */
  specifications_televisie_cigeschikt?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Component */
  specifications_televisie_component?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Composiet */
  specifications_televisie_composiet?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Digitaal coaxale aansluiting */
  specifications_televisie_digitaalcoaxaleaansluiting?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Digitaal optischea ansluiting */
  specifications_televisie_digitaaloptischeaansluiting?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Energieklasse */
  specifications_televisie_energieklasse?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Fabriekscode */
  specifications_televisie_fabriekscode?: Maybe<FilterMatchTypeInput>
  /** Attribute label: gewicht excl. voet */
  specifications_televisie_gewichtexclvoet?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Gewicht incl. voet */
  specifications_televisie_gewichtinclvoet?: Maybe<FilterMatchTypeInput>
  /** Attribute label: HDMI */
  specifications_televisie_hdmi?: Maybe<FilterMatchTypeInput>
  /** Attribute label: HDR */
  specifications_televisie_hdr?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Introductiejaar */
  specifications_televisie_introductiejaar?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Kleur */
  specifications_televisie_kleur?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Koptelefoon */
  specifications_televisie_koptelefoon?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Meegeleverde Accessoires */
  specifications_televisie_meegeleverdeaccessoires?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Merk */
  specifications_televisie_merk?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Resolutie */
  specifications_televisie_resolutie?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Scart */
  specifications_televisie_scart?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Smartplatform */
  specifications_televisie_smartplatform?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Smart TV */
  specifications_televisie_smarttv?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Soort TV */
  specifications_televisie_soorttv?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Speakersysteem */
  specifications_televisie_speakersysteem?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Spotify Connect */
  specifications_televisie_spotifyconnect?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Voicecontrol */
  specifications_televisie_spraakbesturing?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Subwoofer */
  specifications_televisie_subwoofer?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Tuner */
  specifications_televisie_tuner?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Type HDR */
  specifications_televisie_typehdr?: Maybe<FilterEqualTypeInput>
  /** Attribute label: USB */
  specifications_televisie_usb?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Vermogen */
  specifications_televisie_vermogen?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Wifi */
  specifications_televisie_wifi?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Afmetingen */
  specifications_tvmeubel_afmetingen?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Gewicht */
  specifications_tvmeubel_gewicht?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Kleur */
  specifications_tvmeubel_kleur?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Materiaal */
  specifications_tvmeubel_materiaal?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Type product */
  specifications_tvmeubel_typeproduct?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Aansluitingen */
  specifications_versterker_aansluitingen?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Aantal HDMI */
  specifications_versterker_aantalhdmi?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Aantal USB */
  specifications_versterker_aantalusb?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Achterspeakers */
  specifications_versterker_achterspeakers?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Afmetingen */
  specifications_versterker_afmetingen?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Afmetingen Subwoofer */
  specifications_versterker_afmetingensubwoofer?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Belastbaarheid */
  specifications_versterker_belastbaarheid?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Fabriekscode */
  specifications_versterker_fabriekscode?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Gewicht */
  specifications_versterker_gewicht?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Gewicht Subwoofer */
  specifications_versterker_gewichtsubwoofer?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Impendatie */
  specifications_versterker_impendatie?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Introductiejaar */
  specifications_versterker_introductiejaar?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Kanalen */
  specifications_versterker_kanalen?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Kleur */
  specifications_versterker_kleur?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Multiroom */
  specifications_versterker_multiroom?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Radio */
  specifications_versterker_radio?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Speaker aansluiting */
  specifications_versterker_speakeraansluiting?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Speelt af */
  specifications_versterker_speeltaf?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Standaard Meegeleverd */
  specifications_versterker_standaardmeegeleverd?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Streaming */
  specifications_versterker_streaming?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Streaming diensten */
  specifications_versterker_streamingdiensten?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Stroomvoorziening */
  specifications_versterker_stroomvoorziening?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Subwoofer */
  specifications_versterker_subwoofer?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Subwoofer uitgang */
  specifications_versterker_subwooferuitgang?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Type Audio */
  specifications_versterker_typeaudio?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Vermogen */
  specifications_versterker_vermogen?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Waterbestendig */
  specifications_versterker_waterbestendig?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Afmetingen */
  specifications_vloerstandaard_afmetingen?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Kleur */
  specifications_vloerstandaard_kleur?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Producttype */
  specifications_vloerstandaard_producttype?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Draadloos opladen */
  specifications_voeding_draadloosopladen?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Kabellengte */
  specifications_voeding_kabellengte?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Kleur */
  specifications_voeding_kleur?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Producttype */
  specifications_voeding_producttype?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Aansluitingen */
  specifications_wifispeaker_aansluitingen?: Maybe<FilterEqualTypeInput>
  /** Attribute label: AantalSpeakers */
  specifications_wifispeaker_aantalspeakers?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Aantal USB */
  specifications_wifispeaker_aantalusb?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Achterspeakers */
  specifications_wifispeaker_achterspeakers?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Afmetingen */
  specifications_wifispeaker_afmetingen?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Afmetingen Subwoofer */
  specifications_wifispeaker_afmetingensubwoofer?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Belastbaarheid */
  specifications_wifispeaker_belastbaarheid?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Fabriekscode */
  specifications_wifispeaker_fabriekscode?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Gewicht */
  specifications_wifispeaker_gewicht?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Gewicht Subwoofer */
  specifications_wifispeaker_gewichtsubwoofer?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Impendatie */
  specifications_wifispeaker_impendatie?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Introductiejaar */
  specifications_wifispeaker_introductiejaar?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Kanalen */
  specifications_wifispeaker_kanalen?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Kleur */
  specifications_wifispeaker_kleur?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Multiroom */
  specifications_wifispeaker_multiroom?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Radio */
  specifications_wifispeaker_radio?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Speelt af */
  specifications_wifispeaker_speeltaf?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Standaard Meegeleverd */
  specifications_wifispeaker_standaardmeegeleverd?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Streaming */
  specifications_wifispeaker_streaming?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Streaming diensten */
  specifications_wifispeaker_streamingdiensten?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Stroomvoorziening */
  specifications_wifispeaker_stroomvoorziening?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Subwoofer */
  specifications_wifispeaker_subwoofer?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Subwoofer uitgang */
  specifications_wifispeaker_subwooferuitgang?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Type Audio */
  specifications_wifispeaker_typeaudio?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Type speaker */
  specifications_wifispeaker_typespeaker?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Vermogen */
  specifications_wifispeaker_vermogen?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Waterbestendig */
  specifications_wifispeaker_waterbestendig?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Strap/Handle */
  strap_bags?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Style Bags */
  style_bags?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Style Bottom */
  style_bottom?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Style General */
  style_general?: Maybe<FilterEqualTypeInput>
  /** Attribute label: TempCombipakketten */
  tempcombipakketten?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Top 10 product */
  top10product?: Maybe<FilterEqualTypeInput>
  /** Attribute label: tot21u */
  tot21u?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Tweakers */
  tweakers?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Tweakers TextAD */
  tweakerstekstad?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Cross sell template id */
  tweakwisecrossselltemplateid?: Maybe<FilterMatchTypeInput>
  /** The part of the URL that identifies the product */
  url_key?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Variant */
  variant?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Variant waarde (e.g. '40 inch / 120 cm' of '#2da6c1') */
  variant_value?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Vendit GUID */
  venditguid?: Maybe<FilterMatchTypeInput>
  /** Attribute label: VenditPID */
  venditpid?: Maybe<FilterMatchTypeInput>
  /** Attribute label: Voorraad Amsterdam */
  voorraadamsterdam?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Voorraad Arnhem */
  voorraadarnhem?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Voorraad Breda */
  voorraadbreda?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Voorraad Doetinchem */
  voorraaddoetinchem?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Voorraad Eindhoven */
  voorraadeindhoven?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Voorraad Groningen */
  voorraadgroningen?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Voorraad Naarden */
  voorraadnaarden?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Voorraad Nijmegen */
  voorraadnijmegen?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Voorraad Online */
  voorraadonline?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Voorraad Utrecht */
  voorraadutrecht?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Voorraad Zoeterwoude */
  voorraadzoeterwoude?: Maybe<FilterEqualTypeInput>
  /** Attribute label: Zondaglevering */
  zondaglevering?: Maybe<FilterEqualTypeInput>
}

/**
 * ProductAttributeSortInput specifies the attribute to use for sorting search
 * results and indicates whether the results are sorted in ascending or descending
 * order. It's possible to sort products using searchable attributes with enabled
 * 'Use in Filter Options' option
 */
export interface ProductAttributeSortInput {
  /** Attribute label: Product Name */
  name?: Maybe<SortEnum>
  /** Attribute label: Pimcore Product ID */
  pimcore_id?: Maybe<SortEnum>
  /** Sort by the position assigned to each product. */
  position?: Maybe<SortEnum>
  /** Attribute label: Price */
  price?: Maybe<SortEnum>
  /** Sort by the search relevance score (default). */
  relevance?: Maybe<SortEnum>
}

export type ProductBody = ProductBodyProductDescription

export interface ProductBodyProductDescription {
  __typename?: 'ProductBodyProductDescription'
  type: Maybe<Scalars['String']>
  label: Maybe<Scalars['String']>
  primary: Maybe<ProductBodyProductDescriptionPrimary>
}

export interface ProductBodyProductDescriptionPrimary {
  __typename?: 'ProductBodyProductDescriptionPrimary'
  productDescription: Maybe<Scalars['Json']>
}

/** A connection to a list of items. */
export interface ProductConnectionConnection {
  __typename?: 'ProductConnectionConnection'
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  /** A list of edges. */
  edges: Maybe<Array<Maybe<ProductConnectionEdge>>>
  totalCount: Scalars['Long']
}

/** An edge in a connection. */
export interface ProductConnectionEdge {
  __typename?: 'ProductConnectionEdge'
  /** The item at the end of the edge. */
  node: Product
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
}

/** A discount applied to a product price. */
export interface ProductDiscount {
  __typename?: 'ProductDiscount'
  /** The actual value of the discount. */
  amountOff: Maybe<Scalars['Float']>
  /** The discount expressed a percentage. */
  percentOff: Maybe<Scalars['Float']>
}

/**
 * ProductFilterInput is deprecated, use @ProductAttributeFilterInput instead.
 * ProductFilterInput defines the filters to be used in the search. A filter
 * contains at least one attribute, a comparison operator, and the value that is
 * being searched for.
 */
export interface ProductFilterInput {
  /** Category ID the product belongs to. */
  category_id?: Maybe<FilterTypeInput>
  /** The product's country of origin. */
  country_of_manufacture?: Maybe<FilterTypeInput>
  /** Timestamp indicating when the product was created. */
  created_at?: Maybe<FilterTypeInput>
  /** The name of a custom layout. */
  custom_layout?: Maybe<FilterTypeInput>
  /** XML code that is applied as a layout update to the product page. */
  custom_layout_update?: Maybe<FilterTypeInput>
  /** Detailed information about the product. The value can include simple HTML tags. */
  description?: Maybe<FilterTypeInput>
  /** Indicates whether a gift message is available. */
  gift_message_available?: Maybe<FilterTypeInput>
  /** Indicates whether additional attributes have been created for the product. */
  has_options?: Maybe<FilterTypeInput>
  /** The relative path to the main image on the product page. */
  image?: Maybe<FilterTypeInput>
  /** The label assigned to a product image. */
  image_label?: Maybe<FilterTypeInput>
  /** A number representing the product's manufacturer. */
  manufacturer?: Maybe<FilterTypeInput>
  /** The numeric maximal price of the product. Do not include the currency code. */
  max_price?: Maybe<FilterTypeInput>
  /** A brief overview of the product for search results listings, maximum 255 characters. */
  meta_description?: Maybe<FilterTypeInput>
  /** A comma-separated list of keywords that are visible only to search engines. */
  meta_keyword?: Maybe<FilterTypeInput>
  /** A string that is displayed in the title bar and tab of the browser and in search results lists. */
  meta_title?: Maybe<FilterTypeInput>
  /** The numeric minimal price of the product. Do not include the currency code. */
  min_price?: Maybe<FilterTypeInput>
  /** The product name. Customers use this name to identify the product. */
  name?: Maybe<FilterTypeInput>
  /** The beginning date for new product listings, and determines if the product is featured as a new product. */
  news_from_date?: Maybe<FilterTypeInput>
  /** The end date for new product listings. */
  news_to_date?: Maybe<FilterTypeInput>
  /** If the product has multiple options, determines where they appear on the product page. */
  options_container?: Maybe<FilterTypeInput>
  /** The keyword required to perform a logical OR comparison. */
  or?: Maybe<ProductFilterInput>
  /** The price of an item. */
  price?: Maybe<FilterTypeInput>
  /** Indicates whether the product has required options. */
  required_options?: Maybe<FilterTypeInput>
  /** A short description of the product. Its use depends on the theme. */
  short_description?: Maybe<FilterTypeInput>
  /** A number or code assigned to a product to identify the product, options, price, and manufacturer. */
  sku?: Maybe<FilterTypeInput>
  /** The relative path to the small image, which is used on catalog pages. */
  small_image?: Maybe<FilterTypeInput>
  /** The label assigned to a product's small image. */
  small_image_label?: Maybe<FilterTypeInput>
  /** The beginning date that a product has a special price. */
  special_from_date?: Maybe<FilterTypeInput>
  /** The discounted price of the product. Do not include the currency code. */
  special_price?: Maybe<FilterTypeInput>
  /** The end date that a product has a special price. */
  special_to_date?: Maybe<FilterTypeInput>
  /** The file name of a swatch image */
  swatch_image?: Maybe<FilterTypeInput>
  /** The relative path to the product's thumbnail image. */
  thumbnail?: Maybe<FilterTypeInput>
  /** The label assigned to a product's thumbnail image. */
  thumbnail_label?: Maybe<FilterTypeInput>
  /** The price when tier pricing is in effect and the items purchased threshold has been reached. */
  tier_price?: Maybe<FilterTypeInput>
  /** Timestamp indicating when the product was updated. */
  updated_at?: Maybe<FilterTypeInput>
  /** The part of the URL that identifies the product */
  url_key?: Maybe<FilterTypeInput>
  url_path?: Maybe<FilterTypeInput>
  /** The weight of the item, in units defined by the store. */
  weight?: Maybe<FilterTypeInput>
}

/** Product image information. Contains the image URL and label. */
export interface ProductImage extends MediaGalleryInterface {
  __typename?: 'ProductImage'
  /** Whether the image is hidden from view. */
  disabled: Maybe<Scalars['Boolean']>
  /** The label of the product image or video. */
  label: Maybe<Scalars['String']>
  /** The media item's position after it has been sorted. */
  position: Maybe<Scalars['Int']>
  /** The URL of the product image or video. */
  url: Maybe<Scalars['String']>
}

/**
 * The ProductInterface contains attributes that are common to all types of
 * products. Note that descriptions may not be available for custom and EAV attributes.
 */
export interface ProductInterface {
  activity: Maybe<Scalars['String']>
  allowcoupon: Maybe<Scalars['Int']>
  allowingenico: Maybe<Scalars['Int']>
  allowpostnllabel: Maybe<Scalars['Int']>
  allowreview: Maybe<Scalars['Int']>
  alternatiefmemo: Maybe<Scalars['String']>
  /** The attribute set assigned to the product. */
  attributeSetId: Maybe<Scalars['Int']>
  /**
   * Relative canonical URL. This value is returned only if the system setting 'Use
   * Canonical Link Meta Tag For Products' is enabled
   */
  canonicalUrl: Maybe<Scalars['String']>
  /** The categories assigned to a product. */
  categories: Maybe<Array<Maybe<CategoryInterface>>>
  categoryGear: Maybe<Scalars['String']>
  climate: Maybe<Scalars['String']>
  collar: Maybe<Scalars['String']>
  color: Maybe<Scalars['Int']>
  cons: Maybe<Scalars['String']>
  /** The product's country of origin. */
  countryOfManufacture: Maybe<Scalars['String']>
  /** Timestamp indicating when the product was created. */
  createdAt: Maybe<Scalars['String']>
  /** Crosssell Products */
  crosssellProducts: Maybe<Array<Maybe<ProductInterface>>>
  /** Detailed information about the product. The value can include simple HTML tags. */
  description: Maybe<ComplexTextValue>
  doorverkooppremie: Maybe<Scalars['String']>
  ean: Maybe<Scalars['String']>
  ecoCollection: Maybe<Scalars['Int']>
  enabled: Maybe<Scalars['Int']>
  erinRecommends: Maybe<Scalars['Int']>
  factuurinformatie: Maybe<Scalars['String']>
  featuresBags: Maybe<Scalars['String']>
  fixedprice: Maybe<Scalars['Int']>
  fixeduntil: Maybe<Scalars['String']>
  gebruikbundelproductenprijs: Maybe<Scalars['Int']>
  gender: Maybe<Scalars['String']>
  /** Indicates whether a gift message is available. */
  giftMessageAvailable: Maybe<Scalars['String']>
  google: Maybe<Scalars['Int']>
  /** The ID number assigned to the product. */
  id: Scalars['Int']
  /** The relative path to the main image on the product page. */
  image: Maybe<ProductImage>
  inkoopprijs: Maybe<Scalars['String']>
  isBuitenkansje: Maybe<Scalars['Int']>
  isInStock: Maybe<Scalars['Int']>
  keepproductbuttons: Maybe<Scalars['Int']>
  kenmerken: Maybe<Scalars['String']>
  kieskeurig: Maybe<Scalars['Int']>
  kieskeurigbe: Maybe<Scalars['Int']>
  kieskeurigtekstad: Maybe<Scalars['String']>
  korteomschrijving: Maybe<Scalars['String']>
  korteomschrijving2: Maybe<Scalars['String']>
  langeomschrijving: Maybe<Scalars['String']>
  /** A number representing the product's manufacturer. */
  manufacturer: Maybe<Scalars['Int']>
  material: Maybe<Scalars['String']>
  maxprijsomnia: Maybe<Scalars['String']>
  /** An array of Media Gallery objects. */
  mediaGallery: Maybe<Array<Maybe<MediaGalleryInterface>>>
  /**
   * An array of MediaGalleryEntry objects.
   * @deprecated Use product's `media_gallery` instead
   */
  mediaGalleryEntries: Maybe<Array<Maybe<MediaGalleryEntry>>>
  merk: Maybe<Scalars['Int']>
  /** A brief overview of the product for search results listings, maximum 255 characters. */
  metaDescription: Maybe<Scalars['String']>
  /** A comma-separated list of keywords that are visible only to search engines. */
  metaKeyword: Maybe<Scalars['String']>
  /** A string that is displayed in the title bar and tab of the browser and in search results lists. */
  metaTitle: Maybe<Scalars['String']>
  modeltype: Maybe<Scalars['String']>
  /** The product name. Customers use this name to identify the product. */
  name: Scalars['String']
  new: Maybe<Scalars['Int']>
  /** The beginning date for new product listings, and determines if the product is featured as a new product. */
  newFromDate: Maybe<Scalars['String']>
  /** The end date for new product listings. */
  newToDate: Maybe<Scalars['String']>
  omnia: Maybe<Scalars['Int']>
  /** Product stock only x left count */
  onlyXLeftInStock: Maybe<Scalars['Float']>
  opmerking1: Maybe<Scalars['String']>
  opmerking2: Maybe<Scalars['String']>
  /** If the product has multiple options, determines where they appear on the product page. */
  optionsContainer: Maybe<Scalars['String']>
  pattern: Maybe<Scalars['String']>
  percentagekortingopprijsvanbundelproducten: Maybe<Scalars['String']>
  performanceFabric: Maybe<Scalars['Int']>
  pimcoreId: Maybe<Scalars['Int']>
  populariteit: Maybe<Scalars['String']>
  /**
   * A ProductPrices object, indicating the price of an item.
   * @deprecated Use price_range for product price information.
   */
  price: Maybe<ProductPrices>
  /** A PriceRange object, indicating the range of prices for the product */
  priceRange: PriceRange
  /** An array of TierPrice objects. */
  priceTiers: Maybe<Array<Maybe<TierPrice>>>
  prijs: Maybe<Scalars['String']>
  /** An array of ProductLinks objects. */
  productLinks: Maybe<Array<Maybe<ProductLinksInterface>>>
  productnaam: Maybe<Scalars['String']>
  productnaam1: Maybe<Scalars['String']>
  productspideren: Maybe<Scalars['Int']>
  promotekst: Maybe<Scalars['String']>
  pros: Maybe<Scalars['String']>
  /** Related Products */
  relatedProducts: Maybe<Array<Maybe<ProductInterface>>>
  s2m: Maybe<Scalars['Int']>
  sale: Maybe<Scalars['Int']>
  serie: Maybe<Scalars['String']>
  /** A short description of the product. Its use depends on the theme. */
  shortDescription: Maybe<ComplexTextValue>
  size: Maybe<Scalars['Int']>
  /** A number or code assigned to a product to identify the product, options, price, and manufacturer. */
  sku: Scalars['String']
  sleeve: Maybe<Scalars['String']>
  /** The relative path to the small image, which is used on catalog pages. */
  smallImage: Maybe<ProductImage>
  /** The beginning date that a product has a special price. */
  specialFromDate: Maybe<Scalars['String']>
  /** The discounted price of the product. */
  specialPrice: Maybe<Scalars['Float']>
  /** The end date that a product has a special price. */
  specialToDate: Maybe<Scalars['String']>
  specialprice: Maybe<Scalars['String']>
  specificationsBluetoothspeakerAansluitingen: Maybe<Scalars['String']>
  specificationsBluetoothspeakerAantalspeakers: Maybe<Scalars['String']>
  specificationsBluetoothspeakerAantalusb: Maybe<Scalars['String']>
  specificationsBluetoothspeakerAantalusbc: Maybe<Scalars['String']>
  specificationsBluetoothspeakerAfmetingen: Maybe<Scalars['String']>
  specificationsBluetoothspeakerAfmetingensubwoofer: Maybe<Scalars['String']>
  specificationsBluetoothspeakerFabriekscode: Maybe<Scalars['String']>
  specificationsBluetoothspeakerGewicht: Maybe<Scalars['String']>
  specificationsBluetoothspeakerGewichtsubwoofer: Maybe<Scalars['String']>
  specificationsBluetoothspeakerIntroductiejaar: Maybe<Scalars['String']>
  specificationsBluetoothspeakerKanalen: Maybe<Scalars['String']>
  specificationsBluetoothspeakerKleur: Maybe<Scalars['Int']>
  specificationsBluetoothspeakerSpeeltaf: Maybe<Scalars['String']>
  specificationsBluetoothspeakerStandaardmeegeleverd: Maybe<Scalars['String']>
  specificationsBluetoothspeakerStreaming: Maybe<Scalars['String']>
  specificationsBluetoothspeakerStroomvoorziening: Maybe<Scalars['String']>
  specificationsBluetoothspeakerTypeaudio: Maybe<Scalars['Int']>
  specificationsBluetoothspeakerTypespeaker: Maybe<Scalars['String']>
  specificationsBluetoothspeakerVermogen: Maybe<Scalars['String']>
  specificationsBlurayspelerAfmetingen: Maybe<Scalars['String']>
  specificationsBlurayspelerAfspelenvan: Maybe<Scalars['String']>
  specificationsBlurayspelerAnalogeaudio: Maybe<Scalars['String']>
  specificationsBlurayspelerAudioenvideo: Maybe<Scalars['String']>
  specificationsBlurayspelerBdlive: Maybe<Scalars['Int']>
  specificationsBlurayspelerBluetooth: Maybe<Scalars['Int']>
  specificationsBlurayspelerCoaxiaal: Maybe<Scalars['String']>
  specificationsBlurayspelerDecoders: Maybe<Scalars['String']>
  specificationsBlurayspelerDigitaalcoaxaal: Maybe<Scalars['String']>
  specificationsBlurayspelerDigitaaloptisch: Maybe<Scalars['String']>
  specificationsBlurayspelerDigitaleoptisch: Maybe<Scalars['Int']>
  specificationsBlurayspelerDlna: Maybe<Scalars['Int']>
  specificationsBlurayspelerDriedondersteuning: Maybe<Scalars['Int']>
  specificationsBlurayspelerEthernet: Maybe<Scalars['String']>
  specificationsBlurayspelerFormats: Maybe<Scalars['String']>
  specificationsBlurayspelerFuncties: Maybe<Scalars['String']>
  specificationsBlurayspelerGecerthires: Maybe<Scalars['Int']>
  specificationsBlurayspelerGewicht: Maybe<Scalars['String']>
  specificationsBlurayspelerHdmi: Maybe<Scalars['String']>
  specificationsBlurayspelerHdr: Maybe<Scalars['Int']>
  specificationsBlurayspelerKleur: Maybe<Scalars['Int']>
  specificationsBlurayspelerLan: Maybe<Scalars['Int']>
  specificationsBlurayspelerMiracast: Maybe<Scalars['Int']>
  specificationsBlurayspelerMultiroom: Maybe<Scalars['Int']>
  specificationsBlurayspelerOndersteundaudioformaat: Maybe<Scalars['String']>
  specificationsBlurayspelerOptisch: Maybe<Scalars['Int']>
  specificationsBlurayspelerOutputkanalen: Maybe<Scalars['String']>
  specificationsBlurayspelerPlayback: Maybe<Scalars['String']>
  specificationsBlurayspelerResolutie: Maybe<Scalars['String']>
  specificationsBlurayspelerSmarttv: Maybe<Scalars['Int']>
  specificationsBlurayspelerSpeeltaf: Maybe<Scalars['String']>
  specificationsBlurayspelerSpeeltvandisc: Maybe<Scalars['String']>
  specificationsBlurayspelerStandaardmeegeleverd: Maybe<Scalars['String']>
  specificationsBlurayspelerStroomverbruik: Maybe<Scalars['String']>
  specificationsBlurayspelerUpscaling: Maybe<Scalars['Int']>
  specificationsBlurayspelerUsb: Maybe<Scalars['String']>
  specificationsBlurayspelerVierkuhd: Maybe<Scalars['Int']>
  specificationsBlurayspelerVierkuhdups: Maybe<Scalars['Int']>
  specificationsBlurayspelerWifi: Maybe<Scalars['Int']>
  specificationsCdspelerAansluitingen: Maybe<Scalars['String']>
  specificationsCdspelerAantalusb: Maybe<Scalars['String']>
  specificationsCdspelerAchterspeakers: Maybe<Scalars['Int']>
  specificationsCdspelerAfmetingen: Maybe<Scalars['String']>
  specificationsCdspelerFabriekscode: Maybe<Scalars['String']>
  specificationsCdspelerGewicht: Maybe<Scalars['String']>
  specificationsCdspelerImpendatie: Maybe<Scalars['String']>
  specificationsCdspelerIntroductiejaar: Maybe<Scalars['String']>
  specificationsCdspelerKanalen: Maybe<Scalars['String']>
  specificationsCdspelerMultiroom: Maybe<Scalars['Int']>
  specificationsCdspelerRadio: Maybe<Scalars['Int']>
  specificationsCdspelerSpeakeraansluiting: Maybe<Scalars['String']>
  specificationsCdspelerSpeeltaf: Maybe<Scalars['String']>
  specificationsCdspelerStandaardmeegeleverd: Maybe<Scalars['String']>
  specificationsCdspelerStreaming: Maybe<Scalars['String']>
  specificationsCdspelerStreamingdiensten: Maybe<Scalars['String']>
  specificationsCdspelerStroomvoorziening: Maybe<Scalars['Int']>
  specificationsCdspelerSubwooferuitgang: Maybe<Scalars['Int']>
  specificationsCdspelerTypeaudio: Maybe<Scalars['Int']>
  specificationsCdspelerVermogen: Maybe<Scalars['String']>
  specificationsDraadlozespeakerAantalspeakers: Maybe<Scalars['String']>
  specificationsDraadlozespeakerAfmetingen: Maybe<Scalars['String']>
  specificationsDraadlozespeakerAirplay2: Maybe<Scalars['Int']>
  specificationsDraadlozespeakerAux: Maybe<Scalars['Int']>
  specificationsDraadlozespeakerBluetooth: Maybe<Scalars['Int']>
  specificationsDraadlozespeakerComponent: Maybe<Scalars['Int']>
  specificationsDraadlozespeakerComposiet: Maybe<Scalars['Int']>
  specificationsDraadlozespeakerFabriekscode: Maybe<Scalars['String']>
  specificationsDraadlozespeakerGebruiksduuraccu: Maybe<Scalars['String']>
  specificationsDraadlozespeakerGewicht: Maybe<Scalars['String']>
  specificationsDraadlozespeakerHdmiin: Maybe<Scalars['String']>
  specificationsDraadlozespeakerHdmiuit: Maybe<Scalars['String']>
  specificationsDraadlozespeakerKanalen: Maybe<Scalars['String']>
  specificationsDraadlozespeakerMinijack: Maybe<Scalars['Int']>
  specificationsDraadlozespeakerMultiroom: Maybe<Scalars['Int']>
  specificationsDraadlozespeakerOptischcoax: Maybe<Scalars['Int']>
  specificationsDraadlozespeakerPlatenspeler: Maybe<Scalars['Int']>
  specificationsDraadlozespeakerSpotifyconnect: Maybe<Scalars['Int']>
  specificationsDraadlozespeakerSubwoofer: Maybe<Scalars['Int']>
  specificationsDraadlozespeakerUsb: Maybe<Scalars['Int']>
  specificationsDraadlozespeakerVoicecontrol: Maybe<Scalars['Int']>
  specificationsDraadlozespeakerWifi: Maybe<Scalars['Int']>
  specificationsHifispeakerAansluitingen: Maybe<Scalars['String']>
  specificationsHifispeakerAantalspeakers: Maybe<Scalars['String']>
  specificationsHifispeakerAantalusb: Maybe<Scalars['String']>
  specificationsHifispeakerAchterspeakers: Maybe<Scalars['Int']>
  specificationsHifispeakerAfmetingen: Maybe<Scalars['String']>
  specificationsHifispeakerAfmetingensubwoofer: Maybe<Scalars['String']>
  specificationsHifispeakerBelastbaarheid: Maybe<Scalars['String']>
  specificationsHifispeakerFabriekscode: Maybe<Scalars['String']>
  specificationsHifispeakerGewicht: Maybe<Scalars['String']>
  specificationsHifispeakerGewichtsubwoofer: Maybe<Scalars['String']>
  specificationsHifispeakerImpendatie: Maybe<Scalars['String']>
  specificationsHifispeakerIntroductiejaar: Maybe<Scalars['String']>
  specificationsHifispeakerKanalen: Maybe<Scalars['String']>
  specificationsHifispeakerKleur: Maybe<Scalars['Int']>
  specificationsHifispeakerMaximalefrequentie: Maybe<Scalars['String']>
  specificationsHifispeakerMinimalefrequentie: Maybe<Scalars['String']>
  specificationsHifispeakerMultiroom: Maybe<Scalars['Int']>
  specificationsHifispeakerSpeakeraansluiting: Maybe<Scalars['String']>
  specificationsHifispeakerSpeakertype: Maybe<Scalars['String']>
  specificationsHifispeakerStandaardmeegeleverd: Maybe<Scalars['String']>
  specificationsHifispeakerStreaming: Maybe<Scalars['String']>
  specificationsHifispeakerStroomvoorziening: Maybe<Scalars['Int']>
  specificationsHifispeakerTypeaudio: Maybe<Scalars['Int']>
  specificationsHifispeakerTypespeaker: Maybe<Scalars['String']>
  specificationsHifispeakerVermogen: Maybe<Scalars['String']>
  specificationsHifispeakerWaterbestendig: Maybe<Scalars['Int']>
  specificationsHomecinemaAansluitingen: Maybe<Scalars['String']>
  specificationsHomecinemaAantalhdmi: Maybe<Scalars['String']>
  specificationsHomecinemaAantalspeakers: Maybe<Scalars['String']>
  specificationsHomecinemaAantalusb: Maybe<Scalars['String']>
  specificationsHomecinemaAchterspeakers: Maybe<Scalars['Int']>
  specificationsHomecinemaAfmetingen: Maybe<Scalars['String']>
  specificationsHomecinemaFabriekscode: Maybe<Scalars['String']>
  specificationsHomecinemaGewicht: Maybe<Scalars['String']>
  specificationsHomecinemaGewichtsubwoofer: Maybe<Scalars['String']>
  specificationsHomecinemaImpendatie: Maybe<Scalars['String']>
  specificationsHomecinemaIntroductiejaar: Maybe<Scalars['String']>
  specificationsHomecinemaKleur: Maybe<Scalars['Int']>
  specificationsHomecinemaMicrofoon: Maybe<Scalars['Int']>
  specificationsHomecinemaMultiroom: Maybe<Scalars['Int']>
  specificationsHomecinemaRadio: Maybe<Scalars['Int']>
  specificationsHomecinemaSpeakeraansluiting: Maybe<Scalars['String']>
  specificationsHomecinemaSpeeltaf: Maybe<Scalars['String']>
  specificationsHomecinemaStandaardmeegeleverd: Maybe<Scalars['String']>
  specificationsHomecinemaStreaming: Maybe<Scalars['String']>
  specificationsHomecinemaStreamingdiensten: Maybe<Scalars['String']>
  specificationsHomecinemaStroomvoorziening: Maybe<Scalars['Int']>
  specificationsHomecinemaSubwooferuitgang: Maybe<Scalars['String']>
  specificationsHomecinemaTypeaudio: Maybe<Scalars['Int']>
  specificationsHomecinemaTypespeaker: Maybe<Scalars['String']>
  specificationsHomecinemaVermogen: Maybe<Scalars['String']>
  specificationsMuurbeugelAantalgradendraaibaar: Maybe<Scalars['String']>
  specificationsMuurbeugelAantalgradenkantelbaar: Maybe<Scalars['String']>
  specificationsMuurbeugelBedieningviaapp: Maybe<Scalars['Int']>
  specificationsMuurbeugelGarantie: Maybe<Scalars['String']>
  specificationsMuurbeugelGeschiktvoorafmetingentv: Maybe<Scalars['String']>
  specificationsMuurbeugelInterfacebreedte: Maybe<Scalars['String']>
  specificationsMuurbeugelInterfacehoogte: Maybe<Scalars['String']>
  specificationsMuurbeugelIntroductiejaar: Maybe<Scalars['String']>
  specificationsMuurbeugelKleur: Maybe<Scalars['Int']>
  specificationsMuurbeugelMaxafstandmuur: Maybe<Scalars['String']>
  specificationsMuurbeugelMaximalegewichttv: Maybe<Scalars['String']>
  specificationsMuurbeugelMerkmuurbeugel: Maybe<Scalars['Int']>
  specificationsMuurbeugelMinafstandmuur: Maybe<Scalars['String']>
  specificationsMuurbeugelSoortmuurbeugel: Maybe<Scalars['Int']>
  specificationsMuurbeugelStandaardmeegeleverd: Maybe<Scalars['String']>
  specificationsMuurbeugelTypemuurbeugel: Maybe<Scalars['String']>
  specificationsMuurbeugelUittrekbaar: Maybe<Scalars['Int']>
  specificationsMuurbeugelVesaafmetingen: Maybe<Scalars['String']>
  specificationsNetwerkspelerAansluitingen: Maybe<Scalars['String']>
  specificationsNetwerkspelerAantalusb: Maybe<Scalars['String']>
  specificationsNetwerkspelerAchterspeakers: Maybe<Scalars['Int']>
  specificationsNetwerkspelerAfmetingen: Maybe<Scalars['String']>
  specificationsNetwerkspelerAfmetingensubwoofer: Maybe<Scalars['String']>
  specificationsNetwerkspelerBelastbaarheid: Maybe<Scalars['String']>
  specificationsNetwerkspelerFabriekscode: Maybe<Scalars['String']>
  specificationsNetwerkspelerGewicht: Maybe<Scalars['String']>
  specificationsNetwerkspelerGewichtsubwoofer: Maybe<Scalars['String']>
  specificationsNetwerkspelerIntroductiejaar: Maybe<Scalars['String']>
  specificationsNetwerkspelerKanalen: Maybe<Scalars['String']>
  specificationsNetwerkspelerKleur: Maybe<Scalars['Int']>
  specificationsNetwerkspelerMultiroom: Maybe<Scalars['Int']>
  specificationsNetwerkspelerRadio: Maybe<Scalars['Int']>
  specificationsNetwerkspelerSpeakeraansluiting: Maybe<Scalars['String']>
  specificationsNetwerkspelerSpeeltaf: Maybe<Scalars['String']>
  specificationsNetwerkspelerStandaardmeegeleverd: Maybe<Scalars['String']>
  specificationsNetwerkspelerStreaming: Maybe<Scalars['String']>
  specificationsNetwerkspelerStreamingdiensten: Maybe<Scalars['String']>
  specificationsNetwerkspelerStroomvoorziening: Maybe<Scalars['Int']>
  specificationsNetwerkspelerSubwoofer: Maybe<Scalars['Int']>
  specificationsNetwerkspelerSubwooferuitgang: Maybe<Scalars['Int']>
  specificationsNetwerkspelerTypeaudio: Maybe<Scalars['Int']>
  specificationsNetwerkspelerVermogen: Maybe<Scalars['String']>
  specificationsOverigeaudioAansluitingen: Maybe<Scalars['String']>
  specificationsOverigeaudioAantalhdmi: Maybe<Scalars['String']>
  specificationsOverigeaudioAantalspeakers: Maybe<Scalars['String']>
  specificationsOverigeaudioAantalusb: Maybe<Scalars['String']>
  specificationsOverigeaudioAfmetingen: Maybe<Scalars['String']>
  specificationsOverigeaudioAfmetingensubwoofer: Maybe<Scalars['String']>
  specificationsOverigeaudioFabriekscode: Maybe<Scalars['String']>
  specificationsOverigeaudioGewicht: Maybe<Scalars['String']>
  specificationsOverigeaudioGewichtsubwoofer: Maybe<Scalars['String']>
  specificationsOverigeaudioIntroductiejaar: Maybe<Scalars['String']>
  specificationsOverigeaudioKanalen: Maybe<Scalars['String']>
  specificationsOverigeaudioKleur: Maybe<Scalars['Int']>
  specificationsOverigeaudioMaximalefrequentie: Maybe<Scalars['String']>
  specificationsOverigeaudioMinimalefrequentie: Maybe<Scalars['String']>
  specificationsOverigeaudioRadio: Maybe<Scalars['String']>
  specificationsOverigeaudioStandaardmeegeleverd: Maybe<Scalars['String']>
  specificationsOverigeaudioStreaming: Maybe<Scalars['String']>
  specificationsOverigeaudioStroomvoorziening: Maybe<Scalars['Int']>
  specificationsOverigeaudioVermogen: Maybe<Scalars['String']>
  specificationsOverigeaudioWaterbestendig: Maybe<Scalars['Int']>
  specificationsPlafondbeugelsAantaldraai: Maybe<Scalars['String']>
  specificationsPlafondbeugelsBeeldformaat: Maybe<Scalars['String']>
  specificationsPlafondbeugelsDraaien: Maybe<Scalars['String']>
  specificationsPlafondbeugelsGarantie: Maybe<Scalars['String']>
  specificationsPlafondbeugelsGroottetv: Maybe<Scalars['String']>
  specificationsPlafondbeugelsHoogte: Maybe<Scalars['String']>
  specificationsPlafondbeugelsHoogteverstelling: Maybe<Scalars['Int']>
  specificationsPlafondbeugelsInterfacebreedte: Maybe<Scalars['String']>
  specificationsPlafondbeugelsInterfacehoogte: Maybe<Scalars['String']>
  specificationsPlafondbeugelsInterfaceoptioneel: Maybe<Scalars['Int']>
  specificationsPlafondbeugelsKabelinlegsysteem: Maybe<Scalars['String']>
  specificationsPlafondbeugelsKantelen: Maybe<Scalars['String']>
  specificationsPlafondbeugelsKleur: Maybe<Scalars['Int']>
  specificationsPlafondbeugelsLengtebuis: Maybe<Scalars['String']>
  specificationsPlafondbeugelsMaxgewicht: Maybe<Scalars['String']>
  specificationsPlafondbeugelsMontagehoek: Maybe<Scalars['String']>
  specificationsPlafondbeugelsProductlijn: Maybe<Scalars['Int']>
  specificationsPlafondbeugelsRoteren: Maybe<Scalars['Int']>
  specificationsPlafondbeugelsSchuineplafondoplossing: Maybe<Scalars['Int']>
  specificationsPlafondbeugelsUitschuifbaar: Maybe<Scalars['Int']>
  specificationsPlafondbeugelsVesamaximaal: Maybe<Scalars['String']>
  specificationsPlafondbeugelsVesaminimaal: Maybe<Scalars['String']>
  specificationsPlafondbeugelsVesanorm: Maybe<Scalars['String']>
  specificationsPlafondbeugelsZwenken: Maybe<Scalars['Int']>
  specificationsReceiverAansluitingen: Maybe<Scalars['String']>
  specificationsReceiverAantalspeakers: Maybe<Scalars['String']>
  specificationsReceiverAchterspeakers: Maybe<Scalars['Int']>
  specificationsReceiverAfmetingen: Maybe<Scalars['String']>
  specificationsReceiverAirplay2: Maybe<Scalars['Int']>
  specificationsReceiverArc: Maybe<Scalars['Int']>
  specificationsReceiverAux: Maybe<Scalars['Int']>
  specificationsReceiverBeeldondersteuning: Maybe<Scalars['String']>
  specificationsReceiverBluetooth: Maybe<Scalars['Int']>
  specificationsReceiverCoax: Maybe<Scalars['String']>
  specificationsReceiverComponent: Maybe<Scalars['Int']>
  specificationsReceiverComposiet: Maybe<Scalars['Int']>
  specificationsReceiverEthernet: Maybe<Scalars['Int']>
  specificationsReceiverFabriekscode: Maybe<Scalars['String']>
  specificationsReceiverGewicht: Maybe<Scalars['String']>
  specificationsReceiverHdmiin: Maybe<Scalars['String']>
  specificationsReceiverHdmiout: Maybe<Scalars['String']>
  specificationsReceiverImpendatie: Maybe<Scalars['String']>
  specificationsReceiverIntroductiejaar: Maybe<Scalars['String']>
  specificationsReceiverKanalen: Maybe<Scalars['String']>
  specificationsReceiverKleur: Maybe<Scalars['Int']>
  specificationsReceiverMinijack: Maybe<Scalars['Int']>
  specificationsReceiverMultiroom: Maybe<Scalars['Int']>
  specificationsReceiverOptisch: Maybe<Scalars['String']>
  specificationsReceiverPlatenspeler: Maybe<Scalars['Int']>
  specificationsReceiverRadio: Maybe<Scalars['String']>
  specificationsReceiverSpeeltaf: Maybe<Scalars['String']>
  specificationsReceiverSpotifyconnect: Maybe<Scalars['Int']>
  specificationsReceiverStreaming: Maybe<Scalars['String']>
  specificationsReceiverStroomvoorziening: Maybe<Scalars['Int']>
  specificationsReceiverSubwoofer: Maybe<Scalars['Int']>
  specificationsReceiverSubwooferuitgang: Maybe<Scalars['String']>
  specificationsReceiverSurroundsystemen: Maybe<Scalars['String']>
  specificationsReceiverTypeaudio: Maybe<Scalars['Int']>
  specificationsReceiverTypereceiver: Maybe<Scalars['Int']>
  specificationsReceiverUsb: Maybe<Scalars['Int']>
  specificationsReceiverVermogen: Maybe<Scalars['String']>
  specificationsReceiverWifi: Maybe<Scalars['Int']>
  specificationsSoundbarAantalspeakers: Maybe<Scalars['String']>
  specificationsSoundbarAfmetingen: Maybe<Scalars['String']>
  specificationsSoundbarAirplay2: Maybe<Scalars['Int']>
  specificationsSoundbarArc: Maybe<Scalars['Int']>
  specificationsSoundbarAux: Maybe<Scalars['Int']>
  specificationsSoundbarBeeldondersteuning: Maybe<Scalars['String']>
  specificationsSoundbarBluetooth: Maybe<Scalars['Int']>
  specificationsSoundbarComponent: Maybe<Scalars['Int']>
  specificationsSoundbarComposiet: Maybe<Scalars['Int']>
  specificationsSoundbarEthernet: Maybe<Scalars['Int']>
  specificationsSoundbarFabriekscode: Maybe<Scalars['String']>
  specificationsSoundbarGewicht: Maybe<Scalars['String']>
  specificationsSoundbarHdmiin: Maybe<Scalars['String']>
  specificationsSoundbarHdmiout: Maybe<Scalars['String']>
  specificationsSoundbarIntroductiejaar: Maybe<Scalars['String']>
  specificationsSoundbarKanalen: Maybe<Scalars['String']>
  specificationsSoundbarKleur: Maybe<Scalars['Int']>
  specificationsSoundbarMinijack: Maybe<Scalars['Int']>
  specificationsSoundbarMultiroom: Maybe<Scalars['Int']>
  specificationsSoundbarOptischcoax: Maybe<Scalars['String']>
  specificationsSoundbarSpeeltaf: Maybe<Scalars['String']>
  specificationsSoundbarSpotifyconnect: Maybe<Scalars['Int']>
  specificationsSoundbarStreaming: Maybe<Scalars['String']>
  specificationsSoundbarStroomvoorziening: Maybe<Scalars['Int']>
  specificationsSoundbarSubwoofer: Maybe<Scalars['Int']>
  specificationsSoundbarTypeaudio: Maybe<Scalars['Int']>
  specificationsSoundbarUsb: Maybe<Scalars['Int']>
  specificationsSoundbarVermogen: Maybe<Scalars['String']>
  specificationsSoundbarWifi: Maybe<Scalars['Int']>
  specificationsStereosetAansluitingen: Maybe<Scalars['String']>
  specificationsStereosetAantalspeakers: Maybe<Scalars['String']>
  specificationsStereosetAantalusb: Maybe<Scalars['String']>
  specificationsStereosetAfmetingen: Maybe<Scalars['String']>
  specificationsStereosetBelastbaarheid: Maybe<Scalars['String']>
  specificationsStereosetFabriekscode: Maybe<Scalars['String']>
  specificationsStereosetGewicht: Maybe<Scalars['String']>
  specificationsStereosetImpendatie: Maybe<Scalars['Int']>
  specificationsStereosetIntroductiejaar: Maybe<Scalars['String']>
  specificationsStereosetKanalen: Maybe<Scalars['String']>
  specificationsStereosetKleur: Maybe<Scalars['Int']>
  specificationsStereosetMaximalefrequentie: Maybe<Scalars['String']>
  specificationsStereosetMinimalefrequentie: Maybe<Scalars['String']>
  specificationsStereosetMultiroom: Maybe<Scalars['Int']>
  specificationsStereosetRadio: Maybe<Scalars['String']>
  specificationsStereosetSpeakeraansluiting: Maybe<Scalars['Int']>
  specificationsStereosetSpeeltaf: Maybe<Scalars['String']>
  specificationsStereosetStandaardmeegeleverd: Maybe<Scalars['String']>
  specificationsStereosetStreaming: Maybe<Scalars['String']>
  specificationsStereosetStroomvoorziening: Maybe<Scalars['Int']>
  specificationsStereosetSubwooferuitgang: Maybe<Scalars['Int']>
  specificationsStereosetTypeaudio: Maybe<Scalars['Int']>
  specificationsStereosetTypespeaker: Maybe<Scalars['Int']>
  specificationsStereosetVermogen: Maybe<Scalars['String']>
  specificationsSubwooferAansluitingen: Maybe<Scalars['String']>
  specificationsSubwooferAantalusb: Maybe<Scalars['String']>
  specificationsSubwooferAfmetingen: Maybe<Scalars['String']>
  specificationsSubwooferAfmetingensubwoofer: Maybe<Scalars['String']>
  specificationsSubwooferBelastbaarheid: Maybe<Scalars['String']>
  specificationsSubwooferFabriekscode: Maybe<Scalars['String']>
  specificationsSubwooferGewicht: Maybe<Scalars['String']>
  specificationsSubwooferGewichtsubwoofer: Maybe<Scalars['String']>
  specificationsSubwooferIntroductiejaar: Maybe<Scalars['String']>
  specificationsSubwooferKanalen: Maybe<Scalars['String']>
  specificationsSubwooferKleur: Maybe<Scalars['Int']>
  specificationsSubwooferMaximalefrequentie: Maybe<Scalars['String']>
  specificationsSubwooferMinimalefrequentie: Maybe<Scalars['String']>
  specificationsSubwooferMultiroom: Maybe<Scalars['Int']>
  specificationsSubwooferRadio: Maybe<Scalars['Int']>
  specificationsSubwooferSpeakeraansluiting: Maybe<Scalars['String']>
  specificationsSubwooferStandaardmeegeleverd: Maybe<Scalars['String']>
  specificationsSubwooferStreaming: Maybe<Scalars['String']>
  specificationsSubwooferStreamingdiensten: Maybe<Scalars['String']>
  specificationsSubwooferStroomvoorziening: Maybe<Scalars['Int']>
  specificationsSubwooferSubwooferuitgang: Maybe<Scalars['Int']>
  specificationsSubwooferTypeaudio: Maybe<Scalars['Int']>
  specificationsSubwooferTypespeaker: Maybe<Scalars['String']>
  specificationsSubwooferVermogen: Maybe<Scalars['String']>
  specificationsSubwooferWaterbestendig: Maybe<Scalars['Int']>
  specificationsTelevisieAfmetingenexclvoet: Maybe<Scalars['String']>
  specificationsTelevisieAfmetingeninclvoet: Maybe<Scalars['String']>
  specificationsTelevisieAirplay: Maybe<Scalars['Int']>
  specificationsTelevisieAmbilight: Maybe<Scalars['Int']>
  specificationsTelevisieBeeldformaat: Maybe<Scalars['Int']>
  specificationsTelevisieBeeldfrequentie: Maybe<Scalars['Int']>
  specificationsTelevisieBluetooth: Maybe<Scalars['Int']>
  specificationsTelevisieCigeschikt: Maybe<Scalars['String']>
  specificationsTelevisieComponent: Maybe<Scalars['Int']>
  specificationsTelevisieComposiet: Maybe<Scalars['Int']>
  specificationsTelevisieDigitaalcoaxaleaansluiting: Maybe<Scalars['Int']>
  specificationsTelevisieDigitaaloptischeaansluiting: Maybe<Scalars['Int']>
  specificationsTelevisieEnergieklasse: Maybe<Scalars['Int']>
  specificationsTelevisieFabriekscode: Maybe<Scalars['String']>
  specificationsTelevisieGewichtexclvoet: Maybe<Scalars['String']>
  specificationsTelevisieGewichtinclvoet: Maybe<Scalars['String']>
  specificationsTelevisieHdmi: Maybe<Scalars['String']>
  specificationsTelevisieHdr: Maybe<Scalars['Int']>
  specificationsTelevisieIntroductiejaar: Maybe<Scalars['String']>
  specificationsTelevisieKleur: Maybe<Scalars['Int']>
  specificationsTelevisieKoptelefoon: Maybe<Scalars['Int']>
  specificationsTelevisieMeegeleverdeaccessoires: Maybe<Scalars['String']>
  specificationsTelevisieMerk: Maybe<Scalars['Int']>
  specificationsTelevisieResolutie: Maybe<Scalars['Int']>
  specificationsTelevisieScart: Maybe<Scalars['Int']>
  specificationsTelevisieSmartplatform: Maybe<Scalars['Int']>
  specificationsTelevisieSmarttv: Maybe<Scalars['Int']>
  specificationsTelevisieSoorttv: Maybe<Scalars['String']>
  specificationsTelevisieSpeakersysteem: Maybe<Scalars['String']>
  specificationsTelevisieSpotifyconnect: Maybe<Scalars['Int']>
  specificationsTelevisieSpraakbesturing: Maybe<Scalars['Int']>
  specificationsTelevisieSubwoofer: Maybe<Scalars['Int']>
  specificationsTelevisieTuner: Maybe<Scalars['String']>
  specificationsTelevisieTypehdr: Maybe<Scalars['String']>
  specificationsTelevisieUsb: Maybe<Scalars['String']>
  specificationsTelevisieVermogen: Maybe<Scalars['String']>
  specificationsTelevisieWifi: Maybe<Scalars['Int']>
  specificationsTvmeubelAfmetingen: Maybe<Scalars['String']>
  specificationsTvmeubelGewicht: Maybe<Scalars['String']>
  specificationsTvmeubelKleur: Maybe<Scalars['Int']>
  specificationsTvmeubelMateriaal: Maybe<Scalars['String']>
  specificationsTvmeubelTypeproduct: Maybe<Scalars['Int']>
  specificationsVersterkerAansluitingen: Maybe<Scalars['String']>
  specificationsVersterkerAantalhdmi: Maybe<Scalars['String']>
  specificationsVersterkerAantalusb: Maybe<Scalars['String']>
  specificationsVersterkerAchterspeakers: Maybe<Scalars['Int']>
  specificationsVersterkerAfmetingen: Maybe<Scalars['String']>
  specificationsVersterkerAfmetingensubwoofer: Maybe<Scalars['String']>
  specificationsVersterkerBelastbaarheid: Maybe<Scalars['String']>
  specificationsVersterkerFabriekscode: Maybe<Scalars['String']>
  specificationsVersterkerGewicht: Maybe<Scalars['String']>
  specificationsVersterkerGewichtsubwoofer: Maybe<Scalars['String']>
  specificationsVersterkerImpendatie: Maybe<Scalars['String']>
  specificationsVersterkerIntroductiejaar: Maybe<Scalars['String']>
  specificationsVersterkerKanalen: Maybe<Scalars['String']>
  specificationsVersterkerKleur: Maybe<Scalars['Int']>
  specificationsVersterkerMultiroom: Maybe<Scalars['Int']>
  specificationsVersterkerRadio: Maybe<Scalars['String']>
  specificationsVersterkerSpeakeraansluiting: Maybe<Scalars['String']>
  specificationsVersterkerSpeeltaf: Maybe<Scalars['String']>
  specificationsVersterkerStandaardmeegeleverd: Maybe<Scalars['String']>
  specificationsVersterkerStreaming: Maybe<Scalars['String']>
  specificationsVersterkerStreamingdiensten: Maybe<Scalars['String']>
  specificationsVersterkerStroomvoorziening: Maybe<Scalars['Int']>
  specificationsVersterkerSubwoofer: Maybe<Scalars['String']>
  specificationsVersterkerSubwooferuitgang: Maybe<Scalars['Int']>
  specificationsVersterkerTypeaudio: Maybe<Scalars['Int']>
  specificationsVersterkerVermogen: Maybe<Scalars['String']>
  specificationsVersterkerWaterbestendig: Maybe<Scalars['Int']>
  specificationsVloerstandaardAfmetingen: Maybe<Scalars['String']>
  specificationsVloerstandaardKleur: Maybe<Scalars['Int']>
  specificationsVloerstandaardProducttype: Maybe<Scalars['Int']>
  specificationsVoedingDraadloosopladen: Maybe<Scalars['Int']>
  specificationsVoedingKabellengte: Maybe<Scalars['String']>
  specificationsVoedingKleur: Maybe<Scalars['Int']>
  specificationsVoedingProducttype: Maybe<Scalars['Int']>
  specificationsWifispeakerAansluitingen: Maybe<Scalars['String']>
  specificationsWifispeakerAantalspeakers: Maybe<Scalars['String']>
  specificationsWifispeakerAantalusb: Maybe<Scalars['String']>
  specificationsWifispeakerAchterspeakers: Maybe<Scalars['Int']>
  specificationsWifispeakerAfmetingen: Maybe<Scalars['String']>
  specificationsWifispeakerAfmetingensubwoofer: Maybe<Scalars['String']>
  specificationsWifispeakerBelastbaarheid: Maybe<Scalars['String']>
  specificationsWifispeakerFabriekscode: Maybe<Scalars['String']>
  specificationsWifispeakerGewicht: Maybe<Scalars['String']>
  specificationsWifispeakerGewichtsubwoofer: Maybe<Scalars['String']>
  specificationsWifispeakerImpendatie: Maybe<Scalars['String']>
  specificationsWifispeakerIntroductiejaar: Maybe<Scalars['String']>
  specificationsWifispeakerKanalen: Maybe<Scalars['String']>
  specificationsWifispeakerKleur: Maybe<Scalars['Int']>
  specificationsWifispeakerMultiroom: Maybe<Scalars['Int']>
  specificationsWifispeakerRadio: Maybe<Scalars['String']>
  specificationsWifispeakerSpeeltaf: Maybe<Scalars['String']>
  specificationsWifispeakerStandaardmeegeleverd: Maybe<Scalars['String']>
  specificationsWifispeakerStreaming: Maybe<Scalars['String']>
  specificationsWifispeakerStreamingdiensten: Maybe<Scalars['String']>
  specificationsWifispeakerStroomvoorziening: Maybe<Scalars['String']>
  specificationsWifispeakerSubwoofer: Maybe<Scalars['String']>
  specificationsWifispeakerSubwooferuitgang: Maybe<Scalars['String']>
  specificationsWifispeakerTypeaudio: Maybe<Scalars['Int']>
  specificationsWifispeakerTypespeaker: Maybe<Scalars['Int']>
  specificationsWifispeakerVermogen: Maybe<Scalars['String']>
  specificationsWifispeakerWaterbestendig: Maybe<Scalars['Int']>
  /** Stock status of the product */
  stockStatus: Maybe<ProductStockStatus>
  strapBags: Maybe<Scalars['String']>
  styleBags: Maybe<Scalars['String']>
  styleBottom: Maybe<Scalars['String']>
  styleGeneral: Maybe<Scalars['String']>
  /** The file name of a swatch image */
  swatchImage: Maybe<Scalars['String']>
  tempcombipakketten: Maybe<Scalars['String']>
  /** The relative path to the product's thumbnail image. */
  thumbnail: Maybe<ProductImage>
  /**
   * The price when tier pricing is in effect and the items purchased threshold has been reached.
   * @deprecated Use price_tiers for product tier price information.
   */
  tierPrice: Maybe<Scalars['Float']>
  /**
   * An array of ProductTierPrices objects.
   * @deprecated Use price_tiers for product tier price information.
   */
  tierPrices: Maybe<Array<Maybe<ProductTierPrices>>>
  top10product: Maybe<Scalars['Int']>
  tot21u: Maybe<Scalars['Int']>
  tweakers: Maybe<Scalars['Int']>
  tweakerstekstad: Maybe<Scalars['String']>
  tweakwisecrossselltemplateid: Maybe<Scalars['String']>
  /**
   * One of simple, virtual, bundle, downloadable, grouped, or configurable.
   * @deprecated Use __typename instead.
   */
  typeId: Maybe<Scalars['String']>
  /** Timestamp indicating when the product was updated. */
  updatedAt: Maybe<Scalars['String']>
  /** Upsell Products */
  upsellProducts: Maybe<Array<Maybe<ProductInterface>>>
  /** The part of the URL that identifies the product */
  urlKey: Scalars['String']
  /** @deprecated Use product's `canonical_url` or url rewrites instead */
  urlPath: Maybe<Scalars['String']>
  /** URL rewrites list */
  urlRewrites: Maybe<Array<Maybe<UrlRewrite>>>
  /** The part of the product URL that is appended after the url key */
  urlSuffix: Maybe<Scalars['String']>
  variant: Maybe<Scalars['Int']>
  variantValue: Maybe<Scalars['String']>
  venditguid: Maybe<Scalars['String']>
  venditpid: Maybe<Scalars['String']>
  voorraadamsterdam: Maybe<Scalars['Int']>
  voorraadarnhem: Maybe<Scalars['Int']>
  voorraadbreda: Maybe<Scalars['Int']>
  voorraaddoetinchem: Maybe<Scalars['Int']>
  voorraadeindhoven: Maybe<Scalars['Int']>
  voorraadgroningen: Maybe<Scalars['Int']>
  voorraadnaarden: Maybe<Scalars['Int']>
  voorraadnijmegen: Maybe<Scalars['Int']>
  voorraadonline: Maybe<Scalars['Int']>
  voorraadutrecht: Maybe<Scalars['Int']>
  voorraadzoeterwoude: Maybe<Scalars['Int']>
  /**
   * An array of websites in which the product is available.
   * @deprecated The field should not be used on the storefront.
   */
  websites: Maybe<Array<Maybe<Website>>>
  zondaglevering: Maybe<Scalars['Int']>
  pimcoreProductData: Maybe<PimcoreProduct>
}

/** ProductLinks is an implementation of ProductLinksInterface. */
export interface ProductLinks extends ProductLinksInterface {
  __typename?: 'ProductLinks'
  /** One of related, associated, upsell, or crosssell. */
  linkType: Maybe<Scalars['String']>
  /** The SKU of the linked product. */
  linkedProductSku: Maybe<Scalars['String']>
  /** The type of linked product (simple, virtual, bundle, downloadable, grouped, configurable). */
  linkedProductType: Maybe<Scalars['String']>
  /** The position within the list of product links. */
  position: Maybe<Scalars['Int']>
  /** The identifier of the linked product. */
  sku: Maybe<Scalars['String']>
}

/** ProductLinks contains information about linked products, including the link type and product type of each item. */
export interface ProductLinksInterface {
  /** One of related, associated, upsell, or crosssell. */
  linkType: Maybe<Scalars['String']>
  /** The SKU of the linked product. */
  linkedProductSku: Maybe<Scalars['String']>
  /** The type of linked product (simple, virtual, bundle, downloadable, grouped, configurable). */
  linkedProductType: Maybe<Scalars['String']>
  /** The position within the list of product links. */
  position: Maybe<Scalars['Int']>
  /** The identifier of the linked product. */
  sku: Maybe<Scalars['String']>
}

/** ProductMediaGalleryEntriesContent contains an image in base64 format and basic information about the image. */
export interface ProductMediaGalleryEntriesContent {
  __typename?: 'ProductMediaGalleryEntriesContent'
  /** The image in base64 format. */
  base64EncodedData: Maybe<Scalars['String']>
  /** The file name of the image. */
  name: Maybe<Scalars['String']>
  /** The MIME type of the file, such as image/png. */
  type: Maybe<Scalars['String']>
}

/** ProductMediaGalleryEntriesVideoContent contains a link to a video file and basic information about the video. */
export interface ProductMediaGalleryEntriesVideoContent {
  __typename?: 'ProductMediaGalleryEntriesVideoContent'
  /** Must be external-video. */
  mediaType: Maybe<Scalars['String']>
  /** A description of the video. */
  videoDescription: Maybe<Scalars['String']>
  /** Optional data about the video. */
  videoMetadata: Maybe<Scalars['String']>
  /** Describes the video source. */
  videoProvider: Maybe<Scalars['String']>
  /** The title of the video. */
  videoTitle: Maybe<Scalars['String']>
  /** The URL to the video. */
  videoUrl: Maybe<Scalars['String']>
}

/** Represents a product price. */
export interface ProductPrice {
  __typename?: 'ProductPrice'
  /** The price discount. Represents the difference between the regular and final price. */
  discount: Maybe<ProductDiscount>
  /** The final price of the product after discounts applied. */
  finalPrice: Money
  /** The multiple FPTs that can be applied to a product price. */
  fixedProductTaxes: Maybe<Array<Maybe<FixedProductTax>>>
  /** The regular price of the product. */
  regularPrice: Money
}

/**
 * ProductPrices is deprecated, replaced by PriceRange. The ProductPrices object
 * contains the regular price of an item, as well as its minimum and maximum
 * prices. Only composite products, which include bundle, configurable, and grouped
 * products, can contain a minimum and maximum price.
 */
export interface ProductPrices {
  __typename?: 'ProductPrices'
  /**
   * The highest possible final price for all the options defined within a
   * composite product. If you are specifying a price range, this would be the to value.
   * @deprecated Use PriceRange.maximum_price.
   */
  maximalPrice: Maybe<Price>
  /**
   * The lowest possible final price for all the options defined within a composite
   * product. If you are specifying a price range, this would be the from value.
   * @deprecated Use PriceRange.minimum_price.
   */
  minimalPrice: Maybe<Price>
  /**
   * The base price of a product.
   * @deprecated Use regular_price from PriceRange.minimum_price or PriceRange.maximum_price.
   */
  regularPrice: Maybe<Price>
}

export interface ProductReviewRatingInput {
  /** Rating value id. */
  option_id: Scalars['String']
  /** Rating id. */
  rating_id: Scalars['String']
}

/** The Products object is the top-level object returned in a product search. */
export interface Products {
  __typename?: 'Products'
  /** Layered navigation aggregations. */
  aggregations: Maybe<Array<Maybe<Aggregation>>>
  /**
   * Layered navigation filters array.
   * @deprecated Use aggregations instead
   */
  filters: Maybe<Array<Maybe<LayerFilter>>>
  /** An array of products that match the specified search criteria. */
  items: Maybe<Array<Maybe<ProductInterface>>>
  /** An object that includes the page_info and currentPage values specified in the query. */
  pageInfo: Maybe<SearchResultPageInfo>
  /** An object that includes the default sort field and all available sort fields. */
  sortFields: Maybe<SortFields>
  /**
   * The number of products that are marked as visible. By default, in complex
   * products, parent products are visible, but their child products are not.
   */
  totalCount: Maybe<Scalars['Int']>
}

/**
 * ProductSortInput is deprecated, use @ProductAttributeSortInput instead.
 * ProductSortInput specifies the attribute to use for sorting search results and
 * indicates whether the results are sorted in ascending or descending order.
 */
export interface ProductSortInput {
  /** The product's country of origin. */
  country_of_manufacture?: Maybe<SortEnum>
  /** Timestamp indicating when the product was created. */
  created_at?: Maybe<SortEnum>
  /** The name of a custom layout. */
  custom_layout?: Maybe<SortEnum>
  /** XML code that is applied as a layout update to the product page. */
  custom_layout_update?: Maybe<SortEnum>
  /** Detailed information about the product. The value can include simple HTML tags. */
  description?: Maybe<SortEnum>
  /** Indicates whether a gift message is available. */
  gift_message_available?: Maybe<SortEnum>
  /** Indicates whether additional attributes have been created for the product. */
  has_options?: Maybe<SortEnum>
  /** The relative path to the main image on the product page. */
  image?: Maybe<SortEnum>
  /** The label assigned to a product image. */
  image_label?: Maybe<SortEnum>
  /** A number representing the product's manufacturer. */
  manufacturer?: Maybe<SortEnum>
  /** A brief overview of the product for search results listings, maximum 255 characters. */
  meta_description?: Maybe<SortEnum>
  /** A comma-separated list of keywords that are visible only to search engines. */
  meta_keyword?: Maybe<SortEnum>
  /** A string that is displayed in the title bar and tab of the browser and in search results lists. */
  meta_title?: Maybe<SortEnum>
  /** The product name. Customers use this name to identify the product. */
  name?: Maybe<SortEnum>
  /** The beginning date for new product listings, and determines if the product is featured as a new product. */
  news_from_date?: Maybe<SortEnum>
  /** The end date for new product listings. */
  news_to_date?: Maybe<SortEnum>
  /** If the product has multiple options, determines where they appear on the product page. */
  options_container?: Maybe<SortEnum>
  /** The price of the item. */
  price?: Maybe<SortEnum>
  /** Indicates whether the product has required options. */
  required_options?: Maybe<SortEnum>
  /** A short description of the product. Its use depends on the theme. */
  short_description?: Maybe<SortEnum>
  /** A number or code assigned to a product to identify the product, options, price, and manufacturer. */
  sku?: Maybe<SortEnum>
  /** The relative path to the small image, which is used on catalog pages. */
  small_image?: Maybe<SortEnum>
  /** The label assigned to a product's small image. */
  small_image_label?: Maybe<SortEnum>
  /** The beginning date that a product has a special price. */
  special_from_date?: Maybe<SortEnum>
  /** The discounted price of the product. */
  special_price?: Maybe<SortEnum>
  /** The end date that a product has a special price. */
  special_to_date?: Maybe<SortEnum>
  /** The file name of a swatch image */
  swatch_image?: Maybe<SortEnum>
  /** The relative path to the product's thumbnail image. */
  thumbnail?: Maybe<SortEnum>
  /** The label assigned to a product's thumbnail image. */
  thumbnail_label?: Maybe<SortEnum>
  /** The price when tier pricing is in effect and the items purchased threshold has been reached. */
  tier_price?: Maybe<SortEnum>
  /** Timestamp indicating when the product was updated. */
  updated_at?: Maybe<SortEnum>
  /** The part of the URL that identifies the product */
  url_key?: Maybe<SortEnum>
  url_path?: Maybe<SortEnum>
  /** The weight of the item, in units defined by the store. */
  weight?: Maybe<SortEnum>
}

/** This enumeration states whether a product stock status is in stock or out of stock */
export enum ProductStockStatus {
  IN_STOCK = 'IN_STOCK',
  OUT_OF_STOCK = 'OUT_OF_STOCK',
}

/**
 * ProductTierPrices is deprecated and has been replaced by TierPrice. The
 * ProductTierPrices object defines a tier price, which is a quantity discount
 * offered to a specific customer group.
 */
export interface ProductTierPrices {
  __typename?: 'ProductTierPrices'
  /**
   * The ID of the customer group.
   * @deprecated customer_group_id is not relevant for storefront.
   */
  customerGroupId: Maybe<Scalars['String']>
  /**
   * The percentage discount of the item.
   * @deprecated ProductTierPrices is deprecated. Use TierPrice.discount.
   */
  percentageValue: Maybe<Scalars['Float']>
  /**
   * The number of items that must be purchased to qualify for tier pricing.
   * @deprecated ProductTierPrices is deprecated, use TierPrice.quantity.
   */
  qty: Maybe<Scalars['Float']>
  /**
   * The price of the fixed price item.
   * @deprecated ProductTierPrices is deprecated. Use TierPrice.final_price
   */
  value: Maybe<Scalars['Float']>
  /**
   * The ID assigned to the website.
   * @deprecated website_id is not relevant for storefront.
   */
  websiteId: Maybe<Scalars['Float']>
}

/** Contains information about a product video. */
export interface ProductVideo extends MediaGalleryInterface {
  __typename?: 'ProductVideo'
  /** Whether the image is hidden from view. */
  disabled: Maybe<Scalars['Boolean']>
  /** The label of the product image or video. */
  label: Maybe<Scalars['String']>
  /** The media item's position after it has been sorted. */
  position: Maybe<Scalars['Int']>
  /** The URL of the product image or video. */
  url: Maybe<Scalars['String']>
  /** Contains a ProductMediaGalleryEntriesVideoContent object. */
  videoContent: Maybe<ProductMediaGalleryEntriesVideoContent>
}

export interface Promotion extends Document, Linkable {
  __typename?: 'Promotion'
  body: Maybe<Array<PromotionBody>>
  meta: Meta
  linkType: Maybe<Scalars['String']>
}

export type PromotionBody = PromotionBodyPromotionBanner

export interface PromotionBodyPromotionBanner {
  __typename?: 'PromotionBodyPromotionBanner'
  type: Maybe<Scalars['String']>
  label: Maybe<Scalars['String']>
  primary: Maybe<PromotionBodyPromotionBannerPrimary>
}

export interface PromotionBodyPromotionBannerPrimary {
  __typename?: 'PromotionBodyPromotionBannerPrimary'
  title: Maybe<Scalars['Json']>
  contentBlockTitle: Maybe<Scalars['Json']>
  text: Maybe<Scalars['Json']>
  backgroundImage: Maybe<Scalars['Json']>
  backgroundImageMobile: Maybe<Scalars['Json']>
}

/** A connection to a list of items. */
export interface PromotionConnectionConnection {
  __typename?: 'PromotionConnectionConnection'
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  /** A list of edges. */
  edges: Maybe<Array<Maybe<PromotionConnectionEdge>>>
  totalCount: Scalars['Long']
}

/** An edge in a connection. */
export interface PromotionConnectionEdge {
  __typename?: 'PromotionConnectionEdge'
  /** The item at the end of the edge. */
  node: Promotion
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
}

export interface Query {
  __typename?: 'Query'
  advreview: Maybe<ReviewsData>
  amReviewSetting: Maybe<AmReviewSetting>
  amReviewWidget: Maybe<AmReviewWidget>
  /** Returns information about shopping cart */
  cart: Maybe<Cart>
  categories: Maybe<CategoryResult>
  /**
   * The category query searches for categories that match the criteria specified in the search and filter attributes.
   * @deprecated Use 'categoryList' query instead of 'category' query
   */
  category: Maybe<CategoryTree>
  /** Returns an array of categories based on the specified filters. */
  categoryList: Maybe<Array<Maybe<CategoryTree>>>
  /** The Checkout Agreements information */
  checkoutAgreements: Maybe<Array<Maybe<CheckoutAgreement>>>
  /** The CMS block query returns information about CMS blocks */
  cmsBlocks: Maybe<CmsBlocks>
  /** The CMS page query returns information about a CMS page */
  cmsPage: Maybe<CmsPage>
  /** The countries query provides information for all countries. */
  countries: Maybe<Array<Maybe<Country>>>
  /** The countries query provides information for a single country. */
  country: Maybe<Country>
  /** The currency query returns information about store currency. */
  currency: Maybe<Currency>
  /** The customAttributeMetadata query returns the attribute type, given an attribute code and entity type */
  customAttributeMetadata: Maybe<CustomAttributeMetadata>
  /** The customer query returns information about a customer account */
  customer: Maybe<Customer>
  /** Returns information about the customer shopping cart */
  customerCart: Cart
  /** Get list of customer orders */
  customerOrders: Maybe<CustomerOrderResult>
  isEmailAvailable: Maybe<IsEmailAvailableOutput>
  order: Maybe<CustomerOrder>
  /** The pickup locations query searches for locations that match the search request requirements. */
  pickupLocations: Maybe<PickupLocations>
  product: Maybe<ProductInterface>
  /** The products query searches for products that match the criteria specified in the search and filter attributes. */
  products: Maybe<Products>
  /** The store config query */
  storeConfig: Maybe<StoreConfig>
  /**
   * The urlResolver query returns the relative URL for a specified product,
   * category or CMS page, using as input a url_key appended by the url_suffix, if one exists
   */
  urlResolver: Maybe<EntityUrl>
  /**
   * The wishlist query returns the contents of a customer's wish list
   * @deprecated Moved under `Customer` `wishlist`
   */
  wishlist: Maybe<WishlistOutput>
  tweakwiseNavigation: TweakwiseNavigationResult
  /**
   * Returns featured recommended products, to use for example on a homepage.
   *
   * Will return `null` when the template could not be found.
   */
  tweakwiseRecommendationsFeatured: Maybe<Array<TweakwiseNavigationItem>>
  /**
   * Service that returns all available templates for a product. Each template will contain all items matching the template.
   *
   * If a lot of rules have been set up, it is not efficient to request all rules
   * for all products. With these web services, all products of a product can be
   * retrieved in one go for all rules.
   *
   * Will return `null` when the product could not be found in the Tweakwise store.
   */
  tweakwiseRecommendationsProductTemplates: Maybe<
    Array<TweakwiseProductRecommendationsTemplate>
  >
  /**
   * Returns recommended products for a product, such as for cross sell or up sell.
   *
   * Will return `null` when the template could not be found.
   */
  tweakwiseRecommendationsProduct: Maybe<Array<TweakwiseNavigationItem>>
  /**
   * Service that returns product results and search suggestions based on a search
   * term. This service can be called as soon as the user begins to type a search term.
   */
  tweakwiseAutocomplete: TweakwiseAutocompleteResult
  allDocuments: DocumentConnection
  allTests: TestConnectionConnection
  allPages: PageConnectionConnection
  allReviewModals: ReviewModalConnectionConnection
  allStores: StoreConnectionConnection
  allMains: MainConnectionConnection
  specification: Maybe<Specification>
  allSpecifications: SpecificationConnectionConnection
  allFaqcategorys: FaqcategoryConnectionConnection
  promotion: Maybe<Promotion>
  allPromotions: PromotionConnectionConnection
  spec: Maybe<Spec>
  allSpecs: SpecConnectionConnection
  allCategorys: CategoryConnectionConnection
  allProducts: ProductConnectionConnection
  allFaqsubjects: FaqsubjectConnectionConnection
  form: Maybe<Form>
  allForms: FormConnectionConnection
  prismicResolvedPreviewUrl: Maybe<Scalars['String']>
  prismicDocument: Maybe<PrismicDocument>
  prismicDocuments: Maybe<Array<PrismicDocument>>
  /**
   * Get an address based on its unique combination of postcode, house number and
   * house number addition.
   *
   * Coordinate and surfaceArea values are null values if no location is known,
   * i.e. if the address is a PO Box.
   *
   * You must always check the houseNumberAddition result field, as a successful
   * response is also returned if only the input addition isn't found.
   */
  address: Maybe<PostcodeNlAddress>
  googleMapsGeocode: Maybe<Array<Maybe<GoogleMapsGeocodeResult>>>
  googleMapsReverseGeocode: Maybe<Array<Maybe<GoogleMapsGeocodeResult>>>
  googleTravelDistance: Maybe<Array<Maybe<GoogleMapsTravelDistance>>>
  googleTravelDistances: Maybe<Array<Maybe<GoogleMapsDistanceDestination>>>
  googleLocation: Maybe<GoogleLocationInfo>
  googleLocations: Maybe<Array<GoogleLocationInfo>>
  googleLocationMedia: Maybe<GoogleLocationMedia>
  googleAccounts: Maybe<Array<GoogleAccount>>
  getAsset: Maybe<PimcoreAsset>
  getProductListing: Maybe<PimcoreProductConnection>
  pimcoreProductById: Maybe<PimcoreProduct>
  getPrismicSliceListing: Maybe<PimcorePrismicSliceConnection>
  getPrismicSlice: Maybe<PimcoreObjectPrismicSlice>
  getProductButtonListing: Maybe<PimcoreProductButtonConnection>
  getProductButton: Maybe<PimcoreObjectProductButton>
  getCategorieenListing: Maybe<PimcoreCategorieenConnection>
  pimcoreCategoryById: Maybe<PimcoreCategory>
  getBuitenkansjesListing: Maybe<PimcoreBuitenkansjesConnection>
  getBuitenkansjes: Maybe<PimcoreObjectBuitenkansjes>
  getPromotionListing: Maybe<PimcorePromotionConnection>
  getPromotion: Maybe<PimcoreObjectPromotion>
  getSpecialistListing: Maybe<PimcoreSpecialistConnection>
  getSpecialist: Maybe<PimcoreObjectSpecialist>
  getProductAddonListing: Maybe<PimcoreProductAddonConnection>
  getProductAddon: Maybe<PimcoreObjectProductAddon>
  getConfigurationListing: Maybe<PimcoreConfigurationConnection>
  getConfiguration: Maybe<PimcoreObjectConfiguration>
  getCombiDealListing: Maybe<PimcoreCombiDealConnection>
  getCombiDeal: Maybe<PimcoreObjectCombiDeal>
  getRelatedCategoriesListing: Maybe<PimcoreRelatedCategoriesConnection>
  getRelatedCategories: Maybe<PimcoreObjectRelatedCategories>
  getDeliverytimesListing: Maybe<PimcoreDeliverytimesConnection>
  getDeliverytimes: Maybe<PimcoreObjectDeliverytimes>
  getAssetListing: Maybe<PimcoreAssetConnection>
  getAssetFolder: Maybe<PimcoreAssetFolder>
  getObjectFolder: Maybe<PimcoreObjectFolder>
  /** Get the nearest PostNL locations by the provided address */
  nearestPostNLLocations: PostNlLocationResponse
  /** Get all available delivery timeframes by the provided address */
  postNLDeliveryTimeframes: PostNlDeliveryTimeframeResponse
  /** Get the Trustpilot score. The score is cached for 15 minutes. */
  trustpilot: Maybe<Trustpilot>
}

export interface QueryAdvreviewArgs {
  productId: Scalars['Int']
  page: Scalars['Int']
  amreviewDir?: Maybe<Scalars['String']>
  amreviewSort?: Maybe<Scalars['String']>
  stars?: Maybe<Scalars['Int']>
  withImages?: Maybe<Scalars['Boolean']>
  verifiedBuyer?: Maybe<Scalars['Boolean']>
  isRecommended?: Maybe<Scalars['Boolean']>
}

export interface QueryAmReviewWidgetArgs {
  widgetId: Scalars['Int']
  categoryId?: Maybe<Scalars['Int']>
  productId?: Maybe<Scalars['Int']>
}

export interface QueryCartArgs {
  cart_id: Scalars['String']
}

export interface QueryCategoriesArgs {
  filters?: Maybe<CategoryFilterInput>
  pageSize?: Maybe<Scalars['Int']>
  currentPage?: Maybe<Scalars['Int']>
}

export interface QueryCategoryArgs {
  id?: Maybe<Scalars['Int']>
}

export interface QueryCategoryListArgs {
  filters?: Maybe<CategoryFilterInput>
}

export interface QueryCmsBlocksArgs {
  identifiers?: Maybe<Array<Maybe<Scalars['String']>>>
}

export interface QueryCmsPageArgs {
  id?: Maybe<Scalars['Int']>
  identifier?: Maybe<Scalars['String']>
}

export interface QueryCountryArgs {
  id?: Maybe<Scalars['String']>
}

export interface QueryCustomAttributeMetadataArgs {
  attributes: Array<AttributeInput>
}

export interface QueryCustomerOrdersArgs {
  id?: Maybe<Scalars['Int']>
  pageSize?: Maybe<Scalars['Int']>
  currentPage?: Maybe<Scalars['Int']>
}

export interface QueryIsEmailAvailableArgs {
  email: Scalars['String']
}

export interface QueryOrderArgs {
  orderMaskId: Scalars['String']
}

export interface QueryPickupLocationsArgs {
  area?: Maybe<AreaInput>
  filters?: Maybe<PickupLocationFilterInput>
  sort?: Maybe<PickupLocationSortInput>
  pageSize?: Maybe<Scalars['Int']>
  currentPage?: Maybe<Scalars['Int']>
}

export interface QueryProductArgs {
  id: Scalars['Int']
}

export interface QueryProductsArgs {
  search?: Maybe<Scalars['String']>
  filter?: Maybe<ProductAttributeFilterInput>
  pageSize?: Maybe<Scalars['Int']>
  currentPage?: Maybe<Scalars['Int']>
  sort?: Maybe<ProductAttributeSortInput>
}

export interface QueryUrlResolverArgs {
  url: Scalars['String']
}

export interface QueryTweakwiseNavigationArgs {
  params?: Maybe<TweakwiseNavigationParams>
}

export interface QueryTweakwiseRecommendationsFeaturedArgs {
  templateId: Scalars['ID']
  params?: Maybe<TweakwiseRecommendationsFeaturedParams>
}

export interface QueryTweakwiseRecommendationsProductTemplatesArgs {
  itemNo: Scalars['ID']
  params?: Maybe<TweakwiseRecommendationsFeaturedParams>
}

export interface QueryTweakwiseRecommendationsProductArgs {
  itemNo: Scalars['ID']
  templateId: Scalars['ID']
  params?: Maybe<TweakwiseRecommendationsFeaturedParams>
}

export interface QueryTweakwiseAutocompleteArgs {
  query: Scalars['String']
  params?: Maybe<TweakwiseAutocompleteParams>
}

export interface QueryAllDocumentsArgs {
  sortBy?: Maybe<SortDocumentsBy>
  type?: Maybe<Scalars['String']>
  type_in?: Maybe<Array<Scalars['String']>>
  id?: Maybe<Scalars['String']>
  id_in?: Maybe<Array<Scalars['String']>>
  lang?: Maybe<Scalars['String']>
  tags?: Maybe<Array<Scalars['String']>>
  tags_in?: Maybe<Array<Scalars['String']>>
  firstPublicationDate?: Maybe<Scalars['DateTime']>
  firstPublicationDate_after?: Maybe<Scalars['DateTime']>
  firstPublicationDate_before?: Maybe<Scalars['DateTime']>
  lastPublicationDate?: Maybe<Scalars['DateTime']>
  lastPublicationDate_after?: Maybe<Scalars['DateTime']>
  lastPublicationDate_before?: Maybe<Scalars['DateTime']>
  fulltext?: Maybe<Scalars['String']>
  similar?: Maybe<Similar>
  before?: Maybe<Scalars['String']>
  after?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
}

export interface QueryAllTestsArgs {
  sortBy?: Maybe<SortTesty>
  uid?: Maybe<Scalars['String']>
  uid_in?: Maybe<Array<Scalars['String']>>
  id?: Maybe<Scalars['String']>
  id_in?: Maybe<Array<Scalars['String']>>
  lang?: Maybe<Scalars['String']>
  tags?: Maybe<Array<Scalars['String']>>
  tags_in?: Maybe<Array<Scalars['String']>>
  firstPublicationDate?: Maybe<Scalars['DateTime']>
  firstPublicationDate_after?: Maybe<Scalars['DateTime']>
  firstPublicationDate_before?: Maybe<Scalars['DateTime']>
  lastPublicationDate?: Maybe<Scalars['DateTime']>
  lastPublicationDate_after?: Maybe<Scalars['DateTime']>
  lastPublicationDate_before?: Maybe<Scalars['DateTime']>
  fulltext?: Maybe<Scalars['String']>
  similar?: Maybe<Similar>
  before?: Maybe<Scalars['String']>
  after?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
}

export interface QueryAllPagesArgs {
  sortBy?: Maybe<SortPagey>
  uid?: Maybe<Scalars['String']>
  uid_in?: Maybe<Array<Scalars['String']>>
  id?: Maybe<Scalars['String']>
  id_in?: Maybe<Array<Scalars['String']>>
  lang?: Maybe<Scalars['String']>
  tags?: Maybe<Array<Scalars['String']>>
  tags_in?: Maybe<Array<Scalars['String']>>
  firstPublicationDate?: Maybe<Scalars['DateTime']>
  firstPublicationDate_after?: Maybe<Scalars['DateTime']>
  firstPublicationDate_before?: Maybe<Scalars['DateTime']>
  lastPublicationDate?: Maybe<Scalars['DateTime']>
  lastPublicationDate_after?: Maybe<Scalars['DateTime']>
  lastPublicationDate_before?: Maybe<Scalars['DateTime']>
  fulltext?: Maybe<Scalars['String']>
  similar?: Maybe<Similar>
  where?: Maybe<WherePage>
  before?: Maybe<Scalars['String']>
  after?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
}

export interface QueryAllReviewModalsArgs {
  sortBy?: Maybe<SortReviewModaly>
  uid?: Maybe<Scalars['String']>
  uid_in?: Maybe<Array<Scalars['String']>>
  id?: Maybe<Scalars['String']>
  id_in?: Maybe<Array<Scalars['String']>>
  lang?: Maybe<Scalars['String']>
  tags?: Maybe<Array<Scalars['String']>>
  tags_in?: Maybe<Array<Scalars['String']>>
  firstPublicationDate?: Maybe<Scalars['DateTime']>
  firstPublicationDate_after?: Maybe<Scalars['DateTime']>
  firstPublicationDate_before?: Maybe<Scalars['DateTime']>
  lastPublicationDate?: Maybe<Scalars['DateTime']>
  lastPublicationDate_after?: Maybe<Scalars['DateTime']>
  lastPublicationDate_before?: Maybe<Scalars['DateTime']>
  fulltext?: Maybe<Scalars['String']>
  similar?: Maybe<Similar>
  where?: Maybe<WhereReviewModal>
  before?: Maybe<Scalars['String']>
  after?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
}

export interface QueryAllStoresArgs {
  sortBy?: Maybe<SortStorey>
  uid?: Maybe<Scalars['String']>
  uid_in?: Maybe<Array<Scalars['String']>>
  id?: Maybe<Scalars['String']>
  id_in?: Maybe<Array<Scalars['String']>>
  lang?: Maybe<Scalars['String']>
  tags?: Maybe<Array<Scalars['String']>>
  tags_in?: Maybe<Array<Scalars['String']>>
  firstPublicationDate?: Maybe<Scalars['DateTime']>
  firstPublicationDate_after?: Maybe<Scalars['DateTime']>
  firstPublicationDate_before?: Maybe<Scalars['DateTime']>
  lastPublicationDate?: Maybe<Scalars['DateTime']>
  lastPublicationDate_after?: Maybe<Scalars['DateTime']>
  lastPublicationDate_before?: Maybe<Scalars['DateTime']>
  fulltext?: Maybe<Scalars['String']>
  similar?: Maybe<Similar>
  where?: Maybe<WhereStore>
  before?: Maybe<Scalars['String']>
  after?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
}

export interface QueryAllMainsArgs {
  sortBy?: Maybe<SortMainy>
  uid?: Maybe<Scalars['String']>
  uid_in?: Maybe<Array<Scalars['String']>>
  id?: Maybe<Scalars['String']>
  id_in?: Maybe<Array<Scalars['String']>>
  lang?: Maybe<Scalars['String']>
  tags?: Maybe<Array<Scalars['String']>>
  tags_in?: Maybe<Array<Scalars['String']>>
  firstPublicationDate?: Maybe<Scalars['DateTime']>
  firstPublicationDate_after?: Maybe<Scalars['DateTime']>
  firstPublicationDate_before?: Maybe<Scalars['DateTime']>
  lastPublicationDate?: Maybe<Scalars['DateTime']>
  lastPublicationDate_after?: Maybe<Scalars['DateTime']>
  lastPublicationDate_before?: Maybe<Scalars['DateTime']>
  fulltext?: Maybe<Scalars['String']>
  similar?: Maybe<Similar>
  before?: Maybe<Scalars['String']>
  after?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
}

export interface QuerySpecificationArgs {
  uid: Scalars['String']
  lang: Scalars['String']
}

export interface QueryAllSpecificationsArgs {
  sortBy?: Maybe<SortSpecificationy>
  uid?: Maybe<Scalars['String']>
  uid_in?: Maybe<Array<Scalars['String']>>
  id?: Maybe<Scalars['String']>
  id_in?: Maybe<Array<Scalars['String']>>
  lang?: Maybe<Scalars['String']>
  tags?: Maybe<Array<Scalars['String']>>
  tags_in?: Maybe<Array<Scalars['String']>>
  firstPublicationDate?: Maybe<Scalars['DateTime']>
  firstPublicationDate_after?: Maybe<Scalars['DateTime']>
  firstPublicationDate_before?: Maybe<Scalars['DateTime']>
  lastPublicationDate?: Maybe<Scalars['DateTime']>
  lastPublicationDate_after?: Maybe<Scalars['DateTime']>
  lastPublicationDate_before?: Maybe<Scalars['DateTime']>
  fulltext?: Maybe<Scalars['String']>
  similar?: Maybe<Similar>
  where?: Maybe<WhereSpecification>
  before?: Maybe<Scalars['String']>
  after?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
}

export interface QueryAllFaqcategorysArgs {
  sortBy?: Maybe<SortFaqcategoryy>
  uid?: Maybe<Scalars['String']>
  uid_in?: Maybe<Array<Scalars['String']>>
  id?: Maybe<Scalars['String']>
  id_in?: Maybe<Array<Scalars['String']>>
  lang?: Maybe<Scalars['String']>
  tags?: Maybe<Array<Scalars['String']>>
  tags_in?: Maybe<Array<Scalars['String']>>
  firstPublicationDate?: Maybe<Scalars['DateTime']>
  firstPublicationDate_after?: Maybe<Scalars['DateTime']>
  firstPublicationDate_before?: Maybe<Scalars['DateTime']>
  lastPublicationDate?: Maybe<Scalars['DateTime']>
  lastPublicationDate_after?: Maybe<Scalars['DateTime']>
  lastPublicationDate_before?: Maybe<Scalars['DateTime']>
  fulltext?: Maybe<Scalars['String']>
  similar?: Maybe<Similar>
  where?: Maybe<WhereFaqcategory>
  before?: Maybe<Scalars['String']>
  after?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
}

export interface QueryPromotionArgs {
  uid: Scalars['String']
  lang: Scalars['String']
}

export interface QueryAllPromotionsArgs {
  sortBy?: Maybe<SortPromotiony>
  uid?: Maybe<Scalars['String']>
  uid_in?: Maybe<Array<Scalars['String']>>
  id?: Maybe<Scalars['String']>
  id_in?: Maybe<Array<Scalars['String']>>
  lang?: Maybe<Scalars['String']>
  tags?: Maybe<Array<Scalars['String']>>
  tags_in?: Maybe<Array<Scalars['String']>>
  firstPublicationDate?: Maybe<Scalars['DateTime']>
  firstPublicationDate_after?: Maybe<Scalars['DateTime']>
  firstPublicationDate_before?: Maybe<Scalars['DateTime']>
  lastPublicationDate?: Maybe<Scalars['DateTime']>
  lastPublicationDate_after?: Maybe<Scalars['DateTime']>
  lastPublicationDate_before?: Maybe<Scalars['DateTime']>
  fulltext?: Maybe<Scalars['String']>
  similar?: Maybe<Similar>
  before?: Maybe<Scalars['String']>
  after?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
}

export interface QuerySpecArgs {
  uid: Scalars['String']
  lang: Scalars['String']
}

export interface QueryAllSpecsArgs {
  sortBy?: Maybe<SortSpecy>
  uid?: Maybe<Scalars['String']>
  uid_in?: Maybe<Array<Scalars['String']>>
  id?: Maybe<Scalars['String']>
  id_in?: Maybe<Array<Scalars['String']>>
  lang?: Maybe<Scalars['String']>
  tags?: Maybe<Array<Scalars['String']>>
  tags_in?: Maybe<Array<Scalars['String']>>
  firstPublicationDate?: Maybe<Scalars['DateTime']>
  firstPublicationDate_after?: Maybe<Scalars['DateTime']>
  firstPublicationDate_before?: Maybe<Scalars['DateTime']>
  lastPublicationDate?: Maybe<Scalars['DateTime']>
  lastPublicationDate_after?: Maybe<Scalars['DateTime']>
  lastPublicationDate_before?: Maybe<Scalars['DateTime']>
  fulltext?: Maybe<Scalars['String']>
  similar?: Maybe<Similar>
  where?: Maybe<WhereSpec>
  before?: Maybe<Scalars['String']>
  after?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
}

export interface QueryAllCategorysArgs {
  sortBy?: Maybe<SortCategoryy>
  uid?: Maybe<Scalars['String']>
  uid_in?: Maybe<Array<Scalars['String']>>
  id?: Maybe<Scalars['String']>
  id_in?: Maybe<Array<Scalars['String']>>
  lang?: Maybe<Scalars['String']>
  tags?: Maybe<Array<Scalars['String']>>
  tags_in?: Maybe<Array<Scalars['String']>>
  firstPublicationDate?: Maybe<Scalars['DateTime']>
  firstPublicationDate_after?: Maybe<Scalars['DateTime']>
  firstPublicationDate_before?: Maybe<Scalars['DateTime']>
  lastPublicationDate?: Maybe<Scalars['DateTime']>
  lastPublicationDate_after?: Maybe<Scalars['DateTime']>
  lastPublicationDate_before?: Maybe<Scalars['DateTime']>
  fulltext?: Maybe<Scalars['String']>
  similar?: Maybe<Similar>
  where?: Maybe<WhereCategory>
  before?: Maybe<Scalars['String']>
  after?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
}

export interface QueryAllProductsArgs {
  sortBy?: Maybe<SortProducty>
  uid?: Maybe<Scalars['String']>
  uid_in?: Maybe<Array<Scalars['String']>>
  id?: Maybe<Scalars['String']>
  id_in?: Maybe<Array<Scalars['String']>>
  lang?: Maybe<Scalars['String']>
  tags?: Maybe<Array<Scalars['String']>>
  tags_in?: Maybe<Array<Scalars['String']>>
  firstPublicationDate?: Maybe<Scalars['DateTime']>
  firstPublicationDate_after?: Maybe<Scalars['DateTime']>
  firstPublicationDate_before?: Maybe<Scalars['DateTime']>
  lastPublicationDate?: Maybe<Scalars['DateTime']>
  lastPublicationDate_after?: Maybe<Scalars['DateTime']>
  lastPublicationDate_before?: Maybe<Scalars['DateTime']>
  fulltext?: Maybe<Scalars['String']>
  similar?: Maybe<Similar>
  where?: Maybe<WhereProduct>
  before?: Maybe<Scalars['String']>
  after?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
}

export interface QueryAllFaqsubjectsArgs {
  sortBy?: Maybe<SortFaqsubjecty>
  uid?: Maybe<Scalars['String']>
  uid_in?: Maybe<Array<Scalars['String']>>
  id?: Maybe<Scalars['String']>
  id_in?: Maybe<Array<Scalars['String']>>
  lang?: Maybe<Scalars['String']>
  tags?: Maybe<Array<Scalars['String']>>
  tags_in?: Maybe<Array<Scalars['String']>>
  firstPublicationDate?: Maybe<Scalars['DateTime']>
  firstPublicationDate_after?: Maybe<Scalars['DateTime']>
  firstPublicationDate_before?: Maybe<Scalars['DateTime']>
  lastPublicationDate?: Maybe<Scalars['DateTime']>
  lastPublicationDate_after?: Maybe<Scalars['DateTime']>
  lastPublicationDate_before?: Maybe<Scalars['DateTime']>
  fulltext?: Maybe<Scalars['String']>
  similar?: Maybe<Similar>
  where?: Maybe<WhereFaqsubject>
  before?: Maybe<Scalars['String']>
  after?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
}

export interface QueryFormArgs {
  uid: Scalars['String']
  lang: Scalars['String']
}

export interface QueryAllFormsArgs {
  sortBy?: Maybe<SortFormy>
  uid?: Maybe<Scalars['String']>
  uid_in?: Maybe<Array<Scalars['String']>>
  id?: Maybe<Scalars['String']>
  id_in?: Maybe<Array<Scalars['String']>>
  lang?: Maybe<Scalars['String']>
  tags?: Maybe<Array<Scalars['String']>>
  tags_in?: Maybe<Array<Scalars['String']>>
  firstPublicationDate?: Maybe<Scalars['DateTime']>
  firstPublicationDate_after?: Maybe<Scalars['DateTime']>
  firstPublicationDate_before?: Maybe<Scalars['DateTime']>
  lastPublicationDate?: Maybe<Scalars['DateTime']>
  lastPublicationDate_after?: Maybe<Scalars['DateTime']>
  lastPublicationDate_before?: Maybe<Scalars['DateTime']>
  fulltext?: Maybe<Scalars['String']>
  similar?: Maybe<Similar>
  where?: Maybe<WhereForm>
  before?: Maybe<Scalars['String']>
  after?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
}

export interface QueryPrismicResolvedPreviewUrlArgs {
  documentId: Scalars['String']
}

export interface QueryPrismicDocumentArgs {
  storeView?: Maybe<Scalars['String']>
  predicate: PrismicPredicateOneValue
  lang: Scalars['String']
  ref?: Maybe<Scalars['String']>
}

export interface QueryPrismicDocumentsArgs {
  storeView?: Maybe<Scalars['String']>
  predicate: PrismicPredicateManyValues
  lang: Scalars['String']
  ref?: Maybe<Scalars['String']>
}

export interface QueryAddressArgs {
  postcode: Scalars['String']
  houseNumber: Scalars['Int']
  houseNumberAddition?: Maybe<Scalars['String']>
}

export interface QueryGoogleMapsGeocodeArgs {
  search: Scalars['String']
}

export interface QueryGoogleMapsReverseGeocodeArgs {
  coordinates: GoogleMapsGeocodeLocationInput
}

export interface QueryGoogleTravelDistanceArgs {
  from: GoogleMapsGeocodeLocationInput
  to: GoogleMapsGeocodeLocationInput
}

export interface QueryGoogleTravelDistancesArgs {
  input: GoogleMapsDistanceDestinationsInput
}

export interface QueryGoogleLocationArgs {
  name: Scalars['ID']
}

export interface QueryGoogleLocationMediaArgs {
  name: Scalars['ID']
}

export interface QueryGetAssetArgs {
  id: Scalars['Int']
  defaultLanguage?: Maybe<Scalars['String']>
}

export interface QueryGetProductListingArgs {
  ids?: Maybe<Scalars['String']>
  defaultLanguage?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  after?: Maybe<Scalars['Int']>
  sortBy?: Maybe<Array<Maybe<Scalars['String']>>>
  sortOrder?: Maybe<Array<Maybe<Scalars['String']>>>
  filter?: Maybe<Scalars['String']>
  published?: Maybe<Scalars['Boolean']>
}

export interface QueryPimcoreProductByIdArgs {
  id: Scalars['Int']
  defaultLanguage?: Maybe<Scalars['String']>
}

export interface QueryGetPrismicSliceListingArgs {
  ids?: Maybe<Scalars['String']>
  defaultLanguage?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  after?: Maybe<Scalars['Int']>
  sortBy?: Maybe<Array<Maybe<Scalars['String']>>>
  sortOrder?: Maybe<Array<Maybe<Scalars['String']>>>
  filter?: Maybe<Scalars['String']>
  published?: Maybe<Scalars['Boolean']>
}

export interface QueryGetPrismicSliceArgs {
  id: Scalars['Int']
  defaultLanguage?: Maybe<Scalars['String']>
}

export interface QueryGetProductButtonListingArgs {
  ids?: Maybe<Scalars['String']>
  defaultLanguage?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  after?: Maybe<Scalars['Int']>
  sortBy?: Maybe<Array<Maybe<Scalars['String']>>>
  sortOrder?: Maybe<Array<Maybe<Scalars['String']>>>
  filter?: Maybe<Scalars['String']>
  published?: Maybe<Scalars['Boolean']>
}

export interface QueryGetProductButtonArgs {
  id: Scalars['Int']
  defaultLanguage?: Maybe<Scalars['String']>
}

export interface QueryGetCategorieenListingArgs {
  ids?: Maybe<Scalars['String']>
  defaultLanguage?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  after?: Maybe<Scalars['Int']>
  sortBy?: Maybe<Array<Maybe<Scalars['String']>>>
  sortOrder?: Maybe<Array<Maybe<Scalars['String']>>>
  filter?: Maybe<Scalars['String']>
  published?: Maybe<Scalars['Boolean']>
}

export interface QueryPimcoreCategoryByIdArgs {
  id: Scalars['Int']
  defaultLanguage?: Maybe<Scalars['String']>
}

export interface QueryGetBuitenkansjesListingArgs {
  ids?: Maybe<Scalars['String']>
  defaultLanguage?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  after?: Maybe<Scalars['Int']>
  sortBy?: Maybe<Array<Maybe<Scalars['String']>>>
  sortOrder?: Maybe<Array<Maybe<Scalars['String']>>>
  filter?: Maybe<Scalars['String']>
  published?: Maybe<Scalars['Boolean']>
}

export interface QueryGetBuitenkansjesArgs {
  id: Scalars['Int']
  defaultLanguage?: Maybe<Scalars['String']>
}

export interface QueryGetPromotionListingArgs {
  ids?: Maybe<Scalars['String']>
  defaultLanguage?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  after?: Maybe<Scalars['Int']>
  sortBy?: Maybe<Array<Maybe<Scalars['String']>>>
  sortOrder?: Maybe<Array<Maybe<Scalars['String']>>>
  filter?: Maybe<Scalars['String']>
  published?: Maybe<Scalars['Boolean']>
}

export interface QueryGetPromotionArgs {
  id: Scalars['Int']
  defaultLanguage?: Maybe<Scalars['String']>
}

export interface QueryGetSpecialistListingArgs {
  ids?: Maybe<Scalars['String']>
  defaultLanguage?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  after?: Maybe<Scalars['Int']>
  sortBy?: Maybe<Array<Maybe<Scalars['String']>>>
  sortOrder?: Maybe<Array<Maybe<Scalars['String']>>>
  filter?: Maybe<Scalars['String']>
  published?: Maybe<Scalars['Boolean']>
}

export interface QueryGetSpecialistArgs {
  id: Scalars['Int']
  defaultLanguage?: Maybe<Scalars['String']>
}

export interface QueryGetProductAddonListingArgs {
  ids?: Maybe<Scalars['String']>
  defaultLanguage?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  after?: Maybe<Scalars['Int']>
  sortBy?: Maybe<Array<Maybe<Scalars['String']>>>
  sortOrder?: Maybe<Array<Maybe<Scalars['String']>>>
  filter?: Maybe<Scalars['String']>
  published?: Maybe<Scalars['Boolean']>
}

export interface QueryGetProductAddonArgs {
  id: Scalars['Int']
  defaultLanguage?: Maybe<Scalars['String']>
}

export interface QueryGetConfigurationListingArgs {
  ids?: Maybe<Scalars['String']>
  defaultLanguage?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  after?: Maybe<Scalars['Int']>
  sortBy?: Maybe<Array<Maybe<Scalars['String']>>>
  sortOrder?: Maybe<Array<Maybe<Scalars['String']>>>
  filter?: Maybe<Scalars['String']>
  published?: Maybe<Scalars['Boolean']>
}

export interface QueryGetConfigurationArgs {
  id: Scalars['Int']
  defaultLanguage?: Maybe<Scalars['String']>
}

export interface QueryGetCombiDealListingArgs {
  ids?: Maybe<Scalars['String']>
  defaultLanguage?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  after?: Maybe<Scalars['Int']>
  sortBy?: Maybe<Array<Maybe<Scalars['String']>>>
  sortOrder?: Maybe<Array<Maybe<Scalars['String']>>>
  filter?: Maybe<Scalars['String']>
  published?: Maybe<Scalars['Boolean']>
}

export interface QueryGetCombiDealArgs {
  id: Scalars['Int']
  defaultLanguage?: Maybe<Scalars['String']>
}

export interface QueryGetRelatedCategoriesListingArgs {
  ids?: Maybe<Scalars['String']>
  defaultLanguage?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  after?: Maybe<Scalars['Int']>
  sortBy?: Maybe<Array<Maybe<Scalars['String']>>>
  sortOrder?: Maybe<Array<Maybe<Scalars['String']>>>
  filter?: Maybe<Scalars['String']>
  published?: Maybe<Scalars['Boolean']>
}

export interface QueryGetRelatedCategoriesArgs {
  id: Scalars['Int']
  defaultLanguage?: Maybe<Scalars['String']>
}

export interface QueryGetDeliverytimesListingArgs {
  ids?: Maybe<Scalars['String']>
  defaultLanguage?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  after?: Maybe<Scalars['Int']>
  sortBy?: Maybe<Array<Maybe<Scalars['String']>>>
  sortOrder?: Maybe<Array<Maybe<Scalars['String']>>>
  filter?: Maybe<Scalars['String']>
  published?: Maybe<Scalars['Boolean']>
}

export interface QueryGetDeliverytimesArgs {
  id: Scalars['Int']
  defaultLanguage?: Maybe<Scalars['String']>
}

export interface QueryGetAssetListingArgs {
  ids?: Maybe<Scalars['String']>
  defaultLanguage?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  after?: Maybe<Scalars['Int']>
  sortBy?: Maybe<Array<Maybe<Scalars['String']>>>
  sortOrder?: Maybe<Array<Maybe<Scalars['String']>>>
  filter?: Maybe<Scalars['String']>
}

export interface QueryGetAssetFolderArgs {
  id: Scalars['Int']
  defaultLanguage?: Maybe<Scalars['String']>
}

export interface QueryGetObjectFolderArgs {
  id: Scalars['Int']
  defaultLanguage?: Maybe<Scalars['String']>
}

export interface QueryNearestPostNlLocationsArgs {
  input: NearestPostNlLocationsInput
}

export interface QueryPostNlDeliveryTimeframesArgs {
  input: PostNlDeliveryTimeframeInput
}

export interface QueryTrustpilotArgs {
  businessUnitId: Scalars['ID']
}

export interface Rating {
  __typename?: 'Rating'
  ratingCode: Scalars['String']
  ratingId: Scalars['Int']
  ratingOptions: Maybe<Array<Maybe<RatingOption>>>
}

export interface RatingInput {
  /** Rating value id for stars. */
  option_id: Scalars['String']
  /** Rating id. */
  rating_id: Scalars['String']
}

export interface RatingOption {
  __typename?: 'RatingOption'
  optionId: Scalars['Int']
  /** Votes. */
  options: Maybe<Array<Maybe<RatingOptionValues>>>
  /** Option name. */
  ratingCode: Maybe<Scalars['String']>
  /** Option id. */
  ratingId: Maybe<Scalars['Int']>
  value: Scalars['Int']
}

export interface RatingOptionValues {
  __typename?: 'RatingOptionValues'
  /** Rating option code. */
  code: Maybe<Scalars['String']>
  /** Rating option id. */
  optionId: Maybe<Scalars['Int']>
  /** Rating option position. */
  position: Maybe<Scalars['Int']>
  /** Rating option value. */
  value: Maybe<Scalars['Int']>
}

export interface RatingVote {
  __typename?: 'RatingVote'
  /** Customer id. */
  customerId: Maybe<Scalars['Int']>
  /** Product id. */
  entityPkValue: Maybe<Scalars['Int']>
  /** Option id. */
  optionId: Maybe<Scalars['Int']>
  /** Percent. */
  percent: Maybe<Scalars['Int']>
  /** Rating code. */
  ratingCode: Maybe<Scalars['String']>
  /** Rating id. */
  ratingId: Maybe<Scalars['Int']>
  /** Review id. */
  reviewId: Maybe<Scalars['Int']>
  /** Store id. */
  storeId: Maybe<Scalars['Int']>
  /** Value. */
  value: Maybe<Scalars['Int']>
  /** Vote id. */
  voteId: Maybe<Scalars['Int']>
}

export interface Region {
  __typename?: 'Region'
  code: Maybe<Scalars['String']>
  id: Maybe<Scalars['Int']>
  name: Maybe<Scalars['String']>
}

export interface RelatedDocument {
  __typename?: 'RelatedDocument'
  /** The id of the document. */
  id: Scalars['String']
  /** The uid of the document. */
  uid: Maybe<Scalars['String']>
  /** The type of the document. */
  type: Scalars['String']
  /** The language of the document. */
  lang: Scalars['String']
}

export interface RemoveCouponFromCartInput {
  cart_id: Scalars['String']
}

export interface RemoveCouponFromCartOutput {
  __typename?: 'RemoveCouponFromCartOutput'
  cart: Maybe<Cart>
}

export interface RemoveItemFromCartInput {
  cart_id: Scalars['String']
  cart_item_id: Scalars['Int']
}

export interface RemoveItemFromCartOutput {
  __typename?: 'RemoveItemFromCartOutput'
  cart: Cart
}

export interface ReorderItemsOutput {
  __typename?: 'ReorderItemsOutput'
  /** Contains detailed information about the customer's cart. */
  cart: Cart
  /** An array of reordering errors. */
  userInputErrors: Array<Maybe<CheckoutUserInputError>>
}

export interface Review {
  __typename?: 'Review'
  /** Answer. */
  answer: Maybe<Scalars['String']>
  /** Comments. */
  comments: Maybe<Array<Maybe<Comment>>>
  /** Created at. */
  createdAt: Maybe<Scalars['String']>
  /** Reviewer id. */
  customerId: Maybe<Scalars['Int']>
  /** Review detail. */
  detail: Maybe<Scalars['String']>
  /** Detail id. */
  detailId: Maybe<Scalars['Int']>
  /** Entity code. */
  entityCode: Maybe<Scalars['String']>
  /** Entity id. */
  entityId: Maybe<Scalars['Int']>
  /** Product id. */
  entityPkValue: Maybe<Scalars['Int']>
  /** Guest email. */
  guestEmail: Maybe<Scalars['String']>
  /** Images. */
  images: Maybe<Array<Maybe<Images>>>
  /** Reomended. */
  isRecommended: Maybe<Scalars['Boolean']>
  /** List of advantages */
  likeAbout: Maybe<Array<Maybe<Like>>>
  /** Minus review. */
  minusReview: Maybe<Scalars['String']>
  /** Reviewer name. */
  nickname: Maybe<Scalars['String']>
  /** List of disadvantages */
  notLikeAbout: Maybe<Array<Maybe<Like>>>
  /** Plus review. */
  plusReview: Maybe<Scalars['String']>
  /** Rating votes. */
  ratingVotes: Maybe<Array<Maybe<RatingVote>>>
  /** Review id. */
  reviewId: Maybe<Scalars['Int']>
  /** Status id. */
  statusId: Maybe<Scalars['Int']>
  /** Summary vote. */
  summaryVote: Maybe<Scalars['Float']>
  /** Review title. */
  title: Maybe<Scalars['String']>
  /** Verified buyer. */
  verifiedBuyer: Maybe<Scalars['Int']>
}

export interface ReviewFilter {
  __typename?: 'ReviewFilter'
  code: Scalars['String']
  label: Scalars['String']
}

export interface ReviewModal extends Document, Linkable {
  __typename?: 'ReviewModal'
  title: Maybe<Scalars['Json']>
  subtitle: Maybe<Scalars['Json']>
  info: Maybe<Scalars['Json']>
  footer: Maybe<Scalars['Json']>
  meta: Meta
  linkType: Maybe<Scalars['String']>
}

/** A connection to a list of items. */
export interface ReviewModalConnectionConnection {
  __typename?: 'ReviewModalConnectionConnection'
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  /** A list of edges. */
  edges: Maybe<Array<Maybe<ReviewModalConnectionEdge>>>
  totalCount: Scalars['Long']
}

/** An edge in a connection. */
export interface ReviewModalConnectionEdge {
  __typename?: 'ReviewModalConnectionEdge'
  /** The item at the end of the edge. */
  node: ReviewModal
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
}

export interface ReviewOrder {
  __typename?: 'ReviewOrder'
  code: Scalars['String']
  label: Scalars['String']
}

export interface ReviewsData {
  __typename?: 'ReviewsData'
  /** Detailed summary. */
  detailedSummary: Maybe<DetailedSummary>
  /** Reviews. */
  items: Maybe<Array<Maybe<Review>>>
  /** Advantages. */
  preLikes: Maybe<Array<Maybe<PreLike>>>
  /** Disadvantages. */
  preNoLikes: Maybe<Array<Maybe<PreLike>>>
  /** Rating summary. */
  ratingSummary: Maybe<Scalars['Int']>
  /** Rating summary value. */
  ratingSummaryValue: Maybe<Scalars['Float']>
  /** Votes. */
  ratingOptions: Maybe<Array<Maybe<RatingOption>>>
  /** Recomended percent. */
  recomendedPercent: Maybe<Scalars['Int']>
  /** Total records. */
  totalRecords: Maybe<Scalars['Int']>
  /** Total records with applied filters. */
  totalRecordsFiltered: Maybe<Scalars['Int']>
}

export interface RevokeCustomerTokenOutput {
  __typename?: 'RevokeCustomerTokenOutput'
  result: Scalars['Boolean']
}

/** SearchResultPageInfo provides navigation for the query response */
export interface SearchResultPageInfo {
  __typename?: 'SearchResultPageInfo'
  /** Specifies which page of results to return */
  currentPage: Maybe<Scalars['Int']>
  /** Specifies the maximum number of items to return */
  pageSize: Maybe<Scalars['Int']>
  /** Total pages */
  totalPages: Maybe<Scalars['Int']>
}

export interface SelectedBundleOption {
  __typename?: 'SelectedBundleOption'
  id: Scalars['Int']
  label: Scalars['String']
  type: Scalars['String']
  values: Array<Maybe<SelectedBundleOptionValue>>
}

export interface SelectedBundleOptionValue {
  __typename?: 'SelectedBundleOptionValue'
  id: Scalars['Int']
  label: Scalars['String']
  price: Scalars['Float']
  quantity: Scalars['Float']
}

export interface SelectedConfigurableOption {
  __typename?: 'SelectedConfigurableOption'
  id: Scalars['Int']
  optionLabel: Scalars['String']
  valueId: Scalars['Int']
  valueLabel: Scalars['String']
}

export interface SelectedCustomizableOption {
  __typename?: 'SelectedCustomizableOption'
  id: Scalars['Int']
  isRequired: Scalars['Boolean']
  label: Scalars['String']
  sortOrder: Scalars['Int']
  values: Array<Maybe<SelectedCustomizableOptionValue>>
}

export interface SelectedCustomizableOptionValue {
  __typename?: 'SelectedCustomizableOptionValue'
  id: Scalars['Int']
  label: Scalars['String']
  price: CartItemSelectedOptionValuePrice
  value: Scalars['String']
}

export interface SelectedPaymentMethod {
  __typename?: 'SelectedPaymentMethod'
  /** The payment method code */
  code: Scalars['String']
  /** The purchase order number. */
  purchaseOrderNumber: Maybe<Scalars['String']>
  /** The payment method title. */
  title: Scalars['String']
}

export interface SelectedShippingMethod {
  __typename?: 'SelectedShippingMethod'
  amount: Money
  /** @deprecated The field should not be used on the storefront */
  baseAmount: Maybe<Money>
  carrierCode: Scalars['String']
  carrierTitle: Scalars['String']
  methodCode: Scalars['String']
  methodTitle: Scalars['String']
}

export interface SendEmailToFriendInput {
  product_id: Scalars['Int']
  recipients: Array<Maybe<SendEmailToFriendRecipientInput>>
  sender: SendEmailToFriendSenderInput
}

export interface SendEmailToFriendOutput {
  __typename?: 'SendEmailToFriendOutput'
  recipients: Maybe<Array<Maybe<SendEmailToFriendRecipient>>>
  sender: Maybe<SendEmailToFriendSender>
}

export interface SendEmailToFriendRecipient {
  __typename?: 'SendEmailToFriendRecipient'
  email: Scalars['String']
  name: Scalars['String']
}

export interface SendEmailToFriendRecipientInput {
  email: Scalars['String']
  name: Scalars['String']
}

export interface SendEmailToFriendSender {
  __typename?: 'SendEmailToFriendSender'
  email: Scalars['String']
  message: Scalars['String']
  name: Scalars['String']
}

export interface SendEmailToFriendSenderInput {
  email: Scalars['String']
  message: Scalars['String']
  name: Scalars['String']
}

export interface SendFriendConfiguration {
  __typename?: 'SendFriendConfiguration'
  /** Indicates whether the Email to a Friend feature is enabled. */
  enabledForCustomers: Scalars['Boolean']
  /** Indicates whether the Email to a Friend feature is enabled for guests. */
  enabledForGuests: Scalars['Boolean']
}

export interface SetBillingAddressOnCartInput {
  billing_address: BillingAddressInput
  cart_id: Scalars['String']
}

export interface SetBillingAddressOnCartOutput {
  __typename?: 'SetBillingAddressOnCartOutput'
  cart: Cart
}

export interface SetGuestEmailOnCartInput {
  cart_id: Scalars['String']
  email: Scalars['String']
}

export interface SetGuestEmailOnCartOutput {
  __typename?: 'SetGuestEmailOnCartOutput'
  cart: Cart
}

export interface SetPaymentMethodAndPlaceOrderInput {
  cart_id: Scalars['String']
  payment_method: PaymentMethodInput
}

export interface SetPaymentMethodOnCartInput {
  cart_id: Scalars['String']
  payment_method: PaymentMethodInput
}

export interface SetPaymentMethodOnCartOutput {
  __typename?: 'SetPaymentMethodOnCartOutput'
  cart: Cart
}

export interface SetShippingAddressesOnCartInput {
  cart_id: Scalars['String']
  shipping_addresses: Array<Maybe<ShippingAddressInput>>
}

export interface SetShippingAddressesOnCartOutput {
  __typename?: 'SetShippingAddressesOnCartOutput'
  cart: Cart
}

export interface SetShippingMethodsOnCartInput {
  cart_id: Scalars['String']
  shipping_methods: Array<Maybe<ShippingMethodInput>>
}

export interface SetShippingMethodsOnCartOutput {
  __typename?: 'SetShippingMethodsOnCartOutput'
  cart: Cart
}

/** This enumeration defines whether bundle items must be shipped together. */
export enum ShipBundleItemsEnum {
  TOGETHER = 'TOGETHER',
  SEPARATELY = 'SEPARATELY',
}

export interface ShippingAddressInput {
  address?: Maybe<CartAddressInput>
  customer_address_id?: Maybe<Scalars['Int']>
  customer_notes?: Maybe<Scalars['String']>
  /** The code of Pickup Location which will be used for In-Store Pickup. */
  pickup_location_code?: Maybe<Scalars['String']>
}

export interface ShippingCartAddress extends CartAddressInterface {
  __typename?: 'ShippingCartAddress'
  availableShippingMethods: Maybe<Array<Maybe<AvailableShippingMethod>>>
  /** @deprecated `cart_items_v2` should be used instead */
  cartItems: Maybe<Array<Maybe<CartItemQuantity>>>
  cartItemsV2: Maybe<Array<Maybe<CartItemInterface>>>
  city: Scalars['String']
  company: Maybe<Scalars['String']>
  country: CartAddressCountry
  customerNotes: Maybe<Scalars['String']>
  firstname: Scalars['String']
  /** @deprecated This information shoud not be exposed on frontend */
  itemsWeight: Maybe<Scalars['Float']>
  lastname: Scalars['String']
  pickupLocationCode: Maybe<Scalars['String']>
  postcode: Maybe<Scalars['String']>
  region: Maybe<CartAddressRegion>
  selectedShippingMethod: Maybe<SelectedShippingMethod>
  street: Array<Maybe<Scalars['String']>>
  telephone: Scalars['String']
  vatNumber: Maybe<Scalars['String']>
}

export interface ShippingMethodInput {
  carrier_code: Scalars['String']
  method_code: Scalars['String']
}

export interface Similar {
  documentId: Scalars['String']
  max: Scalars['Int']
}

/** Simple Cart Item */
export interface SimpleCartItem extends CartItemInterface {
  __typename?: 'SimpleCartItem'
  customizableOptions: Maybe<Array<Maybe<SelectedCustomizableOption>>>
  id: Scalars['String']
  prices: Maybe<CartItemPrices>
  product: ProductInterface
  quantity: Scalars['Float']
}

/** A simple product is tangible and are usually sold as single units or in fixed quantities. */
export interface SimpleProduct
  extends ProductInterface,
    PhysicalProductInterface,
    CustomizableProductInterface {
  __typename?: 'SimpleProduct'
  activity: Maybe<Scalars['String']>
  allowcoupon: Maybe<Scalars['Int']>
  allowingenico: Maybe<Scalars['Int']>
  allowpostnllabel: Maybe<Scalars['Int']>
  allowreview: Maybe<Scalars['Int']>
  alternatiefmemo: Maybe<Scalars['String']>
  /** The attribute set assigned to the product. */
  attributeSetId: Maybe<Scalars['Int']>
  /**
   * Relative canonical URL. This value is returned only if the system setting 'Use
   * Canonical Link Meta Tag For Products' is enabled
   */
  canonicalUrl: Maybe<Scalars['String']>
  /** The categories assigned to a product. */
  categories: Maybe<Array<Maybe<CategoryInterface>>>
  categoryGear: Maybe<Scalars['String']>
  climate: Maybe<Scalars['String']>
  collar: Maybe<Scalars['String']>
  color: Maybe<Scalars['Int']>
  cons: Maybe<Scalars['String']>
  /** The product's country of origin. */
  countryOfManufacture: Maybe<Scalars['String']>
  /** Timestamp indicating when the product was created. */
  createdAt: Maybe<Scalars['String']>
  /** Crosssell Products */
  crosssellProducts: Maybe<Array<Maybe<ProductInterface>>>
  /** Detailed information about the product. The value can include simple HTML tags. */
  description: Maybe<ComplexTextValue>
  doorverkooppremie: Maybe<Scalars['String']>
  ean: Maybe<Scalars['String']>
  ecoCollection: Maybe<Scalars['Int']>
  enabled: Maybe<Scalars['Int']>
  erinRecommends: Maybe<Scalars['Int']>
  factuurinformatie: Maybe<Scalars['String']>
  featuresBags: Maybe<Scalars['String']>
  fixedprice: Maybe<Scalars['Int']>
  fixeduntil: Maybe<Scalars['String']>
  gebruikbundelproductenprijs: Maybe<Scalars['Int']>
  gender: Maybe<Scalars['String']>
  /** Indicates whether a gift message is available. */
  giftMessageAvailable: Maybe<Scalars['String']>
  google: Maybe<Scalars['Int']>
  /** The ID number assigned to the product. */
  id: Scalars['Int']
  /** The relative path to the main image on the product page. */
  image: Maybe<ProductImage>
  inkoopprijs: Maybe<Scalars['String']>
  isBuitenkansje: Maybe<Scalars['Int']>
  isInStock: Maybe<Scalars['Int']>
  keepproductbuttons: Maybe<Scalars['Int']>
  kenmerken: Maybe<Scalars['String']>
  kieskeurig: Maybe<Scalars['Int']>
  kieskeurigbe: Maybe<Scalars['Int']>
  kieskeurigtekstad: Maybe<Scalars['String']>
  korteomschrijving: Maybe<Scalars['String']>
  korteomschrijving2: Maybe<Scalars['String']>
  langeomschrijving: Maybe<Scalars['String']>
  /** A number representing the product's manufacturer. */
  manufacturer: Maybe<Scalars['Int']>
  material: Maybe<Scalars['String']>
  maxprijsomnia: Maybe<Scalars['String']>
  /** An array of Media Gallery objects. */
  mediaGallery: Maybe<Array<Maybe<MediaGalleryInterface>>>
  /**
   * An array of MediaGalleryEntry objects.
   * @deprecated Use product's `media_gallery` instead
   */
  mediaGalleryEntries: Maybe<Array<Maybe<MediaGalleryEntry>>>
  merk: Maybe<Scalars['Int']>
  /** A brief overview of the product for search results listings, maximum 255 characters. */
  metaDescription: Maybe<Scalars['String']>
  /** A comma-separated list of keywords that are visible only to search engines. */
  metaKeyword: Maybe<Scalars['String']>
  /** A string that is displayed in the title bar and tab of the browser and in search results lists. */
  metaTitle: Maybe<Scalars['String']>
  modeltype: Maybe<Scalars['String']>
  /** The product name. Customers use this name to identify the product. */
  name: Scalars['String']
  new: Maybe<Scalars['Int']>
  /** The beginning date for new product listings, and determines if the product is featured as a new product. */
  newFromDate: Maybe<Scalars['String']>
  /** The end date for new product listings. */
  newToDate: Maybe<Scalars['String']>
  omnia: Maybe<Scalars['Int']>
  /** Product stock only x left count */
  onlyXLeftInStock: Maybe<Scalars['Float']>
  opmerking1: Maybe<Scalars['String']>
  opmerking2: Maybe<Scalars['String']>
  /** An array of options for a customizable product. */
  options: Maybe<Array<Maybe<CustomizableOptionInterface>>>
  /** If the product has multiple options, determines where they appear on the product page. */
  optionsContainer: Maybe<Scalars['String']>
  pattern: Maybe<Scalars['String']>
  percentagekortingopprijsvanbundelproducten: Maybe<Scalars['String']>
  performanceFabric: Maybe<Scalars['Int']>
  pimcoreId: Maybe<Scalars['Int']>
  populariteit: Maybe<Scalars['String']>
  /**
   * A ProductPrices object, indicating the price of an item.
   * @deprecated Use price_range for product price information.
   */
  price: Maybe<ProductPrices>
  /** A PriceRange object, indicating the range of prices for the product */
  priceRange: PriceRange
  /** An array of TierPrice objects. */
  priceTiers: Maybe<Array<Maybe<TierPrice>>>
  prijs: Maybe<Scalars['String']>
  /** An array of ProductLinks objects. */
  productLinks: Maybe<Array<Maybe<ProductLinksInterface>>>
  productnaam: Maybe<Scalars['String']>
  productnaam1: Maybe<Scalars['String']>
  productspideren: Maybe<Scalars['Int']>
  promotekst: Maybe<Scalars['String']>
  pros: Maybe<Scalars['String']>
  /** Related Products */
  relatedProducts: Maybe<Array<Maybe<ProductInterface>>>
  s2m: Maybe<Scalars['Int']>
  sale: Maybe<Scalars['Int']>
  serie: Maybe<Scalars['String']>
  /** A short description of the product. Its use depends on the theme. */
  shortDescription: Maybe<ComplexTextValue>
  size: Maybe<Scalars['Int']>
  /** A number or code assigned to a product to identify the product, options, price, and manufacturer. */
  sku: Scalars['String']
  sleeve: Maybe<Scalars['String']>
  /** The relative path to the small image, which is used on catalog pages. */
  smallImage: Maybe<ProductImage>
  /** The beginning date that a product has a special price. */
  specialFromDate: Maybe<Scalars['String']>
  /** The discounted price of the product. */
  specialPrice: Maybe<Scalars['Float']>
  /** The end date that a product has a special price. */
  specialToDate: Maybe<Scalars['String']>
  specialprice: Maybe<Scalars['String']>
  specificationsBluetoothspeakerAansluitingen: Maybe<Scalars['String']>
  specificationsBluetoothspeakerAantalspeakers: Maybe<Scalars['String']>
  specificationsBluetoothspeakerAantalusb: Maybe<Scalars['String']>
  specificationsBluetoothspeakerAantalusbc: Maybe<Scalars['String']>
  specificationsBluetoothspeakerAfmetingen: Maybe<Scalars['String']>
  specificationsBluetoothspeakerAfmetingensubwoofer: Maybe<Scalars['String']>
  specificationsBluetoothspeakerFabriekscode: Maybe<Scalars['String']>
  specificationsBluetoothspeakerGewicht: Maybe<Scalars['String']>
  specificationsBluetoothspeakerGewichtsubwoofer: Maybe<Scalars['String']>
  specificationsBluetoothspeakerIntroductiejaar: Maybe<Scalars['String']>
  specificationsBluetoothspeakerKanalen: Maybe<Scalars['String']>
  specificationsBluetoothspeakerKleur: Maybe<Scalars['Int']>
  specificationsBluetoothspeakerSpeeltaf: Maybe<Scalars['String']>
  specificationsBluetoothspeakerStandaardmeegeleverd: Maybe<Scalars['String']>
  specificationsBluetoothspeakerStreaming: Maybe<Scalars['String']>
  specificationsBluetoothspeakerStroomvoorziening: Maybe<Scalars['String']>
  specificationsBluetoothspeakerTypeaudio: Maybe<Scalars['Int']>
  specificationsBluetoothspeakerTypespeaker: Maybe<Scalars['String']>
  specificationsBluetoothspeakerVermogen: Maybe<Scalars['String']>
  specificationsBlurayspelerAfmetingen: Maybe<Scalars['String']>
  specificationsBlurayspelerAfspelenvan: Maybe<Scalars['String']>
  specificationsBlurayspelerAnalogeaudio: Maybe<Scalars['String']>
  specificationsBlurayspelerAudioenvideo: Maybe<Scalars['String']>
  specificationsBlurayspelerBdlive: Maybe<Scalars['Int']>
  specificationsBlurayspelerBluetooth: Maybe<Scalars['Int']>
  specificationsBlurayspelerCoaxiaal: Maybe<Scalars['String']>
  specificationsBlurayspelerDecoders: Maybe<Scalars['String']>
  specificationsBlurayspelerDigitaalcoaxaal: Maybe<Scalars['String']>
  specificationsBlurayspelerDigitaaloptisch: Maybe<Scalars['String']>
  specificationsBlurayspelerDigitaleoptisch: Maybe<Scalars['Int']>
  specificationsBlurayspelerDlna: Maybe<Scalars['Int']>
  specificationsBlurayspelerDriedondersteuning: Maybe<Scalars['Int']>
  specificationsBlurayspelerEthernet: Maybe<Scalars['String']>
  specificationsBlurayspelerFormats: Maybe<Scalars['String']>
  specificationsBlurayspelerFuncties: Maybe<Scalars['String']>
  specificationsBlurayspelerGecerthires: Maybe<Scalars['Int']>
  specificationsBlurayspelerGewicht: Maybe<Scalars['String']>
  specificationsBlurayspelerHdmi: Maybe<Scalars['String']>
  specificationsBlurayspelerHdr: Maybe<Scalars['Int']>
  specificationsBlurayspelerKleur: Maybe<Scalars['Int']>
  specificationsBlurayspelerLan: Maybe<Scalars['Int']>
  specificationsBlurayspelerMiracast: Maybe<Scalars['Int']>
  specificationsBlurayspelerMultiroom: Maybe<Scalars['Int']>
  specificationsBlurayspelerOndersteundaudioformaat: Maybe<Scalars['String']>
  specificationsBlurayspelerOptisch: Maybe<Scalars['Int']>
  specificationsBlurayspelerOutputkanalen: Maybe<Scalars['String']>
  specificationsBlurayspelerPlayback: Maybe<Scalars['String']>
  specificationsBlurayspelerResolutie: Maybe<Scalars['String']>
  specificationsBlurayspelerSmarttv: Maybe<Scalars['Int']>
  specificationsBlurayspelerSpeeltaf: Maybe<Scalars['String']>
  specificationsBlurayspelerSpeeltvandisc: Maybe<Scalars['String']>
  specificationsBlurayspelerStandaardmeegeleverd: Maybe<Scalars['String']>
  specificationsBlurayspelerStroomverbruik: Maybe<Scalars['String']>
  specificationsBlurayspelerUpscaling: Maybe<Scalars['Int']>
  specificationsBlurayspelerUsb: Maybe<Scalars['String']>
  specificationsBlurayspelerVierkuhd: Maybe<Scalars['Int']>
  specificationsBlurayspelerVierkuhdups: Maybe<Scalars['Int']>
  specificationsBlurayspelerWifi: Maybe<Scalars['Int']>
  specificationsCdspelerAansluitingen: Maybe<Scalars['String']>
  specificationsCdspelerAantalusb: Maybe<Scalars['String']>
  specificationsCdspelerAchterspeakers: Maybe<Scalars['Int']>
  specificationsCdspelerAfmetingen: Maybe<Scalars['String']>
  specificationsCdspelerFabriekscode: Maybe<Scalars['String']>
  specificationsCdspelerGewicht: Maybe<Scalars['String']>
  specificationsCdspelerImpendatie: Maybe<Scalars['String']>
  specificationsCdspelerIntroductiejaar: Maybe<Scalars['String']>
  specificationsCdspelerKanalen: Maybe<Scalars['String']>
  specificationsCdspelerMultiroom: Maybe<Scalars['Int']>
  specificationsCdspelerRadio: Maybe<Scalars['Int']>
  specificationsCdspelerSpeakeraansluiting: Maybe<Scalars['String']>
  specificationsCdspelerSpeeltaf: Maybe<Scalars['String']>
  specificationsCdspelerStandaardmeegeleverd: Maybe<Scalars['String']>
  specificationsCdspelerStreaming: Maybe<Scalars['String']>
  specificationsCdspelerStreamingdiensten: Maybe<Scalars['String']>
  specificationsCdspelerStroomvoorziening: Maybe<Scalars['Int']>
  specificationsCdspelerSubwooferuitgang: Maybe<Scalars['Int']>
  specificationsCdspelerTypeaudio: Maybe<Scalars['Int']>
  specificationsCdspelerVermogen: Maybe<Scalars['String']>
  specificationsDraadlozespeakerAantalspeakers: Maybe<Scalars['String']>
  specificationsDraadlozespeakerAfmetingen: Maybe<Scalars['String']>
  specificationsDraadlozespeakerAirplay2: Maybe<Scalars['Int']>
  specificationsDraadlozespeakerAux: Maybe<Scalars['Int']>
  specificationsDraadlozespeakerBluetooth: Maybe<Scalars['Int']>
  specificationsDraadlozespeakerComponent: Maybe<Scalars['Int']>
  specificationsDraadlozespeakerComposiet: Maybe<Scalars['Int']>
  specificationsDraadlozespeakerFabriekscode: Maybe<Scalars['String']>
  specificationsDraadlozespeakerGebruiksduuraccu: Maybe<Scalars['String']>
  specificationsDraadlozespeakerGewicht: Maybe<Scalars['String']>
  specificationsDraadlozespeakerHdmiin: Maybe<Scalars['String']>
  specificationsDraadlozespeakerHdmiuit: Maybe<Scalars['String']>
  specificationsDraadlozespeakerKanalen: Maybe<Scalars['String']>
  specificationsDraadlozespeakerMinijack: Maybe<Scalars['Int']>
  specificationsDraadlozespeakerMultiroom: Maybe<Scalars['Int']>
  specificationsDraadlozespeakerOptischcoax: Maybe<Scalars['Int']>
  specificationsDraadlozespeakerPlatenspeler: Maybe<Scalars['Int']>
  specificationsDraadlozespeakerSpotifyconnect: Maybe<Scalars['Int']>
  specificationsDraadlozespeakerSubwoofer: Maybe<Scalars['Int']>
  specificationsDraadlozespeakerUsb: Maybe<Scalars['Int']>
  specificationsDraadlozespeakerVoicecontrol: Maybe<Scalars['Int']>
  specificationsDraadlozespeakerWifi: Maybe<Scalars['Int']>
  specificationsHifispeakerAansluitingen: Maybe<Scalars['String']>
  specificationsHifispeakerAantalspeakers: Maybe<Scalars['String']>
  specificationsHifispeakerAantalusb: Maybe<Scalars['String']>
  specificationsHifispeakerAchterspeakers: Maybe<Scalars['Int']>
  specificationsHifispeakerAfmetingen: Maybe<Scalars['String']>
  specificationsHifispeakerAfmetingensubwoofer: Maybe<Scalars['String']>
  specificationsHifispeakerBelastbaarheid: Maybe<Scalars['String']>
  specificationsHifispeakerFabriekscode: Maybe<Scalars['String']>
  specificationsHifispeakerGewicht: Maybe<Scalars['String']>
  specificationsHifispeakerGewichtsubwoofer: Maybe<Scalars['String']>
  specificationsHifispeakerImpendatie: Maybe<Scalars['String']>
  specificationsHifispeakerIntroductiejaar: Maybe<Scalars['String']>
  specificationsHifispeakerKanalen: Maybe<Scalars['String']>
  specificationsHifispeakerKleur: Maybe<Scalars['Int']>
  specificationsHifispeakerMaximalefrequentie: Maybe<Scalars['String']>
  specificationsHifispeakerMinimalefrequentie: Maybe<Scalars['String']>
  specificationsHifispeakerMultiroom: Maybe<Scalars['Int']>
  specificationsHifispeakerSpeakeraansluiting: Maybe<Scalars['String']>
  specificationsHifispeakerSpeakertype: Maybe<Scalars['String']>
  specificationsHifispeakerStandaardmeegeleverd: Maybe<Scalars['String']>
  specificationsHifispeakerStreaming: Maybe<Scalars['String']>
  specificationsHifispeakerStroomvoorziening: Maybe<Scalars['Int']>
  specificationsHifispeakerTypeaudio: Maybe<Scalars['Int']>
  specificationsHifispeakerTypespeaker: Maybe<Scalars['String']>
  specificationsHifispeakerVermogen: Maybe<Scalars['String']>
  specificationsHifispeakerWaterbestendig: Maybe<Scalars['Int']>
  specificationsHomecinemaAansluitingen: Maybe<Scalars['String']>
  specificationsHomecinemaAantalhdmi: Maybe<Scalars['String']>
  specificationsHomecinemaAantalspeakers: Maybe<Scalars['String']>
  specificationsHomecinemaAantalusb: Maybe<Scalars['String']>
  specificationsHomecinemaAchterspeakers: Maybe<Scalars['Int']>
  specificationsHomecinemaAfmetingen: Maybe<Scalars['String']>
  specificationsHomecinemaFabriekscode: Maybe<Scalars['String']>
  specificationsHomecinemaGewicht: Maybe<Scalars['String']>
  specificationsHomecinemaGewichtsubwoofer: Maybe<Scalars['String']>
  specificationsHomecinemaImpendatie: Maybe<Scalars['String']>
  specificationsHomecinemaIntroductiejaar: Maybe<Scalars['String']>
  specificationsHomecinemaKleur: Maybe<Scalars['Int']>
  specificationsHomecinemaMicrofoon: Maybe<Scalars['Int']>
  specificationsHomecinemaMultiroom: Maybe<Scalars['Int']>
  specificationsHomecinemaRadio: Maybe<Scalars['Int']>
  specificationsHomecinemaSpeakeraansluiting: Maybe<Scalars['String']>
  specificationsHomecinemaSpeeltaf: Maybe<Scalars['String']>
  specificationsHomecinemaStandaardmeegeleverd: Maybe<Scalars['String']>
  specificationsHomecinemaStreaming: Maybe<Scalars['String']>
  specificationsHomecinemaStreamingdiensten: Maybe<Scalars['String']>
  specificationsHomecinemaStroomvoorziening: Maybe<Scalars['Int']>
  specificationsHomecinemaSubwooferuitgang: Maybe<Scalars['String']>
  specificationsHomecinemaTypeaudio: Maybe<Scalars['Int']>
  specificationsHomecinemaTypespeaker: Maybe<Scalars['String']>
  specificationsHomecinemaVermogen: Maybe<Scalars['String']>
  specificationsMuurbeugelAantalgradendraaibaar: Maybe<Scalars['String']>
  specificationsMuurbeugelAantalgradenkantelbaar: Maybe<Scalars['String']>
  specificationsMuurbeugelBedieningviaapp: Maybe<Scalars['Int']>
  specificationsMuurbeugelGarantie: Maybe<Scalars['String']>
  specificationsMuurbeugelGeschiktvoorafmetingentv: Maybe<Scalars['String']>
  specificationsMuurbeugelInterfacebreedte: Maybe<Scalars['String']>
  specificationsMuurbeugelInterfacehoogte: Maybe<Scalars['String']>
  specificationsMuurbeugelIntroductiejaar: Maybe<Scalars['String']>
  specificationsMuurbeugelKleur: Maybe<Scalars['Int']>
  specificationsMuurbeugelMaxafstandmuur: Maybe<Scalars['String']>
  specificationsMuurbeugelMaximalegewichttv: Maybe<Scalars['String']>
  specificationsMuurbeugelMerkmuurbeugel: Maybe<Scalars['Int']>
  specificationsMuurbeugelMinafstandmuur: Maybe<Scalars['String']>
  specificationsMuurbeugelSoortmuurbeugel: Maybe<Scalars['Int']>
  specificationsMuurbeugelStandaardmeegeleverd: Maybe<Scalars['String']>
  specificationsMuurbeugelTypemuurbeugel: Maybe<Scalars['String']>
  specificationsMuurbeugelUittrekbaar: Maybe<Scalars['Int']>
  specificationsMuurbeugelVesaafmetingen: Maybe<Scalars['String']>
  specificationsNetwerkspelerAansluitingen: Maybe<Scalars['String']>
  specificationsNetwerkspelerAantalusb: Maybe<Scalars['String']>
  specificationsNetwerkspelerAchterspeakers: Maybe<Scalars['Int']>
  specificationsNetwerkspelerAfmetingen: Maybe<Scalars['String']>
  specificationsNetwerkspelerAfmetingensubwoofer: Maybe<Scalars['String']>
  specificationsNetwerkspelerBelastbaarheid: Maybe<Scalars['String']>
  specificationsNetwerkspelerFabriekscode: Maybe<Scalars['String']>
  specificationsNetwerkspelerGewicht: Maybe<Scalars['String']>
  specificationsNetwerkspelerGewichtsubwoofer: Maybe<Scalars['String']>
  specificationsNetwerkspelerIntroductiejaar: Maybe<Scalars['String']>
  specificationsNetwerkspelerKanalen: Maybe<Scalars['String']>
  specificationsNetwerkspelerKleur: Maybe<Scalars['Int']>
  specificationsNetwerkspelerMultiroom: Maybe<Scalars['Int']>
  specificationsNetwerkspelerRadio: Maybe<Scalars['Int']>
  specificationsNetwerkspelerSpeakeraansluiting: Maybe<Scalars['String']>
  specificationsNetwerkspelerSpeeltaf: Maybe<Scalars['String']>
  specificationsNetwerkspelerStandaardmeegeleverd: Maybe<Scalars['String']>
  specificationsNetwerkspelerStreaming: Maybe<Scalars['String']>
  specificationsNetwerkspelerStreamingdiensten: Maybe<Scalars['String']>
  specificationsNetwerkspelerStroomvoorziening: Maybe<Scalars['Int']>
  specificationsNetwerkspelerSubwoofer: Maybe<Scalars['Int']>
  specificationsNetwerkspelerSubwooferuitgang: Maybe<Scalars['Int']>
  specificationsNetwerkspelerTypeaudio: Maybe<Scalars['Int']>
  specificationsNetwerkspelerVermogen: Maybe<Scalars['String']>
  specificationsOverigeaudioAansluitingen: Maybe<Scalars['String']>
  specificationsOverigeaudioAantalhdmi: Maybe<Scalars['String']>
  specificationsOverigeaudioAantalspeakers: Maybe<Scalars['String']>
  specificationsOverigeaudioAantalusb: Maybe<Scalars['String']>
  specificationsOverigeaudioAfmetingen: Maybe<Scalars['String']>
  specificationsOverigeaudioAfmetingensubwoofer: Maybe<Scalars['String']>
  specificationsOverigeaudioFabriekscode: Maybe<Scalars['String']>
  specificationsOverigeaudioGewicht: Maybe<Scalars['String']>
  specificationsOverigeaudioGewichtsubwoofer: Maybe<Scalars['String']>
  specificationsOverigeaudioIntroductiejaar: Maybe<Scalars['String']>
  specificationsOverigeaudioKanalen: Maybe<Scalars['String']>
  specificationsOverigeaudioKleur: Maybe<Scalars['Int']>
  specificationsOverigeaudioMaximalefrequentie: Maybe<Scalars['String']>
  specificationsOverigeaudioMinimalefrequentie: Maybe<Scalars['String']>
  specificationsOverigeaudioRadio: Maybe<Scalars['String']>
  specificationsOverigeaudioStandaardmeegeleverd: Maybe<Scalars['String']>
  specificationsOverigeaudioStreaming: Maybe<Scalars['String']>
  specificationsOverigeaudioStroomvoorziening: Maybe<Scalars['Int']>
  specificationsOverigeaudioVermogen: Maybe<Scalars['String']>
  specificationsOverigeaudioWaterbestendig: Maybe<Scalars['Int']>
  specificationsPlafondbeugelsAantaldraai: Maybe<Scalars['String']>
  specificationsPlafondbeugelsBeeldformaat: Maybe<Scalars['String']>
  specificationsPlafondbeugelsDraaien: Maybe<Scalars['String']>
  specificationsPlafondbeugelsGarantie: Maybe<Scalars['String']>
  specificationsPlafondbeugelsGroottetv: Maybe<Scalars['String']>
  specificationsPlafondbeugelsHoogte: Maybe<Scalars['String']>
  specificationsPlafondbeugelsHoogteverstelling: Maybe<Scalars['Int']>
  specificationsPlafondbeugelsInterfacebreedte: Maybe<Scalars['String']>
  specificationsPlafondbeugelsInterfacehoogte: Maybe<Scalars['String']>
  specificationsPlafondbeugelsInterfaceoptioneel: Maybe<Scalars['Int']>
  specificationsPlafondbeugelsKabelinlegsysteem: Maybe<Scalars['String']>
  specificationsPlafondbeugelsKantelen: Maybe<Scalars['String']>
  specificationsPlafondbeugelsKleur: Maybe<Scalars['Int']>
  specificationsPlafondbeugelsLengtebuis: Maybe<Scalars['String']>
  specificationsPlafondbeugelsMaxgewicht: Maybe<Scalars['String']>
  specificationsPlafondbeugelsMontagehoek: Maybe<Scalars['String']>
  specificationsPlafondbeugelsProductlijn: Maybe<Scalars['Int']>
  specificationsPlafondbeugelsRoteren: Maybe<Scalars['Int']>
  specificationsPlafondbeugelsSchuineplafondoplossing: Maybe<Scalars['Int']>
  specificationsPlafondbeugelsUitschuifbaar: Maybe<Scalars['Int']>
  specificationsPlafondbeugelsVesamaximaal: Maybe<Scalars['String']>
  specificationsPlafondbeugelsVesaminimaal: Maybe<Scalars['String']>
  specificationsPlafondbeugelsVesanorm: Maybe<Scalars['String']>
  specificationsPlafondbeugelsZwenken: Maybe<Scalars['Int']>
  specificationsReceiverAansluitingen: Maybe<Scalars['String']>
  specificationsReceiverAantalspeakers: Maybe<Scalars['String']>
  specificationsReceiverAchterspeakers: Maybe<Scalars['Int']>
  specificationsReceiverAfmetingen: Maybe<Scalars['String']>
  specificationsReceiverAirplay2: Maybe<Scalars['Int']>
  specificationsReceiverArc: Maybe<Scalars['Int']>
  specificationsReceiverAux: Maybe<Scalars['Int']>
  specificationsReceiverBeeldondersteuning: Maybe<Scalars['String']>
  specificationsReceiverBluetooth: Maybe<Scalars['Int']>
  specificationsReceiverCoax: Maybe<Scalars['String']>
  specificationsReceiverComponent: Maybe<Scalars['Int']>
  specificationsReceiverComposiet: Maybe<Scalars['Int']>
  specificationsReceiverEthernet: Maybe<Scalars['Int']>
  specificationsReceiverFabriekscode: Maybe<Scalars['String']>
  specificationsReceiverGewicht: Maybe<Scalars['String']>
  specificationsReceiverHdmiin: Maybe<Scalars['String']>
  specificationsReceiverHdmiout: Maybe<Scalars['String']>
  specificationsReceiverImpendatie: Maybe<Scalars['String']>
  specificationsReceiverIntroductiejaar: Maybe<Scalars['String']>
  specificationsReceiverKanalen: Maybe<Scalars['String']>
  specificationsReceiverKleur: Maybe<Scalars['Int']>
  specificationsReceiverMinijack: Maybe<Scalars['Int']>
  specificationsReceiverMultiroom: Maybe<Scalars['Int']>
  specificationsReceiverOptisch: Maybe<Scalars['String']>
  specificationsReceiverPlatenspeler: Maybe<Scalars['Int']>
  specificationsReceiverRadio: Maybe<Scalars['String']>
  specificationsReceiverSpeeltaf: Maybe<Scalars['String']>
  specificationsReceiverSpotifyconnect: Maybe<Scalars['Int']>
  specificationsReceiverStreaming: Maybe<Scalars['String']>
  specificationsReceiverStroomvoorziening: Maybe<Scalars['Int']>
  specificationsReceiverSubwoofer: Maybe<Scalars['Int']>
  specificationsReceiverSubwooferuitgang: Maybe<Scalars['String']>
  specificationsReceiverSurroundsystemen: Maybe<Scalars['String']>
  specificationsReceiverTypeaudio: Maybe<Scalars['Int']>
  specificationsReceiverTypereceiver: Maybe<Scalars['Int']>
  specificationsReceiverUsb: Maybe<Scalars['Int']>
  specificationsReceiverVermogen: Maybe<Scalars['String']>
  specificationsReceiverWifi: Maybe<Scalars['Int']>
  specificationsSoundbarAantalspeakers: Maybe<Scalars['String']>
  specificationsSoundbarAfmetingen: Maybe<Scalars['String']>
  specificationsSoundbarAirplay2: Maybe<Scalars['Int']>
  specificationsSoundbarArc: Maybe<Scalars['Int']>
  specificationsSoundbarAux: Maybe<Scalars['Int']>
  specificationsSoundbarBeeldondersteuning: Maybe<Scalars['String']>
  specificationsSoundbarBluetooth: Maybe<Scalars['Int']>
  specificationsSoundbarComponent: Maybe<Scalars['Int']>
  specificationsSoundbarComposiet: Maybe<Scalars['Int']>
  specificationsSoundbarEthernet: Maybe<Scalars['Int']>
  specificationsSoundbarFabriekscode: Maybe<Scalars['String']>
  specificationsSoundbarGewicht: Maybe<Scalars['String']>
  specificationsSoundbarHdmiin: Maybe<Scalars['String']>
  specificationsSoundbarHdmiout: Maybe<Scalars['String']>
  specificationsSoundbarIntroductiejaar: Maybe<Scalars['String']>
  specificationsSoundbarKanalen: Maybe<Scalars['String']>
  specificationsSoundbarKleur: Maybe<Scalars['Int']>
  specificationsSoundbarMinijack: Maybe<Scalars['Int']>
  specificationsSoundbarMultiroom: Maybe<Scalars['Int']>
  specificationsSoundbarOptischcoax: Maybe<Scalars['String']>
  specificationsSoundbarSpeeltaf: Maybe<Scalars['String']>
  specificationsSoundbarSpotifyconnect: Maybe<Scalars['Int']>
  specificationsSoundbarStreaming: Maybe<Scalars['String']>
  specificationsSoundbarStroomvoorziening: Maybe<Scalars['Int']>
  specificationsSoundbarSubwoofer: Maybe<Scalars['Int']>
  specificationsSoundbarTypeaudio: Maybe<Scalars['Int']>
  specificationsSoundbarUsb: Maybe<Scalars['Int']>
  specificationsSoundbarVermogen: Maybe<Scalars['String']>
  specificationsSoundbarWifi: Maybe<Scalars['Int']>
  specificationsStereosetAansluitingen: Maybe<Scalars['String']>
  specificationsStereosetAantalspeakers: Maybe<Scalars['String']>
  specificationsStereosetAantalusb: Maybe<Scalars['String']>
  specificationsStereosetAfmetingen: Maybe<Scalars['String']>
  specificationsStereosetBelastbaarheid: Maybe<Scalars['String']>
  specificationsStereosetFabriekscode: Maybe<Scalars['String']>
  specificationsStereosetGewicht: Maybe<Scalars['String']>
  specificationsStereosetImpendatie: Maybe<Scalars['Int']>
  specificationsStereosetIntroductiejaar: Maybe<Scalars['String']>
  specificationsStereosetKanalen: Maybe<Scalars['String']>
  specificationsStereosetKleur: Maybe<Scalars['Int']>
  specificationsStereosetMaximalefrequentie: Maybe<Scalars['String']>
  specificationsStereosetMinimalefrequentie: Maybe<Scalars['String']>
  specificationsStereosetMultiroom: Maybe<Scalars['Int']>
  specificationsStereosetRadio: Maybe<Scalars['String']>
  specificationsStereosetSpeakeraansluiting: Maybe<Scalars['Int']>
  specificationsStereosetSpeeltaf: Maybe<Scalars['String']>
  specificationsStereosetStandaardmeegeleverd: Maybe<Scalars['String']>
  specificationsStereosetStreaming: Maybe<Scalars['String']>
  specificationsStereosetStroomvoorziening: Maybe<Scalars['Int']>
  specificationsStereosetSubwooferuitgang: Maybe<Scalars['Int']>
  specificationsStereosetTypeaudio: Maybe<Scalars['Int']>
  specificationsStereosetTypespeaker: Maybe<Scalars['Int']>
  specificationsStereosetVermogen: Maybe<Scalars['String']>
  specificationsSubwooferAansluitingen: Maybe<Scalars['String']>
  specificationsSubwooferAantalusb: Maybe<Scalars['String']>
  specificationsSubwooferAfmetingen: Maybe<Scalars['String']>
  specificationsSubwooferAfmetingensubwoofer: Maybe<Scalars['String']>
  specificationsSubwooferBelastbaarheid: Maybe<Scalars['String']>
  specificationsSubwooferFabriekscode: Maybe<Scalars['String']>
  specificationsSubwooferGewicht: Maybe<Scalars['String']>
  specificationsSubwooferGewichtsubwoofer: Maybe<Scalars['String']>
  specificationsSubwooferIntroductiejaar: Maybe<Scalars['String']>
  specificationsSubwooferKanalen: Maybe<Scalars['String']>
  specificationsSubwooferKleur: Maybe<Scalars['Int']>
  specificationsSubwooferMaximalefrequentie: Maybe<Scalars['String']>
  specificationsSubwooferMinimalefrequentie: Maybe<Scalars['String']>
  specificationsSubwooferMultiroom: Maybe<Scalars['Int']>
  specificationsSubwooferRadio: Maybe<Scalars['Int']>
  specificationsSubwooferSpeakeraansluiting: Maybe<Scalars['String']>
  specificationsSubwooferStandaardmeegeleverd: Maybe<Scalars['String']>
  specificationsSubwooferStreaming: Maybe<Scalars['String']>
  specificationsSubwooferStreamingdiensten: Maybe<Scalars['String']>
  specificationsSubwooferStroomvoorziening: Maybe<Scalars['Int']>
  specificationsSubwooferSubwooferuitgang: Maybe<Scalars['Int']>
  specificationsSubwooferTypeaudio: Maybe<Scalars['Int']>
  specificationsSubwooferTypespeaker: Maybe<Scalars['String']>
  specificationsSubwooferVermogen: Maybe<Scalars['String']>
  specificationsSubwooferWaterbestendig: Maybe<Scalars['Int']>
  specificationsTelevisieAfmetingenexclvoet: Maybe<Scalars['String']>
  specificationsTelevisieAfmetingeninclvoet: Maybe<Scalars['String']>
  specificationsTelevisieAirplay: Maybe<Scalars['Int']>
  specificationsTelevisieAmbilight: Maybe<Scalars['Int']>
  specificationsTelevisieBeeldformaat: Maybe<Scalars['Int']>
  specificationsTelevisieBeeldfrequentie: Maybe<Scalars['Int']>
  specificationsTelevisieBluetooth: Maybe<Scalars['Int']>
  specificationsTelevisieCigeschikt: Maybe<Scalars['String']>
  specificationsTelevisieComponent: Maybe<Scalars['Int']>
  specificationsTelevisieComposiet: Maybe<Scalars['Int']>
  specificationsTelevisieDigitaalcoaxaleaansluiting: Maybe<Scalars['Int']>
  specificationsTelevisieDigitaaloptischeaansluiting: Maybe<Scalars['Int']>
  specificationsTelevisieEnergieklasse: Maybe<Scalars['Int']>
  specificationsTelevisieFabriekscode: Maybe<Scalars['String']>
  specificationsTelevisieGewichtexclvoet: Maybe<Scalars['String']>
  specificationsTelevisieGewichtinclvoet: Maybe<Scalars['String']>
  specificationsTelevisieHdmi: Maybe<Scalars['String']>
  specificationsTelevisieHdr: Maybe<Scalars['Int']>
  specificationsTelevisieIntroductiejaar: Maybe<Scalars['String']>
  specificationsTelevisieKleur: Maybe<Scalars['Int']>
  specificationsTelevisieKoptelefoon: Maybe<Scalars['Int']>
  specificationsTelevisieMeegeleverdeaccessoires: Maybe<Scalars['String']>
  specificationsTelevisieMerk: Maybe<Scalars['Int']>
  specificationsTelevisieResolutie: Maybe<Scalars['Int']>
  specificationsTelevisieScart: Maybe<Scalars['Int']>
  specificationsTelevisieSmartplatform: Maybe<Scalars['Int']>
  specificationsTelevisieSmarttv: Maybe<Scalars['Int']>
  specificationsTelevisieSoorttv: Maybe<Scalars['String']>
  specificationsTelevisieSpeakersysteem: Maybe<Scalars['String']>
  specificationsTelevisieSpotifyconnect: Maybe<Scalars['Int']>
  specificationsTelevisieSpraakbesturing: Maybe<Scalars['Int']>
  specificationsTelevisieSubwoofer: Maybe<Scalars['Int']>
  specificationsTelevisieTuner: Maybe<Scalars['String']>
  specificationsTelevisieTypehdr: Maybe<Scalars['String']>
  specificationsTelevisieUsb: Maybe<Scalars['String']>
  specificationsTelevisieVermogen: Maybe<Scalars['String']>
  specificationsTelevisieWifi: Maybe<Scalars['Int']>
  specificationsTvmeubelAfmetingen: Maybe<Scalars['String']>
  specificationsTvmeubelGewicht: Maybe<Scalars['String']>
  specificationsTvmeubelKleur: Maybe<Scalars['Int']>
  specificationsTvmeubelMateriaal: Maybe<Scalars['String']>
  specificationsTvmeubelTypeproduct: Maybe<Scalars['Int']>
  specificationsVersterkerAansluitingen: Maybe<Scalars['String']>
  specificationsVersterkerAantalhdmi: Maybe<Scalars['String']>
  specificationsVersterkerAantalusb: Maybe<Scalars['String']>
  specificationsVersterkerAchterspeakers: Maybe<Scalars['Int']>
  specificationsVersterkerAfmetingen: Maybe<Scalars['String']>
  specificationsVersterkerAfmetingensubwoofer: Maybe<Scalars['String']>
  specificationsVersterkerBelastbaarheid: Maybe<Scalars['String']>
  specificationsVersterkerFabriekscode: Maybe<Scalars['String']>
  specificationsVersterkerGewicht: Maybe<Scalars['String']>
  specificationsVersterkerGewichtsubwoofer: Maybe<Scalars['String']>
  specificationsVersterkerImpendatie: Maybe<Scalars['String']>
  specificationsVersterkerIntroductiejaar: Maybe<Scalars['String']>
  specificationsVersterkerKanalen: Maybe<Scalars['String']>
  specificationsVersterkerKleur: Maybe<Scalars['Int']>
  specificationsVersterkerMultiroom: Maybe<Scalars['Int']>
  specificationsVersterkerRadio: Maybe<Scalars['String']>
  specificationsVersterkerSpeakeraansluiting: Maybe<Scalars['String']>
  specificationsVersterkerSpeeltaf: Maybe<Scalars['String']>
  specificationsVersterkerStandaardmeegeleverd: Maybe<Scalars['String']>
  specificationsVersterkerStreaming: Maybe<Scalars['String']>
  specificationsVersterkerStreamingdiensten: Maybe<Scalars['String']>
  specificationsVersterkerStroomvoorziening: Maybe<Scalars['Int']>
  specificationsVersterkerSubwoofer: Maybe<Scalars['String']>
  specificationsVersterkerSubwooferuitgang: Maybe<Scalars['Int']>
  specificationsVersterkerTypeaudio: Maybe<Scalars['Int']>
  specificationsVersterkerVermogen: Maybe<Scalars['String']>
  specificationsVersterkerWaterbestendig: Maybe<Scalars['Int']>
  specificationsVloerstandaardAfmetingen: Maybe<Scalars['String']>
  specificationsVloerstandaardKleur: Maybe<Scalars['Int']>
  specificationsVloerstandaardProducttype: Maybe<Scalars['Int']>
  specificationsVoedingDraadloosopladen: Maybe<Scalars['Int']>
  specificationsVoedingKabellengte: Maybe<Scalars['String']>
  specificationsVoedingKleur: Maybe<Scalars['Int']>
  specificationsVoedingProducttype: Maybe<Scalars['Int']>
  specificationsWifispeakerAansluitingen: Maybe<Scalars['String']>
  specificationsWifispeakerAantalspeakers: Maybe<Scalars['String']>
  specificationsWifispeakerAantalusb: Maybe<Scalars['String']>
  specificationsWifispeakerAchterspeakers: Maybe<Scalars['Int']>
  specificationsWifispeakerAfmetingen: Maybe<Scalars['String']>
  specificationsWifispeakerAfmetingensubwoofer: Maybe<Scalars['String']>
  specificationsWifispeakerBelastbaarheid: Maybe<Scalars['String']>
  specificationsWifispeakerFabriekscode: Maybe<Scalars['String']>
  specificationsWifispeakerGewicht: Maybe<Scalars['String']>
  specificationsWifispeakerGewichtsubwoofer: Maybe<Scalars['String']>
  specificationsWifispeakerImpendatie: Maybe<Scalars['String']>
  specificationsWifispeakerIntroductiejaar: Maybe<Scalars['String']>
  specificationsWifispeakerKanalen: Maybe<Scalars['String']>
  specificationsWifispeakerKleur: Maybe<Scalars['Int']>
  specificationsWifispeakerMultiroom: Maybe<Scalars['Int']>
  specificationsWifispeakerRadio: Maybe<Scalars['String']>
  specificationsWifispeakerSpeeltaf: Maybe<Scalars['String']>
  specificationsWifispeakerStandaardmeegeleverd: Maybe<Scalars['String']>
  specificationsWifispeakerStreaming: Maybe<Scalars['String']>
  specificationsWifispeakerStreamingdiensten: Maybe<Scalars['String']>
  specificationsWifispeakerStroomvoorziening: Maybe<Scalars['String']>
  specificationsWifispeakerSubwoofer: Maybe<Scalars['String']>
  specificationsWifispeakerSubwooferuitgang: Maybe<Scalars['String']>
  specificationsWifispeakerTypeaudio: Maybe<Scalars['Int']>
  specificationsWifispeakerTypespeaker: Maybe<Scalars['Int']>
  specificationsWifispeakerVermogen: Maybe<Scalars['String']>
  specificationsWifispeakerWaterbestendig: Maybe<Scalars['Int']>
  /** Stock status of the product */
  stockStatus: Maybe<ProductStockStatus>
  strapBags: Maybe<Scalars['String']>
  styleBags: Maybe<Scalars['String']>
  styleBottom: Maybe<Scalars['String']>
  styleGeneral: Maybe<Scalars['String']>
  /** The file name of a swatch image */
  swatchImage: Maybe<Scalars['String']>
  tempcombipakketten: Maybe<Scalars['String']>
  /** The relative path to the product's thumbnail image. */
  thumbnail: Maybe<ProductImage>
  /**
   * The price when tier pricing is in effect and the items purchased threshold has been reached.
   * @deprecated Use price_tiers for product tier price information.
   */
  tierPrice: Maybe<Scalars['Float']>
  /**
   * An array of ProductTierPrices objects.
   * @deprecated Use price_tiers for product tier price information.
   */
  tierPrices: Maybe<Array<Maybe<ProductTierPrices>>>
  top10product: Maybe<Scalars['Int']>
  tot21u: Maybe<Scalars['Int']>
  tweakers: Maybe<Scalars['Int']>
  tweakerstekstad: Maybe<Scalars['String']>
  tweakwisecrossselltemplateid: Maybe<Scalars['String']>
  /**
   * One of simple, virtual, bundle, downloadable, grouped, or configurable.
   * @deprecated Use __typename instead.
   */
  typeId: Maybe<Scalars['String']>
  /** Timestamp indicating when the product was updated. */
  updatedAt: Maybe<Scalars['String']>
  /** Upsell Products */
  upsellProducts: Maybe<Array<Maybe<ProductInterface>>>
  /** The part of the URL that identifies the product */
  urlKey: Scalars['String']
  /** @deprecated Use product's `canonical_url` or url rewrites instead */
  urlPath: Maybe<Scalars['String']>
  /** URL rewrites list */
  urlRewrites: Maybe<Array<Maybe<UrlRewrite>>>
  /** The part of the product URL that is appended after the url key */
  urlSuffix: Maybe<Scalars['String']>
  variant: Maybe<Scalars['Int']>
  variantValue: Maybe<Scalars['String']>
  venditguid: Maybe<Scalars['String']>
  venditpid: Maybe<Scalars['String']>
  voorraadamsterdam: Maybe<Scalars['Int']>
  voorraadarnhem: Maybe<Scalars['Int']>
  voorraadbreda: Maybe<Scalars['Int']>
  voorraaddoetinchem: Maybe<Scalars['Int']>
  voorraadeindhoven: Maybe<Scalars['Int']>
  voorraadgroningen: Maybe<Scalars['Int']>
  voorraadnaarden: Maybe<Scalars['Int']>
  voorraadnijmegen: Maybe<Scalars['Int']>
  voorraadonline: Maybe<Scalars['Int']>
  voorraadutrecht: Maybe<Scalars['Int']>
  voorraadzoeterwoude: Maybe<Scalars['Int']>
  /**
   * An array of websites in which the product is available.
   * @deprecated The field should not be used on the storefront.
   */
  websites: Maybe<Array<Maybe<Website>>>
  /** The weight of the item, in units defined by the store. */
  weight: Maybe<Scalars['Float']>
  zondaglevering: Maybe<Scalars['Int']>
  pimcoreProductData: Maybe<PimcoreProduct>
}

export interface SimpleProductCartItemInput {
  customizable_options?: Maybe<Array<Maybe<CustomizableOptionInput>>>
  data: CartItemInput
}

export enum SortCategoryy {
  META_FIRST_PUBLICATION_DATE_ASC = 'meta_firstPublicationDate_ASC',
  META_FIRST_PUBLICATION_DATE_DESC = 'meta_firstPublicationDate_DESC',
  META_LAST_PUBLICATION_DATE_ASC = 'meta_lastPublicationDate_ASC',
  META_LAST_PUBLICATION_DATE_DESC = 'meta_lastPublicationDate_DESC',
  CATEGORY_ID_ASC = 'category_id_ASC',
  CATEGORY_ID_DESC = 'category_id_DESC',
}

export enum SortDocumentsBy {
  META_FIRST_PUBLICATION_DATE_ASC = 'meta_firstPublicationDate_ASC',
  META_FIRST_PUBLICATION_DATE_DESC = 'meta_firstPublicationDate_DESC',
  META_LAST_PUBLICATION_DATE_ASC = 'meta_lastPublicationDate_ASC',
  META_LAST_PUBLICATION_DATE_DESC = 'meta_lastPublicationDate_DESC',
}

/** This enumeration indicates whether to return results in ascending or descending order */
export enum SortEnum {
  ASC = 'ASC',
  DESC = 'DESC',
}

export enum SortFaqcategoryy {
  META_FIRST_PUBLICATION_DATE_ASC = 'meta_firstPublicationDate_ASC',
  META_FIRST_PUBLICATION_DATE_DESC = 'meta_firstPublicationDate_DESC',
  META_LAST_PUBLICATION_DATE_ASC = 'meta_lastPublicationDate_ASC',
  META_LAST_PUBLICATION_DATE_DESC = 'meta_lastPublicationDate_DESC',
  CATEGORY_NAME_ASC = 'category_name_ASC',
  CATEGORY_NAME_DESC = 'category_name_DESC',
  CATEGORY_ORDER_ASC = 'category_order_ASC',
  CATEGORY_ORDER_DESC = 'category_order_DESC',
}

export enum SortFaqsubjecty {
  META_FIRST_PUBLICATION_DATE_ASC = 'meta_firstPublicationDate_ASC',
  META_FIRST_PUBLICATION_DATE_DESC = 'meta_firstPublicationDate_DESC',
  META_LAST_PUBLICATION_DATE_ASC = 'meta_lastPublicationDate_ASC',
  META_LAST_PUBLICATION_DATE_DESC = 'meta_lastPublicationDate_DESC',
  SUBJECT_NAME_ASC = 'subject_name_ASC',
  SUBJECT_NAME_DESC = 'subject_name_DESC',
  SUBJECT_ORDER_ASC = 'subject_order_ASC',
  SUBJECT_ORDER_DESC = 'subject_order_DESC',
}

export interface SortField {
  __typename?: 'SortField'
  /** Label of sort field. */
  label: Maybe<Scalars['String']>
  /** Attribute code of sort field. */
  value: Maybe<Scalars['String']>
}

/** SortFields contains a default value for sort fields and all available sort fields. */
export interface SortFields {
  __typename?: 'SortFields'
  /** Default value of sort fields. */
  default: Maybe<Scalars['String']>
  /** Available sort fields. */
  options: Maybe<Array<Maybe<SortField>>>
}

export enum SortFormy {
  META_FIRST_PUBLICATION_DATE_ASC = 'meta_firstPublicationDate_ASC',
  META_FIRST_PUBLICATION_DATE_DESC = 'meta_firstPublicationDate_DESC',
  META_LAST_PUBLICATION_DATE_ASC = 'meta_lastPublicationDate_ASC',
  META_LAST_PUBLICATION_DATE_DESC = 'meta_lastPublicationDate_DESC',
  TITLE_ASC = 'title_ASC',
  TITLE_DESC = 'title_DESC',
  EXPLANATION_ASC = 'explanation_ASC',
  EXPLANATION_DESC = 'explanation_DESC',
  SUBMIT_ASC = 'submit_ASC',
  SUBMIT_DESC = 'submit_DESC',
  SUCCESS_MESSAGE_ASC = 'success_message_ASC',
  SUCCESS_MESSAGE_DESC = 'success_message_DESC',
  PRODUCT_HEADER_SUBTITLE_ASC = 'product_header_subtitle_ASC',
  PRODUCT_HEADER_SUBTITLE_DESC = 'product_header_subtitle_DESC',
}

export enum SortMainy {
  META_FIRST_PUBLICATION_DATE_ASC = 'meta_firstPublicationDate_ASC',
  META_FIRST_PUBLICATION_DATE_DESC = 'meta_firstPublicationDate_DESC',
  META_LAST_PUBLICATION_DATE_ASC = 'meta_lastPublicationDate_ASC',
  META_LAST_PUBLICATION_DATE_DESC = 'meta_lastPublicationDate_DESC',
}

export enum SortPagey {
  META_FIRST_PUBLICATION_DATE_ASC = 'meta_firstPublicationDate_ASC',
  META_FIRST_PUBLICATION_DATE_DESC = 'meta_firstPublicationDate_DESC',
  META_LAST_PUBLICATION_DATE_ASC = 'meta_lastPublicationDate_ASC',
  META_LAST_PUBLICATION_DATE_DESC = 'meta_lastPublicationDate_DESC',
  URL_KEY_ASC = 'url_key_ASC',
  URL_KEY_DESC = 'url_key_DESC',
  SEO_TITLE_ASC = 'seo_title_ASC',
  SEO_TITLE_DESC = 'seo_title_DESC',
  SEO_DESCRIPTION_ASC = 'seo_description_ASC',
  SEO_DESCRIPTION_DESC = 'seo_description_DESC',
  SEO_KEYWORDS_ASC = 'seo_keywords_ASC',
  SEO_KEYWORDS_DESC = 'seo_keywords_DESC',
}

export enum SortProducty {
  META_FIRST_PUBLICATION_DATE_ASC = 'meta_firstPublicationDate_ASC',
  META_FIRST_PUBLICATION_DATE_DESC = 'meta_firstPublicationDate_DESC',
  META_LAST_PUBLICATION_DATE_ASC = 'meta_lastPublicationDate_ASC',
  META_LAST_PUBLICATION_DATE_DESC = 'meta_lastPublicationDate_DESC',
  SERIE_ASC = 'serie_ASC',
  SERIE_DESC = 'serie_DESC',
  PRODUCT_ASC = 'product_ASC',
  PRODUCT_DESC = 'product_DESC',
}

export enum SortPromotiony {
  META_FIRST_PUBLICATION_DATE_ASC = 'meta_firstPublicationDate_ASC',
  META_FIRST_PUBLICATION_DATE_DESC = 'meta_firstPublicationDate_DESC',
  META_LAST_PUBLICATION_DATE_ASC = 'meta_lastPublicationDate_ASC',
  META_LAST_PUBLICATION_DATE_DESC = 'meta_lastPublicationDate_DESC',
}

export enum SortReviewModaly {
  META_FIRST_PUBLICATION_DATE_ASC = 'meta_firstPublicationDate_ASC',
  META_FIRST_PUBLICATION_DATE_DESC = 'meta_firstPublicationDate_DESC',
  META_LAST_PUBLICATION_DATE_ASC = 'meta_lastPublicationDate_ASC',
  META_LAST_PUBLICATION_DATE_DESC = 'meta_lastPublicationDate_DESC',
  TITLE_ASC = 'title_ASC',
  TITLE_DESC = 'title_DESC',
  SUBTITLE_ASC = 'subtitle_ASC',
  SUBTITLE_DESC = 'subtitle_DESC',
  INFO_ASC = 'info_ASC',
  INFO_DESC = 'info_DESC',
  FOOTER_ASC = 'footer_ASC',
  FOOTER_DESC = 'footer_DESC',
}

export enum SortSpecificationy {
  META_FIRST_PUBLICATION_DATE_ASC = 'meta_firstPublicationDate_ASC',
  META_FIRST_PUBLICATION_DATE_DESC = 'meta_firstPublicationDate_DESC',
  META_LAST_PUBLICATION_DATE_ASC = 'meta_lastPublicationDate_ASC',
  META_LAST_PUBLICATION_DATE_DESC = 'meta_lastPublicationDate_DESC',
  NAME_ASC = 'name_ASC',
  NAME_DESC = 'name_DESC',
}

export enum SortSpecy {
  META_FIRST_PUBLICATION_DATE_ASC = 'meta_firstPublicationDate_ASC',
  META_FIRST_PUBLICATION_DATE_DESC = 'meta_firstPublicationDate_DESC',
  META_LAST_PUBLICATION_DATE_ASC = 'meta_lastPublicationDate_ASC',
  META_LAST_PUBLICATION_DATE_DESC = 'meta_lastPublicationDate_DESC',
  SPEC_KEY_ASC = 'spec_key_ASC',
  SPEC_KEY_DESC = 'spec_key_DESC',
}

export enum SortStorey {
  META_FIRST_PUBLICATION_DATE_ASC = 'meta_firstPublicationDate_ASC',
  META_FIRST_PUBLICATION_DATE_DESC = 'meta_firstPublicationDate_DESC',
  META_LAST_PUBLICATION_DATE_ASC = 'meta_lastPublicationDate_ASC',
  META_LAST_PUBLICATION_DATE_DESC = 'meta_lastPublicationDate_DESC',
  URL_KEY_ASC = 'url_key_ASC',
  URL_KEY_DESC = 'url_key_DESC',
  SEO_TITLE_ASC = 'seo_title_ASC',
  SEO_TITLE_DESC = 'seo_title_DESC',
  SEO_DESCRIPTION_ASC = 'seo_description_ASC',
  SEO_DESCRIPTION_DESC = 'seo_description_DESC',
  SEO_KEYWORDS_ASC = 'seo_keywords_ASC',
  SEO_KEYWORDS_DESC = 'seo_keywords_DESC',
}

export enum SortTesty {
  META_FIRST_PUBLICATION_DATE_ASC = 'meta_firstPublicationDate_ASC',
  META_FIRST_PUBLICATION_DATE_DESC = 'meta_firstPublicationDate_DESC',
  META_LAST_PUBLICATION_DATE_ASC = 'meta_lastPublicationDate_ASC',
  META_LAST_PUBLICATION_DATE_DESC = 'meta_lastPublicationDate_DESC',
}

export interface Spec extends Document, Linkable {
  __typename?: 'Spec'
  specKey: Maybe<Scalars['String']>
  body: Maybe<Array<SpecBody>>
  meta: Meta
  linkType: Maybe<Scalars['String']>
}

export type SpecBody =
  | SpecBodyCenterText
  | SpecBodyRichText
  | SpecBodyImageContentTop
  | SpecBodyImageAndTextColumns
  | SpecBodyImageTitleTop
  | SpecBodyImageContentTile
  | SpecBodyYoutubeVideoSlider
  | SpecBodyProductAttributes
  | SpecBodyStoreStock
  | SpecBodyGenericproductslice
  | SpecBodyTest

export interface SpecBodyCenterText {
  __typename?: 'SpecBodyCenterText'
  type: Maybe<Scalars['String']>
  label: Maybe<Scalars['String']>
  primary: Maybe<SpecBodyCenterTextPrimary>
}

export interface SpecBodyCenterTextPrimary {
  __typename?: 'SpecBodyCenterTextPrimary'
  text: Maybe<Scalars['Json']>
}

export interface SpecBodyGenericproductslice {
  __typename?: 'SpecBodyGenericproductslice'
  type: Maybe<Scalars['String']>
  label: Maybe<Scalars['String']>
  primary: Maybe<SpecBodyGenericproductslicePrimary>
}

export interface SpecBodyGenericproductslicePrimary {
  __typename?: 'SpecBodyGenericproductslicePrimary'
  title: Maybe<Scalars['String']>
  subTitle: Maybe<Scalars['String']>
  description: Maybe<Scalars['Json']>
  smallImage: Maybe<Scalars['Json']>
  mediumImage: Maybe<Scalars['Json']>
  largeImage: Maybe<Scalars['Json']>
}

export interface SpecBodyImageAndTextColumns {
  __typename?: 'SpecBodyImageAndTextColumns'
  type: Maybe<Scalars['String']>
  label: Maybe<Scalars['String']>
  primary: Maybe<SpecBodyImageAndTextColumnsPrimary>
}

export interface SpecBodyImageAndTextColumnsPrimary {
  __typename?: 'SpecBodyImageAndTextColumnsPrimary'
  squareImage: Maybe<Scalars['Json']>
  title: Maybe<Scalars['Json']>
  text: Maybe<Scalars['Json']>
  imageLocation: Maybe<Scalars['Json']>
}

export interface SpecBodyImageContentTile {
  __typename?: 'SpecBodyImageContentTile'
  type: Maybe<Scalars['String']>
  label: Maybe<Scalars['String']>
  primary: Maybe<SpecBodyImageContentTilePrimary>
}

export interface SpecBodyImageContentTilePrimary {
  __typename?: 'SpecBodyImageContentTilePrimary'
  title: Maybe<Scalars['Json']>
  subtitle: Maybe<Scalars['Json']>
  text: Maybe<Scalars['Json']>
  image: Maybe<PrismicImageType>
  imageLocation: Maybe<Scalars['Json']>
  contentOverlapsImage: Maybe<Scalars['Json']>
}

export interface SpecBodyImageContentTop {
  __typename?: 'SpecBodyImageContentTop'
  type: Maybe<Scalars['String']>
  label: Maybe<Scalars['String']>
  primary: Maybe<SpecBodyImageContentTopPrimary>
}

export interface SpecBodyImageContentTopPrimary {
  __typename?: 'SpecBodyImageContentTopPrimary'
  title: Maybe<Scalars['Json']>
  subtitle: Maybe<Scalars['Json']>
  text: Maybe<Scalars['Json']>
  backgroundImage: Maybe<Scalars['Json']>
}

export interface SpecBodyImageTitleTop {
  __typename?: 'SpecBodyImageTitleTop'
  type: Maybe<Scalars['String']>
  label: Maybe<Scalars['String']>
  primary: Maybe<SpecBodyImageTitleTopPrimary>
}

export interface SpecBodyImageTitleTopPrimary {
  __typename?: 'SpecBodyImageTitleTopPrimary'
  title: Maybe<Scalars['String']>
  backgroundImage: Maybe<Scalars['Json']>
}

export interface SpecBodyProductAttributes {
  __typename?: 'SpecBodyProductAttributes'
  type: Maybe<Scalars['String']>
  label: Maybe<Scalars['String']>
  fields: Maybe<Array<SpecBodyProductAttributesFields>>
}

export interface SpecBodyProductAttributesFields {
  __typename?: 'SpecBodyProductAttributesFields'
  uid: Maybe<Scalars['String']>
  displayName: Maybe<Scalars['String']>
  sortOrder: Maybe<Scalars['Float']>
  group: Maybe<Scalars['String']>
  showInShortSpecifications: Maybe<Scalars['Json']>
}

export interface SpecBodyRichText {
  __typename?: 'SpecBodyRichText'
  type: Maybe<Scalars['String']>
  label: Maybe<Scalars['String']>
  primary: Maybe<SpecBodyRichTextPrimary>
}

export interface SpecBodyRichTextPrimary {
  __typename?: 'SpecBodyRichTextPrimary'
  text: Maybe<Scalars['Json']>
}

export interface SpecBodyStoreStock {
  __typename?: 'SpecBodyStoreStock'
  type: Maybe<Scalars['String']>
  label: Maybe<Scalars['String']>
  primary: Maybe<SpecBodyStoreStockPrimary>
}

export interface SpecBodyStoreStockPrimary {
  __typename?: 'SpecBodyStoreStockPrimary'
  title: Maybe<Scalars['Json']>
  image: Maybe<PrismicImageType>
  listOfReasonsToGoToTheStore: Maybe<Scalars['Json']>
  link: Maybe<PrismicHyperlink>
  linkText: Maybe<Scalars['String']>
}

export interface SpecBodyTest {
  __typename?: 'SpecBodyTest'
  type: Maybe<Scalars['String']>
  label: Maybe<Scalars['String']>
  primary: Maybe<SpecBodyTestPrimary>
}

export interface SpecBodyTestPrimary {
  __typename?: 'SpecBodyTestPrimary'
  vooraadstatus: Maybe<Scalars['String']>
}

export interface SpecBodyYoutubeVideoSlider {
  __typename?: 'SpecBodyYoutubeVideoSlider'
  type: Maybe<Scalars['String']>
  label: Maybe<Scalars['String']>
  primary: Maybe<SpecBodyYoutubeVideoSliderPrimary>
  fields: Maybe<Array<SpecBodyYoutubeVideoSliderFields>>
}

export interface SpecBodyYoutubeVideoSliderFields {
  __typename?: 'SpecBodyYoutubeVideoSliderFields'
  videoId: Maybe<Scalars['String']>
}

export interface SpecBodyYoutubeVideoSliderPrimary {
  __typename?: 'SpecBodyYoutubeVideoSliderPrimary'
  title: Maybe<Scalars['Json']>
}

/** A connection to a list of items. */
export interface SpecConnectionConnection {
  __typename?: 'SpecConnectionConnection'
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  /** A list of edges. */
  edges: Maybe<Array<Maybe<SpecConnectionEdge>>>
  totalCount: Scalars['Long']
}

/** An edge in a connection. */
export interface SpecConnectionEdge {
  __typename?: 'SpecConnectionEdge'
  /** The item at the end of the edge. */
  node: Spec
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
}

export interface Specification extends Document, Linkable {
  __typename?: 'Specification'
  name: Maybe<Scalars['String']>
  body: Maybe<Array<SpecificationBody>>
  meta: Meta
  linkType: Maybe<Scalars['String']>
}

export type SpecificationBody =
  | SpecificationBodyCenterText
  | SpecificationBodyRichText
  | SpecificationBodyProsAndConsBanner
  | SpecificationBodyImageContentTop
  | SpecificationBodyImageAndTextColumns
  | SpecificationBodyImageTitleTop
  | SpecificationBodyImageContentTile

export interface SpecificationBodyCenterText {
  __typename?: 'SpecificationBodyCenterText'
  type: Maybe<Scalars['String']>
  label: Maybe<Scalars['String']>
  primary: Maybe<SpecificationBodyCenterTextPrimary>
}

export interface SpecificationBodyCenterTextPrimary {
  __typename?: 'SpecificationBodyCenterTextPrimary'
  text: Maybe<Scalars['Json']>
}

export interface SpecificationBodyImageAndTextColumns {
  __typename?: 'SpecificationBodyImageAndTextColumns'
  type: Maybe<Scalars['String']>
  label: Maybe<Scalars['String']>
  primary: Maybe<SpecificationBodyImageAndTextColumnsPrimary>
}

export interface SpecificationBodyImageAndTextColumnsPrimary {
  __typename?: 'SpecificationBodyImageAndTextColumnsPrimary'
  squareImage: Maybe<Scalars['Json']>
  title: Maybe<Scalars['Json']>
  text: Maybe<Scalars['Json']>
  imageLocation: Maybe<Scalars['Json']>
}

export interface SpecificationBodyImageContentTile {
  __typename?: 'SpecificationBodyImageContentTile'
  type: Maybe<Scalars['String']>
  label: Maybe<Scalars['String']>
  primary: Maybe<SpecificationBodyImageContentTilePrimary>
}

export interface SpecificationBodyImageContentTilePrimary {
  __typename?: 'SpecificationBodyImageContentTilePrimary'
  title: Maybe<Scalars['Json']>
  subtitle: Maybe<Scalars['Json']>
  text: Maybe<Scalars['Json']>
  image: Maybe<PrismicImageType>
  imageLocation: Maybe<Scalars['Json']>
  contentOverlapsImage: Maybe<Scalars['Json']>
}

export interface SpecificationBodyImageContentTop {
  __typename?: 'SpecificationBodyImageContentTop'
  type: Maybe<Scalars['String']>
  label: Maybe<Scalars['String']>
  primary: Maybe<SpecificationBodyImageContentTopPrimary>
}

export interface SpecificationBodyImageContentTopPrimary {
  __typename?: 'SpecificationBodyImageContentTopPrimary'
  title: Maybe<Scalars['Json']>
  subtitle: Maybe<Scalars['Json']>
  text: Maybe<Scalars['Json']>
  backgroundImage: Maybe<Scalars['Json']>
}

export interface SpecificationBodyImageTitleTop {
  __typename?: 'SpecificationBodyImageTitleTop'
  type: Maybe<Scalars['String']>
  label: Maybe<Scalars['String']>
  primary: Maybe<SpecificationBodyImageTitleTopPrimary>
}

export interface SpecificationBodyImageTitleTopPrimary {
  __typename?: 'SpecificationBodyImageTitleTopPrimary'
  title: Maybe<Scalars['Json']>
  backgroundImage: Maybe<Scalars['Json']>
}

export interface SpecificationBodyProsAndConsBanner {
  __typename?: 'SpecificationBodyProsAndConsBanner'
  type: Maybe<Scalars['String']>
  label: Maybe<Scalars['String']>
  primary: Maybe<SpecificationBodyProsAndConsBannerPrimary>
}

export interface SpecificationBodyProsAndConsBannerPrimary {
  __typename?: 'SpecificationBodyProsAndConsBannerPrimary'
  title: Maybe<Scalars['Json']>
  subtitle: Maybe<Scalars['Json']>
  pros: Maybe<Scalars['Json']>
  cons: Maybe<Scalars['Json']>
  image: Maybe<PrismicImageType>
}

export interface SpecificationBodyRichText {
  __typename?: 'SpecificationBodyRichText'
  type: Maybe<Scalars['String']>
  label: Maybe<Scalars['String']>
  primary: Maybe<SpecificationBodyRichTextPrimary>
}

export interface SpecificationBodyRichTextPrimary {
  __typename?: 'SpecificationBodyRichTextPrimary'
  text: Maybe<Scalars['Json']>
}

/** A connection to a list of items. */
export interface SpecificationConnectionConnection {
  __typename?: 'SpecificationConnectionConnection'
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  /** A list of edges. */
  edges: Maybe<Array<Maybe<SpecificationConnectionEdge>>>
  totalCount: Scalars['Long']
}

/** An edge in a connection. */
export interface SpecificationConnectionEdge {
  __typename?: 'SpecificationConnectionEdge'
  /** The item at the end of the edge. */
  node: Specification
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
}

export interface Store extends Document, Linkable {
  __typename?: 'Store'
  urlKey: Maybe<Scalars['String']>
  seoTitle: Maybe<Scalars['String']>
  seoDescription: Maybe<Scalars['String']>
  seoKeywords: Maybe<Scalars['String']>
  body: Maybe<Array<StoreBody>>
  meta: Meta
  linkType: Maybe<Scalars['String']>
}

export type StoreBody =
  | StoreBodyCover
  | StoreBodyContact
  | StoreBodyGoogleMap
  | StoreBodyText
  | StoreBodyUsp
  | StoreBodyImages

export interface StoreBodyContact {
  __typename?: 'StoreBodyContact'
  type: Maybe<Scalars['String']>
  label: Maybe<Scalars['String']>
  primary: Maybe<StoreBodyContactPrimary>
  fields: Maybe<Array<StoreBodyContactFields>>
}

export interface StoreBodyContactFields {
  __typename?: 'StoreBodyContactFields'
  specialist: Maybe<Scalars['Json']>
}

export interface StoreBodyContactPrimary {
  __typename?: 'StoreBodyContactPrimary'
  telephoneTitle: Maybe<Scalars['String']>
  telephoneSubtitle: Maybe<Scalars['String']>
  telephoneNumber: Maybe<Scalars['String']>
  whatsappTitle: Maybe<Scalars['String']>
  whatsappSubtitle: Maybe<Scalars['String']>
  whatsappNumber: Maybe<Scalars['String']>
  whatsappChatMessage: Maybe<Scalars['String']>
  emailTitle: Maybe<Scalars['String']>
  emailSubtitle: Maybe<Scalars['String']>
  emailAddress: Maybe<Scalars['String']>
  specialistTitle: Maybe<Scalars['String']>
  specialist1: Maybe<Scalars['Json']>
  specialist2: Maybe<Scalars['Json']>
  specialist3: Maybe<Scalars['Json']>
  specialist4: Maybe<Scalars['Json']>
  specialist5: Maybe<Scalars['Json']>
  specialist6: Maybe<Scalars['Json']>
  specialist7: Maybe<Scalars['Json']>
  specialist8: Maybe<Scalars['Json']>
}

export interface StoreBodyCover {
  __typename?: 'StoreBodyCover'
  type: Maybe<Scalars['String']>
  label: Maybe<Scalars['String']>
  primary: Maybe<StoreBodyCoverPrimary>
  fields: Maybe<Array<StoreBodyCoverFields>>
}

export interface StoreBodyCoverFields {
  __typename?: 'StoreBodyCoverFields'
  specialDateText: Maybe<Scalars['String']>
  specialDate: Maybe<Scalars['Date']>
}

export interface StoreBodyCoverPrimary {
  __typename?: 'StoreBodyCoverPrimary'
  title: Maybe<Scalars['String']>
  label: Maybe<Scalars['String']>
  openTill: Maybe<Scalars['String']>
  image: Maybe<PrismicImageType>
}

export interface StoreBodyGoogleMap {
  __typename?: 'StoreBodyGoogleMap'
  type: Maybe<Scalars['String']>
  label: Maybe<Scalars['String']>
  primary: Maybe<StoreBodyGoogleMapPrimary>
}

export interface StoreBodyGoogleMapPrimary {
  __typename?: 'StoreBodyGoogleMapPrimary'
  latitude: Maybe<Scalars['String']>
  longitude: Maybe<Scalars['String']>
}

export interface StoreBodyImages {
  __typename?: 'StoreBodyImages'
  type: Maybe<Scalars['String']>
  label: Maybe<Scalars['String']>
  fields: Maybe<Array<StoreBodyImagesFields>>
}

export interface StoreBodyImagesFields {
  __typename?: 'StoreBodyImagesFields'
  image: Maybe<PrismicImageType>
}

export interface StoreBodyText {
  __typename?: 'StoreBodyText'
  type: Maybe<Scalars['String']>
  label: Maybe<Scalars['String']>
  primary: Maybe<StoreBodyTextPrimary>
}

export interface StoreBodyTextPrimary {
  __typename?: 'StoreBodyTextPrimary'
  image: Maybe<PrismicImageType>
  text: Maybe<Scalars['Json']>
}

export interface StoreBodyUsp {
  __typename?: 'StoreBodyUsp'
  type: Maybe<Scalars['String']>
  label: Maybe<Scalars['String']>
  fields: Maybe<Array<StoreBodyUspFields>>
}

export interface StoreBodyUspFields {
  __typename?: 'StoreBodyUspFields'
  icon: Maybe<Scalars['Json']>
  title: Maybe<Scalars['String']>
  text: Maybe<Scalars['Json']>
}

/** The type contains information about a store config */
export interface StoreConfig {
  __typename?: 'StoreConfig'
  /** Footer Miscellaneous HTML */
  absoluteFooter: Maybe<Scalars['String']>
  /** Enable autocomplete on login and forgot password forms */
  autocompleteOnStorefront: Maybe<Scalars['Boolean']>
  /** Base currency code */
  baseCurrencyCode: Maybe<Scalars['String']>
  /** Base link URL for the store */
  baseLinkUrl: Maybe<Scalars['String']>
  /** Base media URL for the store */
  baseMediaUrl: Maybe<Scalars['String']>
  /** Base static URL for the store */
  baseStaticUrl: Maybe<Scalars['String']>
  /** Base URL for the store */
  baseUrl: Maybe<Scalars['String']>
  /** Default Sort By. */
  catalogDefaultSortBy: Maybe<Scalars['String']>
  /**
   * Corresponds to the 'Display Prices In Product Lists' field. It indicates how
   * FPT information is displayed on category pages
   */
  categoryFixedProductTaxDisplaySetting: Maybe<FixedProductTaxDisplaySettings>
  /** Category URL Suffix. */
  categoryUrlSuffix: Maybe<Scalars['String']>
  /** CMS Home Page */
  cmsHomePage: Maybe<Scalars['String']>
  /** CMS No Cookies Page */
  cmsNoCookies: Maybe<Scalars['String']>
  /** CMS No Route Page */
  cmsNoRoute: Maybe<Scalars['String']>
  /** A code assigned to the store to identify it */
  code: Maybe<Scalars['String']>
  /** Copyright */
  copyright: Maybe<Scalars['String']>
  defaultCountryId: Maybe<Scalars['String']>
  /** Default Meta Description */
  defaultDescription: Maybe<Scalars['String']>
  /** Default display currency code */
  defaultDisplayCurrencyCode: Maybe<Scalars['String']>
  /** Default Meta Keywords */
  defaultKeywords: Maybe<Scalars['String']>
  /** Default Page Title */
  defaultTitle: Maybe<Scalars['String']>
  /** Display Demo Store Notice */
  demonotice: Maybe<Scalars['Int']>
  /** Default Web URL */
  front: Maybe<Scalars['String']>
  /** Products per Page on Grid Default Value. */
  gridPerPage: Maybe<Scalars['Int']>
  /** Products per Page on Grid Allowed Values. */
  gridPerPageValues: Maybe<Scalars['String']>
  /** GTM Container IDs, optional a comma separated list of Container IDs */
  gtmContainerIds: Maybe<Scalars['String']>
  /** Scripts and Style Sheets */
  headIncludes: Maybe<Scalars['String']>
  /** Favicon Icon */
  headShortcutIcon: Maybe<Scalars['String']>
  /** Logo Image */
  headerLogoSrc: Maybe<Scalars['String']>
  /** The ID number assigned to the store */
  id: Maybe<Scalars['Int']>
  /** List Mode. */
  listMode: Maybe<Scalars['String']>
  /** Products per Page on List Default Value. */
  listPerPage: Maybe<Scalars['Int']>
  /** Products per Page on List Allowed Values. */
  listPerPageValues: Maybe<Scalars['String']>
  /** Store locale */
  locale: Maybe<Scalars['String']>
  /** Logo Image Alt */
  logoAlt: Maybe<Scalars['String']>
  /** Logo Attribute Height */
  logoHeight: Maybe<Scalars['Int']>
  /** Logo Attribute Width */
  logoWidth: Maybe<Scalars['Int']>
  /** The minimum number of characters required for a valid password. */
  minimumPasswordLength: Maybe<Scalars['String']>
  /** Default No-route URL */
  noRoute: Maybe<Scalars['String']>
  /** Default cutoff time */
  postnlCutoffTime: Maybe<Scalars['String']>
  /** Delivery days allow customers to choose on which date they want their order delivered. */
  postnlDeliverydaysActive: Maybe<Scalars['String']>
  /** If evening delivery is available */
  postnlEveningDeliveryActive: Maybe<Scalars['String']>
  /** If evening delivery is available for customers in Belgium */
  postnlEveningDeliveryBeActive: Maybe<Scalars['String']>
  /** Evening delivery fee in shop currency for customers in Belgium */
  postnlEveningDeliveryBeFee: Maybe<Scalars['String']>
  /** Evening delivery fee in shop currency */
  postnlEveningFee: Maybe<Scalars['String']>
  /** How many days in the future after the first delivery moment your customers can choose to receive their orders. */
  postnlMaxDeliverydays: Maybe<Scalars['String']>
  /** Cutoff time for saturday */
  postnlSaturdayCutoffTime: Maybe<Scalars['String']>
  /** Default shipping days until an order is delivered */
  postnlShippingDuration: Maybe<Scalars['String']>
  /** Cutoff time for sunday */
  postnlSundayCutoffTime: Maybe<Scalars['String']>
  /** If Sunday delivery is available */
  postnlSundayDeliveryActive: Maybe<Scalars['String']>
  /** Sunday delivery fee in shop currency */
  postnlSundayFee: Maybe<Scalars['String']>
  /**
   * Corresponds to the 'Display Prices On Product View Page' field. It indicates
   * how FPT information is displayed on product pages
   */
  productFixedProductTaxDisplaySetting: Maybe<FixedProductTaxDisplaySettings>
  /** Product URL Suffix. */
  productUrlSuffix: Maybe<Scalars['String']>
  /** The number of different character classes required in a password (lowercase, uppercase, digits, special characters). */
  requiredCharacterClassesNumber: Maybe<Scalars['String']>
  /** The ID of the root category */
  rootCategoryId: Maybe<Scalars['Int']>
  /**
   * Corresponds to the 'Display Prices In Sales Modules' field. It indicates how
   * FPT information is displayed on cart, checkout, and order pages
   */
  salesFixedProductTaxDisplaySetting: Maybe<FixedProductTaxDisplaySettings>
  /** Secure base link URL for the store */
  secureBaseLinkUrl: Maybe<Scalars['String']>
  /** Secure base media URL for the store */
  secureBaseMediaUrl: Maybe<Scalars['String']>
  /** Secure base static URL for the store */
  secureBaseStaticUrl: Maybe<Scalars['String']>
  /** Secure base URL for the store */
  secureBaseUrl: Maybe<Scalars['String']>
  /** Email to a Friend configuration. */
  sendFriend: Maybe<SendFriendConfiguration>
  /** Show Breadcrumbs for CMS Pages */
  showCmsBreadcrumbs: Maybe<Scalars['Int']>
  socialTrustpilotBusinessUnitId: Maybe<Scalars['String']>
  storeCity: Maybe<Scalars['String']>
  storeCountryId: Maybe<Scalars['String']>
  storeHours: Maybe<Scalars['String']>
  storeMerchantVatNumber: Maybe<Scalars['String']>
  /** Name of the store */
  storeName: Maybe<Scalars['String']>
  storePhone: Maybe<Scalars['String']>
  storePostcode: Maybe<Scalars['String']>
  storeRegionId: Maybe<Scalars['String']>
  storeStreetLine1: Maybe<Scalars['String']>
  storeStreetLine2: Maybe<Scalars['String']>
  /** Timezone of the store */
  timezone: Maybe<Scalars['String']>
  /** Page Title Prefix */
  titlePrefix: Maybe<Scalars['String']>
  /** Page Title Separator. */
  titleSeparator: Maybe<Scalars['String']>
  /** Page Title Suffix */
  titleSuffix: Maybe<Scalars['String']>
  /** The ID number assigned to the website store belongs */
  websiteId: Maybe<Scalars['Int']>
  /** The unit of weight */
  weightUnit: Maybe<Scalars['String']>
  /** Welcome Text */
  welcome: Maybe<Scalars['String']>
}

/** A connection to a list of items. */
export interface StoreConnectionConnection {
  __typename?: 'StoreConnectionConnection'
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  /** A list of edges. */
  edges: Maybe<Array<Maybe<StoreConnectionEdge>>>
  totalCount: Scalars['Long']
}

/** An edge in a connection. */
export interface StoreConnectionEdge {
  __typename?: 'StoreConnectionEdge'
  /** The item at the end of the edge. */
  node: Store
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
}

export interface SubscribeEmailToNewsletterOutput {
  __typename?: 'SubscribeEmailToNewsletterOutput'
  /** Returns the status of the subscription request */
  status: Maybe<SubscriptionStatusesEnum>
}

export enum SubscriptionStatusesEnum {
  NOT_ACTIVE = 'NOT_ACTIVE',
  SUBSCRIBED = 'SUBSCRIBED',
  UNSUBSCRIBED = 'UNSUBSCRIBED',
  UNCONFIRMED = 'UNCONFIRMED',
}

export interface SwatchData {
  __typename?: 'SwatchData'
  /** Type of swatch filter item: 1 - text, 2 - image */
  type: Maybe<Scalars['String']>
  /** Value for swatch item (text or image link) */
  value: Maybe<Scalars['String']>
}

export interface SwatchDataInterface {
  /** Value of swatch item (HEX color code, image link or textual value) */
  value: Maybe<Scalars['String']>
}

export interface SwatchLayerFilterItem
  extends LayerFilterItemInterface,
    SwatchLayerFilterItemInterface {
  __typename?: 'SwatchLayerFilterItem'
  /**
   * Count of items by filter.
   * @deprecated Use AggregationOption.count instead.
   */
  itemsCount: Maybe<Scalars['Int']>
  /**
   * Filter label.
   * @deprecated Use AggregationOption.label instead.
   */
  label: Maybe<Scalars['String']>
  /** Data required to render swatch filter item */
  swatchData: Maybe<SwatchData>
  /**
   * Value for filter request variable to be used in query.
   * @deprecated Use AggregationOption.value instead.
   */
  valueString: Maybe<Scalars['String']>
}

export interface SwatchLayerFilterItemInterface {
  /** Data required to render swatch filter item */
  swatchData: Maybe<SwatchData>
}

export interface Test extends Document, Linkable {
  __typename?: 'Test'
  body: Maybe<Array<TestBody>>
  meta: Meta
  linkType: Maybe<Scalars['String']>
}

export type TestBody = TestBodyMainSlice | TestBodyRelativeSlice

export interface TestBodyMainSlice {
  __typename?: 'TestBodyMainSlice'
  type: Maybe<Scalars['String']>
  label: Maybe<Scalars['String']>
  primary: Maybe<TestBodyMainSlicePrimary>
}

export interface TestBodyMainSlicePrimary {
  __typename?: 'TestBodyMainSlicePrimary'
  title: Maybe<Scalars['Json']>
}

export interface TestBodyRelativeSlice {
  __typename?: 'TestBodyRelativeSlice'
  type: Maybe<Scalars['String']>
  label: Maybe<Scalars['String']>
  primary: Maybe<TestBodyRelativeSlicePrimary>
}

export interface TestBodyRelativeSlicePrimary {
  __typename?: 'TestBodyRelativeSlicePrimary'
  otherSlice: Maybe<PrismicHyperlink>
}

/** A connection to a list of items. */
export interface TestConnectionConnection {
  __typename?: 'TestConnectionConnection'
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  /** A list of edges. */
  edges: Maybe<Array<Maybe<TestConnectionEdge>>>
  totalCount: Scalars['Long']
}

/** An edge in a connection. */
export interface TestConnectionEdge {
  __typename?: 'TestConnectionEdge'
  /** The item at the end of the edge. */
  node: Test
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
}

export interface TextSwatchData extends SwatchDataInterface {
  __typename?: 'TextSwatchData'
  /** Value of swatch item (HEX color code, image link or textual value) */
  value: Maybe<Scalars['String']>
}

/** A price based on the quantity purchased. */
export interface TierPrice {
  __typename?: 'TierPrice'
  /** The price discount that this tier represents. */
  discount: Maybe<ProductDiscount>
  finalPrice: Maybe<Money>
  /** The minimum number of items that must be purchased to qualify for this price tier. */
  quantity: Maybe<Scalars['Float']>
}

export interface Trustpilot {
  __typename?: 'Trustpilot'
  businessUnit: TrustpilotRating
  businessEntity: TrustpilotRating
  profileUrl: Scalars['String']
  evaluateUrl: Scalars['String']
  evaluateEmbedUrl: Scalars['String']
  consumerWebPageUrl: Maybe<Scalars['String']>
}

export interface TrustpilotRating {
  __typename?: 'TrustpilotRating'
  stars: Scalars['Float']
  trustScore: Scalars['Float']
  displayName: Scalars['String']
  numberOfReviews: TrustpilotReviewsCount
  websiteUrl: Scalars['String']
}

export interface TrustpilotReviewsCount {
  __typename?: 'TrustpilotReviewsCount'
  total: Scalars['Int']
  oneStar: Scalars['Int']
  twoStars: Scalars['Int']
  threeStars: Scalars['Int']
  fourStars: Scalars['Int']
  fiveStars: Scalars['Int']
}

export interface TweakwiseAutocompleteParams {
  /**
   * The category that should contain the filtered results. If you want to provide
   * the entire path, you can provide multiple ids.
   */
  categoryId?: Maybe<Array<Scalars['ID']>>
  /** Use instant search. Defaults to false. */
  instant?: Maybe<Scalars['Boolean']>
  /** The number of results that will be returned per component. Defaults to 6. Max 20. */
  maxResults?: Maybe<Scalars['Int']>
  /** Specify the language to use for the search algorithms. */
  language?: Maybe<Scalars['String']>
  /** Specify the keyboard to use for the search algorithms. */
  keyboard?: Maybe<TweakwiseKeyboardLayout>
  /**
   * Hidden parameters can be added to the URL by using the parameter 'tn_parameters'.
   *
   * When filtering by property 'brand' with value 'Coca Cola' or with value
   * 'Pepsi' the value of tn_parameters should be: brand=Coca Cola&brand=Pepsi
   *
   * This value should then be URL encoded.
   */
  parameters?: Maybe<Array<TweakwiseNavigationParameter>>
}

export interface TweakwiseAutocompleteResult {
  __typename?: 'TweakwiseAutocompleteResult'
  items: Array<TweakwiseNavigationItem>
  keywords: Array<Scalars['String']>
  isInstantSearchActive: Maybe<Scalars['Boolean']>
  instantSearchTerm: Maybe<Scalars['String']>
}

export enum TweakwiseKeyboardLayout {
  QWERTY = 'qwerty',
  AZERTY = 'azerty',
  QWERTZ = 'qwertz',
}

export interface TweakwiseNavigationAttribute {
  __typename?: 'TweakwiseNavigationAttribute'
  title: Scalars['String']
  facetAttributeName: Scalars['ID']
  isSelected: Scalars['Boolean']
  nrOfResults: Scalars['Int']
  attributeId: Maybe<Scalars['Int']>
  url: Maybe<Scalars['String']>
  imageTag: Maybe<Scalars['String']>
  children: Maybe<Scalars['TODO']>
  colorSwatch: Maybe<ColorSwatch>
}

export interface TweakwiseNavigationFacet {
  __typename?: 'TweakwiseNavigationFacet'
  facetSettings: FacetSettings
  attributes: Array<TweakwiseNavigationAttribute>
}

export interface TweakwiseNavigationFacetFilter {
  key: Scalars['String']
  values: Array<Scalars['String']>
}

export interface TweakwiseNavigationItem {
  __typename?: 'TweakwiseNavigationItem'
  itemNo: Scalars['ID']
  title: Scalars['String']
  price: Scalars['Float']
  brand: Maybe<Scalars['String']>
  image: Maybe<Scalars['String']>
  product: Maybe<ProductInterface>
}

export interface TweakwiseNavigationParameter {
  property: Scalars['String']
  value: Scalars['String']
}

export interface TweakwiseNavigationParams {
  /**
   * The category ID to query. When filtering by a subcategory, providing the
   * parent categoryIds will keep the category facet accurate.
   */
  categoryId?: Maybe<Array<Scalars['ID']>>
  /** The facets with which the results are filtered by. */
  facets?: Maybe<Array<TweakwiseNavigationFacetFilter>>
  /** Sorting the results. The XML returns the values which can be used for sorting. */
  sortKey?: Maybe<Scalars['String']>
  /** Sort direction when sortKey is set. */
  sortDirection?: Maybe<TweakwiseSortDirection>
  /** The page number of the page that must be displayed. */
  page?: Maybe<Scalars['Int']>
  /**
   * The number of products that must be displayed per page. The standard value is
   * configured at shop level. Only use this parameter to overrule this standard
   * configured quantity.
   */
  pageSize?: Maybe<Scalars['Int']>
  /** Overruling the linked filter template with the specified template. */
  filterTemplateId?: Maybe<Scalars['Int']>
  /** Overruling the linked sorting template with the specified template. */
  sortTemplateId?: Maybe<Scalars['Int']>
  /** Hidden parameters. */
  parameters?: Maybe<Array<TweakwiseNavigationParameter>>
  /**
   * Personal parameters.
   *
   * Personal parameters are similar to hidden parameters, except they only apply
   * to recommendations to which the filters are assigned. This is typically useful
   * when you are using personal merchandising and the filters should only be
   * applied to select components.
   */
  personalParameters?: Maybe<Array<TweakwiseNavigationParameter>>
  /** Specify the keyboard to use for the search algorithms. */
  keyboard?: Maybe<TweakwiseKeyboardLayout>
  /**
   * The visitor key is an identifier for the person browsing your website who is
   * initiating the navigation requests. This same identifier should also be used
   * to identify the visitor when sending events to our Analytics API. Based on the
   * sent events, the visitor can receive personalized results.
   *
   * The visitor key can be any string as long as it is unique to the visitor.
   * Generate for example a Universally Unique Identifier (UUID), a new id per
   * visitor or use an account id.
   */
  visitorKey?: Maybe<Scalars['String']>
  /**
   * Search term entered by the user.
   *
   * This executes a text based search on the Tweakwise rest api. Passing this
   * parameter also queries the `navigate-search` endpoint instead of the
   * `navigate` endpoint.
   */
  query?: Maybe<Scalars['String']>
}

export interface TweakwiseNavigationProperties {
  __typename?: 'TweakwiseNavigationProperties'
  nrOfItems: Scalars['Int']
  pageSize: Scalars['Int']
  nrOfPages: Scalars['Int']
  currentPage: Scalars['Int']
  selectedCategory: Scalars['Int']
  searchTerm: Maybe<Scalars['String']>
  suggestedSearchTerm: Maybe<Scalars['String']>
  isDirectSearch: Scalars['Boolean']
  isRootCategory: Scalars['Boolean']
  pageUrl: Scalars['String']
  resetUrl: Scalars['String']
  sortFields: Array<TweakwiseNavigationPropertiesSortField>
}

export interface TweakwiseNavigationPropertiesSortField {
  __typename?: 'TweakwiseNavigationPropertiesSortField'
  title: Scalars['String']
  displayTitle: Scalars['String']
  order: Scalars['String']
  isSelected: Scalars['Boolean']
  url: Scalars['String']
}

export interface TweakwiseNavigationRedirect {
  __typename?: 'TweakwiseNavigationRedirect'
  url: Scalars['String']
}

export interface TweakwiseNavigationResult {
  __typename?: 'TweakwiseNavigationResult'
  facets: Array<TweakwiseNavigationFacet>
  items: Array<TweakwiseNavigationItem>
  properties: TweakwiseNavigationProperties
  redirects: Array<TweakwiseNavigationRedirect>
}

export interface TweakwiseProductRecommendationsTemplate {
  __typename?: 'TweakwiseProductRecommendationsTemplate'
  id: Scalars['ID']
  name: Scalars['String']
  items: Array<TweakwiseNavigationItem>
}

export interface TweakwiseRecommendationsFeaturedParams {
  /**
   * The category that should contain the filtered results. If you want to provide
   * the entire path, you can provide multiple ids.
   */
  categoryId?: Maybe<Array<Scalars['ID']>>
  /**
   * Hidden parameters can be added to the URL by using the parameter 'tn_parameters'.
   *
   * When filtering by property 'brand' with value 'Coca Cola' or with value
   * 'Pepsi' the value of tn_parameters should be: brand=Coca Cola&brand=Pepsi
   *
   * This value should then be URL encoded.
   */
  parameters?: Maybe<Array<TweakwiseNavigationParameter>>
}

export enum TweakwiseSortDirection {
  ASCENDING = 'Ascending',
  DESCENDING = 'Descending',
}

export interface UpdateCartItemsInput {
  cart_id: Scalars['String']
  cart_items: Array<Maybe<CartItemUpdateInput>>
}

export interface UpdateCartItemsOutput {
  __typename?: 'UpdateCartItemsOutput'
  cart: Cart
}

/** The object contains URL rewrite details */
export interface UrlRewrite {
  __typename?: 'UrlRewrite'
  /** Request parameters */
  parameters: Maybe<Array<Maybe<HttpQueryParameter>>>
  /** Request URL */
  url: Maybe<Scalars['String']>
}

/** This enumeration defines the entity type. */
export enum UrlRewriteEntityTypeEnum {
  CMS_PAGE = 'CMS_PAGE',
  PRODUCT = 'PRODUCT',
  CATEGORY = 'CATEGORY',
  PRISMIC = 'PRISMIC',
  REDIRECT = 'REDIRECT',
}

/** Virtual Cart Item */
export interface VirtualCartItem extends CartItemInterface {
  __typename?: 'VirtualCartItem'
  customizableOptions: Maybe<Array<Maybe<SelectedCustomizableOption>>>
  id: Scalars['String']
  prices: Maybe<CartItemPrices>
  product: ProductInterface
  quantity: Scalars['Float']
}

/** A virtual product is non-tangible product that does not require shipping and is not kept in inventory. */
export interface VirtualProduct
  extends ProductInterface,
    CustomizableProductInterface {
  __typename?: 'VirtualProduct'
  activity: Maybe<Scalars['String']>
  allowcoupon: Maybe<Scalars['Int']>
  allowingenico: Maybe<Scalars['Int']>
  allowpostnllabel: Maybe<Scalars['Int']>
  allowreview: Maybe<Scalars['Int']>
  alternatiefmemo: Maybe<Scalars['String']>
  /** The attribute set assigned to the product. */
  attributeSetId: Maybe<Scalars['Int']>
  /**
   * Relative canonical URL. This value is returned only if the system setting 'Use
   * Canonical Link Meta Tag For Products' is enabled
   */
  canonicalUrl: Maybe<Scalars['String']>
  /** The categories assigned to a product. */
  categories: Maybe<Array<Maybe<CategoryInterface>>>
  categoryGear: Maybe<Scalars['String']>
  climate: Maybe<Scalars['String']>
  collar: Maybe<Scalars['String']>
  color: Maybe<Scalars['Int']>
  cons: Maybe<Scalars['String']>
  /** The product's country of origin. */
  countryOfManufacture: Maybe<Scalars['String']>
  /** Timestamp indicating when the product was created. */
  createdAt: Maybe<Scalars['String']>
  /** Crosssell Products */
  crosssellProducts: Maybe<Array<Maybe<ProductInterface>>>
  /** Detailed information about the product. The value can include simple HTML tags. */
  description: Maybe<ComplexTextValue>
  doorverkooppremie: Maybe<Scalars['String']>
  ean: Maybe<Scalars['String']>
  ecoCollection: Maybe<Scalars['Int']>
  enabled: Maybe<Scalars['Int']>
  erinRecommends: Maybe<Scalars['Int']>
  factuurinformatie: Maybe<Scalars['String']>
  featuresBags: Maybe<Scalars['String']>
  fixedprice: Maybe<Scalars['Int']>
  fixeduntil: Maybe<Scalars['String']>
  gebruikbundelproductenprijs: Maybe<Scalars['Int']>
  gender: Maybe<Scalars['String']>
  /** Indicates whether a gift message is available. */
  giftMessageAvailable: Maybe<Scalars['String']>
  google: Maybe<Scalars['Int']>
  /** The ID number assigned to the product. */
  id: Scalars['Int']
  /** The relative path to the main image on the product page. */
  image: Maybe<ProductImage>
  inkoopprijs: Maybe<Scalars['String']>
  isBuitenkansje: Maybe<Scalars['Int']>
  isInStock: Maybe<Scalars['Int']>
  keepproductbuttons: Maybe<Scalars['Int']>
  kenmerken: Maybe<Scalars['String']>
  kieskeurig: Maybe<Scalars['Int']>
  kieskeurigbe: Maybe<Scalars['Int']>
  kieskeurigtekstad: Maybe<Scalars['String']>
  korteomschrijving: Maybe<Scalars['String']>
  korteomschrijving2: Maybe<Scalars['String']>
  langeomschrijving: Maybe<Scalars['String']>
  /** A number representing the product's manufacturer. */
  manufacturer: Maybe<Scalars['Int']>
  material: Maybe<Scalars['String']>
  maxprijsomnia: Maybe<Scalars['String']>
  /** An array of Media Gallery objects. */
  mediaGallery: Maybe<Array<Maybe<MediaGalleryInterface>>>
  /**
   * An array of MediaGalleryEntry objects.
   * @deprecated Use product's `media_gallery` instead
   */
  mediaGalleryEntries: Maybe<Array<Maybe<MediaGalleryEntry>>>
  merk: Maybe<Scalars['Int']>
  /** A brief overview of the product for search results listings, maximum 255 characters. */
  metaDescription: Maybe<Scalars['String']>
  /** A comma-separated list of keywords that are visible only to search engines. */
  metaKeyword: Maybe<Scalars['String']>
  /** A string that is displayed in the title bar and tab of the browser and in search results lists. */
  metaTitle: Maybe<Scalars['String']>
  modeltype: Maybe<Scalars['String']>
  /** The product name. Customers use this name to identify the product. */
  name: Scalars['String']
  new: Maybe<Scalars['Int']>
  /** The beginning date for new product listings, and determines if the product is featured as a new product. */
  newFromDate: Maybe<Scalars['String']>
  /** The end date for new product listings. */
  newToDate: Maybe<Scalars['String']>
  omnia: Maybe<Scalars['Int']>
  /** Product stock only x left count */
  onlyXLeftInStock: Maybe<Scalars['Float']>
  opmerking1: Maybe<Scalars['String']>
  opmerking2: Maybe<Scalars['String']>
  /** An array of options for a customizable product. */
  options: Maybe<Array<Maybe<CustomizableOptionInterface>>>
  /** If the product has multiple options, determines where they appear on the product page. */
  optionsContainer: Maybe<Scalars['String']>
  pattern: Maybe<Scalars['String']>
  percentagekortingopprijsvanbundelproducten: Maybe<Scalars['String']>
  performanceFabric: Maybe<Scalars['Int']>
  pimcoreId: Maybe<Scalars['Int']>
  populariteit: Maybe<Scalars['String']>
  /**
   * A ProductPrices object, indicating the price of an item.
   * @deprecated Use price_range for product price information.
   */
  price: Maybe<ProductPrices>
  /** A PriceRange object, indicating the range of prices for the product */
  priceRange: PriceRange
  /** An array of TierPrice objects. */
  priceTiers: Maybe<Array<Maybe<TierPrice>>>
  prijs: Maybe<Scalars['String']>
  /** An array of ProductLinks objects. */
  productLinks: Maybe<Array<Maybe<ProductLinksInterface>>>
  productnaam: Maybe<Scalars['String']>
  productnaam1: Maybe<Scalars['String']>
  productspideren: Maybe<Scalars['Int']>
  promotekst: Maybe<Scalars['String']>
  pros: Maybe<Scalars['String']>
  /** Related Products */
  relatedProducts: Maybe<Array<Maybe<ProductInterface>>>
  s2m: Maybe<Scalars['Int']>
  sale: Maybe<Scalars['Int']>
  serie: Maybe<Scalars['String']>
  /** A short description of the product. Its use depends on the theme. */
  shortDescription: Maybe<ComplexTextValue>
  size: Maybe<Scalars['Int']>
  /** A number or code assigned to a product to identify the product, options, price, and manufacturer. */
  sku: Scalars['String']
  sleeve: Maybe<Scalars['String']>
  /** The relative path to the small image, which is used on catalog pages. */
  smallImage: Maybe<ProductImage>
  /** The beginning date that a product has a special price. */
  specialFromDate: Maybe<Scalars['String']>
  /** The discounted price of the product. */
  specialPrice: Maybe<Scalars['Float']>
  /** The end date that a product has a special price. */
  specialToDate: Maybe<Scalars['String']>
  specialprice: Maybe<Scalars['String']>
  specificationsBluetoothspeakerAansluitingen: Maybe<Scalars['String']>
  specificationsBluetoothspeakerAantalspeakers: Maybe<Scalars['String']>
  specificationsBluetoothspeakerAantalusb: Maybe<Scalars['String']>
  specificationsBluetoothspeakerAantalusbc: Maybe<Scalars['String']>
  specificationsBluetoothspeakerAfmetingen: Maybe<Scalars['String']>
  specificationsBluetoothspeakerAfmetingensubwoofer: Maybe<Scalars['String']>
  specificationsBluetoothspeakerFabriekscode: Maybe<Scalars['String']>
  specificationsBluetoothspeakerGewicht: Maybe<Scalars['String']>
  specificationsBluetoothspeakerGewichtsubwoofer: Maybe<Scalars['String']>
  specificationsBluetoothspeakerIntroductiejaar: Maybe<Scalars['String']>
  specificationsBluetoothspeakerKanalen: Maybe<Scalars['String']>
  specificationsBluetoothspeakerKleur: Maybe<Scalars['Int']>
  specificationsBluetoothspeakerSpeeltaf: Maybe<Scalars['String']>
  specificationsBluetoothspeakerStandaardmeegeleverd: Maybe<Scalars['String']>
  specificationsBluetoothspeakerStreaming: Maybe<Scalars['String']>
  specificationsBluetoothspeakerStroomvoorziening: Maybe<Scalars['String']>
  specificationsBluetoothspeakerTypeaudio: Maybe<Scalars['Int']>
  specificationsBluetoothspeakerTypespeaker: Maybe<Scalars['String']>
  specificationsBluetoothspeakerVermogen: Maybe<Scalars['String']>
  specificationsBlurayspelerAfmetingen: Maybe<Scalars['String']>
  specificationsBlurayspelerAfspelenvan: Maybe<Scalars['String']>
  specificationsBlurayspelerAnalogeaudio: Maybe<Scalars['String']>
  specificationsBlurayspelerAudioenvideo: Maybe<Scalars['String']>
  specificationsBlurayspelerBdlive: Maybe<Scalars['Int']>
  specificationsBlurayspelerBluetooth: Maybe<Scalars['Int']>
  specificationsBlurayspelerCoaxiaal: Maybe<Scalars['String']>
  specificationsBlurayspelerDecoders: Maybe<Scalars['String']>
  specificationsBlurayspelerDigitaalcoaxaal: Maybe<Scalars['String']>
  specificationsBlurayspelerDigitaaloptisch: Maybe<Scalars['String']>
  specificationsBlurayspelerDigitaleoptisch: Maybe<Scalars['Int']>
  specificationsBlurayspelerDlna: Maybe<Scalars['Int']>
  specificationsBlurayspelerDriedondersteuning: Maybe<Scalars['Int']>
  specificationsBlurayspelerEthernet: Maybe<Scalars['String']>
  specificationsBlurayspelerFormats: Maybe<Scalars['String']>
  specificationsBlurayspelerFuncties: Maybe<Scalars['String']>
  specificationsBlurayspelerGecerthires: Maybe<Scalars['Int']>
  specificationsBlurayspelerGewicht: Maybe<Scalars['String']>
  specificationsBlurayspelerHdmi: Maybe<Scalars['String']>
  specificationsBlurayspelerHdr: Maybe<Scalars['Int']>
  specificationsBlurayspelerKleur: Maybe<Scalars['Int']>
  specificationsBlurayspelerLan: Maybe<Scalars['Int']>
  specificationsBlurayspelerMiracast: Maybe<Scalars['Int']>
  specificationsBlurayspelerMultiroom: Maybe<Scalars['Int']>
  specificationsBlurayspelerOndersteundaudioformaat: Maybe<Scalars['String']>
  specificationsBlurayspelerOptisch: Maybe<Scalars['Int']>
  specificationsBlurayspelerOutputkanalen: Maybe<Scalars['String']>
  specificationsBlurayspelerPlayback: Maybe<Scalars['String']>
  specificationsBlurayspelerResolutie: Maybe<Scalars['String']>
  specificationsBlurayspelerSmarttv: Maybe<Scalars['Int']>
  specificationsBlurayspelerSpeeltaf: Maybe<Scalars['String']>
  specificationsBlurayspelerSpeeltvandisc: Maybe<Scalars['String']>
  specificationsBlurayspelerStandaardmeegeleverd: Maybe<Scalars['String']>
  specificationsBlurayspelerStroomverbruik: Maybe<Scalars['String']>
  specificationsBlurayspelerUpscaling: Maybe<Scalars['Int']>
  specificationsBlurayspelerUsb: Maybe<Scalars['String']>
  specificationsBlurayspelerVierkuhd: Maybe<Scalars['Int']>
  specificationsBlurayspelerVierkuhdups: Maybe<Scalars['Int']>
  specificationsBlurayspelerWifi: Maybe<Scalars['Int']>
  specificationsCdspelerAansluitingen: Maybe<Scalars['String']>
  specificationsCdspelerAantalusb: Maybe<Scalars['String']>
  specificationsCdspelerAchterspeakers: Maybe<Scalars['Int']>
  specificationsCdspelerAfmetingen: Maybe<Scalars['String']>
  specificationsCdspelerFabriekscode: Maybe<Scalars['String']>
  specificationsCdspelerGewicht: Maybe<Scalars['String']>
  specificationsCdspelerImpendatie: Maybe<Scalars['String']>
  specificationsCdspelerIntroductiejaar: Maybe<Scalars['String']>
  specificationsCdspelerKanalen: Maybe<Scalars['String']>
  specificationsCdspelerMultiroom: Maybe<Scalars['Int']>
  specificationsCdspelerRadio: Maybe<Scalars['Int']>
  specificationsCdspelerSpeakeraansluiting: Maybe<Scalars['String']>
  specificationsCdspelerSpeeltaf: Maybe<Scalars['String']>
  specificationsCdspelerStandaardmeegeleverd: Maybe<Scalars['String']>
  specificationsCdspelerStreaming: Maybe<Scalars['String']>
  specificationsCdspelerStreamingdiensten: Maybe<Scalars['String']>
  specificationsCdspelerStroomvoorziening: Maybe<Scalars['Int']>
  specificationsCdspelerSubwooferuitgang: Maybe<Scalars['Int']>
  specificationsCdspelerTypeaudio: Maybe<Scalars['Int']>
  specificationsCdspelerVermogen: Maybe<Scalars['String']>
  specificationsDraadlozespeakerAantalspeakers: Maybe<Scalars['String']>
  specificationsDraadlozespeakerAfmetingen: Maybe<Scalars['String']>
  specificationsDraadlozespeakerAirplay2: Maybe<Scalars['Int']>
  specificationsDraadlozespeakerAux: Maybe<Scalars['Int']>
  specificationsDraadlozespeakerBluetooth: Maybe<Scalars['Int']>
  specificationsDraadlozespeakerComponent: Maybe<Scalars['Int']>
  specificationsDraadlozespeakerComposiet: Maybe<Scalars['Int']>
  specificationsDraadlozespeakerFabriekscode: Maybe<Scalars['String']>
  specificationsDraadlozespeakerGebruiksduuraccu: Maybe<Scalars['String']>
  specificationsDraadlozespeakerGewicht: Maybe<Scalars['String']>
  specificationsDraadlozespeakerHdmiin: Maybe<Scalars['String']>
  specificationsDraadlozespeakerHdmiuit: Maybe<Scalars['String']>
  specificationsDraadlozespeakerKanalen: Maybe<Scalars['String']>
  specificationsDraadlozespeakerMinijack: Maybe<Scalars['Int']>
  specificationsDraadlozespeakerMultiroom: Maybe<Scalars['Int']>
  specificationsDraadlozespeakerOptischcoax: Maybe<Scalars['Int']>
  specificationsDraadlozespeakerPlatenspeler: Maybe<Scalars['Int']>
  specificationsDraadlozespeakerSpotifyconnect: Maybe<Scalars['Int']>
  specificationsDraadlozespeakerSubwoofer: Maybe<Scalars['Int']>
  specificationsDraadlozespeakerUsb: Maybe<Scalars['Int']>
  specificationsDraadlozespeakerVoicecontrol: Maybe<Scalars['Int']>
  specificationsDraadlozespeakerWifi: Maybe<Scalars['Int']>
  specificationsHifispeakerAansluitingen: Maybe<Scalars['String']>
  specificationsHifispeakerAantalspeakers: Maybe<Scalars['String']>
  specificationsHifispeakerAantalusb: Maybe<Scalars['String']>
  specificationsHifispeakerAchterspeakers: Maybe<Scalars['Int']>
  specificationsHifispeakerAfmetingen: Maybe<Scalars['String']>
  specificationsHifispeakerAfmetingensubwoofer: Maybe<Scalars['String']>
  specificationsHifispeakerBelastbaarheid: Maybe<Scalars['String']>
  specificationsHifispeakerFabriekscode: Maybe<Scalars['String']>
  specificationsHifispeakerGewicht: Maybe<Scalars['String']>
  specificationsHifispeakerGewichtsubwoofer: Maybe<Scalars['String']>
  specificationsHifispeakerImpendatie: Maybe<Scalars['String']>
  specificationsHifispeakerIntroductiejaar: Maybe<Scalars['String']>
  specificationsHifispeakerKanalen: Maybe<Scalars['String']>
  specificationsHifispeakerKleur: Maybe<Scalars['Int']>
  specificationsHifispeakerMaximalefrequentie: Maybe<Scalars['String']>
  specificationsHifispeakerMinimalefrequentie: Maybe<Scalars['String']>
  specificationsHifispeakerMultiroom: Maybe<Scalars['Int']>
  specificationsHifispeakerSpeakeraansluiting: Maybe<Scalars['String']>
  specificationsHifispeakerSpeakertype: Maybe<Scalars['String']>
  specificationsHifispeakerStandaardmeegeleverd: Maybe<Scalars['String']>
  specificationsHifispeakerStreaming: Maybe<Scalars['String']>
  specificationsHifispeakerStroomvoorziening: Maybe<Scalars['Int']>
  specificationsHifispeakerTypeaudio: Maybe<Scalars['Int']>
  specificationsHifispeakerTypespeaker: Maybe<Scalars['String']>
  specificationsHifispeakerVermogen: Maybe<Scalars['String']>
  specificationsHifispeakerWaterbestendig: Maybe<Scalars['Int']>
  specificationsHomecinemaAansluitingen: Maybe<Scalars['String']>
  specificationsHomecinemaAantalhdmi: Maybe<Scalars['String']>
  specificationsHomecinemaAantalspeakers: Maybe<Scalars['String']>
  specificationsHomecinemaAantalusb: Maybe<Scalars['String']>
  specificationsHomecinemaAchterspeakers: Maybe<Scalars['Int']>
  specificationsHomecinemaAfmetingen: Maybe<Scalars['String']>
  specificationsHomecinemaFabriekscode: Maybe<Scalars['String']>
  specificationsHomecinemaGewicht: Maybe<Scalars['String']>
  specificationsHomecinemaGewichtsubwoofer: Maybe<Scalars['String']>
  specificationsHomecinemaImpendatie: Maybe<Scalars['String']>
  specificationsHomecinemaIntroductiejaar: Maybe<Scalars['String']>
  specificationsHomecinemaKleur: Maybe<Scalars['Int']>
  specificationsHomecinemaMicrofoon: Maybe<Scalars['Int']>
  specificationsHomecinemaMultiroom: Maybe<Scalars['Int']>
  specificationsHomecinemaRadio: Maybe<Scalars['Int']>
  specificationsHomecinemaSpeakeraansluiting: Maybe<Scalars['String']>
  specificationsHomecinemaSpeeltaf: Maybe<Scalars['String']>
  specificationsHomecinemaStandaardmeegeleverd: Maybe<Scalars['String']>
  specificationsHomecinemaStreaming: Maybe<Scalars['String']>
  specificationsHomecinemaStreamingdiensten: Maybe<Scalars['String']>
  specificationsHomecinemaStroomvoorziening: Maybe<Scalars['Int']>
  specificationsHomecinemaSubwooferuitgang: Maybe<Scalars['String']>
  specificationsHomecinemaTypeaudio: Maybe<Scalars['Int']>
  specificationsHomecinemaTypespeaker: Maybe<Scalars['String']>
  specificationsHomecinemaVermogen: Maybe<Scalars['String']>
  specificationsMuurbeugelAantalgradendraaibaar: Maybe<Scalars['String']>
  specificationsMuurbeugelAantalgradenkantelbaar: Maybe<Scalars['String']>
  specificationsMuurbeugelBedieningviaapp: Maybe<Scalars['Int']>
  specificationsMuurbeugelGarantie: Maybe<Scalars['String']>
  specificationsMuurbeugelGeschiktvoorafmetingentv: Maybe<Scalars['String']>
  specificationsMuurbeugelInterfacebreedte: Maybe<Scalars['String']>
  specificationsMuurbeugelInterfacehoogte: Maybe<Scalars['String']>
  specificationsMuurbeugelIntroductiejaar: Maybe<Scalars['String']>
  specificationsMuurbeugelKleur: Maybe<Scalars['Int']>
  specificationsMuurbeugelMaxafstandmuur: Maybe<Scalars['String']>
  specificationsMuurbeugelMaximalegewichttv: Maybe<Scalars['String']>
  specificationsMuurbeugelMerkmuurbeugel: Maybe<Scalars['Int']>
  specificationsMuurbeugelMinafstandmuur: Maybe<Scalars['String']>
  specificationsMuurbeugelSoortmuurbeugel: Maybe<Scalars['Int']>
  specificationsMuurbeugelStandaardmeegeleverd: Maybe<Scalars['String']>
  specificationsMuurbeugelTypemuurbeugel: Maybe<Scalars['String']>
  specificationsMuurbeugelUittrekbaar: Maybe<Scalars['Int']>
  specificationsMuurbeugelVesaafmetingen: Maybe<Scalars['String']>
  specificationsNetwerkspelerAansluitingen: Maybe<Scalars['String']>
  specificationsNetwerkspelerAantalusb: Maybe<Scalars['String']>
  specificationsNetwerkspelerAchterspeakers: Maybe<Scalars['Int']>
  specificationsNetwerkspelerAfmetingen: Maybe<Scalars['String']>
  specificationsNetwerkspelerAfmetingensubwoofer: Maybe<Scalars['String']>
  specificationsNetwerkspelerBelastbaarheid: Maybe<Scalars['String']>
  specificationsNetwerkspelerFabriekscode: Maybe<Scalars['String']>
  specificationsNetwerkspelerGewicht: Maybe<Scalars['String']>
  specificationsNetwerkspelerGewichtsubwoofer: Maybe<Scalars['String']>
  specificationsNetwerkspelerIntroductiejaar: Maybe<Scalars['String']>
  specificationsNetwerkspelerKanalen: Maybe<Scalars['String']>
  specificationsNetwerkspelerKleur: Maybe<Scalars['Int']>
  specificationsNetwerkspelerMultiroom: Maybe<Scalars['Int']>
  specificationsNetwerkspelerRadio: Maybe<Scalars['Int']>
  specificationsNetwerkspelerSpeakeraansluiting: Maybe<Scalars['String']>
  specificationsNetwerkspelerSpeeltaf: Maybe<Scalars['String']>
  specificationsNetwerkspelerStandaardmeegeleverd: Maybe<Scalars['String']>
  specificationsNetwerkspelerStreaming: Maybe<Scalars['String']>
  specificationsNetwerkspelerStreamingdiensten: Maybe<Scalars['String']>
  specificationsNetwerkspelerStroomvoorziening: Maybe<Scalars['Int']>
  specificationsNetwerkspelerSubwoofer: Maybe<Scalars['Int']>
  specificationsNetwerkspelerSubwooferuitgang: Maybe<Scalars['Int']>
  specificationsNetwerkspelerTypeaudio: Maybe<Scalars['Int']>
  specificationsNetwerkspelerVermogen: Maybe<Scalars['String']>
  specificationsOverigeaudioAansluitingen: Maybe<Scalars['String']>
  specificationsOverigeaudioAantalhdmi: Maybe<Scalars['String']>
  specificationsOverigeaudioAantalspeakers: Maybe<Scalars['String']>
  specificationsOverigeaudioAantalusb: Maybe<Scalars['String']>
  specificationsOverigeaudioAfmetingen: Maybe<Scalars['String']>
  specificationsOverigeaudioAfmetingensubwoofer: Maybe<Scalars['String']>
  specificationsOverigeaudioFabriekscode: Maybe<Scalars['String']>
  specificationsOverigeaudioGewicht: Maybe<Scalars['String']>
  specificationsOverigeaudioGewichtsubwoofer: Maybe<Scalars['String']>
  specificationsOverigeaudioIntroductiejaar: Maybe<Scalars['String']>
  specificationsOverigeaudioKanalen: Maybe<Scalars['String']>
  specificationsOverigeaudioKleur: Maybe<Scalars['Int']>
  specificationsOverigeaudioMaximalefrequentie: Maybe<Scalars['String']>
  specificationsOverigeaudioMinimalefrequentie: Maybe<Scalars['String']>
  specificationsOverigeaudioRadio: Maybe<Scalars['String']>
  specificationsOverigeaudioStandaardmeegeleverd: Maybe<Scalars['String']>
  specificationsOverigeaudioStreaming: Maybe<Scalars['String']>
  specificationsOverigeaudioStroomvoorziening: Maybe<Scalars['Int']>
  specificationsOverigeaudioVermogen: Maybe<Scalars['String']>
  specificationsOverigeaudioWaterbestendig: Maybe<Scalars['Int']>
  specificationsPlafondbeugelsAantaldraai: Maybe<Scalars['String']>
  specificationsPlafondbeugelsBeeldformaat: Maybe<Scalars['String']>
  specificationsPlafondbeugelsDraaien: Maybe<Scalars['String']>
  specificationsPlafondbeugelsGarantie: Maybe<Scalars['String']>
  specificationsPlafondbeugelsGroottetv: Maybe<Scalars['String']>
  specificationsPlafondbeugelsHoogte: Maybe<Scalars['String']>
  specificationsPlafondbeugelsHoogteverstelling: Maybe<Scalars['Int']>
  specificationsPlafondbeugelsInterfacebreedte: Maybe<Scalars['String']>
  specificationsPlafondbeugelsInterfacehoogte: Maybe<Scalars['String']>
  specificationsPlafondbeugelsInterfaceoptioneel: Maybe<Scalars['Int']>
  specificationsPlafondbeugelsKabelinlegsysteem: Maybe<Scalars['String']>
  specificationsPlafondbeugelsKantelen: Maybe<Scalars['String']>
  specificationsPlafondbeugelsKleur: Maybe<Scalars['Int']>
  specificationsPlafondbeugelsLengtebuis: Maybe<Scalars['String']>
  specificationsPlafondbeugelsMaxgewicht: Maybe<Scalars['String']>
  specificationsPlafondbeugelsMontagehoek: Maybe<Scalars['String']>
  specificationsPlafondbeugelsProductlijn: Maybe<Scalars['Int']>
  specificationsPlafondbeugelsRoteren: Maybe<Scalars['Int']>
  specificationsPlafondbeugelsSchuineplafondoplossing: Maybe<Scalars['Int']>
  specificationsPlafondbeugelsUitschuifbaar: Maybe<Scalars['Int']>
  specificationsPlafondbeugelsVesamaximaal: Maybe<Scalars['String']>
  specificationsPlafondbeugelsVesaminimaal: Maybe<Scalars['String']>
  specificationsPlafondbeugelsVesanorm: Maybe<Scalars['String']>
  specificationsPlafondbeugelsZwenken: Maybe<Scalars['Int']>
  specificationsReceiverAansluitingen: Maybe<Scalars['String']>
  specificationsReceiverAantalspeakers: Maybe<Scalars['String']>
  specificationsReceiverAchterspeakers: Maybe<Scalars['Int']>
  specificationsReceiverAfmetingen: Maybe<Scalars['String']>
  specificationsReceiverAirplay2: Maybe<Scalars['Int']>
  specificationsReceiverArc: Maybe<Scalars['Int']>
  specificationsReceiverAux: Maybe<Scalars['Int']>
  specificationsReceiverBeeldondersteuning: Maybe<Scalars['String']>
  specificationsReceiverBluetooth: Maybe<Scalars['Int']>
  specificationsReceiverCoax: Maybe<Scalars['String']>
  specificationsReceiverComponent: Maybe<Scalars['Int']>
  specificationsReceiverComposiet: Maybe<Scalars['Int']>
  specificationsReceiverEthernet: Maybe<Scalars['Int']>
  specificationsReceiverFabriekscode: Maybe<Scalars['String']>
  specificationsReceiverGewicht: Maybe<Scalars['String']>
  specificationsReceiverHdmiin: Maybe<Scalars['String']>
  specificationsReceiverHdmiout: Maybe<Scalars['String']>
  specificationsReceiverImpendatie: Maybe<Scalars['String']>
  specificationsReceiverIntroductiejaar: Maybe<Scalars['String']>
  specificationsReceiverKanalen: Maybe<Scalars['String']>
  specificationsReceiverKleur: Maybe<Scalars['Int']>
  specificationsReceiverMinijack: Maybe<Scalars['Int']>
  specificationsReceiverMultiroom: Maybe<Scalars['Int']>
  specificationsReceiverOptisch: Maybe<Scalars['String']>
  specificationsReceiverPlatenspeler: Maybe<Scalars['Int']>
  specificationsReceiverRadio: Maybe<Scalars['String']>
  specificationsReceiverSpeeltaf: Maybe<Scalars['String']>
  specificationsReceiverSpotifyconnect: Maybe<Scalars['Int']>
  specificationsReceiverStreaming: Maybe<Scalars['String']>
  specificationsReceiverStroomvoorziening: Maybe<Scalars['Int']>
  specificationsReceiverSubwoofer: Maybe<Scalars['Int']>
  specificationsReceiverSubwooferuitgang: Maybe<Scalars['String']>
  specificationsReceiverSurroundsystemen: Maybe<Scalars['String']>
  specificationsReceiverTypeaudio: Maybe<Scalars['Int']>
  specificationsReceiverTypereceiver: Maybe<Scalars['Int']>
  specificationsReceiverUsb: Maybe<Scalars['Int']>
  specificationsReceiverVermogen: Maybe<Scalars['String']>
  specificationsReceiverWifi: Maybe<Scalars['Int']>
  specificationsSoundbarAantalspeakers: Maybe<Scalars['String']>
  specificationsSoundbarAfmetingen: Maybe<Scalars['String']>
  specificationsSoundbarAirplay2: Maybe<Scalars['Int']>
  specificationsSoundbarArc: Maybe<Scalars['Int']>
  specificationsSoundbarAux: Maybe<Scalars['Int']>
  specificationsSoundbarBeeldondersteuning: Maybe<Scalars['String']>
  specificationsSoundbarBluetooth: Maybe<Scalars['Int']>
  specificationsSoundbarComponent: Maybe<Scalars['Int']>
  specificationsSoundbarComposiet: Maybe<Scalars['Int']>
  specificationsSoundbarEthernet: Maybe<Scalars['Int']>
  specificationsSoundbarFabriekscode: Maybe<Scalars['String']>
  specificationsSoundbarGewicht: Maybe<Scalars['String']>
  specificationsSoundbarHdmiin: Maybe<Scalars['String']>
  specificationsSoundbarHdmiout: Maybe<Scalars['String']>
  specificationsSoundbarIntroductiejaar: Maybe<Scalars['String']>
  specificationsSoundbarKanalen: Maybe<Scalars['String']>
  specificationsSoundbarKleur: Maybe<Scalars['Int']>
  specificationsSoundbarMinijack: Maybe<Scalars['Int']>
  specificationsSoundbarMultiroom: Maybe<Scalars['Int']>
  specificationsSoundbarOptischcoax: Maybe<Scalars['String']>
  specificationsSoundbarSpeeltaf: Maybe<Scalars['String']>
  specificationsSoundbarSpotifyconnect: Maybe<Scalars['Int']>
  specificationsSoundbarStreaming: Maybe<Scalars['String']>
  specificationsSoundbarStroomvoorziening: Maybe<Scalars['Int']>
  specificationsSoundbarSubwoofer: Maybe<Scalars['Int']>
  specificationsSoundbarTypeaudio: Maybe<Scalars['Int']>
  specificationsSoundbarUsb: Maybe<Scalars['Int']>
  specificationsSoundbarVermogen: Maybe<Scalars['String']>
  specificationsSoundbarWifi: Maybe<Scalars['Int']>
  specificationsStereosetAansluitingen: Maybe<Scalars['String']>
  specificationsStereosetAantalspeakers: Maybe<Scalars['String']>
  specificationsStereosetAantalusb: Maybe<Scalars['String']>
  specificationsStereosetAfmetingen: Maybe<Scalars['String']>
  specificationsStereosetBelastbaarheid: Maybe<Scalars['String']>
  specificationsStereosetFabriekscode: Maybe<Scalars['String']>
  specificationsStereosetGewicht: Maybe<Scalars['String']>
  specificationsStereosetImpendatie: Maybe<Scalars['Int']>
  specificationsStereosetIntroductiejaar: Maybe<Scalars['String']>
  specificationsStereosetKanalen: Maybe<Scalars['String']>
  specificationsStereosetKleur: Maybe<Scalars['Int']>
  specificationsStereosetMaximalefrequentie: Maybe<Scalars['String']>
  specificationsStereosetMinimalefrequentie: Maybe<Scalars['String']>
  specificationsStereosetMultiroom: Maybe<Scalars['Int']>
  specificationsStereosetRadio: Maybe<Scalars['String']>
  specificationsStereosetSpeakeraansluiting: Maybe<Scalars['Int']>
  specificationsStereosetSpeeltaf: Maybe<Scalars['String']>
  specificationsStereosetStandaardmeegeleverd: Maybe<Scalars['String']>
  specificationsStereosetStreaming: Maybe<Scalars['String']>
  specificationsStereosetStroomvoorziening: Maybe<Scalars['Int']>
  specificationsStereosetSubwooferuitgang: Maybe<Scalars['Int']>
  specificationsStereosetTypeaudio: Maybe<Scalars['Int']>
  specificationsStereosetTypespeaker: Maybe<Scalars['Int']>
  specificationsStereosetVermogen: Maybe<Scalars['String']>
  specificationsSubwooferAansluitingen: Maybe<Scalars['String']>
  specificationsSubwooferAantalusb: Maybe<Scalars['String']>
  specificationsSubwooferAfmetingen: Maybe<Scalars['String']>
  specificationsSubwooferAfmetingensubwoofer: Maybe<Scalars['String']>
  specificationsSubwooferBelastbaarheid: Maybe<Scalars['String']>
  specificationsSubwooferFabriekscode: Maybe<Scalars['String']>
  specificationsSubwooferGewicht: Maybe<Scalars['String']>
  specificationsSubwooferGewichtsubwoofer: Maybe<Scalars['String']>
  specificationsSubwooferIntroductiejaar: Maybe<Scalars['String']>
  specificationsSubwooferKanalen: Maybe<Scalars['String']>
  specificationsSubwooferKleur: Maybe<Scalars['Int']>
  specificationsSubwooferMaximalefrequentie: Maybe<Scalars['String']>
  specificationsSubwooferMinimalefrequentie: Maybe<Scalars['String']>
  specificationsSubwooferMultiroom: Maybe<Scalars['Int']>
  specificationsSubwooferRadio: Maybe<Scalars['Int']>
  specificationsSubwooferSpeakeraansluiting: Maybe<Scalars['String']>
  specificationsSubwooferStandaardmeegeleverd: Maybe<Scalars['String']>
  specificationsSubwooferStreaming: Maybe<Scalars['String']>
  specificationsSubwooferStreamingdiensten: Maybe<Scalars['String']>
  specificationsSubwooferStroomvoorziening: Maybe<Scalars['Int']>
  specificationsSubwooferSubwooferuitgang: Maybe<Scalars['Int']>
  specificationsSubwooferTypeaudio: Maybe<Scalars['Int']>
  specificationsSubwooferTypespeaker: Maybe<Scalars['String']>
  specificationsSubwooferVermogen: Maybe<Scalars['String']>
  specificationsSubwooferWaterbestendig: Maybe<Scalars['Int']>
  specificationsTelevisieAfmetingenexclvoet: Maybe<Scalars['String']>
  specificationsTelevisieAfmetingeninclvoet: Maybe<Scalars['String']>
  specificationsTelevisieAirplay: Maybe<Scalars['Int']>
  specificationsTelevisieAmbilight: Maybe<Scalars['Int']>
  specificationsTelevisieBeeldformaat: Maybe<Scalars['Int']>
  specificationsTelevisieBeeldfrequentie: Maybe<Scalars['Int']>
  specificationsTelevisieBluetooth: Maybe<Scalars['Int']>
  specificationsTelevisieCigeschikt: Maybe<Scalars['String']>
  specificationsTelevisieComponent: Maybe<Scalars['Int']>
  specificationsTelevisieComposiet: Maybe<Scalars['Int']>
  specificationsTelevisieDigitaalcoaxaleaansluiting: Maybe<Scalars['Int']>
  specificationsTelevisieDigitaaloptischeaansluiting: Maybe<Scalars['Int']>
  specificationsTelevisieEnergieklasse: Maybe<Scalars['Int']>
  specificationsTelevisieFabriekscode: Maybe<Scalars['String']>
  specificationsTelevisieGewichtexclvoet: Maybe<Scalars['String']>
  specificationsTelevisieGewichtinclvoet: Maybe<Scalars['String']>
  specificationsTelevisieHdmi: Maybe<Scalars['String']>
  specificationsTelevisieHdr: Maybe<Scalars['Int']>
  specificationsTelevisieIntroductiejaar: Maybe<Scalars['String']>
  specificationsTelevisieKleur: Maybe<Scalars['Int']>
  specificationsTelevisieKoptelefoon: Maybe<Scalars['Int']>
  specificationsTelevisieMeegeleverdeaccessoires: Maybe<Scalars['String']>
  specificationsTelevisieMerk: Maybe<Scalars['Int']>
  specificationsTelevisieResolutie: Maybe<Scalars['Int']>
  specificationsTelevisieScart: Maybe<Scalars['Int']>
  specificationsTelevisieSmartplatform: Maybe<Scalars['Int']>
  specificationsTelevisieSmarttv: Maybe<Scalars['Int']>
  specificationsTelevisieSoorttv: Maybe<Scalars['String']>
  specificationsTelevisieSpeakersysteem: Maybe<Scalars['String']>
  specificationsTelevisieSpotifyconnect: Maybe<Scalars['Int']>
  specificationsTelevisieSpraakbesturing: Maybe<Scalars['Int']>
  specificationsTelevisieSubwoofer: Maybe<Scalars['Int']>
  specificationsTelevisieTuner: Maybe<Scalars['String']>
  specificationsTelevisieTypehdr: Maybe<Scalars['String']>
  specificationsTelevisieUsb: Maybe<Scalars['String']>
  specificationsTelevisieVermogen: Maybe<Scalars['String']>
  specificationsTelevisieWifi: Maybe<Scalars['Int']>
  specificationsTvmeubelAfmetingen: Maybe<Scalars['String']>
  specificationsTvmeubelGewicht: Maybe<Scalars['String']>
  specificationsTvmeubelKleur: Maybe<Scalars['Int']>
  specificationsTvmeubelMateriaal: Maybe<Scalars['String']>
  specificationsTvmeubelTypeproduct: Maybe<Scalars['Int']>
  specificationsVersterkerAansluitingen: Maybe<Scalars['String']>
  specificationsVersterkerAantalhdmi: Maybe<Scalars['String']>
  specificationsVersterkerAantalusb: Maybe<Scalars['String']>
  specificationsVersterkerAchterspeakers: Maybe<Scalars['Int']>
  specificationsVersterkerAfmetingen: Maybe<Scalars['String']>
  specificationsVersterkerAfmetingensubwoofer: Maybe<Scalars['String']>
  specificationsVersterkerBelastbaarheid: Maybe<Scalars['String']>
  specificationsVersterkerFabriekscode: Maybe<Scalars['String']>
  specificationsVersterkerGewicht: Maybe<Scalars['String']>
  specificationsVersterkerGewichtsubwoofer: Maybe<Scalars['String']>
  specificationsVersterkerImpendatie: Maybe<Scalars['String']>
  specificationsVersterkerIntroductiejaar: Maybe<Scalars['String']>
  specificationsVersterkerKanalen: Maybe<Scalars['String']>
  specificationsVersterkerKleur: Maybe<Scalars['Int']>
  specificationsVersterkerMultiroom: Maybe<Scalars['Int']>
  specificationsVersterkerRadio: Maybe<Scalars['String']>
  specificationsVersterkerSpeakeraansluiting: Maybe<Scalars['String']>
  specificationsVersterkerSpeeltaf: Maybe<Scalars['String']>
  specificationsVersterkerStandaardmeegeleverd: Maybe<Scalars['String']>
  specificationsVersterkerStreaming: Maybe<Scalars['String']>
  specificationsVersterkerStreamingdiensten: Maybe<Scalars['String']>
  specificationsVersterkerStroomvoorziening: Maybe<Scalars['Int']>
  specificationsVersterkerSubwoofer: Maybe<Scalars['String']>
  specificationsVersterkerSubwooferuitgang: Maybe<Scalars['Int']>
  specificationsVersterkerTypeaudio: Maybe<Scalars['Int']>
  specificationsVersterkerVermogen: Maybe<Scalars['String']>
  specificationsVersterkerWaterbestendig: Maybe<Scalars['Int']>
  specificationsVloerstandaardAfmetingen: Maybe<Scalars['String']>
  specificationsVloerstandaardKleur: Maybe<Scalars['Int']>
  specificationsVloerstandaardProducttype: Maybe<Scalars['Int']>
  specificationsVoedingDraadloosopladen: Maybe<Scalars['Int']>
  specificationsVoedingKabellengte: Maybe<Scalars['String']>
  specificationsVoedingKleur: Maybe<Scalars['Int']>
  specificationsVoedingProducttype: Maybe<Scalars['Int']>
  specificationsWifispeakerAansluitingen: Maybe<Scalars['String']>
  specificationsWifispeakerAantalspeakers: Maybe<Scalars['String']>
  specificationsWifispeakerAantalusb: Maybe<Scalars['String']>
  specificationsWifispeakerAchterspeakers: Maybe<Scalars['Int']>
  specificationsWifispeakerAfmetingen: Maybe<Scalars['String']>
  specificationsWifispeakerAfmetingensubwoofer: Maybe<Scalars['String']>
  specificationsWifispeakerBelastbaarheid: Maybe<Scalars['String']>
  specificationsWifispeakerFabriekscode: Maybe<Scalars['String']>
  specificationsWifispeakerGewicht: Maybe<Scalars['String']>
  specificationsWifispeakerGewichtsubwoofer: Maybe<Scalars['String']>
  specificationsWifispeakerImpendatie: Maybe<Scalars['String']>
  specificationsWifispeakerIntroductiejaar: Maybe<Scalars['String']>
  specificationsWifispeakerKanalen: Maybe<Scalars['String']>
  specificationsWifispeakerKleur: Maybe<Scalars['Int']>
  specificationsWifispeakerMultiroom: Maybe<Scalars['Int']>
  specificationsWifispeakerRadio: Maybe<Scalars['String']>
  specificationsWifispeakerSpeeltaf: Maybe<Scalars['String']>
  specificationsWifispeakerStandaardmeegeleverd: Maybe<Scalars['String']>
  specificationsWifispeakerStreaming: Maybe<Scalars['String']>
  specificationsWifispeakerStreamingdiensten: Maybe<Scalars['String']>
  specificationsWifispeakerStroomvoorziening: Maybe<Scalars['String']>
  specificationsWifispeakerSubwoofer: Maybe<Scalars['String']>
  specificationsWifispeakerSubwooferuitgang: Maybe<Scalars['String']>
  specificationsWifispeakerTypeaudio: Maybe<Scalars['Int']>
  specificationsWifispeakerTypespeaker: Maybe<Scalars['Int']>
  specificationsWifispeakerVermogen: Maybe<Scalars['String']>
  specificationsWifispeakerWaterbestendig: Maybe<Scalars['Int']>
  /** Stock status of the product */
  stockStatus: Maybe<ProductStockStatus>
  strapBags: Maybe<Scalars['String']>
  styleBags: Maybe<Scalars['String']>
  styleBottom: Maybe<Scalars['String']>
  styleGeneral: Maybe<Scalars['String']>
  /** The file name of a swatch image */
  swatchImage: Maybe<Scalars['String']>
  tempcombipakketten: Maybe<Scalars['String']>
  /** The relative path to the product's thumbnail image. */
  thumbnail: Maybe<ProductImage>
  /**
   * The price when tier pricing is in effect and the items purchased threshold has been reached.
   * @deprecated Use price_tiers for product tier price information.
   */
  tierPrice: Maybe<Scalars['Float']>
  /**
   * An array of ProductTierPrices objects.
   * @deprecated Use price_tiers for product tier price information.
   */
  tierPrices: Maybe<Array<Maybe<ProductTierPrices>>>
  top10product: Maybe<Scalars['Int']>
  tot21u: Maybe<Scalars['Int']>
  tweakers: Maybe<Scalars['Int']>
  tweakerstekstad: Maybe<Scalars['String']>
  tweakwisecrossselltemplateid: Maybe<Scalars['String']>
  /**
   * One of simple, virtual, bundle, downloadable, grouped, or configurable.
   * @deprecated Use __typename instead.
   */
  typeId: Maybe<Scalars['String']>
  /** Timestamp indicating when the product was updated. */
  updatedAt: Maybe<Scalars['String']>
  /** Upsell Products */
  upsellProducts: Maybe<Array<Maybe<ProductInterface>>>
  /** The part of the URL that identifies the product */
  urlKey: Scalars['String']
  /** @deprecated Use product's `canonical_url` or url rewrites instead */
  urlPath: Maybe<Scalars['String']>
  /** URL rewrites list */
  urlRewrites: Maybe<Array<Maybe<UrlRewrite>>>
  /** The part of the product URL that is appended after the url key */
  urlSuffix: Maybe<Scalars['String']>
  variant: Maybe<Scalars['Int']>
  variantValue: Maybe<Scalars['String']>
  venditguid: Maybe<Scalars['String']>
  venditpid: Maybe<Scalars['String']>
  voorraadamsterdam: Maybe<Scalars['Int']>
  voorraadarnhem: Maybe<Scalars['Int']>
  voorraadbreda: Maybe<Scalars['Int']>
  voorraaddoetinchem: Maybe<Scalars['Int']>
  voorraadeindhoven: Maybe<Scalars['Int']>
  voorraadgroningen: Maybe<Scalars['Int']>
  voorraadnaarden: Maybe<Scalars['Int']>
  voorraadnijmegen: Maybe<Scalars['Int']>
  voorraadonline: Maybe<Scalars['Int']>
  voorraadutrecht: Maybe<Scalars['Int']>
  voorraadzoeterwoude: Maybe<Scalars['Int']>
  /**
   * An array of websites in which the product is available.
   * @deprecated The field should not be used on the storefront.
   */
  websites: Maybe<Array<Maybe<Website>>>
  zondaglevering: Maybe<Scalars['Int']>
  pimcoreProductData: Maybe<PimcoreProduct>
}

export interface VirtualProductCartItemInput {
  customizable_options?: Maybe<Array<Maybe<CustomizableOptionInput>>>
  data: CartItemInput
}

/** Website is deprecated because it is should not be used on storefront. The type contains information about a website */
export interface Website {
  __typename?: 'Website'
  /**
   * A code assigned to the website to identify it
   * @deprecated The field should not be used on the storefront.
   */
  code: Maybe<Scalars['String']>
  /**
   * The default group ID that the website has
   * @deprecated The field should not be used on the storefront.
   */
  defaultGroupId: Maybe<Scalars['String']>
  /**
   * The ID number assigned to the website
   * @deprecated The field should not be used on the storefront.
   */
  id: Maybe<Scalars['Int']>
  /**
   * Specifies if this is the default website
   * @deprecated The field should not be used on the storefront.
   */
  isDefault: Maybe<Scalars['Boolean']>
  /**
   * The website name. Websites use this name to identify it easier.
   * @deprecated The field should not be used on the storefront.
   */
  name: Maybe<Scalars['String']>
  /**
   * The attribute to use for sorting websites
   * @deprecated The field should not be used on the storefront.
   */
  sortOrder: Maybe<Scalars['Int']>
}

export interface WhereCategory {
  categoryId?: Maybe<Scalars['String']>
  categoryIdFulltext?: Maybe<Scalars['String']>
}

export interface WhereFaqcategory {
  categoryName?: Maybe<Scalars['String']>
  categoryNameFulltext?: Maybe<Scalars['String']>
  /** category_order */
  categoryOrder?: Maybe<Scalars['Float']>
  /** category_order */
  categoryOrderLt?: Maybe<Scalars['Float']>
  /** category_order */
  categoryOrderGt?: Maybe<Scalars['Float']>
  /** category_order */
  categoryOrderRange?: Maybe<Array<Scalars['Float']>>
}

export interface WhereFaqsubject {
  subjectName?: Maybe<Scalars['String']>
  subjectNameFulltext?: Maybe<Scalars['String']>
  /** subject_category */
  subjectCategory?: Maybe<Scalars['String']>
  /** subject_order */
  subjectOrder?: Maybe<Scalars['Float']>
  /** subject_order */
  subjectOrderLt?: Maybe<Scalars['Float']>
  /** subject_order */
  subjectOrderGt?: Maybe<Scalars['Float']>
  /** subject_order */
  subjectOrderRange?: Maybe<Array<Scalars['Float']>>
}

export interface WhereForm {
  /** title */
  titleFulltext?: Maybe<Scalars['String']>
  /** explanation */
  explanationFulltext?: Maybe<Scalars['String']>
  submit?: Maybe<Scalars['String']>
  submitFulltext?: Maybe<Scalars['String']>
  /** success_message */
  successMessageFulltext?: Maybe<Scalars['String']>
  productHeaderSubtitle?: Maybe<Scalars['String']>
  productHeaderSubtitleFulltext?: Maybe<Scalars['String']>
  twoColumnGridOnDesktop?: Maybe<Scalars['Boolean']>
}

export interface WherePage {
  urlKey?: Maybe<Scalars['String']>
  urlKeyFulltext?: Maybe<Scalars['String']>
  /** seo_title */
  seoTitleFulltext?: Maybe<Scalars['String']>
  /** seo_description */
  seoDescriptionFulltext?: Maybe<Scalars['String']>
  /** seo_keywords */
  seoKeywordsFulltext?: Maybe<Scalars['String']>
}

export interface WhereProduct {
  serie?: Maybe<Scalars['String']>
  serieFulltext?: Maybe<Scalars['String']>
  product?: Maybe<Scalars['String']>
  productFulltext?: Maybe<Scalars['String']>
  requestDiscountButton?: Maybe<Scalars['Boolean']>
  tradeOldTv?: Maybe<Scalars['Boolean']>
}

export interface WhereReviewModal {
  /** title */
  titleFulltext?: Maybe<Scalars['String']>
  /** subtitle */
  subtitleFulltext?: Maybe<Scalars['String']>
  /** info */
  infoFulltext?: Maybe<Scalars['String']>
  /** footer */
  footerFulltext?: Maybe<Scalars['String']>
}

export interface WhereSpec {
  specKey?: Maybe<Scalars['String']>
  specKeyFulltext?: Maybe<Scalars['String']>
}

export interface WhereSpecification {
  name?: Maybe<Scalars['String']>
  nameFulltext?: Maybe<Scalars['String']>
}

export interface WhereStore {
  urlKey?: Maybe<Scalars['String']>
  urlKeyFulltext?: Maybe<Scalars['String']>
  seoTitle?: Maybe<Scalars['String']>
  seoTitleFulltext?: Maybe<Scalars['String']>
  seoDescription?: Maybe<Scalars['String']>
  seoDescriptionFulltext?: Maybe<Scalars['String']>
  seoKeywords?: Maybe<Scalars['String']>
  seoKeywordsFulltext?: Maybe<Scalars['String']>
}

export interface Wishlist {
  __typename?: 'Wishlist'
  /** Wishlist unique identifier */
  id: Maybe<Scalars['ID']>
  /** An array of items in the customer's wish list */
  items: Maybe<Array<Maybe<WishlistItem>>>
  /** The number of items in the wish list */
  itemsCount: Maybe<Scalars['Int']>
  /** An encrypted code that Magento uses to link to the wish list */
  sharingCode: Maybe<Scalars['String']>
  /** The time of the last modification to the wish list */
  updatedAt: Maybe<Scalars['String']>
}

export interface WishlistItem {
  __typename?: 'WishlistItem'
  /** The time when the customer added the item to the wish list */
  addedAt: Maybe<Scalars['String']>
  /** The customer's comment about this item */
  description: Maybe<Scalars['String']>
  /** The wish list item ID */
  id: Maybe<Scalars['Int']>
  product: Maybe<ProductInterface>
  /** The quantity of this wish list item */
  qty: Maybe<Scalars['Float']>
}

/** Deprecated: `Wishlist` type should be used instead */
export interface WishlistOutput {
  __typename?: 'WishlistOutput'
  /**
   * An array of items in the customer's wish list
   * @deprecated Use field `items` from type `Wishlist` instead
   */
  items: Maybe<Array<Maybe<WishlistItem>>>
  /**
   * The number of items in the wish list
   * @deprecated Use field `items_count` from type `Wishlist` instead
   */
  itemsCount: Maybe<Scalars['Int']>
  /**
   * When multiple wish lists are enabled, the name the customer assigns to the wishlist
   * @deprecated This field is related to Commerce functionality and is always `null` in Open Source edition
   */
  name: Maybe<Scalars['String']>
  /**
   * An encrypted code that Magento uses to link to the wish list
   * @deprecated Use field `sharing_code` from type `Wishlist` instead
   */
  sharingCode: Maybe<Scalars['String']>
  /**
   * The time of the last modification to the wish list
   * @deprecated Use field `updated_at` from type `Wishlist` instead
   */
  updatedAt: Maybe<Scalars['String']>
}
